var $akeyK$react = require("react");
var $akeyK$reactjsxruntime = require("react/jsx-runtime");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec887_1unxz"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec887_1unxz"] = parcelRequire;
}
parcelRequire.register("2wGx1", function(module, exports) {
module.exports = Promise.resolve(require("./Doppio.bbc51261.07959d60.js")).then(()=>parcelRequire("dp4mC"));

});

parcelRequire.register("1Emwx", function(module, exports) {
module.exports = Promise.resolve(require("./RistrettoPlaying.c0a689bc.7614a636.js")).then(()=>parcelRequire("8t9Cn"));

});

parcelRequire.register("ar1F1", function(module, exports) {
module.exports = Promise.resolve(require("./RistrettoBroadcasting.5fa78bd7.0025cf14.js")).then(()=>parcelRequire("hYIxU"));

});

parcelRequire.register("kq8sC", function(module, exports) {
module.exports = Promise.resolve(require("./Native.784c1e4d.7f77bce6.js")).then(()=>parcelRequire("5nLRG"));

});


$parcel$export(module.exports, "EPlayerErrorType", () => $e175c1d94c759890$export$b0dc2e3b984d8891);
$parcel$export(module.exports, "MMP", () => $e175c1d94c759890$export$57663087b8d9f5a6);
$parcel$export(module.exports, "EPlaybackState", () => $cdb872cfc8d057e0$export$af29ccb356acd9fc);
$parcel$export(module.exports, "EPlayerType", () => $cdb872cfc8d057e0$export$41789205b2aea69e);
$parcel$export(module.exports, "EPlaybackStartType", () => $cdb872cfc8d057e0$export$fadb1eea8aff454b);
$parcel$export(module.exports, "useMouflonPlayer", () => $a5b117aca3c08d12$export$35d029da0d03482e);
$parcel$export(module.exports, "useMouflonPlayerV2", () => $88026686cd5bfe8a$export$76f5745079d42a31);
$parcel$export(module.exports, "MouflonPlayer", () => $b274644de02feaf1$export$57663087b8d9f5a6);
$parcel$export(module.exports, "useUserMedia", () => $59ca1dda55658eb6$export$a16ee9849ed85b4e);
$parcel$export(module.exports, "getVideoElement", () => $006bb0748335bd60$export$ccb78460aa37b1d6);
$parcel$export(module.exports, "MMP_VERSION", () => $7bee1a93fb5bc362$export$28c82a02d50f6df3);
var $e175c1d94c759890$var$e, $e175c1d94c759890$var$t, $e175c1d94c759890$var$r, $e175c1d94c759890$var$n, $e175c1d94c759890$var$i, $e175c1d94c759890$var$s, $e175c1d94c759890$var$o, $e175c1d94c759890$var$a, $e175c1d94c759890$var$l, $e175c1d94c759890$var$u, $e175c1d94c759890$var$c, $e175c1d94c759890$var$h, $e175c1d94c759890$var$d, $e175c1d94c759890$var$_ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : {};
function $e175c1d94c759890$var$f(e, t, r, n) {
    Object.defineProperty(e, t, {
        get: r,
        set: n,
        enumerable: !0,
        configurable: !0
    });
}
var $e175c1d94c759890$var$p = {}, $e175c1d94c759890$var$v = {}, $e175c1d94c759890$var$g = $e175c1d94c759890$var$_.parcelRequire3a38_xft3l;
null == $e175c1d94c759890$var$g && (($e175c1d94c759890$var$g = function(e) {
    if (e in $e175c1d94c759890$var$p) return $e175c1d94c759890$var$p[e].exports;
    if (e in $e175c1d94c759890$var$v) {
        var t = $e175c1d94c759890$var$v[e];
        delete $e175c1d94c759890$var$v[e];
        var r = {
            id: e,
            exports: {}
        };
        return $e175c1d94c759890$var$p[e] = r, t.call(r.exports, r, r.exports), r.exports;
    }
    var n = Error("Cannot find module '" + e + "'");
    throw n.code = "MODULE_NOT_FOUND", n;
}).register = function(e, t) {
    $e175c1d94c759890$var$v[e] = t;
}, $e175c1d94c759890$var$_.parcelRequire3a38_xft3l = $e175c1d94c759890$var$g);
var $e175c1d94c759890$var$m = $e175c1d94c759890$var$g.register;




$e175c1d94c759890$var$m("hJ7nZ", function(e, t) {
    function r(e, t, r, n) {
        Object.defineProperty(e, t, {
            get: r,
            set: n,
            enumerable: !0,
            configurable: !0
        });
    }
    $e175c1d94c759890$var$f(e.exports, "EVideoControllerCustomEvent", function() {
        return E;
    }), $e175c1d94c759890$var$f(e.exports, "EPlayerType", function() {
        return S;
    }), $e175c1d94c759890$var$f(e.exports, "EPlaybackState", function() {
        return C;
    }), $e175c1d94c759890$var$f(e.exports, "EPlaybackStartType", function() {
        return T;
    }), $e175c1d94c759890$var$f(e.exports, "EventBus", function() {
        return z;
    }), $e175c1d94c759890$var$f(e.exports, "ObjectDeepDiff", function() {
        return ee;
    }), $e175c1d94c759890$var$f(e.exports, "createConfig", function() {
        return et;
    }), $e175c1d94c759890$var$f(e.exports, "bind", function() {
        return er;
    }), $e175c1d94c759890$var$f(e.exports, "CustomEventTarget", function() {
        return ev;
    }), $e175c1d94c759890$var$f(e.exports, "VideoElementController", function() {
        return ti;
    }), $e175c1d94c759890$var$f(e.exports, "WebRTCCommonHelpers", function() {
        return rU;
    }), $e175c1d94c759890$var$f(e.exports, "HLSCommon", function() {
        return rK;
    }), $e175c1d94c759890$var$f(e.exports, "queued", function() {
        return rJ;
    }), $e175c1d94c759890$var$f(e.exports, "AsyncGuarderDecorator", function() {
        return rX;
    }), $e175c1d94c759890$var$f(e.exports, "getVideoPlaybackQuality", function() {
        return r4;
    });
    var n, i, s, o, a, l, u, c, h, d, p, v, g, m, y, b, E, S, C, T, A, w, P, R, I, O, M, L, D = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== $e175c1d94c759890$var$_ ? $e175c1d94c759890$var$_ : {}, k = {}, N = {}, x = D.parcelRequire6891_vldu9;
    function B() {
        return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== D ? D : void 0;
    }
    null == x && ((x = function(e) {
        if (e in k) return k[e].exports;
        if (e in N) {
            var t = N[e];
            delete N[e];
            var r = {
                id: e,
                exports: {}
            };
            return k[e] = r, t.call(r.exports, r, r.exports), r.exports;
        }
        var n = Error("Cannot find module '" + e + "'");
        throw n.code = "MODULE_NOT_FOUND", n;
    }).register = function(e, t) {
        N[e] = t;
    }, D.parcelRequire6891_vldu9 = x), x.register("iuHwr", function(e, t) {
        r(e.exports, "default", function() {
            return l;
        });
        var n = x("iCUkT"), i = x("eEfty"), s = t && !t.nodeType && t, o = s && e && !e.nodeType && e, a = o && o.exports === s ? n.default.Buffer : void 0, l = (a ? a.isBuffer : void 0) || i.default;
    }), x.register("iCUkT", function(e, t) {
        r(e.exports, "default", function() {
            return s;
        });
        var n = x("39qEx"), i = "object" == typeof self && self && self.Object === Object && self, s = n.default || i || Function("return this")();
    }), x.register("39qEx", function(e, t) {
        r(e.exports, "default", function() {
            return n;
        });
        var n = "object" == typeof D && D && D.Object === Object && D;
    }), x.register("eEfty", function(e, t) {
        r(e.exports, "default", function() {
            return n;
        });
        var n = function() {
            return !1;
        };
    }), x.register("8tO4H", function(e, t) {
        r(e.exports, "default", function() {
            return a;
        });
        var n = x("39qEx"), i = t && !t.nodeType && t, s = i && e && !e.nodeType && e, o = s && s.exports === i && n.default.process, a = function() {
            try {
                var e = s && s.require && s.require("util").types;
                if (e) return e;
                return o && o.binding && o.binding("util");
            } catch (e) {}
        }();
    }), "undefined" == typeof globalThis && (globalThis = B());
    let V = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== D && D;
    function U(e) {
        try {
            new e("");
        } catch (e) {
            return !1;
        }
        return !0;
    }
    "function" == typeof V.Event && U(V.Event) || (V.Event = function(e, t) {
        this.bubbles = !!t && !!t.bubbles, this.cancelable = !!t && !!t.cancelable, this.composed = !!t && !!t.composed, this.type = e;
    }), void 0 !== V.EventTarget && U(V.EventTarget) || (V.EventTarget = function() {
        function e() {
            this.__listeners = new Map;
        }
        return e.prototype = Object.create(Object.prototype), e.prototype.addEventListener = function(e, t, r) {
            if (arguments.length < 2) throw TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
            let n = this.__listeners, i = e.toString();
            n.has(i) || n.set(i, new Map);
            let s = n.get(i);
            s.has(t) || s.set(t, r);
        }, e.prototype.removeEventListener = function(e, t, r) {
            if (arguments.length < 2) throw TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
            let n = this.__listeners, i = e.toString();
            if (n.has(i)) {
                let e = n.get(i);
                e.has(t) && e.delete(t);
            }
        }, e.prototype.dispatchEvent = function(e) {
            if (!(e instanceof Event)) throw TypeError("Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.");
            let t = e.type, r = this.__listeners.get(t);
            if (r) for (let [t, n] of r.entries()){
                try {
                    "function" == typeof t ? t.call(this, e) : t && "function" == typeof t.handleEvent && t.handleEvent(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    });
                }
                n && n.once && r.delete(t);
            }
            return !0;
        }, e;
    }());
    let j = class {
        constructor(){
            Object.defineProperty(this, "listeners", {
                value: {},
                writable: !0,
                configurable: !0
            });
        }
        addEventListener(e, t, r) {
            e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
                callback: t,
                options: r
            });
        }
        removeEventListener(e, t) {
            if (!(e in this.listeners)) return;
            let r = this.listeners[e];
            for(let e = 0, n = r.length; e < n; e++)if (r[e].callback === t) return void r.splice(e, 1);
        }
        dispatchEvent(e) {
            if (!(e.type in this.listeners)) return;
            let t = this.listeners[e.type].slice();
            for(let r = 0, n = t.length; r < n; r++){
                let n = t[r];
                try {
                    n.callback.call(this, e);
                } catch (e) {
                    Promise.resolve().then(()=>{
                        throw e;
                    });
                }
                n.options && n.options.once && this.removeEventListener(e.type, n.callback);
            }
            return !e.defaultPrevented;
        }
    }, F = class extends j {
        constructor(){
            super(), this.listeners || j.call(this), Object.defineProperty(this, "aborted", {
                value: !1,
                writable: !0,
                configurable: !0
            }), Object.defineProperty(this, "onabort", {
                value: null,
                writable: !0,
                configurable: !0
            }), Object.defineProperty(this, "reason", {
                value: void 0,
                writable: !0,
                configurable: !0
            });
        }
        toString() {
            return "[object AbortSignal]";
        }
        dispatchEvent(e) {
            "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), super.dispatchEvent(e);
        }
    }, W = class {
        constructor(){
            Object.defineProperty(this, "signal", {
                value: new F,
                writable: !0,
                configurable: !0
            });
        }
        abort(e) {
            let t;
            t = new Event("abort");
            let r = e;
            void 0 === r && ((r = Error("This operation was aborted")).name = "AbortError"), this.signal.reason = r, this.signal.dispatchEvent(t);
        }
        toString() {
            return "[object AbortController]";
        }
    };
    ("function" != typeof (n = "undefined" != typeof self ? self : D).Request || n.Request.prototype.hasOwnProperty("signal")) && n.AbortController || ("undefined" != typeof Symbol && Symbol.toStringTag && (W.prototype[Symbol.toStringTag] = "AbortController", F.prototype[Symbol.toStringTag] = "AbortSignal"), n.AbortController = W, n.AbortSignal = F);
    let H = B();
    "function" != typeof H.queueMicrotask && (H.queueMicrotask = function(e) {
        Promise.resolve().then(e).catch((e)=>setTimeout(()=>{
                throw e;
            }));
    }), Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", {
        configurable: !0,
        value: function e() {
            let t = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
            return t ? Array.prototype.reduce.call(this, function(r, n) {
                return Array.isArray(n) ? r.push.apply(r, e.call(n, t - 1)) : r.push(n), r;
            }, []) : Array.prototype.slice.call(this);
        },
        writable: !0
    }), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", {
        configurable: !0,
        value: function(e) {
            return Array.prototype.map.apply(this, arguments).flat();
        },
        writable: !0
    }), (i = E || (E = {})).CLICK = "videoElement.click", i.PLAYING = "videoElement.playing", i.LOADING = "videoElement.loading", i.PAUSE = "videoElement.pause", i.VIDEO_PLAYBACK_STATE_CHANGE = "videoElement.videoPlaybackStateChange", i.NATIVE_EVENT = "videoElement.nativeEvent", i.UPDATE_PLAYER_RESOLUTION = "videoElement.updatePlayerResolution", i.TIME_UPDATE = "videoElement.timeUpdate";
    let z = class {
        constructor(e = !0){
            this.appId = null, this._lastUid = -1, this._messages = {}, this._immediateExceptions = !1, this._allSubscribingMsg = "*", this._immediateExceptions = e;
        }
        setAppId(e) {
            this.appId = e;
        }
        getAppId() {
            return this.appId;
        }
        publish(e, t) {
            return this._publish(e, t, !1, this._immediateExceptions);
        }
        publishSync(e, t) {
            return this._publish(e, t, !0, this._immediateExceptions);
        }
        subscribe(e, t) {
            if ("function" != typeof t) return "";
            let r = "uid_" + String(++this._lastUid);
            return this._messages[e] || (this._messages[e] = {}), (this._messages[e] || {})[r] = t, r;
        }
        toggleSubscriptionBulk(e) {
            "subscribe" === e.action ? Object.entries(e.callbacks).forEach(([e, t])=>{
                this.subscribe.call(this, e, t);
            }) : Object.entries(e.callbacks).forEach(([e, t])=>{
                this.unsubscribe.call(this, t);
            });
        }
        subscribeAll(e) {
            return this.subscribe(this._allSubscribingMsg, e);
        }
        subscribeOnce(e, t) {
            let r = this.subscribe(e, (...e)=>{
                this.unsubscribe(r), t.apply(this, e);
            });
            return this;
        }
        clearAllSubscriptions() {
            this._messages = {};
        }
        clearSubscriptions(e) {
            for(let t in this._messages)Object.prototype.hasOwnProperty.call(this._messages, t) && 0 === t.indexOf(e) && delete this._messages[t];
        }
        unsubscribe(e) {
            let t = "string" == typeof e && (Object.prototype.hasOwnProperty.call(this._messages, e) || this._descendantTopicExists(e)), r = !t && "string" == typeof e, n = "function" == typeof e, i = !1;
            if (t) return void this.clearSubscriptions(e);
            for(let t in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, t)) {
                let s = this._messages[t] || {};
                if (r && s[e]) {
                    delete s[e], i = e;
                    break;
                }
                if (n) for(let t in s)Object.prototype.hasOwnProperty.call(s, t) && s[t] === e && (delete s[t], i = !0);
            }
            return i;
        }
        _hasKeys(e) {
            for(let t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !0;
            return !1;
        }
        _throwException(e) {
            return ()=>{
                throw e;
            };
        }
        _callSubscriberWithDelayedExceptions(e, t) {
            try {
                e(t);
            } catch (e) {
                setTimeout(this._throwException(e), 0);
            }
        }
        _callSubscriberWithImmediateExceptions(e, t) {
            e(t);
        }
        _deliverMessage(e, t, r, n) {
            let i = this._messages[t] || {}, s = n ? this._callSubscriberWithImmediateExceptions : this._callSubscriberWithDelayedExceptions;
            if (Object.prototype.hasOwnProperty.call(this._messages, t)) for(let e in i)Object.prototype.hasOwnProperty.call(i, e) && s(i[e], r);
        }
        _createDeliveryFunction(e, t, r) {
            return ()=>{
                let n = String(e), i = n.lastIndexOf(".");
                for(this._deliverMessage(e, e, t, r); i > -1;)i = (n = n.substr(0, i)).lastIndexOf("."), this._deliverMessage(e, n, t, r);
                this._deliverMessage(e, this._allSubscribingMsg, t, r);
            };
        }
        _hasDirectSubscribersFor(e) {
            let t = String(e);
            return !!(Object.prototype.hasOwnProperty.call(this._messages, t) && this._hasKeys(this._messages[t] || {}));
        }
        _messageHasSubscribers(e) {
            let t = String(e), r = this._hasDirectSubscribersFor(t) || this._hasDirectSubscribersFor(this._allSubscribingMsg), n = t.lastIndexOf(".");
            for(; !r && -1 !== n;)n = (t = t.substr(0, n)).lastIndexOf("."), r = this._hasDirectSubscribersFor(t);
            return r;
        }
        _publish(e, t, r, n) {
            let i = "symbol" == typeof e ? e.toString() : e, s = this._createDeliveryFunction(i, t, n);
            return !!this._messageHasSubscribers(i) && (r ? s() : setTimeout(s, 0), !0);
        }
        _descendantTopicExists(e) {
            for(let t in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, t) && 0 === t.indexOf(e)) return !0;
            return !1;
        }
    };
    new z, new z;
    let G = (e)=>`configProvider.configUpdated.${e}`, $ = (e)=>{
        let t = {};
        return {
            configConsumerConstructor: class {
                constructor(r, n){
                    this._onConfigUpdatedWithContext = this._onConfigUpdated.bind(this), this._configKey = r, this._eventBus = n || e;
                    let i = G(r);
                    this._onConfigUpdatedListener = this._eventBus.subscribe(i, this._onConfigUpdatedWithContext), this.config = t[r];
                }
                destroy() {
                    this._eventBus.unsubscribe(this._onConfigUpdatedListener);
                }
                _handleConfigUpdated(e, t) {}
                _onConfigUpdated(e) {
                    t = e.newConfig;
                    let r = e.newConfig[this._configKey];
                    this.config = r, this._handleConfigUpdated(e.updatedValues, r);
                }
            },
            setConsumerConfig: (e)=>{
                t = e;
            }
        };
    }, Y = (e)=>e instanceof Date, q = (e)=>e instanceof Element || e instanceof Document, K = (e)=>0 === Object.keys(e).length, Q = (e)=>null != e && "object" == typeof e, J = (e, ...t)=>Object.prototype.hasOwnProperty.call(e, ...t), Z = (e)=>Q(e) && K(e), X = (e)=>(t)=>new Promise((r, n)=>{
                e(t, (e)=>{
                    r(e);
                }, (e)=>{
                    n(e);
                });
            }), ee = (e, t)=>{
        if (e === t) return {};
        if (!Q(e) || !Q(t) || q(e) || q(t)) return t;
        let r = Object.keys(e).reduce((e, r)=>(J(t, r) || (e[r] = void 0), e), {});
        return Y(e) || Y(t) ? e.valueOf() == t.valueOf() ? {} : t : Object.keys(t).reduce((r, n)=>{
            if (!J(e, n)) return r[n] = t[n], r;
            let i = ee(e[n], t[n]);
            return Z(i) && !Y(i) && (Z(e[n]) || !Z(t[n])) || (r[n] = i), r;
        }, r);
    }, et = (e)=>{
        let t = {
            ...e
        }, { configConsumerConstructor: r , setConsumerConfig: n  } = $(new z);
        return n(e), {
            getConfigField: (e)=>t[e],
            setConfig: (e, r, i = !1)=>{
                let s = Object.entries(e).reduce((e, [t, r])=>(e[t] = {
                        ...e[t],
                        ...r
                    }, e), {
                    ...t
                }), o = ee(t, s);
                t = s, Object.entries(o).forEach(([e, t])=>{
                    let n = G(e);
                    i ? r.publishSync(n, {
                        updatedValues: t,
                        newConfig: s
                    }) : r.publish(n, {
                        updatedValues: t,
                        newConfig: s
                    });
                }), n(t);
            },
            getConfig: ()=>t,
            resetConfig: ()=>{
                t = {
                    ...e
                };
            },
            ConfigConsumer: r
        };
    };
    function er(e, t, r) {
        if (!r || "function" != typeof r.value) throw TypeError(`Only methods can be decorated with @bind. <${t}> is not a method!`);
        return {
            configurable: !0,
            get () {
                let e = r.value?.bind(this);
                return Object.defineProperty(this, t, {
                    value: e,
                    configurable: !0,
                    writable: !0
                }), e;
            }
        };
    }
    function en(e, t, r, n) {
        var i, s = arguments.length, o = s < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) o = Reflect.decorate(e, t, r, n);
        else for(var a = e.length - 1; a >= 0; a--)(i = e[a]) && (o = (s < 3 ? i(o) : s > 3 ? i(t, r, o) : i(t, r)) || o);
        return s > 3 && o && Object.defineProperty(t, r, o), o;
    }
    (s = S || (S = {})).HLS = "hls", s.WEBRTC = "webrtc", s.NATIVE = "native", s.BROADCAST = "broadcast", (o = C || (C = {})).IDLE = "idle", o.LOADING = "loading", o.PAUSED = "paused", o.PLAYING = "playing", o.ERROR = "error", (a = T || (T = {})).WAITING = "waiting", a.AUTO = "auto", a.MANUAL = "manual", (l = A || (A = {})).BROADCAST_STATE_CHANGED = "commonEvents.broadcastStateChanged", l.BROADCAST_REMOTE_STATS_AVAILABLE = "commonEvents.broadcastRemoteStatsAvailable", l.PLAYING_STATE_CHANGED = "commonEvents.playingStateChanged", l.COMMON_ERROR = "commonEvents.commonError", new z, (w || (w = {})).LOG = "logger.log";
    let ei = (e, t, r)=>(n, i)=>{
            e.publish(w.LOG, {
                domain: t,
                timestamp: performance.now(),
                level: r,
                message: n,
                payload: i
            });
        }, es = (e, t)=>{
        let r = `${t}{${(Math.random() + 1).toString(36).substring(2, 6)}}`;
        return {
            debug: ei(e, r, "debug"),
            verbose: ei(e, r, "verbose"),
            info: ei(e, r, "info"),
            warn: ei(e, r, "warn"),
            error: ei(e, r, "error"),
            fatal: ei(e, r, "fatal")
        };
    }, eo = (...e)=>console.log(...e.filter((e)=>void 0 !== e)), ea = {
        debug: (e, t)=>eo(`%c${e}`, "color: rgb(102, 102, 102)", t),
        verbose: (e, t)=>eo(`%c${e}`, "color: rgb(36, 114, 200)", t),
        info: (e, t)=>eo(`%c${e}`, "color: rgb(13, 188, 121)", t),
        warn: (e, t)=>eo(`%c${e}`, "color: rgb(229, 229, 16)", t),
        error: (e, t)=>eo(`%c${e}`, "color: rgb(241, 76, 76)", t),
        fatal: (e, t)=>eo(`%c${e}`, "background: rgb(241, 76, 76); color: #fff", t)
    }, el = [], eu = class {
        constructor(e, t = el, r = [], n = [], i = !0){
            this._levels = t, this._eventBus = e, this._enableErrorAutoLog = i, this._onLogMessageReceivedToken = this._eventBus.subscribe(w.LOG, this._onMessageReceived), this._onErrorReceivedToken = this._eventBus.subscribe(A.COMMON_ERROR, this._onErrorReceived), this._ignoreDomains = n, this._additionalScopeSubscriptions = r.map((e)=>this._eventBus.subscribe(e, (t)=>{
                    this._onAdditionalScopeMessageReceived(e, t);
                })), this._appId = `${(Math.random() + 1).toString(36).substring(2, 6)}`;
        }
        destroy() {
            this._eventBus.unsubscribe(this._onLogMessageReceivedToken), this._eventBus.unsubscribe(this._onErrorReceivedToken), this._additionalScopeSubscriptions.forEach(this._eventBus.unsubscribe);
        }
        _onMessageReceived(e) {
            let { domain: t , timestamp: r , level: n , message: i , payload: s  } = e;
            !this._levels.includes(n) || this._ignoreDomains.includes(t) || (ea[n] || ea.info)(`(${this._appId}) :: [${t}] ${n.toUpperCase()}:
${i}@${r}`, s);
        }
        _onAdditionalScopeMessageReceived(e, t) {
            (0, ea.verbose)(`[${e}] Event receiver with payload ${t} @ ${performance.now()}`);
        }
        _onErrorReceived({ error: e  }) {
            this._enableErrorAutoLog && es(this._eventBus, "COMMON ERROR").error(`Error in ${e.domain}: ${e.message} ${e.info && " (" + e.info + ")"}`);
        }
    };
    en([
        er
    ], eu.prototype, "_onMessageReceived", null), en([
        er
    ], eu.prototype, "_onAdditionalScopeMessageReceived", null), en([
        er
    ], eu.prototype, "_onErrorReceived", null);
    let ec = {
        videoElementControllerConfig: {
            limitCheckingAutoplay: 5,
            minimalPossibleVideoDimension: 50,
            timeoutUpdateStatusPlaying: 2e3,
            timeoutUpdateVideoDuration: 500
        }
    }, { ConfigConsumer: eh , setConfig: ed , resetConfig: e_  } = et(ec);
    (u = P || (P = {})).NATIVE_EVENT = "videoElementController.nativeEvent", u.CLICK = "videoElementController.click", u.FORCE_PLAY_AFTER_PAUSE = "videoElementController.forcePlayAfterPause", u.VIDEO_START = "videoElementController.videoStart", u.VIDEO_PAUSE = "videoElementController.videoPause", u.VIDEO_RESET = "videoElementController.videoReset", u.PAUSED = "videoElementController.paused", u.PLAYING = "videoElementController.playing", u.LOADING = "videoElementController.loading", u.LOADED = "videoElementController.loaded", u.UPDATED = "videoElementController.updated", u.DESTROY = "videoElementController.destroy", u.STREAM_RESET = "videoElementController.streamReset", u.CAN_PLAY = "videoElementController.canPlay", u.REMOVE_MEDIA_STREAM = "videoElementController.removeMediaStream", u.ERROR = "videoElementController.error", u.ABORT = "videoElementController.abort", u.STALLED = "videoElementController.stalled", u.WAITING = "videoElementController.waiting", u.UPDATE_PLAYER_RESOLUTION = "videoElementController.updatePlayerResolution", u.RESET_CHECKING_AUTOPLAY_COUNT = "videoElementController.resetCheckingAutoplayCount", u.CANCEL_RESET_STREAM = "videoElementController.cancelResetStream", u.RESTART = "videoElementController.restart", u.TIME_UPDATE_NATIVE = "videoElementController.native", u.UPDATE_MEDIA_STREAM = "videoElementController.updateMediaStream", u.VIDEO_ELEMENT_RECREATED = "videoElementController.videoElementRecreated", u.VIDEO_PLAYBACK_STATE_CHANGED = "videoElementController.videoPlaybackStateChanged", u.SET_VOLUME = "videoElementController.setVolume";
    let ef = 0, ep = class {
        constructor(e){
            this._config = {}, this._eventsMap = {
                [P.CAN_PLAY]: this._checkAutoplayEnabled,
                [P.DESTROY]: this.destroy,
                [P.FORCE_PLAY_AFTER_PAUSE]: this._forcePlayAfterPause,
                [P.RESET_CHECKING_AUTOPLAY_COUNT]: this._resetCheckingAutoplayCount
            }, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - AutoplayController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._logger.debug("Initial state", this._state), this.init();
        }
        setConfig(e) {
            this._logger.debug("Config update received, the new one:", e), this._config = e;
        }
        destroy() {
            this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
        }
        init() {
            this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        _handleConfigUpdated() {}
        _forcePlayAfterPause(e) {
            if (void 0 !== this._config.autoplay && !this._config.autoplay) return void this._logger.verbose("Autoplay is disabled.");
            this._logger.verbose(`Trying to force video to play.
    Reason: ${e.reason}`);
            let t = this._state.getState();
            if (!t.startedPlaying || t.isPlaying || this._config.canBePaused) return void this._logger.verbose("Currently unable to autoplay the video");
            this._checkAutoplayEnabled();
        }
        _checkAutoplayEnabled() {
            if (this._logger.debug("Checking if autoplay is possible"), !this._state.getState().canPlay) return void this._logger.verbose("No canPlay event caught, skipping check");
            if (void 0 !== this._config.autoplay && !this._config.autoplay) return void this._logger.verbose("Autoplay is disabled.");
            if (ef > this._config.limitCheckingAutoplay) {
                this._logger.verbose(`Unable to autoplay the video. The limit of autoplay checking (${this._config.limitCheckingAutoplay}) is exceeded`), this._eventBus.publish(P.PAUSED, {});
                return;
            }
            ef += 1, this._logger.verbose("Autoplay is used to play the video"), this._eventBus.publish(P.VIDEO_START, {});
        }
        _resetCheckingAutoplayCount() {
            ef = 0;
        }
    };
    en([
        er
    ], ep.prototype, "destroy", null), en([
        er
    ], ep.prototype, "init", null), en([
        er
    ], ep.prototype, "_forcePlayAfterPause", null), en([
        er
    ], ep.prototype, "_checkAutoplayEnabled", null), en([
        er
    ], ep.prototype, "_resetCheckingAutoplayCount", null);
    let ev = class extends EventTarget {
        constructor(){
            super();
        }
        emitEvent(e, t) {
            this.dispatchEvent(new CustomEvent(e, {
                detail: t
            }));
        }
    }, eg = class extends ev {
        constructor(e){
            super(), this._eventsMap = {
                [P.PLAYING]: this._handlePlaying,
                [P.LOADING]: this._handleLoading,
                [P.VIDEO_PAUSE]: this._handlePause,
                [P.CLICK]: this._handleClick,
                [P.DESTROY]: this.destroy,
                [P.NATIVE_EVENT]: this._handleNativeEvent,
                [P.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
                [P.VIDEO_PLAYBACK_STATE_CHANGED]: this._handleVideoPlaybackStateChange,
                [P.TIME_UPDATE_NATIVE]: this._handleTimeUpdate
            }, this._eventBus = e.eventBus, this.init();
        }
        destroy() {
            this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
        }
        init() {
            this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        _handlePlaying(e) {
            this.emitEvent(E.PLAYING, e);
        }
        _handleLoading() {
            this.emitEvent(E.LOADING, {});
        }
        _handlePause() {
            this.emitEvent(E.PAUSE, {});
        }
        _handleClick(e) {
            this.emitEvent(E.CLICK, {
                originalEvent: e.originalEvent
            });
        }
        _handleNativeEvent(e) {
            this.emitEvent(E.NATIVE_EVENT, e);
        }
        _handleUpdatePlayerResolution(e) {
            this.emitEvent(E.UPDATE_PLAYER_RESOLUTION, e);
        }
        _handleTimeUpdate(e) {
            this.emitEvent(E.TIME_UPDATE, e);
        }
        _handleVideoPlaybackStateChange(e) {
            this.emitEvent(E.VIDEO_PLAYBACK_STATE_CHANGE, {
                prevState: e.prevState,
                nextState: e.nextState
            });
        }
    };
    en([
        er
    ], eg.prototype, "destroy", null), en([
        er
    ], eg.prototype, "init", null), en([
        er
    ], eg.prototype, "_handlePlaying", null), en([
        er
    ], eg.prototype, "_handleLoading", null), en([
        er
    ], eg.prototype, "_handlePause", null), en([
        er
    ], eg.prototype, "_handleClick", null), en([
        er
    ], eg.prototype, "_handleNativeEvent", null), en([
        er
    ], eg.prototype, "_handleUpdatePlayerResolution", null), en([
        er
    ], eg.prototype, "_handleTimeUpdate", null), en([
        er
    ], eg.prototype, "_handleVideoPlaybackStateChange", null);
    var em = {};
    em = function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t || 4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n = r(18);
            t.default = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), o = Math.max(i, s), a = 0, l = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = o - e.getVersionPrecision(t), n = t + Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (a = o - Math.min(i, s)), o -= 1; o >= a;){
                        if (l[0][o] > l[1][o]) return 1;
                        if (l[0][o] === l[1][o]) {
                            if (o === a) return 0;
                            o -= 1;
                        } else if (l[0][o] < l[1][o]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = arguments.length, i = Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(i));
                    for(t = 0, r = i.length; t < r; t += 1)!function() {
                        var r = i[t];
                        "object" == typeof r && null !== r && Object.keys(r).forEach(function(t) {
                            e[t] = r[t];
                        });
                    }();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }(), e.exports = t.default;
        },
        18: function(e, t, r) {
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            }, t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            }, t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            }, t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            }, t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            t.default = function() {
                function e() {}
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, function(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }(e, [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ]), e;
            }(), e.exports = t.default;
        },
        91: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n = l(r(92)), i = l(r(93)), s = l(r(94)), o = l(r(95)), a = l(r(17));
            function l(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.default = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = a.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = a.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = a.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = a.default.find(o.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return a.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var o = e[t];
                        "string" == typeof o ? (i[t] = o, s += 1) : "object" == typeof o && (r[t] = o, n += 1);
                    }), n > 0) {
                        var o = Object.keys(r), l = a.default.find(o, function(e) {
                            return t.isOS(e);
                        });
                        if (l) {
                            var u = this.satisfies(r[l]);
                            if (void 0 !== u) return u;
                        }
                        var c = a.default.find(o, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var h = this.satisfies(r[c]);
                            if (void 0 !== h) return h;
                        }
                    }
                    if (s > 0) {
                        var d = Object.keys(i), _ = a.default.find(d, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== _) return this.compareVersion(i[_]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = a.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(a.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }(), e.exports = t.default;
        },
        92: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = /version\/(\d+(\.?_?\d+)+)/i;
            t.default = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ], e.exports = t.default;
        },
        93: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            t.default = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ], e.exports = t.default;
        },
        94: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            t.default = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ], e.exports = t.default;
        },
        95: function(e, t, r) {
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            t.default = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ], e.exports = t.default;
        }
    });
    let ey = globalThis?.navigator?.userAgent ? ((c = em) && c.__esModule ? c.default : c).getParser(globalThis.navigator.userAgent) : null, eb = (e)=>!!ey && (ey.satisfies(e) || !1), eE = {
        safari15OrHigher: eb({
            safari: ">=15"
        }),
        firefox: eb({
            firefox: ">0"
        }),
        safari: eb({
            safari: ">0"
        }),
        chrome: eb({
            chrome: ">0"
        }),
        edge: eb({
            edge: ">0"
        })
    }, eS = new WeakMap, eC = {
        IDLE: 1,
        LOADING: 2
    }, eT = (e, t)=>{
        let r = 0 === e.readyState, n = e.networkState !== eC.LOADING && e.networkState !== eC.IDLE;
        if (eE.firefox && "play" === t && r && n) throw Error("Can not play audio");
    }, eA = (e, t)=>e instanceof HTMLMediaElement ? (eT(e, t), "function" == typeof t) ? t(e) : e[t]() : null, ew = (e, t)=>{
        let r = (eS.get(e) || Promise.resolve()).then(()=>{
            let r = eA(e, t);
            return r?.then ? Promise.resolve(r) : new Promise((e)=>{
                setTimeout(()=>{
                    e(r);
                }, 150);
            });
        }).then(()=>{
            eS.delete(e);
        }).catch((t)=>{
            throw eS.delete(e), t;
        });
        return eS.set(e, r), r;
    }, eP = class {
        constructor(e){
            this._eventsMap = {
                [P.VIDEO_START]: this._startVideo,
                [P.VIDEO_PAUSE]: this._pauseVideo,
                [P.VIDEO_RESET]: this._resetVideo,
                [P.RESTART]: this._restart,
                [P.DESTROY]: this._destroy
            }, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - PlaybackController"), this._logger.info("Created"), this._logger.debug("Initial state", this._state), this.init();
        }
        init() {
            this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        _startVideo() {
            let e = this._state.getState().videoElement;
            if (this._logger.verbose("Starting the video"), e) return e.playbackRate || (e.playbackRate = 1), this._logger.debug("Play call is added to the promises queue"), ew(e, "play").then(()=>{
                this._logger.debug("Play call resolved"), this._state.getState().canPlay && this._eventBus.publish(P.PLAYING, {});
            }).catch((e)=>{
                this._state.setState({
                    isAutoplayError: !0
                }), this._logger.error("An error occured when trying to play the video.", {
                    error: e
                }), this._state.getState().canPlay && this._eventBus.publish(P.PAUSED, {});
            });
        }
        _pauseVideo() {
            this._logger.debug("Pausing the video");
            let e = this._state.getState().videoElement;
            if (e) return this._logger.debug("Pause call is added to the promises queue"), ew(e, "pause").then(()=>{
                this._logger.debug("Pause call resolved");
            }).catch((e)=>{
                this._logger.warn("Could not pause video", e);
            });
        }
        _loadVideo() {
            this._logger.verbose("Loading the video");
            let e = this._state.getState().videoElement;
            return e?.src && e.src.startsWith("blob") ? void this._logger.debug("Stream seems to be blob. Skipping load") : e ? (this._logger.debug("Load call is added to the promises queue"), ew(e, "load").then(()=>{
                this._logger.debug("Load call resolved");
            }).catch((e)=>{
                this._logger.warn("Could not load video", e);
            })) : void 0;
        }
        _resetVideo() {
            this._logger.verbose("Resetting the video"), this._state.getState().videoElement && (this._eventBus.publish(P.LOADING, {}), this._loadVideo());
        }
        async _restart() {
            this._logger.verbose("Restarting the video"), await this._pauseVideo(), this._startVideo();
        }
        _destroy() {
            this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
        }
    };
    en([
        er
    ], eP.prototype, "init", null), en([
        er
    ], eP.prototype, "_startVideo", null), en([
        er
    ], eP.prototype, "_pauseVideo", null), en([
        er
    ], eP.prototype, "_loadVideo", null), en([
        er
    ], eP.prototype, "_resetVideo", null), en([
        er
    ], eP.prototype, "_restart", null), en([
        er
    ], eP.prototype, "_destroy", null);
    let eR = (e, t)=>{
        if (!t || t < 0) e.muted = !0, e.volume = 0;
        else {
            let r = Math.min(t, 1);
            isNaN(r) || (e.muted = !1, e.volume = r);
        }
    }, eI = (e)=>{
        e && e.parentNode && e.parentNode.removeChild(e);
    }, eO = `
  width: 100%;
`, eM = class {
        constructor(e){
            this._knownVideoElementStyles = "", this._eventsMap = {
                [P.PLAYING]: this.startAnimationFrame,
                [P.LOADING]: this.cancelAnimationFrame,
                [P.REMOVE_MEDIA_STREAM]: this.cancelAnimationFrame
            }, this._applyStyles = ()=>{
                this._logger.debug("Apply styles for canvas and video elements");
                let { canvasElement: e , videoElement: t  } = this._getElements();
                e && t && (this._knownVideoElementStyles = t.style.cssText, e.style.cssText = eO, t.style.cssText = `
      ${eO}
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
    `);
            }, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - CanvasVideoRenderer");
            let t = document.createElement("canvas");
            this._canvasContext = t.getContext("2d"), e.className && (t.className = e.className), this.init(), this._state.setState({
                canvasElement: t
            }), this._applyStyles(), this._logger.verbose("Canvas renderer has been created");
        }
        startAnimationFrame() {
            let { canvasElement: e , videoElement: t  } = this._getElements();
            if (this.cancelAnimationFrame(), !e || !t) return;
            let { width: r , height: n  } = e.getBoundingClientRect(), { videoWidth: i , videoHeight: s  } = t;
            if (r / n < 1 && i / s > 1) {
                let o = Math.max(r, i), a = r / i * s;
                if (this._canvasContext) {
                    let t = devicePixelRatio;
                    e.width = o * t, e.height = n * t, this._canvasContext.scale(t, t);
                }
                this._canvasContext?.drawImage(t, r > o ? (r - o) / 2 : 0, (n - a) / 2, o, a);
            } else {
                let o = Math.max(n, s), a = n / s * i;
                if (this._canvasContext) {
                    let t = devicePixelRatio;
                    e.width = r * t, e.height = o * t, this._canvasContext.scale(t, t);
                }
                this._canvasContext?.drawImage(t, (r - a) / 2, n > o ? (n - o) / 2 : 0, a, o);
            }
            this._state.getState().isLoading || (this._canvasAnimationFrameId = requestAnimationFrame(this.startAnimationFrame));
        }
        getCanvasElement() {
            return this._getElements().canvasElement;
        }
        destroy() {
            this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
            let { canvasElement: e , videoElement: t  } = this._getElements();
            e && e.parentNode && e.parentNode.removeChild(e), t && (t.style.cssText = this._knownVideoElementStyles, this._knownVideoElementStyles = ""), this._state.setState({
                canvasElement: null
            }), this._logger.verbose("Canvas renderer was destroyed");
        }
        init() {
            this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        cancelAnimationFrame() {
            this._canvasAnimationFrameId && (cancelAnimationFrame(this._canvasAnimationFrameId), this._canvasAnimationFrameId = null);
        }
        _getElements() {
            let { videoElement: e , canvasElement: t  } = this._state.getState();
            return {
                videoElement: e,
                canvasElement: t
            };
        }
    };
    en([
        er
    ], eM.prototype, "startAnimationFrame", null), en([
        er
    ], eM.prototype, "destroy", null), en([
        er
    ], eM.prototype, "init", null), en([
        er
    ], eM.prototype, "cancelAnimationFrame", null), en([
        er
    ], eM.prototype, "_getElements", null);
    let eL = class {
        constructor(e){
            this._canvasVideoRenderer = null, this._config = {}, this._isLocalVideo = !1, this._eventsMap = {
                [P.SET_VOLUME]: this._setVolume,
                [P.DESTROY]: this._destroy
            }, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - RenderController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._logger.debug("Initial state", this._state), this.init();
        }
        setConfig(e) {
            this._logger.debug("Config update received, the new one:", e), this._config = e, this.applyConfigToVideoElement();
        }
        init() {
            this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        getElements() {
            let { videoElement: e , canvasElement: t , ownContainer: r  } = this._state.getState();
            return {
                videoElement: e,
                canvasElement: t,
                ownContainer: r
            };
        }
        getVideoElement() {
            return this.getElements().videoElement;
        }
        getCanvasElement() {
            return this.getElements().canvasElement;
        }
        renderVideoInto(e) {
            let { ownContainer: t , videoElement: r  } = this.getElements();
            this._logger.debug("renderVideoInto method was called");
            let n = !1;
            if (e && r) {
                let i = t || e;
                r.parentElement !== i && (n = !0, i.appendChild(r));
                let s = this._canvasVideoRenderer?.getCanvasElement();
                this._canvasVideoRenderer && s?.parentElement !== i && (n = !0, i.appendChild(s), this._logger.info("Canvas element has been rendered to DOM")), i === t && t.parentElement !== e && (n = !0, e.appendChild(t)), n ? this._logger.info("Video element has been rendered to DOM") : this._logger.verbose("Skipping video element render: video element is already mounted to the DOM.");
            }
        }
        setVideoElement(e, t) {
            if (this._logger.debug("Video element updated", {
                videoElement: e
            }), e === this.getVideoElement()) return void this._logger.verbose("Received video element is equal to the previous one. Skipping");
            this._isLocalVideo && (this._logger.verbose("Removing video element and container from document"), eI(this.getElements().videoElement), eI(this.getElements().ownContainer)), this._state.setState({
                videoElement: e,
                ownContainer: t
            }), this.applyConfigToVideoElement();
        }
        applyConfigToVideoElement() {
            if (this._logger.debug("Applying config to the video element"), !this.getVideoElement()) return void this._logger.verbose("No video element known, could not apply config");
            let e = this.getVideoElement();
            if (!e) return;
            let { isNonAnonymous: t , isMuted: r , nativeControls: n , videoElementClassName: i , canvasElementClassName: s , shouldUseCanvas: o , rootElement: a , autoplay: l  } = this._config;
            this._logger.verbose("Applied config", this._config), l && (e.autoplay = !0), e.playsInline = !0, void 0 !== n && (e.controls = !!n), void 0 !== r && (e.muted = !!r), void 0 !== t && (t ? e.removeAttribute("crossOrigin") : e.crossOrigin = "anonymous"), i && (e.className = i);
            let u = [
                this._state.getState().volume,
                this._config.volume
            ].find((e)=>void 0 !== e);
            if (void 0 !== u && this._setVolume({
                volume: u
            }), o && !this._canvasVideoRenderer && (this._logger.verbose("Adding canvas as requested"), this._addCanvasVideoRenderer(), this._state.getState().isPlaying && this._canvasVideoRenderer.startAnimationFrame()), !o && this._canvasVideoRenderer) {
                let e = this._state.getState().stream;
                this._logger.verbose("Removing canvas renderer"), e && this._eventBus.publish(P.UPDATE_MEDIA_STREAM, e), this._destroyCanvasRenderer();
            }
            let c = this.getCanvasElement();
            c && (e.className = "", s && (c.className = s)), a && this.renderVideoInto(a);
        }
        destroy() {
            if (this._logger.info("Destroying"), this._destroyCanvasRenderer(), this._isLocalVideo) {
                this._logger.debug("Removing video element and container from document in destroy");
                let { videoElement: e , ownContainer: t  } = this.getElements();
                eI(e), eI(t);
            }
        }
        createVideoElement() {
            let e, t;
            this._logger.info("Creating video element"), this._config.videoElement ? (this._logger.debug("External video element passed from config - using existing one", this._config.videoElement), this._isLocalVideo = !1, e = this._config.videoElement) : (this._isLocalVideo = !0, e = document.createElement("video"), t = document.createElement("div"), this._logger.debug("No external video element provided in config - created the new one", {
                videoElement: e,
                ownContainer: t
            }), t.style.position = "relative"), this.setVideoElement(e, t), this._eventBus.publish(P.VIDEO_ELEMENT_RECREATED, {
                videoElement: this.getVideoElement()
            });
        }
        _addCanvasVideoRenderer() {
            this._logger.debug("Adding canvas renderer"), this._canvasVideoRenderer || (this._canvasVideoRenderer = new eM({
                videoElement: this.getVideoElement(),
                className: this._config.videoElementClassName,
                state: this._state,
                eventBus: this._eventBus
            }));
        }
        _destroyCanvasRenderer() {
            this._logger.debug("Destroying canvas renderer"), this._canvasVideoRenderer && (this._canvasVideoRenderer.destroy(), this._canvasVideoRenderer = null);
        }
        _setVolume({ volume: e  }) {
            let t = this.getVideoElement();
            t && (eR(t, e), this._logger.verbose(`Video volume level has been set to ${e}`));
        }
        _destroy() {
            this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
        }
    };
    en([
        er
    ], eL.prototype, "getElements", null), en([
        er
    ], eL.prototype, "getVideoElement", null), en([
        er
    ], eL.prototype, "getCanvasElement", null), en([
        er
    ], eL.prototype, "renderVideoInto", null), en([
        er
    ], eL.prototype, "setVideoElement", null), en([
        er
    ], eL.prototype, "applyConfigToVideoElement", null), en([
        er
    ], eL.prototype, "createVideoElement", null), en([
        er
    ], eL.prototype, "_addCanvasVideoRenderer", null), en([
        er
    ], eL.prototype, "_destroyCanvasRenderer", null), en([
        er
    ], eL.prototype, "_setVolume", null), en([
        er
    ], eL.prototype, "_destroy", null);
    let eD = class {
        constructor(e){
            this._config = {}, this._eventsMap = {
                [P.PLAYING]: this._handlePlaying,
                [P.LOADING]: this._handleLoading,
                [P.VIDEO_PAUSE]: this._handlePause,
                [P.CAN_PLAY]: this._handleCanPlay,
                [P.PAUSED]: this._handlePaused,
                [P.RESTART]: this._handleRestart,
                [P.UPDATED]: this._handleUpdate,
                [P.STALLED]: this._handleStalled,
                [P.WAITING]: this._handleWaiting,
                [P.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
                [P.ERROR]: this._handleError,
                [P.SET_VOLUME]: this._handleSetVolume,
                [P.DESTROY]: this.destroy
            }, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - StateController"), this._logger.info("Created"), this._logger.verbose("Initial state", e.state), this.init();
        }
        setConfig(e) {
            this._logger.debug("Config update received, the new one:", e), this._config = e;
        }
        destroy() {
            this._logger.info("Destroy"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            }), this._state.resetState(), this._state.setState({
                isDestroyed: !0
            });
        }
        init() {
            this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        _updateState(e) {
            let t = this._state.getState().videoPlaybackState, r = t;
            e.isPlaying ? r = C.PLAYING : e.isLoading ? r = C.LOADING : e.isPaused ? r = C.PAUSED : e.isError && (r = C.ERROR), this._logger.debug(`State updated: ${t} -> ${r}`), this._state.setState({
                ...e,
                videoPlaybackState: r
            }), t !== r && this._eventBus.publish(P.VIDEO_PLAYBACK_STATE_CHANGED, {
                prevState: t,
                nextState: r
            });
        }
        _handlePlaying() {
            this._logger.debug("Playing event received"), this._updateState({
                isPlaying: !0,
                startedPlaying: !0,
                isLoading: !1,
                isStalled: !1,
                isWaiting: !1,
                isPaused: !1,
                isError: !1
            });
        }
        _handleLoading() {
            this._logger.debug("Loading event received"), this._updateState({
                isLoading: !0,
                isPlaying: !1
            });
        }
        _handlePause() {
            this._logger.debug("Pause event received"), this._updateState({
                isPlaying: !1,
                isPaused: !0
            });
        }
        _handlePaused() {
            this._logger.debug("Paused event received"), this._updateState({
                isPlaying: !1,
                isLoading: !1,
                isPaused: !0
            });
        }
        _handleCanPlay() {
            this._logger.debug("CanPlay event received"), this._updateState({
                canPlay: !0,
                isDestroyed: !1
            });
        }
        _handleRestart() {
            this._logger.debug("Restart event received"), this._updateState({
                isRestarted: !0
            });
        }
        _handleStalled() {
            this._logger.debug("Stalled event received"), this._updateState({
                isStalled: !0
            });
        }
        _handleWaiting() {
            this._logger.debug("Waiting event received"), this._updateState({
                isWaiting: !0
            });
        }
        _handleError() {
            this._logger.debug("Error event received"), this._updateState({
                isError: !0
            });
        }
        _handleSetVolume({ volume: e  }) {
            this._logger.debug("Volume event received", {
                volume: e
            }), this._updateState({
                volume: e
            });
        }
        _handleUpdatePlayerResolution(e) {
            this._logger.debug("Player resolution event received", {
                height: e.height,
                width: e.width
            }), this._updateState({
                videoElementResolution: {
                    height: e.height,
                    width: e.width
                }
            });
        }
        _handleUpdate() {
            this._logger.debug("Update event received"), this._updateState({
                canPlay: !1,
                isLoading: !0,
                isPlaying: !1,
                isRestarted: !1,
                isPaused: !1,
                isError: !1
            });
        }
    };
    en([
        er
    ], eD.prototype, "destroy", null), en([
        er
    ], eD.prototype, "init", null), en([
        er
    ], eD.prototype, "_updateState", null), en([
        er
    ], eD.prototype, "_handlePlaying", null), en([
        er
    ], eD.prototype, "_handleLoading", null), en([
        er
    ], eD.prototype, "_handlePause", null), en([
        er
    ], eD.prototype, "_handlePaused", null), en([
        er
    ], eD.prototype, "_handleCanPlay", null), en([
        er
    ], eD.prototype, "_handleRestart", null), en([
        er
    ], eD.prototype, "_handleStalled", null), en([
        er
    ], eD.prototype, "_handleWaiting", null), en([
        er
    ], eD.prototype, "_handleError", null), en([
        er
    ], eD.prototype, "_handleSetVolume", null), en([
        er
    ], eD.prototype, "_handleUpdatePlayerResolution", null), en([
        er
    ], eD.prototype, "_handleUpdate", null);
    let ek = class {
        constructor(e){
            this._config = {}, this._eventsMap = {
                [P.PLAYING]: this._cancelResetStream,
                [P.LOADING]: this._cancelResetStream,
                [P.LOADED]: this._cancelResetStream,
                [P.PAUSED]: this._cancelResetStream,
                [P.UPDATED]: this._cancelResetStream,
                [P.CANCEL_RESET_STREAM]: this._cancelResetStream,
                [P.STREAM_RESET]: this._resetStream,
                [P.UPDATE_MEDIA_STREAM]: this.updateMediaStream,
                [P.DESTROY]: this.destroy
            }, this._getIsSrcObjectAvailable = ()=>this._props.getVideoElement()?.srcObject !== void 0, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - StreamController"), this._props = e, this._logger.info("Created"), this._logger.verbose("Initial state", e.state), this.init();
        }
        setConfig(e) {
            this._logger.debug("Config update received, the new one:", e), this._config = e;
        }
        updateMediaStream(e) {
            if (this._logger.info("Updating media stream", {
                stream: e
            }), !this._props.getVideoElement()) return void this._logger.debug("No video element known. Skipping media stream update");
            this._attachStream(e), this._eventBus.publish(P.VIDEO_START, {});
        }
        removeMediaStream() {
            this._logger.info("Removing media stream");
            let e = this._props.getVideoElement();
            if (!e) return void this._logger.debug("No video element known. Skipping media stream remove");
            this._eventBus.publish(P.VIDEO_PAUSE, {}), this._eventBus.publish(P.REMOVE_MEDIA_STREAM, {}), this._getIsSrcObjectAvailable() ? (this._logger.debug("Setting srcObject to null"), e.srcObject = null) : (this._logger.debug("Revoking object url", {
                url: e.src
            }), window.URL.revokeObjectURL(e.src)), e.src && (this._logger.debug("Removing src attribute from video"), e.removeAttribute("src"));
        }
        destroy() {
            this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
        }
        init() {
            this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        _attachStream(e) {
            this._logger.info("Attaching media stream", {
                stream: e
            });
            let t = this._props.getVideoElement();
            return t && e ? t.src === e ? void this._logger.debug("Current video element src attribute value is equal to the new stream. Skipping stream set") : void ("string" == typeof e ? (this._logger.debug("Setting video element src attribute"), t.src = e) : this._getIsSrcObjectAvailable() ? (this._logger.debug("Setting video element srcObject attribute"), t.srcObject = e) : (t.src = window.URL.createObjectURL(e), this._logger.debug(`Got MediaStream as stream, but srcObject is not available. Created new object URL: ${t.src}`))) : void this._logger.debug("No video element or stream defined. Skipping stream set");
        }
        _cancelResetStream() {
            this._logger.debug("Stream reset action cancel required"), this._streamResetDelayId && (clearTimeout(this._streamResetDelayId), this._logger.debug("Stream reset action cancelled"));
        }
        _resetStream({ timeout: e  }) {
            if (this._logger.debug("Reset stream required"), !e) return void this._logger.verbose("No timeout set, skipping stream reset", {
                timeout: e
            });
            this._cancelResetStream(), this._streamResetDelayId = setTimeout(()=>{
                this._logger.debug("Resetting stream timeout fired");
                let e = !1;
                this._config.onResetStream && (e = this._config.onResetStream());
                let t = this._state.getState().stream;
                if (t && !e) {
                    if ("string" == typeof t && t.startsWith("blob")) return void this._logger.debug("Streams seems to be object url. Skipping reset");
                    this._logger.debug("Resetting stream"), this.removeMediaStream(), this.updateMediaStream(t);
                }
            }, e);
        }
    };
    en([
        er
    ], ek.prototype, "updateMediaStream", null), en([
        er
    ], ek.prototype, "removeMediaStream", null), en([
        er
    ], ek.prototype, "destroy", null), en([
        er
    ], ek.prototype, "init", null), en([
        er
    ], ek.prototype, "_attachStream", null), en([
        er
    ], ek.prototype, "_cancelResetStream", null), en([
        er
    ], ek.prototype, "_resetStream", null);
    var eN = function(e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
    }, ex = x("iCUkT"), eB = function() {
        return ex.default.Date.now();
    }, eV = /\s/, eU = function(e) {
        for(var t = e.length; t-- && eV.test(e.charAt(t)););
        return t;
    }, ej = /^\s+/, ex = x("iCUkT"), eF = ex.default.Symbol, eW = Object.prototype, eH = eW.hasOwnProperty, ez = eW.toString, eG = eF ? eF.toStringTag : void 0, e$ = function(e) {
        var t = eH.call(e, eG), r = e[eG];
        try {
            e[eG] = void 0;
            var n = !0;
        } catch (e) {}
        var i = ez.call(e);
        return n && (t ? e[eG] = r : delete e[eG]), i;
    }, eY = Object.prototype.toString, eq = eF ? eF.toStringTag : void 0, eK = function(e) {
        return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : eq && eq in Object(e) ? e$(e) : eY.call(e);
    }, eQ = function(e) {
        return null != e && "object" == typeof e;
    }, eJ = 0 / 0, eZ = /^[-+]0x[0-9a-f]+$/i, eX = /^0b[01]+$/i, e0 = /^0o[0-7]+$/i, e1 = parseInt, e2 = function(e) {
        if ("number" == typeof e) return e;
        if ("symbol" == typeof (t = e) || eQ(t) && "[object Symbol]" == eK(t)) return eJ;
        if (eN(e)) {
            var t, r, n = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = eN(n) ? n + "" : n;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = (r = e) ? r.slice(0, eU(r) + 1).replace(ej, "") : r;
        var i = eX.test(e);
        return i || e0.test(e) ? e1(e.slice(2), i ? 2 : 8) : eZ.test(e) ? eJ : +e;
    }, e3 = Math.max, e4 = Math.min, e6 = function(e, t, r) {
        var n, i, s, o, a, l, u = 0, c = !1, h = !1, d = !0;
        if ("function" != typeof e) throw TypeError("Expected a function");
        function _(t) {
            var r = n, s = i;
            return n = i = void 0, u = t, o = e.apply(s, r);
        }
        function f(e) {
            var r = e - l, n = e - u;
            return void 0 === l || r >= t || r < 0 || h && n >= s;
        }
        function p() {
            var e, r, n, i = eB();
            if (f(i)) return v(i);
            a = setTimeout(p, (e = i - l, r = i - u, n = t - e, h ? e4(n, s - r) : n));
        }
        function v(e) {
            return (a = void 0, d && n) ? _(e) : (n = i = void 0, o);
        }
        function g() {
            var e, r = eB(), s = f(r);
            if (n = arguments, i = this, l = r, s) {
                if (void 0 === a) return u = e = l, a = setTimeout(p, t), c ? _(e) : o;
                if (h) return clearTimeout(a), a = setTimeout(p, t), _(l);
            }
            return void 0 === a && (a = setTimeout(p, t)), o;
        }
        return t = e2(t) || 0, eN(r) && (c = !!r.leading, s = (h = "maxWait" in r) ? e3(e2(r.maxWait) || 0, t) : s, d = "trailing" in r ? !!r.trailing : d), g.cancel = function() {
            void 0 !== a && clearTimeout(a), u = 0, n = l = i = a = void 0;
        }, g.flush = function() {
            return void 0 === a ? o : v(eB());
        }, g;
    }, e5 = function(e, t, r) {
        var n = !0, i = !0;
        if ("function" != typeof e) throw TypeError("Expected a function");
        return eN(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), e6(e, t, {
            leading: n,
            maxWait: t,
            trailing: i
        });
    };
    let e8 = "ristrettoWasRestarted", e9 = 0, e7 = 0, te = class {
        constructor(e){
            this._shouldSetNextUpdateVideoDurationId = !0, this._config = {}, this._onNativeTimeUpdateHandlerThrottled = e5(this._onNativeTimeUpdateHandler, 2e3, {
                trailing: !1
            }), this._eventsMap = {
                [P.TIME_UPDATE_NATIVE]: this._onNativeTimeUpdateHandlerThrottled,
                [P.DESTROY]: this._destroy
            }, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - TimeUpdateController"), this._props = e, this._logger.info("Created"), this._logger.debug("Initial state", e.state), this._logger.debug("Initial props", e);
        }
        setConfig(e) {
            this._logger.debug("Config update received, the new one:", e);
            let t = e.timeoutUpdateStatusPlaying !== this._config.timeoutUpdateStatusPlaying;
            this._config = e, t && (this._eventsMap[P.TIME_UPDATE_NATIVE] = e5(this._onNativeTimeUpdateHandler, e.timeoutUpdateStatusPlaying, {
                trailing: !1
            }), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            }), this.init());
        }
        init() {
            this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        startTimeUpdate() {
            if (this._stopTimeUpdate(), !this._shouldSetNextUpdateVideoDurationId || !this._config) {
                this._shouldSetNextUpdateVideoDurationId = !0;
                return;
            }
            this._updateVideoDurationId = setTimeout(this._onTimeUpdate, this._config.timeoutUpdateVideoDuration), this._publishUpdatePlayerResolutionIfNeeded();
        }
        _onNativeTimeUpdateHandler(e) {
            if (this._logger.debug("Native video timeUpdate caught"), e?.originalEvent?.defaultPrevented) return;
            let t = this._props.getVideoElement(), { canPlay: r , isPlaying: n , isLoading: i , isRestarted: s  } = this._state.getState();
            if (this._publishUpdatePlayerResolutionIfNeeded(), !r) return void this._logger.verbose("CanPlay shared state is false. Skipping");
            this._eventBus.publish(P.RESET_CHECKING_AUTOPLAY_COUNT, {});
            let o = e9 !== t?.currentTime;
            this._logger.verbose(`Video current time is ${o ? "" : "not"} changed`), o ? (this._eventBus.publish(P.CANCEL_RESET_STREAM, {}), !eE.safari15OrHigher || s || localStorage?.getItem(e8) || (localStorage.setItem(e8, "1"), this._eventBus.publish(P.RESTART, {})), t && (e9 = t.currentTime), (!n || i) && this._eventBus.publish(P.PLAYING, {})) : i ? this._eventBus.publish(P.VIDEO_RESET, {}) : this._eventBus.publish(P.LOADING, {});
        }
        _stopTimeUpdate() {
            clearTimeout(this._updateVideoDurationId);
        }
        _onTimeUpdate() {
            if (!this._state.getState().canPlay) return void this.startTimeUpdate();
            let e = this._props.getVideoElement();
            e && e7 !== e.currentTime && (e7 = e.currentTime), this.startTimeUpdate();
        }
        _publishUpdatePlayerResolutionIfNeeded() {
            let e = this._props.getVideoElement();
            if (e) {
                let { videoWidth: t , videoHeight: r  } = e, { videoElementResolution: n  } = this._state.getState();
                (!n || n.height !== r || n.width !== t) && this._config.minimalPossibleVideoDimension && Math.min(r, t) > this._config.minimalPossibleVideoDimension && (this._logger.verbose(`Stored resolution is ${n?.width}x${n?.height}, current is ${t}x${r}`), this._eventBus.publish(P.UPDATE_PLAYER_RESOLUTION, {
                    width: t,
                    height: r
                }));
            }
        }
        _destroy() {
            this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            }), this._shouldSetNextUpdateVideoDurationId = !1, this._stopTimeUpdate();
        }
    };
    en([
        er
    ], te.prototype, "init", null), en([
        er
    ], te.prototype, "startTimeUpdate", null), en([
        er
    ], te.prototype, "_onNativeTimeUpdateHandler", null), en([
        er
    ], te.prototype, "_stopTimeUpdate", null), en([
        er
    ], te.prototype, "_onTimeUpdate", null), en([
        er
    ], te.prototype, "_publishUpdatePlayerResolutionIfNeeded", null), en([
        er
    ], te.prototype, "_destroy", null);
    let tt = class {
        constructor(e){
            this._config = {}, this._timeUpdateEventWasLogged = !1, this._eventsMap = {
                [P.VIDEO_ELEMENT_RECREATED]: this._handleVideoElementRecreated,
                [P.DESTROY]: this._handleDestroy
            }, this._onVideoClick = (e)=>{
                this._logger.verbose('"click" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish(P.CLICK, {
                    originalEvent: e
                });
            }, this._onSeeked = (e)=>{
                this._logger.verbose('"seeked" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish(P.FORCE_PLAY_AFTER_PAUSE, {
                    reason: "seeked video native event"
                });
            }, this._onRateChange = (e)=>{
                this._logger.verbose('"ratechange" video native event fired'), this._handleNativeEvent(e), e.target && !e.target.playbackRate && this._eventBus.publish(P.FORCE_PLAY_AFTER_PAUSE, {
                    reason: "video playbackRate is 0"
                });
            }, this._onCanPlayThrough = (e)=>{
                this._logger.verbose('"canplaythrough" video native event fired');
                let t = this._state.getState();
                this._handleNativeEvent(e), (t.isStalled || t.isWaiting) && this._eventBus.publish(P.FORCE_PLAY_AFTER_PAUSE, {
                    reason: "canplaythrough video native event fired, and video is in the state of either stalled or waiting"
                });
            }, this._onPlayingHandler = (e)=>{
                this._logger.verbose('"playing" video native event fired'), this._logger.info("Video has started playing"), this._handleNativeEvent(e), this._eventBus.publish(P.PLAYING, {
                    isAutoplay: !this._state.getState().isAutoplayError
                });
            }, this._onAbortHandler = (e)=>{
                this._logger.verbose('"abort" video native event fired'), this._handleNativeEvent(e), e.defaultPrevented || this._eventBus.publish(P.LOADING, {});
            }, this._onPauseHandler = (e)=>{
                this._logger.verbose('"pause" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish(P.VIDEO_PAUSE, {}), this._eventBus.publish(P.FORCE_PLAY_AFTER_PAUSE, {
                    reason: "pause video event fired (most likely user paused the video manually)"
                });
            }, this._onCanPlayHandler = (e)=>{
                this._logger.verbose('"canplay" video native event fired'), this._handleNativeEvent(e), e.defaultPrevented || (this._state.setState({
                    canPlay: !0
                }), this._eventBus.publish(P.CAN_PLAY, {}));
            }, this._onErrorHandler = (e)=>{
                if (this._logger.error('"error" video native event fired', {
                    error: e
                }), this._handleNativeEvent(e), this._eventBus.publish(P.ERROR, {
                    originalEvent: e
                }), !e.defaultPrevented) {
                    let { MEDIA_ERR_SRC_NOT_SUPPORTED: e  } = MediaError, t = this._props.getVideoElement()?.error;
                    t?.code !== e && (this._logger.verbose("Video element error is not of MEDIA_ERR_SRC_NOT_SUPPORTED kind. Requesting reset"), this._eventBus.publish(P.VIDEO_RESET, {}));
                }
            }, this._onTimeUpdateHandler = (e)=>{
                this._handleNativeEvent(e), this._timeUpdateEventWasLogged || (this._logger.verbose('"timeupdate" video native event fired for the first time'), this._timeUpdateEventWasLogged = !0), this._eventBus.publishSync(P.TIME_UPDATE_NATIVE, {
                    originalEvent: e
                });
            }, this._onLoadStartHandler = (e)=>{
                this._handleNativeEvent(e), this._logger.verbose('"loadstart" video native event fired');
                let { timeoutUpdateStream: t  } = this._config;
                this._eventBus.publish(P.LOADING, {}), this._eventBus.publish(P.STREAM_RESET, {
                    reason: "onLoadStartHandler",
                    timeout: t
                });
            }, this._onLoadedDataHandler = (e)=>{
                this._logger.verbose('"loadeddata" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish(P.LOADED, {});
            }, this._onWaiting = (e)=>{
                this._logger.verbose('"waiting" video native event fired');
                let { timeoutWaitingStream: t  } = this._config;
                this._handleNativeEvent(e), this._eventBus.publish(P.WAITING, {}), this._eventBus.publish(P.LOADING, {}), this._eventBus.publish(P.STREAM_RESET, {
                    reason: "onWaiting",
                    timeout: t
                });
            }, this._onStalled = (e)=>{
                this._logger.verbose('"stalled" video native event fired');
                let { timeoutWaitingStream: t  } = this._config;
                this._handleNativeEvent(e), this._eventBus.publish(P.STALLED, {}), this._eventBus.publish(P.STREAM_RESET, {
                    reason: "onStalled",
                    timeout: t
                });
            }, this._onEndFullscreenHandler = (e)=>{
                this._handleNativeEvent(e);
            }, this._props = e, this._state = e.state, this._eventBus = e.eventBus, this._logger = es(this._eventBus, "VideoElementController - VideoEventsHandler"), this.init();
        }
        setConfig(e) {
            this._config = e;
        }
        init() {
            this._eventBus.toggleSubscriptionBulk({
                action: "subscribe",
                callbacks: this._eventsMap
            });
        }
        toggleEvents(e, t) {
            let r = t || this._props.getVideoElement();
            if (!r) return;
            let n = "attach" === e ? "addEventListener" : "removeEventListener";
            r[n]("click", this._onVideoClick), r[n]("playing", this._onPlayingHandler), r[n]("abort", this._onAbortHandler), r[n]("pause", this._onPauseHandler), r[n]("canplay", this._onCanPlayHandler), r[n]("error", this._onErrorHandler), r[n]("timeupdate", this._onTimeUpdateHandler), r[n]("loadstart", this._onLoadStartHandler), r[n]("loadeddata", this._onLoadedDataHandler), r[n]("waiting", this._onWaiting), r[n]("stalled", this._onStalled), r[n]("canplaythrough", this._onCanPlayThrough), r[n]("seeked", this._onSeeked), r[n]("ratechange", this._onRateChange), r[n]("webkitendfullscreen", this._onEndFullscreenHandler), "addEventListener" === n ? this._logger.verbose("event listeners are ATTACHED to the video element") : this._logger.verbose("event listeners are DETACHED from the video element");
        }
        _handleVideoElementRecreated() {
            this.toggleEvents("attach");
        }
        _handleDestroy() {
            this.toggleEvents("detach"), this._eventBus.toggleSubscriptionBulk({
                action: "unsubscribe",
                callbacks: this._eventsMap
            });
        }
        _handleNativeEvent(e) {
            this._eventBus.publishSync(P.NATIVE_EVENT, {
                eventName: e.type,
                event: e
            });
        }
    };
    en([
        er
    ], tt.prototype, "init", null), en([
        er
    ], tt.prototype, "_handleVideoElementRecreated", null), en([
        er
    ], tt.prototype, "_handleDestroy", null);
    let tr = {
        canPlay: !1,
        isLoading: !0,
        isError: !1,
        isAutoplayError: !1,
        isPaused: !1,
        isPlaying: !1,
        isRestarted: !1,
        isStalled: !1,
        isWaiting: !1,
        isDestroyed: !1,
        videoPlaybackState: C.IDLE,
        startedPlaying: !1
    }, tn = class {
        constructor(e){
            this._initState = {
                ...e
            }, this._state = {
                ...e
            };
        }
        setState(e, t) {
            Object.assign(this._state, e), t && t(this._state);
        }
        getState() {
            return this._state;
        }
        resetState() {
            this.setState(this._initState);
        }
    }, ti = class {
        constructor(){
            this._config = {
                ...ec.videoElementControllerConfig
            }, this.attachVideoElementEvents = ()=>{
                this._logger.debug("Attach event listeners"), this._eventsHandler.toggleEvents("attach"), this._timeUpdateController.startTimeUpdate();
            }, this.detachVideoElementEvents = (e)=>{
                this._logger.debug("Detach event listeners"), this._eventsHandler.toggleEvents("detach", e);
            }, this._updated = ()=>{
                this._eventBus.publish(P.UPDATED, {});
            }, this._eventBus = new z, this._loggerTransport = new eu(this._eventBus), this._logger = es(this._eventBus, "VideoController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._createControllers();
        }
        addEventListener(e, t) {
            this._logger.verbose(`Attaching ${e} event listener`), this._customEventsEmitter.addEventListener(e, t);
        }
        removeEventListener(e, t) {
            this._logger.verbose(`Detaching ${e} event listener`), this._customEventsEmitter.removeEventListener(e, t);
        }
        getIsPlaying() {
            return this._state.getState().isPlaying;
        }
        getVideoElement() {
            return this._state.getState().videoElement;
        }
        getCanvasElement() {
            return this._state.getState().canvasElement;
        }
        updateConfig(e) {
            this._config = {
                ...this._config,
                ...e
            }, this._logger.debug("Config update received, the new one: ", this._config), e.isRemote && this.attachVideoElementEvents(), this._syncConfig();
        }
        setVideoElement(e) {
            let t = this._state.getState().videoElement;
            e !== t && (t && this.detachVideoElementEvents(t), this._logger.info("Video element set", {
                videoElement: e
            }), this._renderController.setVideoElement(e), this.attachVideoElementEvents());
        }
        createVideoElement() {
            return this._logger.info("Creating video element"), this._renderController.createVideoElement(), this.getVideoElement();
        }
        setStream(e) {
            return (this._logger.info("Setting media stream"), this._state.getState().stream === e) ? void this._logger.verbose("Previous stream is equal to the new one. Skipping.") : (e ? this._streamController.updateMediaStream(e) : this._streamController.removeMediaStream(), this._updated(), this._state.setState({
                stream: e
            }), this);
        }
        renderVideoInto(e) {
            this._logger.info("Rendering video element into container", e), this._renderController.renderVideoInto(e);
        }
        setVolume(e) {
            this._logger.info("Setting volume of the video element", {
                volume: e
            }), this._eventBus.publish(P.SET_VOLUME, {
                volume: e
            });
        }
        getState() {
            return this._state.getState();
        }
        destroy() {
            this._logger.info("Destroying"), this._config = {
                ...ec.videoElementControllerConfig
            }, this.detachVideoElementEvents(), this._streamController.removeMediaStream(), this._renderController.destroy(), this._eventBus.publishSync(P.DESTROY, {}), this._logger.info("VideoElementController was destroyed"), this._loggerTransport?.destroy();
        }
        reinit() {
            this._logger.info("Reinit requested"), [
                this._autoplayController,
                this._customEventsEmitter,
                this._playbackController,
                this._streamController,
                this._stateController,
                this._timeUpdateController,
                this._renderController,
                this._eventsHandler
            ].forEach((e)=>{
                e && e.init();
            }), this.attachVideoElementEvents(), this._logger.info("VideoElementController was reinited");
        }
        setLoggerLevels(e, t = [], r = []) {
            this._logger.info("Setting new log level", {
                levels: e
            }), this._loggerTransport && (this._loggerTransport.destroy(), this._loggerTransport = null), e.length && (this._loggerTransport = new eu(this._eventBus, e, t, r));
        }
        _syncConfig() {
            this._logger.verbose("Sycronizing configs across all controllers"), this._autoplayController?.setConfig(this._config), this._eventsHandler.setConfig(this._config), this._streamController.setConfig(this._config), this._timeUpdateController.setConfig(this._config), this._renderController.setConfig(this._config), this._stateController.setConfig(this._config);
        }
        _createControllers() {
            this._logger.verbose("Creating all controllers"), this._state = new tn(tr);
            let e = {
                getVideoElement: this.getVideoElement,
                state: this._state,
                eventBus: this._eventBus
            };
            this._autoplayController = new ep(e), this._customEventsEmitter = new eg(e), this._eventsHandler = new tt(e), this._playbackController = new eP(e), this._streamController = new ek(e), this._stateController = new eD(e), this._timeUpdateController = new te(e), this._renderController = new eL(e), this._logger.verbose("Controllers created");
        }
    };
    en([
        er
    ], ti.prototype, "addEventListener", null), en([
        er
    ], ti.prototype, "removeEventListener", null), en([
        er
    ], ti.prototype, "getIsPlaying", null), en([
        er
    ], ti.prototype, "getVideoElement", null), en([
        er
    ], ti.prototype, "getCanvasElement", null), (h = R || (R = {}))[h.FATAL = 0] = "FATAL", h[h.ERROR = 1] = "ERROR", h[h.WARN = 2] = "WARN", h[h.INFO = 3] = "INFO", h[h.DEBUG = 4] = "DEBUG", h[h.VERBOSE = 5] = "VERBOSE", R.FATAL, R.ERROR, R.WARN, R.INFO, R.DEBUG, R.VERBOSE, R.FATAL, R.WARN, R.ERROR, R.INFO, R.DEBUG, R.VERBOSE;
    let ts = (e)=>{
        e && (e.getTracks().forEach((t)=>{
            t.stop(), e.removeTrack(t);
        }), e.stop && e.stop());
    }, to = class {
        get fakeTrack() {
            return this._audioStream || this._initFakeStream(), this._statPlaying(), this._audioStream?.getAudioTracks()[0];
        }
        stopFakeStream() {
            this._audioStream && (this._oscillator?.stop(), this._oscillator = null, ts(this._audioStream), this._audioStream = null, this._audioContext?.close(), this._audioContext = null);
        }
        _statPlaying() {
            let e = this._audioContext?.createOscillator();
            this._dest && (e?.connect(this._dest), e?.start());
        }
        _initFakeStream() {
            this._audioStream && this.stopFakeStream(), this._audioContext = new AudioContext, this._dest = this._audioContext.createMediaStreamDestination(), this._audioStream = this._dest.stream;
        }
        constructor(){
            this._oscillator = null;
        }
    }, ta = class {
        get fakeTrack() {
            return this._canvasStream || this._initFakeStream(), this._statPlaying(), this._canvasStream?.getVideoTracks()[0];
        }
        stopFakeStream() {
            this._canvasStream && (null !== this._drawIntervalId && (clearInterval(this._drawIntervalId), this._drawIntervalId = null), ts(this._canvasStream), this._canvasStream = null, this._canvasDomElement?.parentElement && (this._canvasDomElement.remove(), this._canvasDomElement = null));
        }
        _statPlaying() {
            if (!this._canvasDomElement) return;
            let e = this._canvasDomElement.getContext("2d");
            e && (this._drawIntervalId = setInterval(()=>{
                e.fillStyle = `rgb(${255 * Math.random()},0,0)`, e?.fillRect(0, 0, 1, 1), this._canvasStream?.getVideoTracks()[0].requestFrame();
            }, 1e3 / 30));
        }
        _initFakeStream() {
            this._canvasStream && this.stopFakeStream(), this._canvasDomElement = document.createElement("canvas"), this._canvasDomElement.width = 240, this._canvasDomElement.height = 240, this._canvasStream = this._canvasDomElement.captureStream(29);
        }
    };
    (d = I || (I = {}))[d.MEDIA_DEVICES_UPDATED = 0] = "MEDIA_DEVICES_UPDATED";
    var tl = function(e, t) {
        return e === t || e != e && t != t;
    }, tu = function(e, t) {
        for(var r = e.length; r--;)if (tl(e[r][0], t)) return r;
        return -1;
    }, tc = Array.prototype.splice;
    function th(e) {
        var t = -1, r = null == e ? 0 : e.length;
        for(this.clear(); ++t < r;){
            var n = e[t];
            this.set(n[0], n[1]);
        }
    }
    th.prototype.clear = function() {
        this.__data__ = [], this.size = 0;
    }, th.prototype.delete = function(e) {
        var t = this.__data__, r = tu(t, e);
        return !(r < 0) && (r == t.length - 1 ? t.pop() : tc.call(t, r, 1), --this.size, !0);
    }, th.prototype.get = function(e) {
        var t = this.__data__, r = tu(t, e);
        return r < 0 ? void 0 : t[r][1];
    }, th.prototype.has = function(e) {
        return tu(this.__data__, e) > -1;
    }, th.prototype.set = function(e, t) {
        var r = this.__data__, n = tu(r, e);
        return n < 0 ? (++this.size, r.push([
            e,
            t
        ])) : r[n][1] = t, this;
    };
    var td = function(e) {
        if (!eN(e)) return !1;
        var t = eK(e);
        return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    }, ex = x("iCUkT"), t_ = ex.default["__core-js_shared__"], tf = (p = /[^.]+$/.exec(t_ && t_.keys && t_.keys.IE_PROTO || "")) ? "Symbol(src)_1." + p : "", tp = Function.prototype.toString, tv = function(e) {
        if (null != e) {
            try {
                return tp.call(e);
            } catch (e) {}
            try {
                return e + "";
            } catch (e) {}
        }
        return "";
    }, tg = /^\[object .+?Constructor\]$/, tm = Object.prototype, ty = Function.prototype.toString, tb = tm.hasOwnProperty, tE = RegExp("^" + ty.call(tb).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), tS = function(e, t) {
        var r = null == e ? void 0 : e[t];
        return !(!eN(r) || tf && tf in r) && (td(r) ? tE : tg).test(tv(r)) ? r : void 0;
    }, ex = x("iCUkT"), tC = tS(ex.default, "Map"), tT = tS(Object, "create"), tA = Object.prototype.hasOwnProperty, tw = Object.prototype.hasOwnProperty;
    function tP(e) {
        var t = -1, r = null == e ? 0 : e.length;
        for(this.clear(); ++t < r;){
            var n = e[t];
            this.set(n[0], n[1]);
        }
    }
    tP.prototype.clear = function() {
        this.__data__ = tT ? tT(null) : {}, this.size = 0;
    }, tP.prototype.delete = function(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= !!t, t;
    }, tP.prototype.get = function(e) {
        var t = this.__data__;
        if (tT) {
            var r = t[e];
            return "__lodash_hash_undefined__" === r ? void 0 : r;
        }
        return tA.call(t, e) ? t[e] : void 0;
    }, tP.prototype.has = function(e) {
        var t = this.__data__;
        return tT ? void 0 !== t[e] : tw.call(t, e);
    }, tP.prototype.set = function(e, t) {
        var r = this.__data__;
        return this.size += +!this.has(e), r[e] = tT && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
    var tR = function(e) {
        var t = typeof e;
        return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    }, tI = function(e, t) {
        var r = e.__data__;
        return tR(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
    };
    function tO(e) {
        var t = -1, r = null == e ? 0 : e.length;
        for(this.clear(); ++t < r;){
            var n = e[t];
            this.set(n[0], n[1]);
        }
    }
    function tM(e) {
        var t = this.__data__ = new th(e);
        this.size = t.size;
    }
    function tL(e) {
        var t = -1, r = null == e ? 0 : e.length;
        for(this.__data__ = new tO; ++t < r;)this.add(e[t]);
    }
    tO.prototype.clear = function() {
        this.size = 0, this.__data__ = {
            hash: new tP,
            map: new (tC || th),
            string: new tP
        };
    }, tO.prototype.delete = function(e) {
        var t = tI(this, e).delete(e);
        return this.size -= !!t, t;
    }, tO.prototype.get = function(e) {
        return tI(this, e).get(e);
    }, tO.prototype.has = function(e) {
        return tI(this, e).has(e);
    }, tO.prototype.set = function(e, t) {
        var r = tI(this, e), n = r.size;
        return r.set(e, t), this.size += +(r.size != n), this;
    }, tM.prototype.clear = function() {
        this.__data__ = new th, this.size = 0;
    }, tM.prototype.delete = function(e) {
        var t = this.__data__, r = t.delete(e);
        return this.size = t.size, r;
    }, tM.prototype.get = function(e) {
        return this.__data__.get(e);
    }, tM.prototype.has = function(e) {
        return this.__data__.has(e);
    }, tM.prototype.set = function(e, t) {
        var r = this.__data__;
        if (r instanceof th) {
            var n = r.__data__;
            if (!tC || n.length < 199) return n.push([
                e,
                t
            ]), this.size = ++r.size, this;
            r = this.__data__ = new tO(n);
        }
        return r.set(e, t), this.size = r.size, this;
    }, tL.prototype.add = tL.prototype.push = function(e) {
        return this.__data__.set(e, "__lodash_hash_undefined__"), this;
    }, tL.prototype.has = function(e) {
        return this.__data__.has(e);
    };
    var tD = function(e, t) {
        for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
        return !1;
    }, tk = function(e, t, r, n, i, s) {
        var o = 1 & r, a = e.length, l = t.length;
        if (a != l && !(o && l > a)) return !1;
        var u = s.get(e), c = s.get(t);
        if (u && c) return u == t && c == e;
        var h = -1, d = !0, _ = 2 & r ? new tL : void 0;
        for(s.set(e, t), s.set(t, e); ++h < a;){
            var f = e[h], p = t[h];
            if (n) var v = o ? n(p, f, h, t, e, s) : n(f, p, h, e, t, s);
            if (void 0 !== v) {
                if (v) continue;
                d = !1;
                break;
            }
            if (_) {
                if (!tD(t, function(e, t) {
                    if (!_.has(t) && (f === e || i(f, e, r, n, s))) return _.push(t);
                })) {
                    d = !1;
                    break;
                }
            } else if (!(f === p || i(f, p, r, n, s))) {
                d = !1;
                break;
            }
        }
        return s.delete(e), s.delete(t), d;
    }, ex = x("iCUkT"), tN = ex.default.Uint8Array, tx = function(e) {
        var t = -1, r = Array(e.size);
        return e.forEach(function(e, n) {
            r[++t] = [
                n,
                e
            ];
        }), r;
    }, tB = function(e) {
        var t = -1, r = Array(e.size);
        return e.forEach(function(e) {
            r[++t] = e;
        }), r;
    }, tV = eF ? eF.prototype : void 0, tU = tV ? tV.valueOf : void 0, tj = function(e, t, r, n, i, s, o) {
        switch(r){
            case "[object DataView]":
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) break;
                e = e.buffer, t = t.buffer;
            case "[object ArrayBuffer]":
                if (e.byteLength != t.byteLength || !s(new tN(e), new tN(t))) break;
                return !0;
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
                return tl(+e, +t);
            case "[object Error]":
                return e.name == t.name && e.message == t.message;
            case "[object RegExp]":
            case "[object String]":
                return e == t + "";
            case "[object Map]":
                var a = tx;
            case "[object Set]":
                var l = 1 & n;
                if (a || (a = tB), e.size != t.size && !l) break;
                var u = o.get(e);
                if (u) return u == t;
                n |= 2, o.set(e, t);
                var c = tk(a(e), a(t), n, i, s, o);
                return o.delete(e), c;
            case "[object Symbol]":
                if (tU) return tU.call(e) == tU.call(t);
        }
        return !1;
    }, tF = function(e, t) {
        for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
        return e;
    }, tW = Array.isArray, tH = function(e, t, r) {
        var n = t(e);
        return tW(e) ? n : tF(n, r(e));
    }, tz = function(e, t) {
        for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
            var o = e[r];
            t(o, r, e) && (s[i++] = o);
        }
        return s;
    }, tG = Object.prototype.propertyIsEnumerable, t$ = Object.getOwnPropertySymbols, tY = t$ ? function(e) {
        return null == e ? [] : tz(t$(e = Object(e)), function(t) {
            return tG.call(e, t);
        });
    } : function() {
        return [];
    }, tq = function(e, t) {
        for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
        return n;
    }, tK = function(e) {
        return eQ(e) && "[object Arguments]" == eK(e);
    }, tQ = Object.prototype, tJ = tQ.hasOwnProperty, tZ = tQ.propertyIsEnumerable, tX = tK(function() {
        return arguments;
    }()) ? tK : function(e) {
        return eQ(e) && tJ.call(e, "callee") && !tZ.call(e, "callee");
    }, t0 = x("iuHwr"), t1 = /^(?:0|[1-9]\d*)$/, t2 = function(e, t) {
        var r = typeof e;
        return !!(t = null == t ? 0x1fffffffffffff : t) && ("number" == r || "symbol" != r && t1.test(e)) && e > -1 && e % 1 == 0 && e < t;
    }, t3 = function(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 0x1fffffffffffff;
    }, t4 = {};
    t4["[object Float32Array]"] = t4["[object Float64Array]"] = t4["[object Int8Array]"] = t4["[object Int16Array]"] = t4["[object Int32Array]"] = t4["[object Uint8Array]"] = t4["[object Uint8ClampedArray]"] = t4["[object Uint16Array]"] = t4["[object Uint32Array]"] = !0, t4["[object Arguments]"] = t4["[object Array]"] = t4["[object ArrayBuffer]"] = t4["[object Boolean]"] = t4["[object DataView]"] = t4["[object Date]"] = t4["[object Error]"] = t4["[object Function]"] = t4["[object Map]"] = t4["[object Number]"] = t4["[object Object]"] = t4["[object RegExp]"] = t4["[object Set]"] = t4["[object String]"] = t4["[object WeakMap]"] = !1;
    var t6 = x("8tO4H"), t5 = t6.default && t6.default.isTypedArray, t8 = t5 ? function(e) {
        return t5(e);
    } : function(e) {
        return eQ(e) && t3(e.length) && !!t4[eK(e)];
    }, t9 = Object.prototype.hasOwnProperty, t7 = function(e, t) {
        var r = tW(e), n = !r && tX(e), i = !r && !n && (0, t0.default)(e), s = !r && !n && !i && t8(e), o = r || n || i || s, a = o ? tq(e.length, String) : [], l = a.length;
        for(var u in e)(t || t9.call(e, u)) && !(o && ("length" == u || i && ("offset" == u || "parent" == u) || s && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || t2(u, l))) && a.push(u);
        return a;
    }, re = Object.prototype, rt = function(e) {
        var t = e && e.constructor;
        return e === ("function" == typeof t && t.prototype || re);
    }, rr = (y = Object.keys, b = Object, function(e) {
        return y(b(e));
    }), rn = Object.prototype.hasOwnProperty, ri = function(e) {
        if (!rt(e)) return rr(e);
        var t = [];
        for(var r in Object(e))rn.call(e, r) && "constructor" != r && t.push(r);
        return t;
    }, rs = function(e) {
        return null != e && t3(e.length) && !td(e) ? t7(e) : ri(e);
    }, ro = function(e) {
        return tH(e, rs, tY);
    }, ra = Object.prototype.hasOwnProperty, rl = function(e, t, r, n, i, s) {
        var o = 1 & r, a = ro(e), l = a.length;
        if (l != ro(t).length && !o) return !1;
        for(var u = l; u--;){
            var c = a[u];
            if (!(o ? c in t : ra.call(t, c))) return !1;
        }
        var h = s.get(e), d = s.get(t);
        if (h && d) return h == t && d == e;
        var _ = !0;
        s.set(e, t), s.set(t, e);
        for(var f = o; ++u < l;){
            var p = e[c = a[u]], v = t[c];
            if (n) var g = o ? n(v, p, c, t, e, s) : n(p, v, c, e, t, s);
            if (!(void 0 === g ? p === v || i(p, v, r, n, s) : g)) {
                _ = !1;
                break;
            }
            f || (f = "constructor" == c);
        }
        if (_ && !f) {
            var m = e.constructor, y = t.constructor;
            m != y && "constructor" in e && "constructor" in t && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (_ = !1);
        }
        return s.delete(e), s.delete(t), _;
    }, ex = x("iCUkT"), ru = tS(ex.default, "DataView"), ex = x("iCUkT"), rc = tS(ex.default, "Promise"), ex = x("iCUkT"), rh = tS(ex.default, "Set"), ex = x("iCUkT"), rd = tS(ex.default, "WeakMap"), r_ = "[object Map]", rf = "[object Promise]", rp = "[object Set]", rv = "[object WeakMap]", rg = "[object DataView]", rm = tv(ru), ry = tv(tC), rb = tv(rc), rE = tv(rh), rS = tv(rd), rC = eK;
    (ru && rC(new ru(new ArrayBuffer(1))) != rg || tC && rC(new tC) != r_ || rc && rC(rc.resolve()) != rf || rh && rC(new rh) != rp || rd && rC(new rd) != rv) && (rC = function(e) {
        var t = eK(e), r = "[object Object]" == t ? e.constructor : void 0, n = r ? tv(r) : "";
        if (n) switch(n){
            case rm:
                return rg;
            case ry:
                return r_;
            case rb:
                return rf;
            case rE:
                return rp;
            case rS:
                return rv;
        }
        return t;
    });
    var rT = rC, t0 = x("iuHwr"), rA = "[object Arguments]", rw = "[object Array]", rP = "[object Object]", rR = Object.prototype.hasOwnProperty, rI = function(e, t, r, n, i, s) {
        var o = tW(e), a = tW(t), l = o ? rw : rT(e), u = a ? rw : rT(t);
        l = l == rA ? rP : l, u = u == rA ? rP : u;
        var c = l == rP, h = u == rP, d = l == u;
        if (d && (0, t0.default)(e)) {
            if (!(0, t0.default)(t)) return !1;
            o = !0, c = !1;
        }
        if (d && !c) return s || (s = new tM), o || t8(e) ? tk(e, t, r, n, i, s) : tj(e, t, l, r, n, i, s);
        if (!(1 & r)) {
            var _ = c && rR.call(e, "__wrapped__"), f = h && rR.call(t, "__wrapped__");
            if (_ || f) {
                var p = _ ? e.value() : e, v = f ? t.value() : t;
                return s || (s = new tM), i(p, v, r, n, s);
            }
        }
        return !!d && (s || (s = new tM), rl(e, t, r, n, i, s));
    };
    let rO = "H264/90000", rM = "VP8/90000", rL = /a=rtpmap:\d+\s/, rD = ({ sdp: e  })=>e ? [
            ...new Set(e.split(/\r?\n/).filter((e)=>e.match(rL)).map((e)=>e.replace(rL, "")))
        ] : [], rk = async (e, t)=>{
        try {
            let r = "play" === e ? "recvonly" : "sendonly", n = new (rN())({
                iceServers: []
            });
            n.addTransceiver && (n.addTransceiver("audio", {
                direction: r
            }), n.addTransceiver("video", {
                direction: r
            }));
            let i = await n.createOffer({}), s = rD(i);
            return n.close(), t.filter((e)=>s.includes(e));
        } catch (e) {
            return [];
        }
    }, rN = ()=>window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection, rx = ()=>window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate, rB = ()=>window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription, rV = ()=>{
        let e = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices) || navigator.getUserMedia && X(navigator.getUserMedia.bind(navigator)) || navigator.webkitGetUserMedia && X(navigator.webkitGetUserMedia.bind(navigator)) || navigator.mozGetUserMedia && X(navigator.mozGetUserMedia.bind(navigator));
        return (t)=>e.call(navigator, t);
    }, rU = {
        getIsWebRTCApiSupported: ()=>!!(rN() && rx() && rB()),
        resolveGetUserMedia: rV,
        resolveRTCPeerConnection: rN,
        resolveRTCIceCandidate: rx,
        resolveRTCSessionDescription: rB,
        isH264BroadcastSupported: async ()=>(await rk("broadcast", [
                rO,
                rM
            ])).some((e)=>[
                    rO,
                    rM
                ].includes(e)),
        isH264PlayingSupported: async ()=>(await rk("play", [
                rO,
                rM
            ])).some((e)=>[
                    rO,
                    rM
                ].includes(e))
    }, rj = (e)=>!!e && ("boolean" == typeof e ? e : !!e.deviceId && {
            deviceId: eE.safari ? e.deviceId : {
                exact: e.deviceId
            },
            channelCount: 2
        }), rF = (e, t)=>{
        if (!e) return !1;
        if ("boolean" == typeof e) return !0;
        let r = e.width && e.height ? Number(e.width) / Number(e.height) : t.baseAspectRatio, n = {};
        return e.frameRate && (n.frameRate = {
            ideal: e.frameRate,
            min: 15
        }), e.facingMode && navigator.mediaDevices.getSupportedConstraints().facingMode && (n.facingMode = {
            exact: e.facingMode
        }), e.width && (n.width = {
            ideal: e.width
        }), e.height && (n.height = {
            ideal: e.height
        }), e.width && e.height && r && (n.aspectRatio = r), e.deviceId && (n.deviceId = eE.safari ? e.deviceId : {
            exact: e.deviceId
        }), e.width && e.height && !n.facingMode && (n.advanced = [
            {
                width: {
                    min: e.width - t.sizeThreshold,
                    max: e.width + t.sizeThreshold
                },
                height: {
                    min: e.height - t.sizeThreshold,
                    max: e.height + t.sizeThreshold
                }
            },
            {
                aspectRatio: r
            }
        ]), 0 !== Object.keys(n).length && n;
    };
    (v = O || (O = {})).VIDEO_INPUT = "videoinput", v.AUDIO_INPUT = "audioinput", v.AUDIO_OUTPUT = "audiooutput";
    let rW = (e, t)=>e.filter((e)=>e.kind === t), rH = async ()=>{
        let e = await navigator.mediaDevices.enumerateDevices();
        return {
            audioInputs: rW(e, O.AUDIO_INPUT),
            audioOutputs: rW(e, O.AUDIO_OUTPUT),
            videoInputs: rW(e, O.VIDEO_INPUT)
        };
    };
    (g = M || (M = {})).SYSTEM_PERMISSION_DENIED = "SystemPermissionDenied", g.USER_PERMISSION_DENIED = "UserPermissionDenied", g.COULD_NOT_START_VIDEO_SOURCE = "CouldNotStartVideoSource", g.GENERIC = "Generic";
    let rz = async (e)=>new Promise((t, r)=>{
            navigator.mediaDevices.getUserMedia(e ?? {
                audio: !0,
                video: !0
            }).then((e)=>{
                e.getTracks().forEach((e)=>{
                    e.stop();
                }), t(!0);
            }).catch((e)=>{
                let t = e.name, n = e.message, i = M.GENERIC;
                eE.chrome ? "NotAllowedError" === t ? "Permission denied by system" === n ? i = M.SYSTEM_PERMISSION_DENIED : "Permission denied" === n && (i = M.USER_PERMISSION_DENIED) : "NotReadableError" === t && (i = M.COULD_NOT_START_VIDEO_SOURCE) : eE.safari ? "NotAllowedError" === t && (i = M.USER_PERMISSION_DENIED) : eE.edge ? "NotAllowedError" === t ? i = M.USER_PERMISSION_DENIED : "NotReadableError" === t && (i = M.COULD_NOT_START_VIDEO_SOURCE) : eE.firefox && ("NotFoundError" === t || "NotReadableError" === t ? i = M.SYSTEM_PERMISSION_DENIED : "NotAllowedError" === t ? i = M.USER_PERMISSION_DENIED : "AbortError" === t && (i = M.COULD_NOT_START_VIDEO_SOURCE)), r({
                    type: i,
                    name: e.name,
                    message: e.message
                });
            });
        });
    (m = L || (L = {})).LIVE = "live", m.ENDED = "ended";
    let rG = (e)=>{
        if (!e) return !0;
        let { muted: t , enabled: r , readyState: n  } = e;
        return t || !r || n === L.ENDED;
    }, r$ = (e)=>!e.active || e.getTracks().every(rG);
    en([
        er
    ], (class extends ev {
        constructor(){
            super(), this._currentMediaStream = null, this._mediaCheckCache = null, this._allowedDevice = {
                audioinput: void 0,
                videoinput: void 0
            }, this._mediaDevices = null, this._fakeVideoTrack = null, this._fakeAudioTrack = null, this._eventBus = new z, this._logger = es(this._eventBus, "UserMedia"), this._loggerTransport = new eu(this._eventBus), this._logger.info("Created"), navigator.mediaDevices.addEventListener("devicechange", this._onDevicesChanged);
        }
        destroy() {
            navigator.mediaDevices.removeEventListener("devicechange", this._onDevicesChanged), this._logger.info("Destroyed"), this._stopCurrentStream();
        }
        async requestPermissions(e) {
            if (this._logger.info("Requesting permissions"), this._mediaCheckCache && function e(t, r, n, i, s) {
                return t === r || (null != t && null != r && (eQ(t) || eQ(r)) ? rI(t, r, n, i, e, s) : t != t && r != r);
            }(e, this._cachedRequestedDevices)) return this._logger.debug("Has previous check results cached. Returning it"), this._logger.info("Check results", {
                ...this._mediaCheckCache
            }), this._mediaCheckCache;
            let t = e || {
                video: !0,
                audio: !0
            };
            try {
                return this._logger.verbose("Request both video and audio permissions"), await rz(t), this._cachedRequestedDevices = e, await this._findAllowedDevices(t), this._logger.debug("No exceptions thrown while checking permissions. Saving both as available in cache"), this._mediaCheckCache = {
                    video: {
                        isAvailable: !0,
                        error: null
                    },
                    audio: {
                        isAvailable: !0,
                        error: null
                    },
                    allowedDevices: this._allowedDevice
                }, this._logger.info("Check results", {
                    ...this._mediaCheckCache
                }), this._mediaCheckCache;
            } catch (r) {
                this._logger.debug("Got an exception while checking both audio and video permissions. Checking them individually", {
                    exception: r.toString()
                });
                let t = {
                    video: {
                        isAvailable: !1,
                        error: null
                    },
                    audio: {
                        isAvailable: !1,
                        error: null
                    },
                    allowedDevices: this._allowedDevice
                };
                return e?.audio && (t.audio = await this._checkKindPermissions({
                    video: !1,
                    audio: !0
                }), this._logger.verbose(`Audio permissions result: ${t.audio.isAvailable}`)), e?.video && (t.video = await this._checkKindPermissions({
                    video: !0,
                    audio: !1
                }), this._logger.verbose(`Video permissions result: ${t.video.isAvailable}`)), this._mediaCheckCache = t, this._logger.debug("Got individual check results", {
                    ...t
                }), this._logger.info("Check results", {
                    ...this._mediaCheckCache
                }), this._mediaCheckCache;
            }
        }
        async getVideoDevices() {
            this._logger.info("Getting video devices list");
            let e = await this._getMediaDevices();
            return this._logger.info("Got video devices", e), e.videoInputs;
        }
        async getAudioInputDevices() {
            this._logger.info("Getting audio input devices list");
            let e = await this._getMediaDevices();
            return this._logger.info("Got audio input devices", e), e.audioInputs;
        }
        async getAudioOutputDevices() {
            this._logger.info("Getting audio output devices list");
            let e = await this._getMediaDevices();
            return this._logger.info("Got audio output devices", e), e.audioOutputs;
        }
        async getMediaStream(e, t, r) {
            this._logger.info("Getting media stream", {
                constraints: e,
                defaults: t
            });
            let n = {};
            if (e.audio && (this._logger.debug("Audio constraints are specified in requested constraints. Mapping it"), n.audio = rj(e.audio), this._logger.debug("Audio constraints mapped", {
                constraints: n.audio
            })), e.video && (this._logger.debug("Video constraints are specified in requested constraints. Mapping it"), n.video = rF(e.video, t), this._logger.debug("Video constraints mapped", {
                constraints: n.video
            })), this._logger.info("Final constraints for media stream", {
                mappedConstraints: n
            }), !this._currentMediaStream) {
                this._logger.debug("No current media stream known. Creating new stream");
                let e = await this._createNewStream(n, r);
                return this._logger.info("Media stream is ready", {
                    mediaStream: e
                }), e;
            }
            let i = !r$(this._currentMediaStream.stream);
            if (i && await this._isCurrentStreamSatisfiesConstraints(n)) return this._logger.debug("Current stream is active and satisfies constraints. Returning cached one"), this._logger.info("Media stream is ready", {
                mediaStream: this._currentMediaStream.stream
            }), this._currentMediaStream.stream;
            this._logger.debug(`Current stream ${i ? "does not satisfies constraints" : "is inactive"}. Creating new stream`), await this._stopCurrentStream();
            let s = await this._createNewStream(n);
            return this._logger.info("Media stream is ready", {
                mediaStream: s
            }), s;
        }
        async _stopCurrentStream() {
            if (this._logger.debug("Stopping current media stream"), !this._currentMediaStream) return void this._logger.verbose("No current stream known. Skipping");
            this._stopFakeStreams(), await ts(this._currentMediaStream.stream), this._currentMediaStream = null;
        }
        async _findAllowedDevices(e) {
            let t;
            try {
                t = await navigator.mediaDevices.getUserMedia({
                    audio: e?.audio,
                    video: e?.video
                });
                let r = new Set(t.getTracks().map((e)=>e.getSettings().deviceId));
                return (await navigator.mediaDevices.enumerateDevices()).forEach((e)=>{
                    r.has(e.deviceId) && ("videoinput" === e.kind || "audioinput" === e.kind) && (this._allowedDevice[e.kind] = e.deviceId);
                }), this._allowedDevice;
            } catch (e) {
                return this._allowedDevice;
            } finally{
                t && ts(t);
            }
        }
        async _checkKindPermissions(e) {
            this._logger.debug("Checking kind permissions", {
                constraints: e
            });
            let t = {
                isAvailable: !1,
                error: null
            };
            try {
                this._logger.verbose("Requesting media permissions for constraints", {
                    constraints: e
                }), t.isAvailable = await rz(e), this._logger.verbose("Successfully got permissions for constraints", {
                    constraints: e
                });
            } catch (r) {
                this._logger.verbose("Could not get permissions for constraints", {
                    constraints: e,
                    error: r
                }), t.isAvailable = !1, t.error = r;
            }
            return this._logger.debug("Final result of permissions check", {
                constraints: e,
                checkResults: t
            }), t;
        }
        async _getMediaStream(e) {
            this._logger.debug("Getting media stream with constraints", {
                constraints: e
            });
            let t = rV(), r = await t(e);
            return this._currentMediaStream = {
                constraints: e,
                stream: r
            }, this._logger.debug("Resulting media stream", {
                mediaStream: this._currentMediaStream.stream
            }), this._currentMediaStream.stream;
        }
        async _createNewStream(e, t) {
            this._logger.debug("Creating new media stream with constraints", {
                constraints: e
            });
            try {
                let r = await this._getMediaStream(e);
                return this._appendFakeTracks(r, t), r;
            } catch (t) {
                if (this._logger.warn("Got an error while creating new media stream", {
                    error: t,
                    constraints: e
                }), "OverconstrainedError" === t.name && "deviceId" === t.constraint) {
                    this._logger.verbose("Trying to get stream with no audio deviceId specified");
                    let t = {
                        ...e,
                        audio: !0
                    };
                    return await this._getMediaStream(t);
                }
                throw t;
            }
        }
        _appendFakeTracks(e, t) {
            if (t?.useVideoFakeTrack && 0 === e.getVideoTracks().length) {
                this._fakeVideoTrack = new ta;
                let t = this._fakeVideoTrack?.fakeTrack;
                t && e.addTrack(t);
            }
            if (t?.useAudioFakeTrack && 0 === e.getAudioTracks().length) {
                this._fakeAudioTrack = new to;
                let t = this._fakeAudioTrack?.fakeTrack;
                t && e.addTrack(t);
            }
        }
        _stopFakeStreams() {
            let e = this._fakeVideoTrack?.fakeTrack, t = this._fakeAudioTrack?.fakeTrack;
            e && (this._currentMediaStream?.stream.removeTrack(e), this._fakeVideoTrack?.stopFakeStream()), t && (this._currentMediaStream?.stream.removeTrack(t), this._fakeAudioTrack?.stopFakeStream());
        }
        async _getMediaDevices() {
            return (this._logger.verbose("Getting media devices"), this._mediaDevices) ? this._logger.verbose("Has media devices in cache, returning them", {
                devices: this._mediaDevices
            }) : this._mediaDevices = await rH(), this._mediaDevices;
        }
        async _isCurrentStreamSatisfiesConstraints(e) {
            if (this._logger.debug("Checking if current media stream satisfies constraints", {
                constraints: e,
                mediaStream: this._currentMediaStream
            }), !this._currentMediaStream) return this._logger.verbose("No current media stream available"), !1;
            try {
                if (e.video) {
                    this._logger.verbose("Checking video track constraints");
                    let t = this._currentMediaStream.stream.getVideoTracks()[0];
                    if (!t && e.video) return this._logger.verbose("No video track in media stream and constraints has video"), !1;
                    if (t && !e.video) return this._logger.verbose("There is video track in media stream and constraints has no video"), !1;
                    if ("object" == typeof e.video && e.video.deviceId && t.getCapabilities().deviceId !== e.video.deviceId) return this._logger.verbose("Constraints has video device ID and it not matches current device id"), !1;
                    t && "boolean" != typeof e.video && (this._logger.verbose("Trying to apply new constraints for video"), await t.applyConstraints(e.video));
                }
            } catch (e) {
                return this._logger.debug("Could not apply constraints or get capabilities of video track", {
                    error: e
                }), !1;
            }
            try {
                if (e.audio) {
                    this._logger.verbose("Checking audio track constraints");
                    let t = this._currentMediaStream.stream.getAudioTracks()[0];
                    if (!t && e.audio) return this._logger.verbose("No audio track in media stream and constraints has audio"), !1;
                    if (t && !e.audio) return this._logger.verbose("There is audio track in media stream and constraints has no audio"), !1;
                    if ("object" == typeof e.audio && e.audio.deviceId && t.getCapabilities().deviceId !== e.audio.deviceId) return this._logger.verbose("Constraints has audio device ID and it not matches current device id"), !1;
                    t && "boolean" != typeof e.audio && (this._logger.verbose("Trying to apply new constraints for audio"), await t.applyConstraints(e.audio));
                }
            } catch (e) {
                return this._logger.debug("Could not apply constraints or get capabilities of audio track", {
                    error: e
                }), !1;
            }
            return !0;
        }
        async _onDevicesChanged() {
            this._logger.debug("Media devices has changed"), this._mediaDevices = null;
            let e = await this._getMediaDevices();
            this._mediaDevices = e, this.emitEvent(I.MEDIA_DEVICES_UPDATED, e);
        }
        get streamFPS() {
            if (!this._currentMediaStream?.stream) return null;
            let e = this._currentMediaStream.stream.getVideoTracks()[0];
            if (!e) return null;
            try {
                return e.getSettings().frameRate || null;
            } catch (e) {
                return null;
            }
        }
    }).prototype, "_onDevicesChanged", null);
    let rY = ()=>window.MediaSource || window.WebKitMediaSource || window.ManagedMediaSource, rq = ()=>window.SourceBuffer || window.WebKitSourceBuffer || window.ManagedSourceBuffer, rK = {
        isHLSSupported: ()=>{
            let e = rY();
            if (!e) return !1;
            let t = rq(), r = "function" == typeof e.isTypeSupported && e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), n = !t || t.prototype && "function" == typeof t.prototype.appendBuffer && "function" == typeof t.prototype.remove;
            return r && n;
        }
    }, rQ = class {
        enqueue(e) {
            this._queue.push(e), this._runNext();
        }
        _runNext() {
            if (this._isRunning) return;
            let e = this._queue.shift();
            if (e) {
                this._isRunning = !0;
                try {
                    let t = e();
                    Promise.resolve(t).catch((e)=>console.error("QueueLocker error: ", e)).finally(()=>{
                        this._isRunning = !1, this._runNext();
                    });
                } catch (e) {
                    this._isRunning = !1, this._runNext();
                }
            }
        }
        constructor(){
            this._queue = [], this._isRunning = !1;
        }
    }, rJ = ()=>{
        let e = new WeakMap;
        return function(t, r, n) {
            let i = n.value;
            return n.value = function(...t) {
                let r = e.get(this);
                r || (r = new rQ, e.set(this, r)), r.enqueue(()=>i.apply(this, t));
            }, n;
        };
    }, rZ = class {
        run(e) {
            return this._currentPromise || (this._currentPromise = new Promise((t, r)=>{
                Promise.resolve().then(()=>e()).then((e)=>{
                    this._currentPromise = null, t(e);
                }).catch((e)=>{
                    this._currentPromise = null, r(e);
                });
            })), this._currentPromise;
        }
        constructor(){
            this._currentPromise = null;
        }
    };
    function rX(e, t, r) {
        let n = r.value, i = Symbol(t.toString());
        return r.value = function(...e) {
            let t = this[i];
            t || (t = new rZ, this[i] = t), t.run(()=>{
                try {
                    let t = n.apply(this, e);
                    return Promise.resolve(t);
                } catch (e) {
                    return Promise.reject(e);
                }
            });
        }, r;
    }
    let r0 = ()=>"undefined" != typeof window && "HTMLVideoElement" in window, r1 = ()=>r0() && "function" == typeof window.HTMLVideoElement?.prototype?.getVideoPlaybackQuality, r2 = ()=>r0() && "webkitDroppedFrameCount" in window.HTMLVideoElement.prototype, r3 = ()=>r0() && "mozPaintedFrames" in window.HTMLVideoElement.prototype;
    function r4(e) {
        return r1() ? e.getVideoPlaybackQuality() : r2() ? {
            corruptedVideoFrames: 0,
            creationTime: window.performance?.now?.() ?? Date.now(),
            droppedVideoFrames: e.webkitDroppedFrameCount || 0,
            totalVideoFrames: e.webkitDecodedFrameCount || 0
        } : r3() ? {
            corruptedVideoFrames: 0,
            creationTime: window.performance?.now?.() ?? Date.now(),
            droppedVideoFrames: 0,
            totalVideoFrames: e.mozPaintedFrames || 0
        } : {
            corruptedVideoFrames: 0,
            creationTime: window.performance?.now?.() ?? Date.now(),
            droppedVideoFrames: 0,
            totalVideoFrames: 0
        };
    }
}), $e175c1d94c759890$var$m("bsvQL", function(e, t) {
    function r(e, t, r, n) {
        var i, s = arguments.length, o = s < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) o = Reflect.decorate(e, t, r, n);
        else for(var a = e.length - 1; a >= 0; a--)(i = e[a]) && (o = (s < 3 ? i(o) : s > 3 ? i(t, r, o) : i(t, r)) || o);
        return s > 3 && o && Object.defineProperty(t, r, o), o;
    }
    $e175c1d94c759890$var$f(e.exports, "__decorate", function() {
        return r;
    }), "function" == typeof SuppressedError && SuppressedError;
}), $e175c1d94c759890$var$m("5tFqc", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "EWatchDogEvent", function() {
        return n;
    });
    var r, n = ((r = {}).ALIVE_PLAYER = "alivePlayer", r.ANOTHER_ACTIVE_PLAYER = "anotherActivePlayer", r);
}), $e175c1d94c759890$var$m("iuHwr", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "default", function() {
        return a;
    });
    var r = $e175c1d94c759890$var$g("iCUkT"), n = $e175c1d94c759890$var$g("eEfty"), i = t && !t.nodeType && t, s = i && e && !e.nodeType && e, o = s && s.exports === i ? r.default.Buffer : void 0, a = (o ? o.isBuffer : void 0) || n.default;
}), $e175c1d94c759890$var$m("iCUkT", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "default", function() {
        return i;
    });
    var r = $e175c1d94c759890$var$g("39qEx"), n = "object" == typeof self && self && self.Object === Object && self, i = r.default || n || Function("return this")();
}), $e175c1d94c759890$var$m("39qEx", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "default", function() {
        return r;
    });
    var r = "object" == typeof $e175c1d94c759890$var$_ && $e175c1d94c759890$var$_ && $e175c1d94c759890$var$_.Object === Object && $e175c1d94c759890$var$_;
}), $e175c1d94c759890$var$m("eEfty", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "default", function() {
        return r;
    });
    var r = function() {
        return !1;
    };
}), $e175c1d94c759890$var$m("8tO4H", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "default", function() {
        return o;
    });
    var r = $e175c1d94c759890$var$g("39qEx"), n = t && !t.nodeType && t, i = n && e && !e.nodeType && e, s = i && i.exports === n && r.default.process, o = function() {
        try {
            var e = i && i.require && i.require("util").types;
            if (e) return e;
            return s && s.binding && s.binding("util");
        } catch (e) {}
    }();
}), $e175c1d94c759890$var$m("h3fWd", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "default", function() {
        return a;
    });
    var r = $e175c1d94c759890$var$g("iCUkT"), n = t && !t.nodeType && t, i = n && e && !e.nodeType && e, s = i && i.exports === n ? r.default.Buffer : void 0, o = s ? s.allocUnsafe : void 0, a = function(e, t) {
        if (t) return e.slice();
        var r = e.length, n = o ? o(r) : new e.constructor(r);
        return e.copy(n), n;
    };
}), $e175c1d94c759890$var$m("1QtI2", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "EPlayerType", function() {
        return i;
    }), $e175c1d94c759890$var$f(e.exports, "AVAILABLE_PLAYER_TYPES", function() {
        return s;
    }), $e175c1d94c759890$var$f(e.exports, "EPlayerErrorType", function() {
        return o;
    });
    var r, n, i = ((r = {}).HLS = "hls", r.WEBRTC = "webrtc", r.BROADCAST = "broadcast", r.NATIVE = "native", r.UNKNOWN = "unknown", r);
    let s = [
        "hls",
        "broadcast",
        "webrtc",
        "native",
        "unknown"
    ];
    var o = ((n = {}).BROADCAST_NOT_SUPPORTED_BY_BROWSER = "broadcastNotSupportedByBrowser", n);
}), $e175c1d94c759890$var$m("giOKx", function(e, t) {
    $e175c1d94c759890$var$f(e.exports, "EPlayersEvents", function() {
        return n;
    });
    var r, n = ((r = {}).MODULE_LOADED = "playerEvents.moduleLoaded", r.PLAYBACK_STATE_CHANGED = "playerEvents.playbackStateChanged", r.DEBUGGER_CONNECTED = "playerEvents.debuggerConnected", r.ERROR = "playerEvents.error", r.AUTO_RESOLUTION_SWITCHED = "playerEvents.autoResolutionSwitched", r.RESOLUTION_SWITCHED = "playerEvents.resolutionSwitched", r.VIDEO_PLAYBACK_STATE_CHANGED = "playerEvents.videoPlaybackStateChanged", r.RESOLUTIONS_AVAILABLE = "playerEvents.resolutionsAvailable", r.RESOLUTION_NOT_FOUND = "playerEvents.resolutionNotFound", r.VIDEO_ELEMENT_UPDATED = "playerEvents.videoElementUpdated", r.PLAYER_TYPES_AVAILABLE = "playerEvents.playerTypesAvailable", r.TOGGLE_TURN_SERVERS = "playerEvents.toggleTURNServers", r.FORCE_PLAYER_TYPE = "playerEvents.forcePlayerType", r.PLAYER_TYPE_CHANGED = "playerEvents.playerTypeChanged", r.STREAM_CONFIG_UPDATED = "playerEvents.streamConfigUpdated", r.STREAM_CONFIG_UPDATED_INTERNAL = "playerEvents.streamConfigUpdatedInternal", r.BROADCAST_SUPPORTED_CHANGE = "playerEvents.broadcastSupportedChange", r.LATENCY_ESTIMATION_AVAILABLE = "playerEvents.latencyEstimationAvailable", r.STREAM_LOAD_ERROR = "playerEvents.streamLoadError", r);
}), $e175c1d94c759890$var$m("apP9s", function(e, t) {
    (function() {
        var r, n = "Expected a function", i = "__lodash_hash_undefined__", s = "__lodash_placeholder__", o = 1 / 0, a = 0 / 0, l = [
            [
                "ary",
                128
            ],
            [
                "bind",
                1
            ],
            [
                "bindKey",
                2
            ],
            [
                "curry",
                8
            ],
            [
                "curryRight",
                16
            ],
            [
                "flip",
                512
            ],
            [
                "partial",
                32
            ],
            [
                "partialRight",
                64
            ],
            [
                "rearg",
                256
            ]
        ], u = "[object Arguments]", c = "[object Array]", h = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", v = "[object GeneratorFunction]", g = "[object Map]", m = "[object Number]", y = "[object Object]", b = "[object Promise]", E = "[object RegExp]", S = "[object Set]", C = "[object String]", T = "[object Symbol]", A = "[object WeakMap]", w = "[object ArrayBuffer]", P = "[object DataView]", R = "[object Float32Array]", I = "[object Float64Array]", O = "[object Int8Array]", M = "[object Int16Array]", L = "[object Int32Array]", D = "[object Uint8Array]", k = "[object Uint8ClampedArray]", N = "[object Uint16Array]", x = "[object Uint32Array]", B = /\b__p \+= '';/g, V = /\b(__p \+=) '' \+/g, U = /(__e\(.*?\)|\b__t\)) \+\n'';/g, j = /&(?:amp|lt|gt|quot|#39);/g, F = /[&<>"']/g, W = RegExp(j.source), H = RegExp(F.source), z = /<%-([\s\S]+?)%>/g, G = /<%([\s\S]+?)%>/g, $ = /<%=([\s\S]+?)%>/g, Y = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, q = /^\w*$/, K = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Q = /[\\^$.*+?()[\]{}|]/g, J = RegExp(Q.source), Z = /^\s+/, X = /\s/, ee = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, et = /\{\n\/\* \[wrapped with (.+)\] \*/, er = /,? & /, en = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ei = /[()=,{}\[\]\/\s]/, es = /\\(\\)?/g, eo = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ea = /\w*$/, el = /^[-+]0x[0-9a-f]+$/i, eu = /^0b[01]+$/i, ec = /^\[object .+?Constructor\]$/, eh = /^0o[0-7]+$/i, ed = /^(?:0|[1-9]\d*)$/, e_ = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ef = /($^)/, ep = /['\n\r\u2028\u2029\\]/g, ev = "\ud800-\udfff", eg = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", em = "\\u2700-\\u27bf", ey = "a-z\\xdf-\\xf6\\xf8-\\xff", eb = "A-Z\\xc0-\\xd6\\xd8-\\xde", eE = "\\ufe0e\\ufe0f", eS = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", eC = "['’]", eT = "[" + eS + "]", eA = "[" + eg + "]", ew = "[" + ey + "]", eP = "[^" + ev + eS + "\\d+" + em + ey + eb + "]", eR = "\ud83c[\udffb-\udfff]", eI = "[^" + ev + "]", eO = "(?:\ud83c[\udde6-\uddff]){2}", eM = "[\ud800-\udbff][\udc00-\udfff]", eL = "[" + eb + "]", eD = "\\u200d", ek = "(?:" + ew + "|" + eP + ")", eN = "(?:" + eL + "|" + eP + ")", ex = "(?:" + eC + "(?:d|ll|m|re|s|t|ve))?", eB = "(?:" + eC + "(?:D|LL|M|RE|S|T|VE))?", eV = "(?:" + eA + "|" + eR + ")?", eU = "[" + eE + "]?", ej = "(?:" + eD + "(?:" + [
            eI,
            eO,
            eM
        ].join("|") + ")" + eU + eV + ")*", eF = eU + eV + ej, eW = "(?:" + [
            "[" + em + "]",
            eO,
            eM
        ].join("|") + ")" + eF, eH = "(?:" + [
            eI + eA + "?",
            eA,
            eO,
            eM,
            "[" + ev + "]"
        ].join("|") + ")", ez = RegExp(eC, "g"), eG = RegExp(eA, "g"), e$ = RegExp(eR + "(?=" + eR + ")|" + eH + eF, "g"), eY = RegExp([
            eL + "?" + ew + "+" + ex + "(?=" + [
                eT,
                eL,
                "$"
            ].join("|") + ")",
            eN + "+" + eB + "(?=" + [
                eT,
                eL + ek,
                "$"
            ].join("|") + ")",
            eL + "?" + ek + "+" + ex,
            eL + "+" + eB,
            "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
            "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
            "\\d+",
            eW
        ].join("|"), "g"), eq = RegExp("[" + eD + ev + eg + eE + "]"), eK = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, eQ = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], eJ = -1, eZ = {};
        eZ[R] = eZ[I] = eZ[O] = eZ[M] = eZ[L] = eZ[D] = eZ[k] = eZ[N] = eZ[x] = !0, eZ[u] = eZ[c] = eZ[w] = eZ[h] = eZ[P] = eZ[d] = eZ[f] = eZ[p] = eZ[g] = eZ[m] = eZ[y] = eZ[E] = eZ[S] = eZ[C] = eZ[A] = !1;
        var eX = {};
        eX[u] = eX[c] = eX[w] = eX[P] = eX[h] = eX[d] = eX[R] = eX[I] = eX[O] = eX[M] = eX[L] = eX[g] = eX[m] = eX[y] = eX[E] = eX[S] = eX[C] = eX[T] = eX[D] = eX[k] = eX[N] = eX[x] = !0, eX[f] = eX[p] = eX[A] = !1;
        var e0 = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, e1 = parseFloat, e2 = parseInt, e3 = "object" == typeof $e175c1d94c759890$var$_ && $e175c1d94c759890$var$_ && $e175c1d94c759890$var$_.Object === Object && $e175c1d94c759890$var$_, e4 = "object" == typeof self && self && self.Object === Object && self, e6 = e3 || e4 || Function("return this")(), e5 = t && !t.nodeType && t, e8 = e5 && e && !e.nodeType && e, e9 = e8 && e8.exports === e5, e7 = e9 && e3.process, te = function() {
            try {
                var e = e8 && e8.require && e8.require("util").types;
                if (e) return e;
                return e7 && e7.binding && e7.binding("util");
            } catch (e) {}
        }(), tt = te && te.isArrayBuffer, tr = te && te.isDate, tn = te && te.isMap, ti = te && te.isRegExp, ts = te && te.isSet, to = te && te.isTypedArray;
        function ta(e, t, r) {
            switch(r.length){
                case 0:
                    return e.call(t);
                case 1:
                    return e.call(t, r[0]);
                case 2:
                    return e.call(t, r[0], r[1]);
                case 3:
                    return e.call(t, r[0], r[1], r[2]);
            }
            return e.apply(t, r);
        }
        function tl(e, t, r, n) {
            for(var i = -1, s = null == e ? 0 : e.length; ++i < s;){
                var o = e[i];
                t(n, o, r(o), e);
            }
            return n;
        }
        function tu(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e););
            return e;
        }
        function tc(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (!t(e[r], r, e)) return !1;
            return !0;
        }
        function th(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                var o = e[r];
                t(o, r, e) && (s[i++] = o);
            }
            return s;
        }
        function td(e, t) {
            return !!(null == e ? 0 : e.length) && tS(e, t, 0) > -1;
        }
        function t_(e, t, r) {
            for(var n = -1, i = null == e ? 0 : e.length; ++n < i;)if (r(t, e[n])) return !0;
            return !1;
        }
        function tf(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length, i = Array(n); ++r < n;)i[r] = t(e[r], r, e);
            return i;
        }
        function tp(e, t) {
            for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
            return e;
        }
        function tv(e, t, r, n) {
            var i = -1, s = null == e ? 0 : e.length;
            for(n && s && (r = e[++i]); ++i < s;)r = t(r, e[i], i, e);
            return r;
        }
        function tg(e, t, r, n) {
            var i = null == e ? 0 : e.length;
            for(n && i && (r = e[--i]); i--;)r = t(r, e[i], i, e);
            return r;
        }
        function tm(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
            return !1;
        }
        var ty = tw("length");
        function tb(e, t, r) {
            var n;
            return r(e, function(e, r, i) {
                if (t(e, r, i)) return n = r, !1;
            }), n;
        }
        function tE(e, t, r, n) {
            for(var i = e.length, s = r + (n ? 1 : -1); n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
            return -1;
        }
        function tS(e, t, r) {
            return t == t ? function(e, t, r) {
                for(var n = r - 1, i = e.length; ++n < i;)if (e[n] === t) return n;
                return -1;
            }(e, t, r) : tE(e, tT, r);
        }
        function tC(e, t, r, n) {
            for(var i = r - 1, s = e.length; ++i < s;)if (n(e[i], t)) return i;
            return -1;
        }
        function tT(e) {
            return e != e;
        }
        function tA(e, t) {
            var r = null == e ? 0 : e.length;
            return r ? tI(e, t) / r : a;
        }
        function tw(e) {
            return function(t) {
                return null == t ? r : t[e];
            };
        }
        function tP(e) {
            return function(t) {
                return null == e ? r : e[t];
            };
        }
        function tR(e, t, r, n, i) {
            return i(e, function(e, i, s) {
                r = n ? (n = !1, e) : t(r, e, i, s);
            }), r;
        }
        function tI(e, t) {
            for(var n, i = -1, s = e.length; ++i < s;){
                var o = t(e[i]);
                o !== r && (n = n === r ? o : n + o);
            }
            return n;
        }
        function tO(e, t) {
            for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
            return n;
        }
        function tM(e) {
            return e ? e.slice(0, tY(e) + 1).replace(Z, "") : e;
        }
        function tL(e) {
            return function(t) {
                return e(t);
            };
        }
        function tD(e, t) {
            return tf(t, function(t) {
                return e[t];
            });
        }
        function tk(e, t) {
            return e.has(t);
        }
        function tN(e, t) {
            for(var r = -1, n = e.length; ++r < n && tS(t, e[r], 0) > -1;);
            return r;
        }
        function tx(e, t) {
            for(var r = e.length; r-- && tS(t, e[r], 0) > -1;);
            return r;
        }
        var tB = tP({
            À: "A",
            Á: "A",
            Â: "A",
            Ã: "A",
            Ä: "A",
            Å: "A",
            à: "a",
            á: "a",
            â: "a",
            ã: "a",
            ä: "a",
            å: "a",
            Ç: "C",
            ç: "c",
            Ð: "D",
            ð: "d",
            È: "E",
            É: "E",
            Ê: "E",
            Ë: "E",
            è: "e",
            é: "e",
            ê: "e",
            ë: "e",
            Ì: "I",
            Í: "I",
            Î: "I",
            Ï: "I",
            ì: "i",
            í: "i",
            î: "i",
            ï: "i",
            Ñ: "N",
            ñ: "n",
            Ò: "O",
            Ó: "O",
            Ô: "O",
            Õ: "O",
            Ö: "O",
            Ø: "O",
            ò: "o",
            ó: "o",
            ô: "o",
            õ: "o",
            ö: "o",
            ø: "o",
            Ù: "U",
            Ú: "U",
            Û: "U",
            Ü: "U",
            ù: "u",
            ú: "u",
            û: "u",
            ü: "u",
            Ý: "Y",
            ý: "y",
            ÿ: "y",
            Æ: "Ae",
            æ: "ae",
            Þ: "Th",
            þ: "th",
            ß: "ss",
            Ā: "A",
            Ă: "A",
            Ą: "A",
            ā: "a",
            ă: "a",
            ą: "a",
            Ć: "C",
            Ĉ: "C",
            Ċ: "C",
            Č: "C",
            ć: "c",
            ĉ: "c",
            ċ: "c",
            č: "c",
            Ď: "D",
            Đ: "D",
            ď: "d",
            đ: "d",
            Ē: "E",
            Ĕ: "E",
            Ė: "E",
            Ę: "E",
            Ě: "E",
            ē: "e",
            ĕ: "e",
            ė: "e",
            ę: "e",
            ě: "e",
            Ĝ: "G",
            Ğ: "G",
            Ġ: "G",
            Ģ: "G",
            ĝ: "g",
            ğ: "g",
            ġ: "g",
            ģ: "g",
            Ĥ: "H",
            Ħ: "H",
            ĥ: "h",
            ħ: "h",
            Ĩ: "I",
            Ī: "I",
            Ĭ: "I",
            Į: "I",
            İ: "I",
            ĩ: "i",
            ī: "i",
            ĭ: "i",
            į: "i",
            ı: "i",
            Ĵ: "J",
            ĵ: "j",
            Ķ: "K",
            ķ: "k",
            ĸ: "k",
            Ĺ: "L",
            Ļ: "L",
            Ľ: "L",
            Ŀ: "L",
            Ł: "L",
            ĺ: "l",
            ļ: "l",
            ľ: "l",
            ŀ: "l",
            ł: "l",
            Ń: "N",
            Ņ: "N",
            Ň: "N",
            Ŋ: "N",
            ń: "n",
            ņ: "n",
            ň: "n",
            ŋ: "n",
            Ō: "O",
            Ŏ: "O",
            Ő: "O",
            ō: "o",
            ŏ: "o",
            ő: "o",
            Ŕ: "R",
            Ŗ: "R",
            Ř: "R",
            ŕ: "r",
            ŗ: "r",
            ř: "r",
            Ś: "S",
            Ŝ: "S",
            Ş: "S",
            Š: "S",
            ś: "s",
            ŝ: "s",
            ş: "s",
            š: "s",
            Ţ: "T",
            Ť: "T",
            Ŧ: "T",
            ţ: "t",
            ť: "t",
            ŧ: "t",
            Ũ: "U",
            Ū: "U",
            Ŭ: "U",
            Ů: "U",
            Ű: "U",
            Ų: "U",
            ũ: "u",
            ū: "u",
            ŭ: "u",
            ů: "u",
            ű: "u",
            ų: "u",
            Ŵ: "W",
            ŵ: "w",
            Ŷ: "Y",
            ŷ: "y",
            Ÿ: "Y",
            Ź: "Z",
            Ż: "Z",
            Ž: "Z",
            ź: "z",
            ż: "z",
            ž: "z",
            Ĳ: "IJ",
            ĳ: "ij",
            Œ: "Oe",
            œ: "oe",
            ŉ: "'n",
            ſ: "s"
        }), tV = tP({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        });
        function tU(e) {
            return "\\" + e0[e];
        }
        function tj(e) {
            return eq.test(e);
        }
        function tF(e) {
            var t = -1, r = Array(e.size);
            return e.forEach(function(e, n) {
                r[++t] = [
                    n,
                    e
                ];
            }), r;
        }
        function tW(e, t) {
            return function(r) {
                return e(t(r));
            };
        }
        function tH(e, t) {
            for(var r = -1, n = e.length, i = 0, o = []; ++r < n;){
                var a = e[r];
                (a === t || a === s) && (e[r] = s, o[i++] = r);
            }
            return o;
        }
        function tz(e) {
            var t = -1, r = Array(e.size);
            return e.forEach(function(e) {
                r[++t] = e;
            }), r;
        }
        function tG(e) {
            return tj(e) ? function(e) {
                for(var t = e$.lastIndex = 0; e$.test(e);)++t;
                return t;
            }(e) : ty(e);
        }
        function t$(e) {
            return tj(e) ? e.match(e$) || [] : e.split("");
        }
        function tY(e) {
            for(var t = e.length; t-- && X.test(e.charAt(t)););
            return t;
        }
        var tq = tP({
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }), tK = function e(t) {
            var _, X, ev, eg, em = (t = null == t ? e6 : tK.defaults(e6.Object(), t, tK.pick(e6, eQ))).Array, ey = t.Date, eb = t.Error, eE = t.Function, eS = t.Math, eC = t.Object, eT = t.RegExp, eA = t.String, ew = t.TypeError, eP = em.prototype, eR = eE.prototype, eI = eC.prototype, eO = t["__core-js_shared__"], eM = eR.toString, eL = eI.hasOwnProperty, eD = 0, ek = (_ = /[^.]+$/.exec(eO && eO.keys && eO.keys.IE_PROTO || "")) ? "Symbol(src)_1." + _ : "", eN = eI.toString, ex = eM.call(eC), eB = e6._, eV = eT("^" + eM.call(eL).replace(Q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), eU = e9 ? t.Buffer : r, ej = t.Symbol, eF = t.Uint8Array, eW = eU ? eU.allocUnsafe : r, eH = tW(eC.getPrototypeOf, eC), e$ = eC.create, eq = eI.propertyIsEnumerable, e0 = eP.splice, e3 = ej ? ej.isConcatSpreadable : r, e4 = ej ? ej.iterator : r, e5 = ej ? ej.toStringTag : r, e8 = function() {
                try {
                    var e = i_(eC, "defineProperty");
                    return e({}, "", {}), e;
                } catch (e) {}
            }(), e7 = t.clearTimeout !== e6.clearTimeout && t.clearTimeout, te = ey && ey.now !== e6.Date.now && ey.now, ty = t.setTimeout !== e6.setTimeout && t.setTimeout, tP = eS.ceil, tQ = eS.floor, tJ = eC.getOwnPropertySymbols, tZ = eU ? eU.isBuffer : r, tX = t.isFinite, t0 = eP.join, t1 = tW(eC.keys, eC), t2 = eS.max, t3 = eS.min, t4 = ey.now, t6 = t.parseInt, t5 = eS.random, t8 = eP.reverse, t9 = i_(t, "DataView"), t7 = i_(t, "Map"), re = i_(t, "Promise"), rt = i_(t, "Set"), rr = i_(t, "WeakMap"), rn = i_(eC, "create"), ri = rr && new rr, rs = {}, ro = iU(t9), ra = iU(t7), rl = iU(re), ru = iU(rt), rc = iU(rr), rh = ej ? ej.prototype : r, rd = rh ? rh.valueOf : r, r_ = rh ? rh.toString : r;
            function rf(e) {
                if (sq(e) && !sB(e) && !(e instanceof rm)) {
                    if (e instanceof rg) return e;
                    if (eL.call(e, "__wrapped__")) return ij(e);
                }
                return new rg(e);
            }
            var rp = function() {
                function e() {}
                return function(t) {
                    if (!sY(t)) return {};
                    if (e$) return e$(t);
                    e.prototype = t;
                    var n = new e;
                    return e.prototype = r, n;
                };
            }();
            function rv() {}
            function rg(e, t) {
                this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = r;
            }
            function rm(e) {
                this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 0xffffffff, this.__views__ = [];
            }
            function ry(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function rb(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function rE(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function rS(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.__data__ = new rE; ++t < r;)this.add(e[t]);
            }
            function rC(e) {
                var t = this.__data__ = new rb(e);
                this.size = t.size;
            }
            function rT(e, t) {
                var r = sB(e), n = !r && sx(e), i = !r && !n && sF(e), s = !r && !n && !i && s2(e), o = r || n || i || s, a = o ? tO(e.length, eA) : [], l = a.length;
                for(var u in e)(t || eL.call(e, u)) && !(o && ("length" == u || i && ("offset" == u || "parent" == u) || s && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || iE(u, l))) && a.push(u);
                return a;
            }
            function rA(e) {
                var t = e.length;
                return t ? e[nu(0, t - 1)] : r;
            }
            rf.templateSettings = {
                escape: z,
                evaluate: G,
                interpolate: $,
                variable: "",
                imports: {
                    _: rf
                }
            }, rf.prototype = rv.prototype, rf.prototype.constructor = rf, rg.prototype = rp(rv.prototype), rg.prototype.constructor = rg, rm.prototype = rp(rv.prototype), rm.prototype.constructor = rm, ry.prototype.clear = function() {
                this.__data__ = rn ? rn(null) : {}, this.size = 0;
            }, ry.prototype.delete = function(e) {
                var t = this.has(e) && delete this.__data__[e];
                return this.size -= !!t, t;
            }, ry.prototype.get = function(e) {
                var t = this.__data__;
                if (rn) {
                    var n = t[e];
                    return n === i ? r : n;
                }
                return eL.call(t, e) ? t[e] : r;
            }, ry.prototype.has = function(e) {
                var t = this.__data__;
                return rn ? t[e] !== r : eL.call(t, e);
            }, ry.prototype.set = function(e, t) {
                var n = this.__data__;
                return this.size += +!this.has(e), n[e] = rn && t === r ? i : t, this;
            }, rb.prototype.clear = function() {
                this.__data__ = [], this.size = 0;
            }, rb.prototype.delete = function(e) {
                var t = this.__data__, r = rR(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : e0.call(t, r, 1), --this.size, !0);
            }, rb.prototype.get = function(e) {
                var t = this.__data__, n = rR(t, e);
                return n < 0 ? r : t[n][1];
            }, rb.prototype.has = function(e) {
                return rR(this.__data__, e) > -1;
            }, rb.prototype.set = function(e, t) {
                var r = this.__data__, n = rR(r, e);
                return n < 0 ? (++this.size, r.push([
                    e,
                    t
                ])) : r[n][1] = t, this;
            }, rE.prototype.clear = function() {
                this.size = 0, this.__data__ = {
                    hash: new ry,
                    map: new (t7 || rb),
                    string: new ry
                };
            }, rE.prototype.delete = function(e) {
                var t = ih(this, e).delete(e);
                return this.size -= !!t, t;
            }, rE.prototype.get = function(e) {
                return ih(this, e).get(e);
            }, rE.prototype.has = function(e) {
                return ih(this, e).has(e);
            }, rE.prototype.set = function(e, t) {
                var r = ih(this, e), n = r.size;
                return r.set(e, t), this.size += +(r.size != n), this;
            }, rS.prototype.add = rS.prototype.push = function(e) {
                return this.__data__.set(e, i), this;
            }, rS.prototype.has = function(e) {
                return this.__data__.has(e);
            };
            function rw(e, t, n) {
                (n === r || sD(e[t], n)) && (n !== r || t in e) || rM(e, t, n);
            }
            function rP(e, t, n) {
                var i = e[t];
                eL.call(e, t) && sD(i, n) && (n !== r || t in e) || rM(e, t, n);
            }
            function rR(e, t) {
                for(var r = e.length; r--;)if (sD(e[r][0], t)) return r;
                return -1;
            }
            function rI(e, t, r, n) {
                return rV(e, function(e, i, s) {
                    t(n, e, r(e), s);
                }), n;
            }
            function rO(e, t) {
                return e && nF(t, of(t), e);
            }
            function rM(e, t, r) {
                "__proto__" == t && e8 ? e8(e, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: r,
                    writable: !0
                }) : e[t] = r;
            }
            function rL(e, t) {
                for(var n = -1, i = t.length, s = em(i), o = null == e; ++n < i;)s[n] = o ? r : ou(e, t[n]);
                return s;
            }
            function rD(e, t, n) {
                return e == e && (n !== r && (e = e <= n ? e : n), t !== r && (e = e >= t ? e : t)), e;
            }
            function rk(e, t, n, i, s, o) {
                var a, l = 1 & t, c = 2 & t, _ = 4 & t;
                if (n && (a = s ? n(e, i, s, o) : n(e)), a !== r) return a;
                if (!sY(e)) return e;
                var f = sB(e);
                if (f) {
                    if (A = (b = e).length, B = new b.constructor(A), A && "string" == typeof b[0] && eL.call(b, "index") && (B.index = b.index, B.input = b.input), a = B, !l) return nj(e, a);
                } else {
                    var b, A, B, V, U, j, F, W, H = ig(e), z = H == p || H == v;
                    if (sF(e)) return nk(e, l);
                    if (H == y || H == u || z && !s) {
                        if (a = c || z ? {} : iy(e), !l) return c ? (V = e, U = (W = a) && nF(e, op(e), W), nF(V, iv(V), U)) : (j = e, F = rO(a, e), nF(j, ip(j), F));
                    } else {
                        if (!eX[H]) return s ? e : {};
                        a = function(e, t, r) {
                            var n, i, s = e.constructor;
                            switch(t){
                                case w:
                                    return nN(e);
                                case h:
                                case d:
                                    return new s(+e);
                                case P:
                                    return n = r ? nN(e.buffer) : e.buffer, new e.constructor(n, e.byteOffset, e.byteLength);
                                case R:
                                case I:
                                case O:
                                case M:
                                case L:
                                case D:
                                case k:
                                case N:
                                case x:
                                    return nx(e, r);
                                case g:
                                    return new s;
                                case m:
                                case C:
                                    return new s(e);
                                case E:
                                    return (i = new e.constructor(e.source, ea.exec(e))).lastIndex = e.lastIndex, i;
                                case S:
                                    return new s;
                                case T:
                                    return rd ? eC(rd.call(e)) : {};
                            }
                        }(e, H, l);
                    }
                }
                o || (o = new rC);
                var G = o.get(e);
                if (G) return G;
                o.set(e, a), sX(e) ? e.forEach(function(r) {
                    a.add(rk(r, t, n, r, e, o));
                }) : sK(e) && e.forEach(function(r, i) {
                    a.set(i, rk(r, t, n, i, e, o));
                });
                var $ = _ ? c ? io : is : c ? op : of, Y = f ? r : $(e);
                return tu(Y || e, function(r, i) {
                    Y && (r = e[i = r]), rP(a, i, rk(r, t, n, i, e, o));
                }), a;
            }
            function rN(e, t, n) {
                var i = n.length;
                if (null == e) return !i;
                for(e = eC(e); i--;){
                    var s = n[i], o = t[s], a = e[s];
                    if (a === r && !(s in e) || !o(a)) return !1;
                }
                return !0;
            }
            function rx(e, t, i) {
                if ("function" != typeof e) throw new ew(n);
                return iL(function() {
                    e.apply(r, i);
                }, t);
            }
            function rB(e, t, r, n) {
                var i = -1, s = td, o = !0, a = e.length, l = [], u = t.length;
                if (!a) return l;
                r && (t = tf(t, tL(r))), n ? (s = t_, o = !1) : t.length >= 200 && (s = tk, o = !1, t = new rS(t));
                e: for(; ++i < a;){
                    var c = e[i], h = null == r ? c : r(c);
                    if (c = n || 0 !== c ? c : 0, o && h == h) {
                        for(var d = u; d--;)if (t[d] === h) continue e;
                        l.push(c);
                    } else s(t, h, n) || l.push(c);
                }
                return l;
            }
            rC.prototype.clear = function() {
                this.__data__ = new rb, this.size = 0;
            }, rC.prototype.delete = function(e) {
                var t = this.__data__, r = t.delete(e);
                return this.size = t.size, r;
            }, rC.prototype.get = function(e) {
                return this.__data__.get(e);
            }, rC.prototype.has = function(e) {
                return this.__data__.has(e);
            }, rC.prototype.set = function(e, t) {
                var r = this.__data__;
                if (r instanceof rb) {
                    var n = r.__data__;
                    if (!t7 || n.length < 199) return n.push([
                        e,
                        t
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new rE(n);
                }
                return r.set(e, t), this.size = r.size, this;
            };
            var rV = nz(r$), rU = nz(rY, !0);
            function rj(e, t) {
                var r = !0;
                return rV(e, function(e, n, i) {
                    return r = !!t(e, n, i);
                }), r;
            }
            function rF(e, t, n) {
                for(var i = -1, s = e.length; ++i < s;){
                    var o = e[i], a = t(o);
                    if (null != a && (l === r ? a == a && !s1(a) : n(a, l))) var l = a, u = o;
                }
                return u;
            }
            function rW(e, t) {
                var r = [];
                return rV(e, function(e, n, i) {
                    t(e, n, i) && r.push(e);
                }), r;
            }
            function rH(e, t, r, n, i) {
                var s = -1, o = e.length;
                for(r || (r = ib), i || (i = []); ++s < o;){
                    var a = e[s];
                    t > 0 && r(a) ? t > 1 ? rH(a, t - 1, r, n, i) : tp(i, a) : n || (i[i.length] = a);
                }
                return i;
            }
            var rz = nG(), rG = nG(!0);
            function r$(e, t) {
                return e && rz(e, t, of);
            }
            function rY(e, t) {
                return e && rG(e, t, of);
            }
            function rq(e, t) {
                return th(t, function(t) {
                    return sz(e[t]);
                });
            }
            function rK(e, t) {
                t = nM(t, e);
                for(var n = 0, i = t.length; null != e && n < i;)e = e[iV(t[n++])];
                return n && n == i ? e : r;
            }
            function rQ(e, t, r) {
                var n = t(e);
                return sB(e) ? n : tp(n, r(e));
            }
            function rJ(e) {
                var t;
                return null == e ? e === r ? "[object Undefined]" : "[object Null]" : e5 && e5 in eC(e) ? function(e) {
                    var t = eL.call(e, e5), n = e[e5];
                    try {
                        e[e5] = r;
                        var i = !0;
                    } catch (e) {}
                    var s = eN.call(e);
                    return i && (t ? e[e5] = n : delete e[e5]), s;
                }(e) : (t = e, eN.call(t));
            }
            function rZ(e, t) {
                return e > t;
            }
            function rX(e, t) {
                return null != e && eL.call(e, t);
            }
            function r0(e, t) {
                return null != e && t in eC(e);
            }
            function r1(e, t, n) {
                for(var i = n ? t_ : td, s = e[0].length, o = e.length, a = o, l = em(o), u = 1 / 0, c = []; a--;){
                    var h = e[a];
                    a && t && (h = tf(h, tL(t))), u = t3(h.length, u), l[a] = !n && (t || s >= 120 && h.length >= 120) ? new rS(a && h) : r;
                }
                h = e[0];
                var d = -1, _ = l[0];
                e: for(; ++d < s && c.length < u;){
                    var f = h[d], p = t ? t(f) : f;
                    if (f = n || 0 !== f ? f : 0, !(_ ? tk(_, p) : i(c, p, n))) {
                        for(a = o; --a;){
                            var v = l[a];
                            if (!(v ? tk(v, p) : i(e[a], p, n))) continue e;
                        }
                        _ && _.push(p), c.push(f);
                    }
                }
                return c;
            }
            function r2(e, t, n) {
                t = nM(t, e);
                var i = null == (e = iI(e, t)) ? e : e[iV(iJ(t))];
                return null == i ? r : ta(i, e, n);
            }
            function r3(e) {
                return sq(e) && rJ(e) == u;
            }
            function r4(e, t, n, i, s) {
                return e === t || (null != e && null != t && (sq(e) || sq(t)) ? function(e, t, n, i, s, o) {
                    var a = sB(e), l = sB(t), _ = a ? c : ig(e), p = l ? c : ig(t);
                    _ = _ == u ? y : _, p = p == u ? y : p;
                    var v = _ == y, b = p == y, A = _ == p;
                    if (A && sF(e)) {
                        if (!sF(t)) return !1;
                        a = !0, v = !1;
                    }
                    if (A && !v) return o || (o = new rC), a || s2(e) ? ir(e, t, n, i, s, o) : function(e, t, r, n, i, s, o) {
                        switch(r){
                            case P:
                                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) break;
                                e = e.buffer, t = t.buffer;
                            case w:
                                if (e.byteLength != t.byteLength || !s(new eF(e), new eF(t))) break;
                                return !0;
                            case h:
                            case d:
                            case m:
                                return sD(+e, +t);
                            case f:
                                return e.name == t.name && e.message == t.message;
                            case E:
                            case C:
                                return e == t + "";
                            case g:
                                var a = tF;
                            case S:
                                var l = 1 & n;
                                if (a || (a = tz), e.size != t.size && !l) break;
                                var u = o.get(e);
                                if (u) return u == t;
                                n |= 2, o.set(e, t);
                                var c = ir(a(e), a(t), n, i, s, o);
                                return o.delete(e), c;
                            case T:
                                if (rd) return rd.call(e) == rd.call(t);
                        }
                        return !1;
                    }(e, t, _, n, i, s, o);
                    if (!(1 & n)) {
                        var R = v && eL.call(e, "__wrapped__"), I = b && eL.call(t, "__wrapped__");
                        if (R || I) {
                            var O = R ? e.value() : e, M = I ? t.value() : t;
                            return o || (o = new rC), s(O, M, n, i, o);
                        }
                    }
                    return !!A && (o || (o = new rC), function(e, t, n, i, s, o) {
                        var a = 1 & n, l = is(e), u = l.length;
                        if (u != is(t).length && !a) return !1;
                        for(var c = u; c--;){
                            var h = l[c];
                            if (!(a ? h in t : eL.call(t, h))) return !1;
                        }
                        var d = o.get(e), _ = o.get(t);
                        if (d && _) return d == t && _ == e;
                        var f = !0;
                        o.set(e, t), o.set(t, e);
                        for(var p = a; ++c < u;){
                            var v = e[h = l[c]], g = t[h];
                            if (i) var m = a ? i(g, v, h, t, e, o) : i(v, g, h, e, t, o);
                            if (!(m === r ? v === g || s(v, g, n, i, o) : m)) {
                                f = !1;
                                break;
                            }
                            p || (p = "constructor" == h);
                        }
                        if (f && !p) {
                            var y = e.constructor, b = t.constructor;
                            y != b && "constructor" in e && "constructor" in t && !("function" == typeof y && y instanceof y && "function" == typeof b && b instanceof b) && (f = !1);
                        }
                        return o.delete(e), o.delete(t), f;
                    }(e, t, n, i, s, o));
                }(e, t, n, i, r4, s) : e != e && t != t);
            }
            function r6(e, t, n, i) {
                var s = n.length, o = s, a = !i;
                if (null == e) return !o;
                for(e = eC(e); s--;){
                    var l = n[s];
                    if (a && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
                }
                for(; ++s < o;){
                    var u = (l = n[s])[0], c = e[u], h = l[1];
                    if (a && l[2]) {
                        if (c === r && !(u in e)) return !1;
                    } else {
                        var d = new rC;
                        if (i) var _ = i(c, h, u, e, t, d);
                        if (!(_ === r ? r4(h, c, 3, i, d) : _)) return !1;
                    }
                }
                return !0;
            }
            function r5(e) {
                var t;
                return !(!sY(e) || (t = e, ek && ek in t)) && (sz(e) ? eV : ec).test(iU(e));
            }
            function r8(e) {
                return "function" == typeof e ? e : null == e ? oj : "object" == typeof e ? sB(e) ? nr(e[0], e[1]) : nt(e) : oK(e);
            }
            function r9(e) {
                if (!iw(e)) return t1(e);
                var t = [];
                for(var r in eC(e))eL.call(e, r) && "constructor" != r && t.push(r);
                return t;
            }
            function r7(e, t) {
                return e < t;
            }
            function ne(e, t) {
                var r = -1, n = sU(e) ? em(e.length) : [];
                return rV(e, function(e, i, s) {
                    n[++r] = t(e, i, s);
                }), n;
            }
            function nt(e) {
                var t = id(e);
                return 1 == t.length && t[0][2] ? iP(t[0][0], t[0][1]) : function(r) {
                    return r === e || r6(r, e, t);
                };
            }
            function nr(e, t) {
                var n;
                return iC(e) && (n = t) == n && !sY(n) ? iP(iV(e), t) : function(n) {
                    var i = ou(n, e);
                    return i === r && i === t ? oc(n, e) : r4(t, i, 3);
                };
            }
            function nn(e, t, n, i, s) {
                e !== t && rz(t, function(o, a) {
                    if (s || (s = new rC), sY(o)) !function(e, t, n, i, s, o, a) {
                        var l = iO(e, n), u = iO(t, n), c = a.get(u);
                        if (c) return rw(e, n, c);
                        var h = o ? o(l, u, n + "", e, t, a) : r, d = h === r;
                        if (d) {
                            var _ = sB(u), f = !_ && sF(u), p = !_ && !f && s2(u);
                            h = u, _ || f || p ? sB(l) ? h = l : sj(l) ? h = nj(l) : f ? (d = !1, h = nk(u, !0)) : p ? (d = !1, h = nx(u, !0)) : h = [] : sJ(u) || sx(u) ? (h = l, sx(l) ? h = oe(l) : (!sY(l) || sz(l)) && (h = iy(u))) : d = !1;
                        }
                        d && (a.set(u, h), s(h, u, i, o, a), a.delete(u)), rw(e, n, h);
                    }(e, t, a, n, nn, i, s);
                    else {
                        var l = i ? i(iO(e, a), o, a + "", e, t, s) : r;
                        l === r && (l = o), rw(e, a, l);
                    }
                }, op);
            }
            function ni(e, t) {
                var n = e.length;
                if (n) return iE(t += t < 0 ? n : 0, n) ? e[t] : r;
            }
            function ns(e, t, r) {
                t = t.length ? tf(t, function(e) {
                    return sB(e) ? function(t) {
                        return rK(t, 1 === e.length ? e[0] : e);
                    } : e;
                }) : [
                    oj
                ];
                var n = -1;
                t = tf(t, tL(ic()));
                var i = ne(e, function(e, r, i) {
                    return {
                        criteria: tf(t, function(t) {
                            return t(e);
                        }),
                        index: ++n,
                        value: e
                    };
                }), s = i.length;
                for(i.sort(function(e, t) {
                    return function(e, t, r) {
                        for(var n = -1, i = e.criteria, s = t.criteria, o = i.length, a = r.length; ++n < o;){
                            var l = nB(i[n], s[n]);
                            if (l) {
                                if (n >= a) return l;
                                return l * ("desc" == r[n] ? -1 : 1);
                            }
                        }
                        return e.index - t.index;
                    }(e, t, r);
                }); s--;)i[s] = i[s].value;
                return i;
            }
            function no(e, t, r) {
                for(var n = -1, i = t.length, s = {}; ++n < i;){
                    var o = t[n], a = rK(e, o);
                    r(a, o) && nd(s, nM(o, e), a);
                }
                return s;
            }
            function na(e, t, r, n) {
                var i = n ? tC : tS, s = -1, o = t.length, a = e;
                for(e === t && (t = nj(t)), r && (a = tf(e, tL(r))); ++s < o;)for(var l = 0, u = t[s], c = r ? r(u) : u; (l = i(a, c, l, n)) > -1;)a !== e && e0.call(a, l, 1), e0.call(e, l, 1);
                return e;
            }
            function nl(e, t) {
                for(var r = e ? t.length : 0, n = r - 1; r--;){
                    var i = t[r];
                    if (r == n || i !== s) {
                        var s = i;
                        iE(i) ? e0.call(e, i, 1) : nC(e, i);
                    }
                }
                return e;
            }
            function nu(e, t) {
                return e + tQ(t5() * (t - e + 1));
            }
            function nc(e, t) {
                var r = "";
                if (!e || t < 1 || t > 0x1fffffffffffff) return r;
                do t % 2 && (r += e), (t = tQ(t / 2)) && (e += e);
                while (t);
                return r;
            }
            function nh(e, t) {
                return iD(iR(e, t, oj), e + "");
            }
            function nd(e, t, n, i) {
                if (!sY(e)) return e;
                t = nM(t, e);
                for(var s = -1, o = t.length, a = o - 1, l = e; null != l && ++s < o;){
                    var u = iV(t[s]), c = n;
                    if ("__proto__" === u || "constructor" === u || "prototype" === u) break;
                    if (s != a) {
                        var h = l[u];
                        (c = i ? i(h, u, l) : r) === r && (c = sY(h) ? h : iE(t[s + 1]) ? [] : {});
                    }
                    rP(l, u, c), l = l[u];
                }
                return e;
            }
            var n_ = ri ? function(e, t) {
                return ri.set(e, t), e;
            } : oj, nf = e8 ? function(e, t) {
                return e8(e, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: oB(t),
                    writable: !0
                });
            } : oj;
            function np(e, t, r) {
                var n = -1, i = e.length;
                t < 0 && (t = -t > i ? 0 : i + t), (r = r > i ? i : r) < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
                for(var s = em(i); ++n < i;)s[n] = e[n + t];
                return s;
            }
            function nv(e, t) {
                var r;
                return rV(e, function(e, n, i) {
                    return !(r = t(e, n, i));
                }), !!r;
            }
            function ng(e, t, r) {
                var n = 0, i = null == e ? n : e.length;
                if ("number" == typeof t && t == t && i <= 0x7fffffff) {
                    for(; n < i;){
                        var s = n + i >>> 1, o = e[s];
                        null !== o && !s1(o) && (r ? o <= t : o < t) ? n = s + 1 : i = s;
                    }
                    return i;
                }
                return nm(e, t, oj, r);
            }
            function nm(e, t, n, i) {
                var s = 0, o = null == e ? 0 : e.length;
                if (0 === o) return 0;
                for(var a = (t = n(t)) != t, l = null === t, u = s1(t), c = t === r; s < o;){
                    var h = tQ((s + o) / 2), d = n(e[h]), _ = d !== r, f = null === d, p = d == d, v = s1(d);
                    if (a) var g = i || p;
                    else g = c ? p && (i || _) : l ? p && _ && (i || !f) : u ? p && _ && !f && (i || !v) : !f && !v && (i ? d <= t : d < t);
                    g ? s = h + 1 : o = h;
                }
                return t3(o, 0xfffffffe);
            }
            function ny(e, t) {
                for(var r = -1, n = e.length, i = 0, s = []; ++r < n;){
                    var o = e[r], a = t ? t(o) : o;
                    if (!r || !sD(a, l)) {
                        var l = a;
                        s[i++] = 0 === o ? 0 : o;
                    }
                }
                return s;
            }
            function nb(e) {
                return "number" == typeof e ? e : s1(e) ? a : +e;
            }
            function nE(e) {
                if ("string" == typeof e) return e;
                if (sB(e)) return tf(e, nE) + "";
                if (s1(e)) return r_ ? r_.call(e) : "";
                var t = e + "";
                return "0" == t && 1 / e == -o ? "-0" : t;
            }
            function nS(e, t, r) {
                var n = -1, i = td, s = e.length, o = !0, a = [], l = a;
                if (r) o = !1, i = t_;
                else if (s >= 200) {
                    var u = t ? null : n5(e);
                    if (u) return tz(u);
                    o = !1, i = tk, l = new rS;
                } else l = t ? [] : a;
                e: for(; ++n < s;){
                    var c = e[n], h = t ? t(c) : c;
                    if (c = r || 0 !== c ? c : 0, o && h == h) {
                        for(var d = l.length; d--;)if (l[d] === h) continue e;
                        t && l.push(h), a.push(c);
                    } else i(l, h, r) || (l !== a && l.push(h), a.push(c));
                }
                return a;
            }
            function nC(e, t) {
                return t = nM(t, e), null == (e = iI(e, t)) || delete e[iV(iJ(t))];
            }
            function nT(e, t, r, n) {
                return nd(e, t, r(rK(e, t)), n);
            }
            function nA(e, t, r, n) {
                for(var i = e.length, s = n ? i : -1; (n ? s-- : ++s < i) && t(e[s], s, e););
                return r ? np(e, n ? 0 : s, n ? s + 1 : i) : np(e, n ? s + 1 : 0, n ? i : s);
            }
            function nw(e, t) {
                var r = e;
                return r instanceof rm && (r = r.value()), tv(t, function(e, t) {
                    return t.func.apply(t.thisArg, tp([
                        e
                    ], t.args));
                }, r);
            }
            function nP(e, t, r) {
                var n = e.length;
                if (n < 2) return n ? nS(e[0]) : [];
                for(var i = -1, s = em(n); ++i < n;)for(var o = e[i], a = -1; ++a < n;)a != i && (s[i] = rB(s[i] || o, e[a], t, r));
                return nS(rH(s, 1), t, r);
            }
            function nR(e, t, n) {
                for(var i = -1, s = e.length, o = t.length, a = {}; ++i < s;){
                    var l = i < o ? t[i] : r;
                    n(a, e[i], l);
                }
                return a;
            }
            function nI(e) {
                return sj(e) ? e : [];
            }
            function nO(e) {
                return "function" == typeof e ? e : oj;
            }
            function nM(e, t) {
                return sB(e) ? e : iC(e, t) ? [
                    e
                ] : iB(ot(e));
            }
            function nL(e, t, n) {
                var i = e.length;
                return n = n === r ? i : n, !t && n >= i ? e : np(e, t, n);
            }
            var nD = e7 || function(e) {
                return e6.clearTimeout(e);
            };
            function nk(e, t) {
                if (t) return e.slice();
                var r = e.length, n = eW ? eW(r) : new e.constructor(r);
                return e.copy(n), n;
            }
            function nN(e) {
                var t = new e.constructor(e.byteLength);
                return new eF(t).set(new eF(e)), t;
            }
            function nx(e, t) {
                var r = t ? nN(e.buffer) : e.buffer;
                return new e.constructor(r, e.byteOffset, e.length);
            }
            function nB(e, t) {
                if (e !== t) {
                    var n = e !== r, i = null === e, s = e == e, o = s1(e), a = t !== r, l = null === t, u = t == t, c = s1(t);
                    if (!l && !c && !o && e > t || o && a && u && !l && !c || i && a && u || !n && u || !s) return 1;
                    if (!i && !o && !c && e < t || c && n && s && !i && !o || l && n && s || !a && s || !u) return -1;
                }
                return 0;
            }
            function nV(e, t, r, n) {
                for(var i = -1, s = e.length, o = r.length, a = -1, l = t.length, u = t2(s - o, 0), c = em(l + u), h = !n; ++a < l;)c[a] = t[a];
                for(; ++i < o;)(h || i < s) && (c[r[i]] = e[i]);
                for(; u--;)c[a++] = e[i++];
                return c;
            }
            function nU(e, t, r, n) {
                for(var i = -1, s = e.length, o = -1, a = r.length, l = -1, u = t.length, c = t2(s - a, 0), h = em(c + u), d = !n; ++i < c;)h[i] = e[i];
                for(var _ = i; ++l < u;)h[_ + l] = t[l];
                for(; ++o < a;)(d || i < s) && (h[_ + r[o]] = e[i++]);
                return h;
            }
            function nj(e, t) {
                var r = -1, n = e.length;
                for(t || (t = em(n)); ++r < n;)t[r] = e[r];
                return t;
            }
            function nF(e, t, n, i) {
                var s = !n;
                n || (n = {});
                for(var o = -1, a = t.length; ++o < a;){
                    var l = t[o], u = i ? i(n[l], e[l], l, n, e) : r;
                    u === r && (u = e[l]), s ? rM(n, l, u) : rP(n, l, u);
                }
                return n;
            }
            function nW(e, t) {
                return function(r, n) {
                    var i = sB(r) ? tl : rI, s = t ? t() : {};
                    return i(r, e, ic(n, 2), s);
                };
            }
            function nH(e) {
                return nh(function(t, n) {
                    var i = -1, s = n.length, o = s > 1 ? n[s - 1] : r, a = s > 2 ? n[2] : r;
                    for(o = e.length > 3 && "function" == typeof o ? (s--, o) : r, a && iS(n[0], n[1], a) && (o = s < 3 ? r : o, s = 1), t = eC(t); ++i < s;){
                        var l = n[i];
                        l && e(t, l, i, o);
                    }
                    return t;
                });
            }
            function nz(e, t) {
                return function(r, n) {
                    if (null == r) return r;
                    if (!sU(r)) return e(r, n);
                    for(var i = r.length, s = t ? i : -1, o = eC(r); (t ? s-- : ++s < i) && !1 !== n(o[s], s, o););
                    return r;
                };
            }
            function nG(e) {
                return function(t, r, n) {
                    for(var i = -1, s = eC(t), o = n(t), a = o.length; a--;){
                        var l = o[e ? a : ++i];
                        if (!1 === r(s[l], l, s)) break;
                    }
                    return t;
                };
            }
            function n$(e) {
                return function(t) {
                    var n = tj(t = ot(t)) ? t$(t) : r, i = n ? n[0] : t.charAt(0), s = n ? nL(n, 1).join("") : t.slice(1);
                    return i[e]() + s;
                };
            }
            function nY(e) {
                return function(t) {
                    return tv(ok(ow(t).replace(ez, "")), e, "");
                };
            }
            function nq(e) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new e;
                        case 1:
                            return new e(t[0]);
                        case 2:
                            return new e(t[0], t[1]);
                        case 3:
                            return new e(t[0], t[1], t[2]);
                        case 4:
                            return new e(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new e(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var r = rp(e.prototype), n = e.apply(r, t);
                    return sY(n) ? n : r;
                };
            }
            function nK(e) {
                return function(t, n, i) {
                    var s = eC(t);
                    if (!sU(t)) {
                        var o = ic(n, 3);
                        t = of(t), n = function(e) {
                            return o(s[e], e, s);
                        };
                    }
                    var a = e(t, n, i);
                    return a > -1 ? s[o ? t[a] : a] : r;
                };
            }
            function nQ(e) {
                return ii(function(t) {
                    var i = t.length, s = i, o = rg.prototype.thru;
                    for(e && t.reverse(); s--;){
                        var a = t[s];
                        if ("function" != typeof a) throw new ew(n);
                        if (o && !l && "wrapper" == il(a)) var l = new rg([], !0);
                    }
                    for(s = l ? s : i; ++s < i;){
                        var u = il(a = t[s]), c = "wrapper" == u ? ia(a) : r;
                        l = c && iT(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9] ? l[il(c[0])].apply(l, c[3]) : 1 == a.length && iT(a) ? l[u]() : l.thru(a);
                    }
                    return function() {
                        var e = arguments, r = e[0];
                        if (l && 1 == e.length && sB(r)) return l.plant(r).value();
                        for(var n = 0, s = i ? t[n].apply(this, e) : r; ++n < i;)s = t[n].call(this, s);
                        return s;
                    };
                });
            }
            function nJ(e, t, n, i, s, o, a, l, u, c) {
                var h = 128 & t, d = 1 & t, _ = 2 & t, f = 24 & t, p = 512 & t, v = _ ? r : nq(e);
                function g() {
                    for(var m = arguments.length, y = em(m), b = m; b--;)y[b] = arguments[b];
                    if (f) var E = iu(g), S = function(e, t) {
                        for(var r = e.length, n = 0; r--;)e[r] === t && ++n;
                        return n;
                    }(y, E);
                    if (i && (y = nV(y, i, s, f)), o && (y = nU(y, o, a, f)), m -= S, f && m < c) {
                        var C = tH(y, E);
                        return n4(e, t, nJ, g.placeholder, n, y, C, l, u, c - m);
                    }
                    var T = d ? n : this, A = _ ? T[e] : e;
                    return m = y.length, l ? y = function(e, t) {
                        for(var n = e.length, i = t3(t.length, n), s = nj(e); i--;){
                            var o = t[i];
                            e[i] = iE(o, n) ? s[o] : r;
                        }
                        return e;
                    }(y, l) : p && m > 1 && y.reverse(), h && u < m && (y.length = u), this && this !== e6 && this instanceof g && (A = v || nq(A)), A.apply(T, y);
                }
                return g;
            }
            function nZ(e, t) {
                return function(r, n) {
                    var i, s;
                    return i = t(n), s = {}, r$(r, function(t, r, n) {
                        e(s, i(t), r, n);
                    }), s;
                };
            }
            function nX(e, t) {
                return function(n, i) {
                    var s;
                    if (n === r && i === r) return t;
                    if (n !== r && (s = n), i !== r) {
                        if (s === r) return i;
                        "string" == typeof n || "string" == typeof i ? (n = nE(n), i = nE(i)) : (n = nb(n), i = nb(i)), s = e(n, i);
                    }
                    return s;
                };
            }
            function n0(e) {
                return ii(function(t) {
                    return t = tf(t, tL(ic())), nh(function(r) {
                        var n = this;
                        return e(t, function(e) {
                            return ta(e, n, r);
                        });
                    });
                });
            }
            function n1(e, t) {
                var n = (t = t === r ? " " : nE(t)).length;
                if (n < 2) return n ? nc(t, e) : t;
                var i = nc(t, tP(e / tG(t)));
                return tj(t) ? nL(t$(i), 0, e).join("") : i.slice(0, e);
            }
            function n2(e) {
                return function(t, n, i) {
                    i && "number" != typeof i && iS(t, n, i) && (n = i = r), t = s5(t), n === r ? (n = t, t = 0) : n = s5(n), i = i === r ? t < n ? 1 : -1 : s5(i);
                    for(var s = t, o = n, a = i, l = -1, u = t2(tP((o - s) / (a || 1)), 0), c = em(u); u--;)c[e ? u : ++l] = s, s += a;
                    return c;
                };
            }
            function n3(e) {
                return function(t, r) {
                    return ("string" != typeof t || "string" != typeof r) && (t = s7(t), r = s7(r)), e(t, r);
                };
            }
            function n4(e, t, n, i, s, o, a, l, u, c) {
                var h = 8 & t, d = h ? a : r, _ = h ? r : a, f = h ? o : r, p = h ? r : o;
                t |= h ? 32 : 64, 4 & (t &= ~(h ? 64 : 32)) || (t &= -4);
                var v = [
                    e,
                    t,
                    s,
                    f,
                    d,
                    p,
                    _,
                    l,
                    u,
                    c
                ], g = n.apply(r, v);
                return iT(e) && iM(g, v), g.placeholder = i, ik(g, e, t);
            }
            function n6(e) {
                var t = eS[e];
                return function(e, r) {
                    if (e = s7(e), (r = null == r ? 0 : t3(s8(r), 292)) && tX(e)) {
                        var n = (ot(e) + "e").split("e");
                        return +((n = (ot(t(n[0] + "e" + (+n[1] + r))) + "e").split("e"))[0] + "e" + (n[1] - r));
                    }
                    return t(e);
                };
            }
            var n5 = rt && 1 / tz(new rt([
                ,
                -0
            ]))[1] == o ? function(e) {
                return new rt(e);
            } : oG;
            function n8(e) {
                return function(t) {
                    var r, n, i = ig(t);
                    return i == g ? tF(t) : i == S ? (r = -1, n = Array(t.size), t.forEach(function(e) {
                        n[++r] = [
                            e,
                            e
                        ];
                    }), n) : tf(e(t), function(e) {
                        return [
                            e,
                            t[e]
                        ];
                    });
                };
            }
            function n9(e, t, i, o, a, l, u, c) {
                var h = 2 & t;
                if (!h && "function" != typeof e) throw new ew(n);
                var d = o ? o.length : 0;
                if (d || (t &= -97, o = a = r), u = u === r ? u : t2(s8(u), 0), c = c === r ? c : s8(c), d -= a ? a.length : 0, 64 & t) {
                    var _ = o, f = a;
                    o = a = r;
                }
                var p = h ? r : ia(e), v = [
                    e,
                    t,
                    i,
                    o,
                    a,
                    _,
                    f,
                    l,
                    u,
                    c
                ];
                if (p && function(e, t) {
                    var r = e[1], n = t[1], i = r | n, o = i < 131, a = 128 == n && 8 == r || 128 == n && 256 == r && e[7].length <= t[8] || 384 == n && t[7].length <= t[8] && 8 == r;
                    if (o || a) {
                        1 & n && (e[2] = t[2], i |= 1 & r ? 0 : 4);
                        var l = t[3];
                        if (l) {
                            var u = e[3];
                            e[3] = u ? nV(u, l, t[4]) : l, e[4] = u ? tH(e[3], s) : t[4];
                        }
                        (l = t[5]) && (u = e[5], e[5] = u ? nU(u, l, t[6]) : l, e[6] = u ? tH(e[5], s) : t[6]), (l = t[7]) && (e[7] = l), 128 & n && (e[8] = null == e[8] ? t[8] : t3(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = i;
                    }
                }(v, p), e = v[0], t = v[1], i = v[2], o = v[3], a = v[4], (c = v[9] = v[9] === r ? h ? 0 : e.length : t2(v[9] - d, 0)) || !(24 & t) || (t &= -25), t && 1 != t) 8 == t || 16 == t ? R = function(e, t, n) {
                    var i = nq(e);
                    function s() {
                        for(var o = arguments.length, a = em(o), l = o, u = iu(s); l--;)a[l] = arguments[l];
                        var c = o < 3 && a[0] !== u && a[o - 1] !== u ? [] : tH(a, u);
                        return (o -= c.length) < n ? n4(e, t, nJ, s.placeholder, r, a, c, r, r, n - o) : ta(this && this !== e6 && this instanceof s ? i : e, this, a);
                    }
                    return s;
                }(e, t, c) : 32 != t && 33 != t || a.length ? R = nJ.apply(r, v) : (g = e, m = t, y = i, b = o, E = 1 & m, S = nq(g), R = function e() {
                    for(var t = -1, r = arguments.length, n = -1, i = b.length, s = em(i + r), o = this && this !== e6 && this instanceof e ? S : g; ++n < i;)s[n] = b[n];
                    for(; r--;)s[n++] = arguments[++t];
                    return ta(o, E ? y : this, s);
                });
                else var g, m, y, b, E, S, C, T, A, w, P, R = (C = e, T = t, A = i, w = 1 & T, P = nq(C), function e() {
                    return (this && this !== e6 && this instanceof e ? P : C).apply(w ? A : this, arguments);
                });
                return ik((p ? n_ : iM)(R, v), e, t);
            }
            function n7(e, t, n, i) {
                return e === r || sD(e, eI[n]) && !eL.call(i, n) ? t : e;
            }
            function ie(e, t, n, i, s, o) {
                return sY(e) && sY(t) && (o.set(t, e), nn(e, t, r, ie, o), o.delete(t)), e;
            }
            function it(e) {
                return sJ(e) ? r : e;
            }
            function ir(e, t, n, i, s, o) {
                var a = 1 & n, l = e.length, u = t.length;
                if (l != u && !(a && u > l)) return !1;
                var c = o.get(e), h = o.get(t);
                if (c && h) return c == t && h == e;
                var d = -1, _ = !0, f = 2 & n ? new rS : r;
                for(o.set(e, t), o.set(t, e); ++d < l;){
                    var p = e[d], v = t[d];
                    if (i) var g = a ? i(v, p, d, t, e, o) : i(p, v, d, e, t, o);
                    if (g !== r) {
                        if (g) continue;
                        _ = !1;
                        break;
                    }
                    if (f) {
                        if (!tm(t, function(e, t) {
                            if (!tk(f, t) && (p === e || s(p, e, n, i, o))) return f.push(t);
                        })) {
                            _ = !1;
                            break;
                        }
                    } else if (!(p === v || s(p, v, n, i, o))) {
                        _ = !1;
                        break;
                    }
                }
                return o.delete(e), o.delete(t), _;
            }
            function ii(e) {
                return iD(iR(e, r, i$), e + "");
            }
            function is(e) {
                return rQ(e, of, ip);
            }
            function io(e) {
                return rQ(e, op, iv);
            }
            var ia = ri ? function(e) {
                return ri.get(e);
            } : oG;
            function il(e) {
                for(var t = e.name + "", r = rs[t], n = eL.call(rs, t) ? r.length : 0; n--;){
                    var i = r[n], s = i.func;
                    if (null == s || s == e) return i.name;
                }
                return t;
            }
            function iu(e) {
                return (eL.call(rf, "placeholder") ? rf : e).placeholder;
            }
            function ic() {
                var e = rf.iteratee || oF;
                return e = e === oF ? r8 : e, arguments.length ? e(arguments[0], arguments[1]) : e;
            }
            function ih(e, t) {
                var r, n, i = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
            }
            function id(e) {
                for(var t = of(e), r = t.length; r--;){
                    var n, i = t[r], s = e[i];
                    t[r] = [
                        i,
                        s,
                        (n = s) == n && !sY(n)
                    ];
                }
                return t;
            }
            function i_(e, t) {
                var n = null == e ? r : e[t];
                return r5(n) ? n : r;
            }
            var ip = tJ ? function(e) {
                return null == e ? [] : th(tJ(e = eC(e)), function(t) {
                    return eq.call(e, t);
                });
            } : oZ, iv = tJ ? function(e) {
                for(var t = []; e;)tp(t, ip(e)), e = eH(e);
                return t;
            } : oZ, ig = rJ;
            function im(e, t, r) {
                t = nM(t, e);
                for(var n = -1, i = t.length, s = !1; ++n < i;){
                    var o = iV(t[n]);
                    if (!(s = null != e && r(e, o))) break;
                    e = e[o];
                }
                return s || ++n != i ? s : !!(i = null == e ? 0 : e.length) && s$(i) && iE(o, i) && (sB(e) || sx(e));
            }
            function iy(e) {
                return "function" != typeof e.constructor || iw(e) ? {} : rp(eH(e));
            }
            function ib(e) {
                return sB(e) || sx(e) || !!(e3 && e && e[e3]);
            }
            function iE(e, t) {
                var r = typeof e;
                return !!(t = null == t ? 0x1fffffffffffff : t) && ("number" == r || "symbol" != r && ed.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function iS(e, t, r) {
                if (!sY(r)) return !1;
                var n = typeof t;
                return ("number" == n ? !!(sU(r) && iE(t, r.length)) : "string" == n && t in r) && sD(r[t], e);
            }
            function iC(e, t) {
                if (sB(e)) return !1;
                var r = typeof e;
                return !!("number" == r || "symbol" == r || "boolean" == r || null == e || s1(e)) || q.test(e) || !Y.test(e) || null != t && e in eC(t);
            }
            function iT(e) {
                var t = il(e), r = rf[t];
                if ("function" != typeof r || !(t in rm.prototype)) return !1;
                if (e === r) return !0;
                var n = ia(r);
                return !!n && e === n[0];
            }
            (t9 && ig(new t9(new ArrayBuffer(1))) != P || t7 && ig(new t7) != g || re && ig(re.resolve()) != b || rt && ig(new rt) != S || rr && ig(new rr) != A) && (ig = function(e) {
                var t = rJ(e), n = t == y ? e.constructor : r, i = n ? iU(n) : "";
                if (i) switch(i){
                    case ro:
                        return P;
                    case ra:
                        return g;
                    case rl:
                        return b;
                    case ru:
                        return S;
                    case rc:
                        return A;
                }
                return t;
            });
            var iA = eO ? sz : oX;
            function iw(e) {
                var t = e && e.constructor;
                return e === ("function" == typeof t && t.prototype || eI);
            }
            function iP(e, t) {
                return function(n) {
                    return null != n && n[e] === t && (t !== r || e in eC(n));
                };
            }
            function iR(e, t, n) {
                return t = t2(t === r ? e.length - 1 : t, 0), function() {
                    for(var r = arguments, i = -1, s = t2(r.length - t, 0), o = em(s); ++i < s;)o[i] = r[t + i];
                    i = -1;
                    for(var a = em(t + 1); ++i < t;)a[i] = r[i];
                    return a[t] = n(o), ta(e, this, a);
                };
            }
            function iI(e, t) {
                return t.length < 2 ? e : rK(e, np(t, 0, -1));
            }
            function iO(e, t) {
                if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
            }
            var iM = iN(n_), iL = ty || function(e, t) {
                return e6.setTimeout(e, t);
            }, iD = iN(nf);
            function ik(e, t, r) {
                var n, i, s, o = t + "";
                return iD(e, function(e, t) {
                    var r = t.length;
                    if (!r) return e;
                    var n = r - 1;
                    return t[n] = (r > 1 ? "& " : "") + t[n], t = t.join(r > 2 ? ", " : " "), e.replace(ee, "{\n/* [wrapped with " + t + "] */\n");
                }(o, (n = (s = o.match(et)) ? s[1].split(er) : [], i = r, tu(l, function(e) {
                    var t = "_." + e[0];
                    i & e[1] && !td(n, t) && n.push(t);
                }), n.sort())));
            }
            function iN(e) {
                var t = 0, n = 0;
                return function() {
                    var i = t4(), s = 16 - (i - n);
                    if (n = i, s > 0) {
                        if (++t >= 800) return arguments[0];
                    } else t = 0;
                    return e.apply(r, arguments);
                };
            }
            function ix(e, t) {
                var n = -1, i = e.length, s = i - 1;
                for(t = t === r ? i : t; ++n < t;){
                    var o = nu(n, s), a = e[o];
                    e[o] = e[n], e[n] = a;
                }
                return e.length = t, e;
            }
            var iB = (ev = (X = sP(function(e) {
                var t = [];
                return 46 === e.charCodeAt(0) && t.push(""), e.replace(K, function(e, r, n, i) {
                    t.push(n ? i.replace(es, "$1") : r || e);
                }), t;
            }, function(e) {
                return 500 === ev.size && ev.clear(), e;
            })).cache, X);
            function iV(e) {
                if ("string" == typeof e || s1(e)) return e;
                var t = e + "";
                return "0" == t && 1 / e == -o ? "-0" : t;
            }
            function iU(e) {
                if (null != e) {
                    try {
                        return eM.call(e);
                    } catch (e) {}
                    try {
                        return e + "";
                    } catch (e) {}
                }
                return "";
            }
            function ij(e) {
                if (e instanceof rm) return e.clone();
                var t = new rg(e.__wrapped__, e.__chain__);
                return t.__actions__ = nj(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
            }
            var iF = nh(function(e, t) {
                return sj(e) ? rB(e, rH(t, 1, sj, !0)) : [];
            }), iW = nh(function(e, t) {
                var n = iJ(t);
                return sj(n) && (n = r), sj(e) ? rB(e, rH(t, 1, sj, !0), ic(n, 2)) : [];
            }), iH = nh(function(e, t) {
                var n = iJ(t);
                return sj(n) && (n = r), sj(e) ? rB(e, rH(t, 1, sj, !0), r, n) : [];
            });
            function iz(e, t, r) {
                var n = null == e ? 0 : e.length;
                if (!n) return -1;
                var i = null == r ? 0 : s8(r);
                return i < 0 && (i = t2(n + i, 0)), tE(e, ic(t, 3), i);
            }
            function iG(e, t, n) {
                var i = null == e ? 0 : e.length;
                if (!i) return -1;
                var s = i - 1;
                return n !== r && (s = s8(n), s = n < 0 ? t2(i + s, 0) : t3(s, i - 1)), tE(e, ic(t, 3), s, !0);
            }
            function i$(e) {
                return (null == e ? 0 : e.length) ? rH(e, 1) : [];
            }
            function iY(e) {
                return e && e.length ? e[0] : r;
            }
            var iq = nh(function(e) {
                var t = tf(e, nI);
                return t.length && t[0] === e[0] ? r1(t) : [];
            }), iK = nh(function(e) {
                var t = iJ(e), n = tf(e, nI);
                return t === iJ(n) ? t = r : n.pop(), n.length && n[0] === e[0] ? r1(n, ic(t, 2)) : [];
            }), iQ = nh(function(e) {
                var t = iJ(e), n = tf(e, nI);
                return (t = "function" == typeof t ? t : r) && n.pop(), n.length && n[0] === e[0] ? r1(n, r, t) : [];
            });
            function iJ(e) {
                var t = null == e ? 0 : e.length;
                return t ? e[t - 1] : r;
            }
            var iZ = nh(iX);
            function iX(e, t) {
                return e && e.length && t && t.length ? na(e, t) : e;
            }
            var i0 = ii(function(e, t) {
                var r = null == e ? 0 : e.length, n = rL(e, t);
                return nl(e, tf(t, function(e) {
                    return iE(e, r) ? +e : e;
                }).sort(nB)), n;
            });
            function i1(e) {
                return null == e ? e : t8.call(e);
            }
            var i2 = nh(function(e) {
                return nS(rH(e, 1, sj, !0));
            }), i3 = nh(function(e) {
                var t = iJ(e);
                return sj(t) && (t = r), nS(rH(e, 1, sj, !0), ic(t, 2));
            }), i4 = nh(function(e) {
                var t = iJ(e);
                return t = "function" == typeof t ? t : r, nS(rH(e, 1, sj, !0), r, t);
            });
            function i6(e) {
                if (!(e && e.length)) return [];
                var t = 0;
                return e = th(e, function(e) {
                    if (sj(e)) return t = t2(e.length, t), !0;
                }), tO(t, function(t) {
                    return tf(e, tw(t));
                });
            }
            function i5(e, t) {
                if (!(e && e.length)) return [];
                var n = i6(e);
                return null == t ? n : tf(n, function(e) {
                    return ta(t, r, e);
                });
            }
            var i8 = nh(function(e, t) {
                return sj(e) ? rB(e, t) : [];
            }), i9 = nh(function(e) {
                return nP(th(e, sj));
            }), i7 = nh(function(e) {
                var t = iJ(e);
                return sj(t) && (t = r), nP(th(e, sj), ic(t, 2));
            }), se = nh(function(e) {
                var t = iJ(e);
                return t = "function" == typeof t ? t : r, nP(th(e, sj), r, t);
            }), st = nh(i6), sr = nh(function(e) {
                var t = e.length, n = t > 1 ? e[t - 1] : r;
                return n = "function" == typeof n ? (e.pop(), n) : r, i5(e, n);
            });
            function sn(e) {
                var t = rf(e);
                return t.__chain__ = !0, t;
            }
            function si(e, t) {
                return t(e);
            }
            var ss = ii(function(e) {
                var t = e.length, n = t ? e[0] : 0, i = this.__wrapped__, s = function(t) {
                    return rL(t, e);
                };
                return !(t > 1) && !this.__actions__.length && i instanceof rm && iE(n) ? ((i = i.slice(n, +n + +!!t)).__actions__.push({
                    func: si,
                    args: [
                        s
                    ],
                    thisArg: r
                }), new rg(i, this.__chain__).thru(function(e) {
                    return t && !e.length && e.push(r), e;
                })) : this.thru(s);
            }), so = nW(function(e, t, r) {
                eL.call(e, r) ? ++e[r] : rM(e, r, 1);
            }), sa = nK(iz), sl = nK(iG);
            function su(e, t) {
                return (sB(e) ? tu : rV)(e, ic(t, 3));
            }
            function sc(e, t) {
                return (sB(e) ? function(e, t) {
                    for(var r = null == e ? 0 : e.length; r-- && !1 !== t(e[r], r, e););
                    return e;
                } : rU)(e, ic(t, 3));
            }
            var sh = nW(function(e, t, r) {
                eL.call(e, r) ? e[r].push(t) : rM(e, r, [
                    t
                ]);
            }), sd = nh(function(e, t, r) {
                var n = -1, i = "function" == typeof t, s = sU(e) ? em(e.length) : [];
                return rV(e, function(e) {
                    s[++n] = i ? ta(t, e, r) : r2(e, t, r);
                }), s;
            }), s_ = nW(function(e, t, r) {
                rM(e, r, t);
            });
            function sf(e, t) {
                return (sB(e) ? tf : ne)(e, ic(t, 3));
            }
            var sp = nW(function(e, t, r) {
                e[+!r].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            }), sv = nh(function(e, t) {
                if (null == e) return [];
                var r = t.length;
                return r > 1 && iS(e, t[0], t[1]) ? t = [] : r > 2 && iS(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), ns(e, rH(t, 1), []);
            }), sg = te || function() {
                return e6.Date.now();
            };
            function sm(e, t, n) {
                return t = n ? r : t, t = e && null == t ? e.length : t, n9(e, 128, r, r, r, r, t);
            }
            function sy(e, t) {
                var i;
                if ("function" != typeof t) throw new ew(n);
                return e = s8(e), function() {
                    return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = r), i;
                };
            }
            var sb = nh(function(e, t, r) {
                var n = 1;
                if (r.length) {
                    var i = tH(r, iu(sb));
                    n |= 32;
                }
                return n9(e, n, t, r, i);
            }), sE = nh(function(e, t, r) {
                var n = 3;
                if (r.length) {
                    var i = tH(r, iu(sE));
                    n |= 32;
                }
                return n9(t, n, e, r, i);
            });
            function sS(e, t, n) {
                t = n ? r : t;
                var i = n9(e, 8, r, r, r, r, r, t);
                return i.placeholder = sS.placeholder, i;
            }
            function sC(e, t, n) {
                t = n ? r : t;
                var i = n9(e, 16, r, r, r, r, r, t);
                return i.placeholder = sC.placeholder, i;
            }
            function sT(e, t, i) {
                var s, o, a, l, u, c, h = 0, d = !1, _ = !1, f = !0;
                if ("function" != typeof e) throw new ew(n);
                function p(t) {
                    var n = s, i = o;
                    return s = o = r, h = t, l = e.apply(i, n);
                }
                function v(e) {
                    var n = e - c, i = e - h;
                    return c === r || n >= t || n < 0 || _ && i >= a;
                }
                function g() {
                    var e, r, n, i = sg();
                    if (v(i)) return m(i);
                    u = iL(g, (e = i - c, r = i - h, n = t - e, _ ? t3(n, a - r) : n));
                }
                function m(e) {
                    return (u = r, f && s) ? p(e) : (s = o = r, l);
                }
                function y() {
                    var e, n = sg(), i = v(n);
                    if (s = arguments, o = this, c = n, i) {
                        if (u === r) return h = e = c, u = iL(g, t), d ? p(e) : l;
                        if (_) return nD(u), u = iL(g, t), p(c);
                    }
                    return u === r && (u = iL(g, t)), l;
                }
                return t = s7(t) || 0, sY(i) && (d = !!i.leading, a = (_ = "maxWait" in i) ? t2(s7(i.maxWait) || 0, t) : a, f = "trailing" in i ? !!i.trailing : f), y.cancel = function() {
                    u !== r && nD(u), h = 0, s = c = o = u = r;
                }, y.flush = function() {
                    return u === r ? l : m(sg());
                }, y;
            }
            var sA = nh(function(e, t) {
                return rx(e, 1, t);
            }), sw = nh(function(e, t, r) {
                return rx(e, s7(t) || 0, r);
            });
            function sP(e, t) {
                if ("function" != typeof e || null != t && "function" != typeof t) throw new ew(n);
                var r = function() {
                    var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                    if (s.has(i)) return s.get(i);
                    var o = e.apply(this, n);
                    return r.cache = s.set(i, o) || s, o;
                };
                return r.cache = new (sP.Cache || rE), r;
            }
            function sR(e) {
                if ("function" != typeof e) throw new ew(n);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !e.call(this);
                        case 1:
                            return !e.call(this, t[0]);
                        case 2:
                            return !e.call(this, t[0], t[1]);
                        case 3:
                            return !e.call(this, t[0], t[1], t[2]);
                    }
                    return !e.apply(this, t);
                };
            }
            sP.Cache = rE;
            var sI = nh(function(e, t) {
                var r = (t = 1 == t.length && sB(t[0]) ? tf(t[0], tL(ic())) : tf(rH(t, 1), tL(ic()))).length;
                return nh(function(n) {
                    for(var i = -1, s = t3(n.length, r); ++i < s;)n[i] = t[i].call(this, n[i]);
                    return ta(e, this, n);
                });
            }), sO = nh(function(e, t) {
                var n = tH(t, iu(sO));
                return n9(e, 32, r, t, n);
            }), sM = nh(function(e, t) {
                var n = tH(t, iu(sM));
                return n9(e, 64, r, t, n);
            }), sL = ii(function(e, t) {
                return n9(e, 256, r, r, r, t);
            });
            function sD(e, t) {
                return e === t || e != e && t != t;
            }
            var sk = n3(rZ), sN = n3(function(e, t) {
                return e >= t;
            }), sx = r3(function() {
                return arguments;
            }()) ? r3 : function(e) {
                return sq(e) && eL.call(e, "callee") && !eq.call(e, "callee");
            }, sB = em.isArray, sV = tt ? tL(tt) : function(e) {
                return sq(e) && rJ(e) == w;
            };
            function sU(e) {
                return null != e && s$(e.length) && !sz(e);
            }
            function sj(e) {
                return sq(e) && sU(e);
            }
            var sF = tZ || oX, sW = tr ? tL(tr) : function(e) {
                return sq(e) && rJ(e) == d;
            };
            function sH(e) {
                if (!sq(e)) return !1;
                var t = rJ(e);
                return t == f || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !sJ(e);
            }
            function sz(e) {
                if (!sY(e)) return !1;
                var t = rJ(e);
                return t == p || t == v || "[object AsyncFunction]" == t || "[object Proxy]" == t;
            }
            function sG(e) {
                return "number" == typeof e && e == s8(e);
            }
            function s$(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 0x1fffffffffffff;
            }
            function sY(e) {
                var t = typeof e;
                return null != e && ("object" == t || "function" == t);
            }
            function sq(e) {
                return null != e && "object" == typeof e;
            }
            var sK = tn ? tL(tn) : function(e) {
                return sq(e) && ig(e) == g;
            };
            function sQ(e) {
                return "number" == typeof e || sq(e) && rJ(e) == m;
            }
            function sJ(e) {
                if (!sq(e) || rJ(e) != y) return !1;
                var t = eH(e);
                if (null === t) return !0;
                var r = eL.call(t, "constructor") && t.constructor;
                return "function" == typeof r && r instanceof r && eM.call(r) == ex;
            }
            var sZ = ti ? tL(ti) : function(e) {
                return sq(e) && rJ(e) == E;
            }, sX = ts ? tL(ts) : function(e) {
                return sq(e) && ig(e) == S;
            };
            function s0(e) {
                return "string" == typeof e || !sB(e) && sq(e) && rJ(e) == C;
            }
            function s1(e) {
                return "symbol" == typeof e || sq(e) && rJ(e) == T;
            }
            var s2 = to ? tL(to) : function(e) {
                return sq(e) && s$(e.length) && !!eZ[rJ(e)];
            }, s3 = n3(r7), s4 = n3(function(e, t) {
                return e <= t;
            });
            function s6(e) {
                if (!e) return [];
                if (sU(e)) return s0(e) ? t$(e) : nj(e);
                if (e4 && e[e4]) {
                    for(var t, r = e[e4](), n = []; !(t = r.next()).done;)n.push(t.value);
                    return n;
                }
                var i = ig(e);
                return (i == g ? tF : i == S ? tz : oC)(e);
            }
            function s5(e) {
                return e ? (e = s7(e)) === o || e === -o ? (e < 0 ? -1 : 1) * 17976931348623157e292 : e == e ? e : 0 : 0 === e ? e : 0;
            }
            function s8(e) {
                var t = s5(e), r = t % 1;
                return t == t ? r ? t - r : t : 0;
            }
            function s9(e) {
                return e ? rD(s8(e), 0, 0xffffffff) : 0;
            }
            function s7(e) {
                if ("number" == typeof e) return e;
                if (s1(e)) return a;
                if (sY(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = sY(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = tM(e);
                var r = eu.test(e);
                return r || eh.test(e) ? e2(e.slice(2), r ? 2 : 8) : el.test(e) ? a : +e;
            }
            function oe(e) {
                return nF(e, op(e));
            }
            function ot(e) {
                return null == e ? "" : nE(e);
            }
            var or = nH(function(e, t) {
                if (iw(t) || sU(t)) return void nF(t, of(t), e);
                for(var r in t)eL.call(t, r) && rP(e, r, t[r]);
            }), on = nH(function(e, t) {
                nF(t, op(t), e);
            }), oi = nH(function(e, t, r, n) {
                nF(t, op(t), e, n);
            }), os = nH(function(e, t, r, n) {
                nF(t, of(t), e, n);
            }), oo = ii(rL), oa = nh(function(e, t) {
                e = eC(e);
                var n = -1, i = t.length, s = i > 2 ? t[2] : r;
                for(s && iS(t[0], t[1], s) && (i = 1); ++n < i;)for(var o = t[n], a = op(o), l = -1, u = a.length; ++l < u;){
                    var c = a[l], h = e[c];
                    (h === r || sD(h, eI[c]) && !eL.call(e, c)) && (e[c] = o[c]);
                }
                return e;
            }), ol = nh(function(e) {
                return e.push(r, ie), ta(og, r, e);
            });
            function ou(e, t, n) {
                var i = null == e ? r : rK(e, t);
                return i === r ? n : i;
            }
            function oc(e, t) {
                return null != e && im(e, t, r0);
            }
            var oh = nZ(function(e, t, r) {
                null != t && "function" != typeof t.toString && (t = eN.call(t)), e[t] = r;
            }, oB(oj)), od = nZ(function(e, t, r) {
                null != t && "function" != typeof t.toString && (t = eN.call(t)), eL.call(e, t) ? e[t].push(r) : e[t] = [
                    r
                ];
            }, ic), o_ = nh(r2);
            function of(e) {
                return sU(e) ? rT(e) : r9(e);
            }
            function op(e) {
                return sU(e) ? rT(e, !0) : function(e) {
                    if (!sY(e)) {
                        var t = e, r = [];
                        if (null != t) for(var n in eC(t))r.push(n);
                        return r;
                    }
                    var i = iw(e), s = [];
                    for(var o in e)"constructor" == o && (i || !eL.call(e, o)) || s.push(o);
                    return s;
                }(e);
            }
            var ov = nH(function(e, t, r) {
                nn(e, t, r);
            }), og = nH(function(e, t, r, n) {
                nn(e, t, r, n);
            }), om = ii(function(e, t) {
                var r = {};
                if (null == e) return r;
                var n = !1;
                t = tf(t, function(t) {
                    return t = nM(t, e), n || (n = t.length > 1), t;
                }), nF(e, io(e), r), n && (r = rk(r, 7, it));
                for(var i = t.length; i--;)nC(r, t[i]);
                return r;
            }), oy = ii(function(e, t) {
                return null == e ? {} : no(e, t, function(t, r) {
                    return oc(e, r);
                });
            });
            function ob(e, t) {
                if (null == e) return {};
                var r = tf(io(e), function(e) {
                    return [
                        e
                    ];
                });
                return t = ic(t), no(e, r, function(e, r) {
                    return t(e, r[0]);
                });
            }
            var oE = n8(of), oS = n8(op);
            function oC(e) {
                return null == e ? [] : tD(e, of(e));
            }
            var oT = nY(function(e, t, r) {
                return t = t.toLowerCase(), e + (r ? oA(t) : t);
            });
            function oA(e) {
                return oD(ot(e).toLowerCase());
            }
            function ow(e) {
                return (e = ot(e)) && e.replace(e_, tB).replace(eG, "");
            }
            var oP = nY(function(e, t, r) {
                return e + (r ? "-" : "") + t.toLowerCase();
            }), oR = nY(function(e, t, r) {
                return e + (r ? " " : "") + t.toLowerCase();
            }), oI = n$("toLowerCase"), oO = nY(function(e, t, r) {
                return e + (r ? "_" : "") + t.toLowerCase();
            }), oM = nY(function(e, t, r) {
                return e + (r ? " " : "") + oD(t);
            }), oL = nY(function(e, t, r) {
                return e + (r ? " " : "") + t.toUpperCase();
            }), oD = n$("toUpperCase");
            function ok(e, t, n) {
                if (e = ot(e), (t = n ? r : t) === r) {
                    var i;
                    return (i = e, eK.test(i)) ? e.match(eY) || [] : e.match(en) || [];
                }
                return e.match(t) || [];
            }
            var oN = nh(function(e, t) {
                try {
                    return ta(e, r, t);
                } catch (e) {
                    return sH(e) ? e : new eb(e);
                }
            }), ox = ii(function(e, t) {
                return tu(t, function(t) {
                    rM(e, t = iV(t), sb(e[t], e));
                }), e;
            });
            function oB(e) {
                return function() {
                    return e;
                };
            }
            var oV = nQ(), oU = nQ(!0);
            function oj(e) {
                return e;
            }
            function oF(e) {
                return r8("function" == typeof e ? e : rk(e, 1));
            }
            var oW = nh(function(e, t) {
                return function(r) {
                    return r2(r, e, t);
                };
            }), oH = nh(function(e, t) {
                return function(r) {
                    return r2(e, r, t);
                };
            });
            function oz(e, t, r) {
                var n = of(t), i = rq(t, n);
                null != r || sY(t) && (i.length || !n.length) || (r = t, t = e, e = this, i = rq(t, of(t)));
                var s = !(sY(r) && "chain" in r) || !!r.chain, o = sz(e);
                return tu(i, function(r) {
                    var n = t[r];
                    e[r] = n, o && (e.prototype[r] = function() {
                        var t = this.__chain__;
                        if (s || t) {
                            var r = e(this.__wrapped__);
                            return (r.__actions__ = nj(this.__actions__)).push({
                                func: n,
                                args: arguments,
                                thisArg: e
                            }), r.__chain__ = t, r;
                        }
                        return n.apply(e, tp([
                            this.value()
                        ], arguments));
                    });
                }), e;
            }
            function oG() {}
            var o$ = n0(tf), oY = n0(tc), oq = n0(tm);
            function oK(e) {
                return iC(e) ? tw(iV(e)) : function(t) {
                    return rK(t, e);
                };
            }
            var oQ = n2(), oJ = n2(!0);
            function oZ() {
                return [];
            }
            function oX() {
                return !1;
            }
            var o0 = nX(function(e, t) {
                return e + t;
            }, 0), o1 = n6("ceil"), o2 = nX(function(e, t) {
                return e / t;
            }, 1), o3 = n6("floor"), o4 = nX(function(e, t) {
                return e * t;
            }, 1), o6 = n6("round"), o5 = nX(function(e, t) {
                return e - t;
            }, 0);
            return rf.after = function(e, t) {
                if ("function" != typeof t) throw new ew(n);
                return e = s8(e), function() {
                    if (--e < 1) return t.apply(this, arguments);
                };
            }, rf.ary = sm, rf.assign = or, rf.assignIn = on, rf.assignInWith = oi, rf.assignWith = os, rf.at = oo, rf.before = sy, rf.bind = sb, rf.bindAll = ox, rf.bindKey = sE, rf.castArray = function() {
                if (!arguments.length) return [];
                var e = arguments[0];
                return sB(e) ? e : [
                    e
                ];
            }, rf.chain = sn, rf.chunk = function(e, t, n) {
                t = (n ? iS(e, t, n) : t === r) ? 1 : t2(s8(t), 0);
                var i = null == e ? 0 : e.length;
                if (!i || t < 1) return [];
                for(var s = 0, o = 0, a = em(tP(i / t)); s < i;)a[o++] = np(e, s, s += t);
                return a;
            }, rf.compact = function(e) {
                for(var t = -1, r = null == e ? 0 : e.length, n = 0, i = []; ++t < r;){
                    var s = e[t];
                    s && (i[n++] = s);
                }
                return i;
            }, rf.concat = function() {
                var e = arguments.length;
                if (!e) return [];
                for(var t = em(e - 1), r = arguments[0], n = e; n--;)t[n - 1] = arguments[n];
                return tp(sB(r) ? nj(r) : [
                    r
                ], rH(t, 1));
            }, rf.cond = function(e) {
                var t = null == e ? 0 : e.length, r = ic();
                return e = t ? tf(e, function(e) {
                    if ("function" != typeof e[1]) throw new ew(n);
                    return [
                        r(e[0]),
                        e[1]
                    ];
                }) : [], nh(function(r) {
                    for(var n = -1; ++n < t;){
                        var i = e[n];
                        if (ta(i[0], this, r)) return ta(i[1], this, r);
                    }
                });
            }, rf.conforms = function(e) {
                var t, r;
                return r = of(t = rk(e, 1)), function(e) {
                    return rN(e, t, r);
                };
            }, rf.constant = oB, rf.countBy = so, rf.create = function(e, t) {
                var r = rp(e);
                return null == t ? r : rO(r, t);
            }, rf.curry = sS, rf.curryRight = sC, rf.debounce = sT, rf.defaults = oa, rf.defaultsDeep = ol, rf.defer = sA, rf.delay = sw, rf.difference = iF, rf.differenceBy = iW, rf.differenceWith = iH, rf.drop = function(e, t, n) {
                var i = null == e ? 0 : e.length;
                return i ? np(e, (t = n || t === r ? 1 : s8(t)) < 0 ? 0 : t, i) : [];
            }, rf.dropRight = function(e, t, n) {
                var i = null == e ? 0 : e.length;
                return i ? np(e, 0, (t = i - (t = n || t === r ? 1 : s8(t))) < 0 ? 0 : t) : [];
            }, rf.dropRightWhile = function(e, t) {
                return e && e.length ? nA(e, ic(t, 3), !0, !0) : [];
            }, rf.dropWhile = function(e, t) {
                return e && e.length ? nA(e, ic(t, 3), !0) : [];
            }, rf.fill = function(e, t, n, i) {
                var s = null == e ? 0 : e.length;
                if (!s) return [];
                n && "number" != typeof n && iS(e, t, n) && (n = 0, i = s);
                var o = n, a = i, l = e.length;
                for((o = s8(o)) < 0 && (o = -o > l ? 0 : l + o), (a = a === r || a > l ? l : s8(a)) < 0 && (a += l), a = o > a ? 0 : s9(a); o < a;)e[o++] = t;
                return e;
            }, rf.filter = function(e, t) {
                return (sB(e) ? th : rW)(e, ic(t, 3));
            }, rf.flatMap = function(e, t) {
                return rH(sf(e, t), 1);
            }, rf.flatMapDeep = function(e, t) {
                return rH(sf(e, t), o);
            }, rf.flatMapDepth = function(e, t, n) {
                return n = n === r ? 1 : s8(n), rH(sf(e, t), n);
            }, rf.flatten = i$, rf.flattenDeep = function(e) {
                return (null == e ? 0 : e.length) ? rH(e, o) : [];
            }, rf.flattenDepth = function(e, t) {
                return (null == e ? 0 : e.length) ? rH(e, t = t === r ? 1 : s8(t)) : [];
            }, rf.flip = function(e) {
                return n9(e, 512);
            }, rf.flow = oV, rf.flowRight = oU, rf.fromPairs = function(e) {
                for(var t = -1, r = null == e ? 0 : e.length, n = {}; ++t < r;){
                    var i = e[t];
                    n[i[0]] = i[1];
                }
                return n;
            }, rf.functions = function(e) {
                return null == e ? [] : rq(e, of(e));
            }, rf.functionsIn = function(e) {
                return null == e ? [] : rq(e, op(e));
            }, rf.groupBy = sh, rf.initial = function(e) {
                return (null == e ? 0 : e.length) ? np(e, 0, -1) : [];
            }, rf.intersection = iq, rf.intersectionBy = iK, rf.intersectionWith = iQ, rf.invert = oh, rf.invertBy = od, rf.invokeMap = sd, rf.iteratee = oF, rf.keyBy = s_, rf.keys = of, rf.keysIn = op, rf.map = sf, rf.mapKeys = function(e, t) {
                var r = {};
                return t = ic(t, 3), r$(e, function(e, n, i) {
                    rM(r, t(e, n, i), e);
                }), r;
            }, rf.mapValues = function(e, t) {
                var r = {};
                return t = ic(t, 3), r$(e, function(e, n, i) {
                    rM(r, n, t(e, n, i));
                }), r;
            }, rf.matches = function(e) {
                return nt(rk(e, 1));
            }, rf.matchesProperty = function(e, t) {
                return nr(e, rk(t, 1));
            }, rf.memoize = sP, rf.merge = ov, rf.mergeWith = og, rf.method = oW, rf.methodOf = oH, rf.mixin = oz, rf.negate = sR, rf.nthArg = function(e) {
                return e = s8(e), nh(function(t) {
                    return ni(t, e);
                });
            }, rf.omit = om, rf.omitBy = function(e, t) {
                return ob(e, sR(ic(t)));
            }, rf.once = function(e) {
                return sy(2, e);
            }, rf.orderBy = function(e, t, n, i) {
                return null == e ? [] : (sB(t) || (t = null == t ? [] : [
                    t
                ]), sB(n = i ? r : n) || (n = null == n ? [] : [
                    n
                ]), ns(e, t, n));
            }, rf.over = o$, rf.overArgs = sI, rf.overEvery = oY, rf.overSome = oq, rf.partial = sO, rf.partialRight = sM, rf.partition = sp, rf.pick = oy, rf.pickBy = ob, rf.property = oK, rf.propertyOf = function(e) {
                return function(t) {
                    return null == e ? r : rK(e, t);
                };
            }, rf.pull = iZ, rf.pullAll = iX, rf.pullAllBy = function(e, t, r) {
                return e && e.length && t && t.length ? na(e, t, ic(r, 2)) : e;
            }, rf.pullAllWith = function(e, t, n) {
                return e && e.length && t && t.length ? na(e, t, r, n) : e;
            }, rf.pullAt = i0, rf.range = oQ, rf.rangeRight = oJ, rf.rearg = sL, rf.reject = function(e, t) {
                return (sB(e) ? th : rW)(e, sR(ic(t, 3)));
            }, rf.remove = function(e, t) {
                var r = [];
                if (!(e && e.length)) return r;
                var n = -1, i = [], s = e.length;
                for(t = ic(t, 3); ++n < s;){
                    var o = e[n];
                    t(o, n, e) && (r.push(o), i.push(n));
                }
                return nl(e, i), r;
            }, rf.rest = function(e, t) {
                if ("function" != typeof e) throw new ew(n);
                return nh(e, t = t === r ? t : s8(t));
            }, rf.reverse = i1, rf.sampleSize = function(e, t, n) {
                return t = (n ? iS(e, t, n) : t === r) ? 1 : s8(t), (sB(e) ? function(e, t) {
                    return ix(nj(e), rD(t, 0, e.length));
                } : function(e, t) {
                    var r = oC(e);
                    return ix(r, rD(t, 0, r.length));
                })(e, t);
            }, rf.set = function(e, t, r) {
                return null == e ? e : nd(e, t, r);
            }, rf.setWith = function(e, t, n, i) {
                return i = "function" == typeof i ? i : r, null == e ? e : nd(e, t, n, i);
            }, rf.shuffle = function(e) {
                return (sB(e) ? function(e) {
                    return ix(nj(e));
                } : function(e) {
                    return ix(oC(e));
                })(e);
            }, rf.slice = function(e, t, n) {
                var i = null == e ? 0 : e.length;
                return i ? (n && "number" != typeof n && iS(e, t, n) ? (t = 0, n = i) : (t = null == t ? 0 : s8(t), n = n === r ? i : s8(n)), np(e, t, n)) : [];
            }, rf.sortBy = sv, rf.sortedUniq = function(e) {
                return e && e.length ? ny(e) : [];
            }, rf.sortedUniqBy = function(e, t) {
                return e && e.length ? ny(e, ic(t, 2)) : [];
            }, rf.split = function(e, t, n) {
                return (n && "number" != typeof n && iS(e, t, n) && (t = n = r), n = n === r ? 0xffffffff : n >>> 0) ? (e = ot(e)) && ("string" == typeof t || null != t && !sZ(t)) && !(t = nE(t)) && tj(e) ? nL(t$(e), 0, n) : e.split(t, n) : [];
            }, rf.spread = function(e, t) {
                if ("function" != typeof e) throw new ew(n);
                return t = null == t ? 0 : t2(s8(t), 0), nh(function(r) {
                    var n = r[t], i = nL(r, 0, t);
                    return n && tp(i, n), ta(e, this, i);
                });
            }, rf.tail = function(e) {
                var t = null == e ? 0 : e.length;
                return t ? np(e, 1, t) : [];
            }, rf.take = function(e, t, n) {
                return e && e.length ? np(e, 0, (t = n || t === r ? 1 : s8(t)) < 0 ? 0 : t) : [];
            }, rf.takeRight = function(e, t, n) {
                var i = null == e ? 0 : e.length;
                return i ? np(e, (t = i - (t = n || t === r ? 1 : s8(t))) < 0 ? 0 : t, i) : [];
            }, rf.takeRightWhile = function(e, t) {
                return e && e.length ? nA(e, ic(t, 3), !1, !0) : [];
            }, rf.takeWhile = function(e, t) {
                return e && e.length ? nA(e, ic(t, 3)) : [];
            }, rf.tap = function(e, t) {
                return t(e), e;
            }, rf.throttle = function(e, t, r) {
                var i = !0, s = !0;
                if ("function" != typeof e) throw new ew(n);
                return sY(r) && (i = "leading" in r ? !!r.leading : i, s = "trailing" in r ? !!r.trailing : s), sT(e, t, {
                    leading: i,
                    maxWait: t,
                    trailing: s
                });
            }, rf.thru = si, rf.toArray = s6, rf.toPairs = oE, rf.toPairsIn = oS, rf.toPath = function(e) {
                return sB(e) ? tf(e, iV) : s1(e) ? [
                    e
                ] : nj(iB(ot(e)));
            }, rf.toPlainObject = oe, rf.transform = function(e, t, r) {
                var n = sB(e), i = n || sF(e) || s2(e);
                if (t = ic(t, 4), null == r) {
                    var s = e && e.constructor;
                    r = i ? n ? new s : [] : sY(e) && sz(s) ? rp(eH(e)) : {};
                }
                return (i ? tu : r$)(e, function(e, n, i) {
                    return t(r, e, n, i);
                }), r;
            }, rf.unary = function(e) {
                return sm(e, 1);
            }, rf.union = i2, rf.unionBy = i3, rf.unionWith = i4, rf.uniq = function(e) {
                return e && e.length ? nS(e) : [];
            }, rf.uniqBy = function(e, t) {
                return e && e.length ? nS(e, ic(t, 2)) : [];
            }, rf.uniqWith = function(e, t) {
                return t = "function" == typeof t ? t : r, e && e.length ? nS(e, r, t) : [];
            }, rf.unset = function(e, t) {
                return null == e || nC(e, t);
            }, rf.unzip = i6, rf.unzipWith = i5, rf.update = function(e, t, r) {
                return null == e ? e : nT(e, t, nO(r));
            }, rf.updateWith = function(e, t, n, i) {
                return i = "function" == typeof i ? i : r, null == e ? e : nT(e, t, nO(n), i);
            }, rf.values = oC, rf.valuesIn = function(e) {
                return null == e ? [] : tD(e, op(e));
            }, rf.without = i8, rf.words = ok, rf.wrap = function(e, t) {
                return sO(nO(t), e);
            }, rf.xor = i9, rf.xorBy = i7, rf.xorWith = se, rf.zip = st, rf.zipObject = function(e, t) {
                return nR(e || [], t || [], rP);
            }, rf.zipObjectDeep = function(e, t) {
                return nR(e || [], t || [], nd);
            }, rf.zipWith = sr, rf.entries = oE, rf.entriesIn = oS, rf.extend = on, rf.extendWith = oi, oz(rf, rf), rf.add = o0, rf.attempt = oN, rf.camelCase = oT, rf.capitalize = oA, rf.ceil = o1, rf.clamp = function(e, t, n) {
                return n === r && (n = t, t = r), n !== r && (n = (n = s7(n)) == n ? n : 0), t !== r && (t = (t = s7(t)) == t ? t : 0), rD(s7(e), t, n);
            }, rf.clone = function(e) {
                return rk(e, 4);
            }, rf.cloneDeep = function(e) {
                return rk(e, 5);
            }, rf.cloneDeepWith = function(e, t) {
                return rk(e, 5, t = "function" == typeof t ? t : r);
            }, rf.cloneWith = function(e, t) {
                return rk(e, 4, t = "function" == typeof t ? t : r);
            }, rf.conformsTo = function(e, t) {
                return null == t || rN(e, t, of(t));
            }, rf.deburr = ow, rf.defaultTo = function(e, t) {
                return null == e || e != e ? t : e;
            }, rf.divide = o2, rf.endsWith = function(e, t, n) {
                e = ot(e), t = nE(t);
                var i = e.length, s = n = n === r ? i : rD(s8(n), 0, i);
                return (n -= t.length) >= 0 && e.slice(n, s) == t;
            }, rf.eq = sD, rf.escape = function(e) {
                return (e = ot(e)) && H.test(e) ? e.replace(F, tV) : e;
            }, rf.escapeRegExp = function(e) {
                return (e = ot(e)) && J.test(e) ? e.replace(Q, "\\$&") : e;
            }, rf.every = function(e, t, n) {
                var i = sB(e) ? tc : rj;
                return n && iS(e, t, n) && (t = r), i(e, ic(t, 3));
            }, rf.find = sa, rf.findIndex = iz, rf.findKey = function(e, t) {
                return tb(e, ic(t, 3), r$);
            }, rf.findLast = sl, rf.findLastIndex = iG, rf.findLastKey = function(e, t) {
                return tb(e, ic(t, 3), rY);
            }, rf.floor = o3, rf.forEach = su, rf.forEachRight = sc, rf.forIn = function(e, t) {
                return null == e ? e : rz(e, ic(t, 3), op);
            }, rf.forInRight = function(e, t) {
                return null == e ? e : rG(e, ic(t, 3), op);
            }, rf.forOwn = function(e, t) {
                return e && r$(e, ic(t, 3));
            }, rf.forOwnRight = function(e, t) {
                return e && rY(e, ic(t, 3));
            }, rf.get = ou, rf.gt = sk, rf.gte = sN, rf.has = function(e, t) {
                return null != e && im(e, t, rX);
            }, rf.hasIn = oc, rf.head = iY, rf.identity = oj, rf.includes = function(e, t, r, n) {
                e = sU(e) ? e : oC(e), r = r && !n ? s8(r) : 0;
                var i = e.length;
                return r < 0 && (r = t2(i + r, 0)), s0(e) ? r <= i && e.indexOf(t, r) > -1 : !!i && tS(e, t, r) > -1;
            }, rf.indexOf = function(e, t, r) {
                var n = null == e ? 0 : e.length;
                if (!n) return -1;
                var i = null == r ? 0 : s8(r);
                return i < 0 && (i = t2(n + i, 0)), tS(e, t, i);
            }, rf.inRange = function(e, t, n) {
                var i, s, o;
                return t = s5(t), n === r ? (n = t, t = 0) : n = s5(n), (i = e = s7(e)) >= t3(s = t, o = n) && i < t2(s, o);
            }, rf.invoke = o_, rf.isArguments = sx, rf.isArray = sB, rf.isArrayBuffer = sV, rf.isArrayLike = sU, rf.isArrayLikeObject = sj, rf.isBoolean = function(e) {
                return !0 === e || !1 === e || sq(e) && rJ(e) == h;
            }, rf.isBuffer = sF, rf.isDate = sW, rf.isElement = function(e) {
                return sq(e) && 1 === e.nodeType && !sJ(e);
            }, rf.isEmpty = function(e) {
                if (null == e) return !0;
                if (sU(e) && (sB(e) || "string" == typeof e || "function" == typeof e.splice || sF(e) || s2(e) || sx(e))) return !e.length;
                var t = ig(e);
                if (t == g || t == S) return !e.size;
                if (iw(e)) return !r9(e).length;
                for(var r in e)if (eL.call(e, r)) return !1;
                return !0;
            }, rf.isEqual = function(e, t) {
                return r4(e, t);
            }, rf.isEqualWith = function(e, t, n) {
                var i = (n = "function" == typeof n ? n : r) ? n(e, t) : r;
                return i === r ? r4(e, t, r, n) : !!i;
            }, rf.isError = sH, rf.isFinite = function(e) {
                return "number" == typeof e && tX(e);
            }, rf.isFunction = sz, rf.isInteger = sG, rf.isLength = s$, rf.isMap = sK, rf.isMatch = function(e, t) {
                return e === t || r6(e, t, id(t));
            }, rf.isMatchWith = function(e, t, n) {
                return n = "function" == typeof n ? n : r, r6(e, t, id(t), n);
            }, rf.isNaN = function(e) {
                return sQ(e) && e != +e;
            }, rf.isNative = function(e) {
                if (iA(e)) throw new eb("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
                return r5(e);
            }, rf.isNil = function(e) {
                return null == e;
            }, rf.isNull = function(e) {
                return null === e;
            }, rf.isNumber = sQ, rf.isObject = sY, rf.isObjectLike = sq, rf.isPlainObject = sJ, rf.isRegExp = sZ, rf.isSafeInteger = function(e) {
                return sG(e) && e >= -9007199254740991 && e <= 0x1fffffffffffff;
            }, rf.isSet = sX, rf.isString = s0, rf.isSymbol = s1, rf.isTypedArray = s2, rf.isUndefined = function(e) {
                return e === r;
            }, rf.isWeakMap = function(e) {
                return sq(e) && ig(e) == A;
            }, rf.isWeakSet = function(e) {
                return sq(e) && "[object WeakSet]" == rJ(e);
            }, rf.join = function(e, t) {
                return null == e ? "" : t0.call(e, t);
            }, rf.kebabCase = oP, rf.last = iJ, rf.lastIndexOf = function(e, t, n) {
                var i = null == e ? 0 : e.length;
                if (!i) return -1;
                var s = i;
                return n !== r && (s = (s = s8(n)) < 0 ? t2(i + s, 0) : t3(s, i - 1)), t == t ? function(e, t, r) {
                    for(var n = r + 1; n-- && e[n] !== t;);
                    return n;
                }(e, t, s) : tE(e, tT, s, !0);
            }, rf.lowerCase = oR, rf.lowerFirst = oI, rf.lt = s3, rf.lte = s4, rf.max = function(e) {
                return e && e.length ? rF(e, oj, rZ) : r;
            }, rf.maxBy = function(e, t) {
                return e && e.length ? rF(e, ic(t, 2), rZ) : r;
            }, rf.mean = function(e) {
                return tA(e, oj);
            }, rf.meanBy = function(e, t) {
                return tA(e, ic(t, 2));
            }, rf.min = function(e) {
                return e && e.length ? rF(e, oj, r7) : r;
            }, rf.minBy = function(e, t) {
                return e && e.length ? rF(e, ic(t, 2), r7) : r;
            }, rf.stubArray = oZ, rf.stubFalse = oX, rf.stubObject = function() {
                return {};
            }, rf.stubString = function() {
                return "";
            }, rf.stubTrue = function() {
                return !0;
            }, rf.multiply = o4, rf.nth = function(e, t) {
                return e && e.length ? ni(e, s8(t)) : r;
            }, rf.noConflict = function() {
                return e6._ === this && (e6._ = eB), this;
            }, rf.noop = oG, rf.now = sg, rf.pad = function(e, t, r) {
                e = ot(e);
                var n = (t = s8(t)) ? tG(e) : 0;
                if (!t || n >= t) return e;
                var i = (t - n) / 2;
                return n1(tQ(i), r) + e + n1(tP(i), r);
            }, rf.padEnd = function(e, t, r) {
                e = ot(e);
                var n = (t = s8(t)) ? tG(e) : 0;
                return t && n < t ? e + n1(t - n, r) : e;
            }, rf.padStart = function(e, t, r) {
                e = ot(e);
                var n = (t = s8(t)) ? tG(e) : 0;
                return t && n < t ? n1(t - n, r) + e : e;
            }, rf.parseInt = function(e, t, r) {
                return r || null == t ? t = 0 : t && (t *= 1), t6(ot(e).replace(Z, ""), t || 0);
            }, rf.random = function(e, t, n) {
                if (n && "boolean" != typeof n && iS(e, t, n) && (t = n = r), n === r && ("boolean" == typeof t ? (n = t, t = r) : "boolean" == typeof e && (n = e, e = r)), e === r && t === r ? (e = 0, t = 1) : (e = s5(e), t === r ? (t = e, e = 0) : t = s5(t)), e > t) {
                    var i = e;
                    e = t, t = i;
                }
                if (n || e % 1 || t % 1) {
                    var s = t5();
                    return t3(e + s * (t - e + e1("1e-" + ((s + "").length - 1))), t);
                }
                return nu(e, t);
            }, rf.reduce = function(e, t, r) {
                var n = sB(e) ? tv : tR, i = arguments.length < 3;
                return n(e, ic(t, 4), r, i, rV);
            }, rf.reduceRight = function(e, t, r) {
                var n = sB(e) ? tg : tR, i = arguments.length < 3;
                return n(e, ic(t, 4), r, i, rU);
            }, rf.repeat = function(e, t, n) {
                return t = (n ? iS(e, t, n) : t === r) ? 1 : s8(t), nc(ot(e), t);
            }, rf.replace = function() {
                var e = arguments, t = ot(e[0]);
                return e.length < 3 ? t : t.replace(e[1], e[2]);
            }, rf.result = function(e, t, n) {
                t = nM(t, e);
                var i = -1, s = t.length;
                for(s || (s = 1, e = r); ++i < s;){
                    var o = null == e ? r : e[iV(t[i])];
                    o === r && (i = s, o = n), e = sz(o) ? o.call(e) : o;
                }
                return e;
            }, rf.round = o6, rf.runInContext = e, rf.sample = function(e) {
                return (sB(e) ? rA : function(e) {
                    return rA(oC(e));
                })(e);
            }, rf.size = function(e) {
                if (null == e) return 0;
                if (sU(e)) return s0(e) ? tG(e) : e.length;
                var t = ig(e);
                return t == g || t == S ? e.size : r9(e).length;
            }, rf.snakeCase = oO, rf.some = function(e, t, n) {
                var i = sB(e) ? tm : nv;
                return n && iS(e, t, n) && (t = r), i(e, ic(t, 3));
            }, rf.sortedIndex = function(e, t) {
                return ng(e, t);
            }, rf.sortedIndexBy = function(e, t, r) {
                return nm(e, t, ic(r, 2));
            }, rf.sortedIndexOf = function(e, t) {
                var r = null == e ? 0 : e.length;
                if (r) {
                    var n = ng(e, t);
                    if (n < r && sD(e[n], t)) return n;
                }
                return -1;
            }, rf.sortedLastIndex = function(e, t) {
                return ng(e, t, !0);
            }, rf.sortedLastIndexBy = function(e, t, r) {
                return nm(e, t, ic(r, 2), !0);
            }, rf.sortedLastIndexOf = function(e, t) {
                if (null == e ? 0 : e.length) {
                    var r = ng(e, t, !0) - 1;
                    if (sD(e[r], t)) return r;
                }
                return -1;
            }, rf.startCase = oM, rf.startsWith = function(e, t, r) {
                return e = ot(e), r = null == r ? 0 : rD(s8(r), 0, e.length), t = nE(t), e.slice(r, r + t.length) == t;
            }, rf.subtract = o5, rf.sum = function(e) {
                return e && e.length ? tI(e, oj) : 0;
            }, rf.sumBy = function(e, t) {
                return e && e.length ? tI(e, ic(t, 2)) : 0;
            }, rf.template = function(e, t, n) {
                var i = rf.templateSettings;
                n && iS(e, t, n) && (t = r), e = ot(e), t = oi({}, t, i, n7);
                var s, o, a = oi({}, t.imports, i.imports, n7), l = of(a), u = tD(a, l), c = 0, h = t.interpolate || ef, d = "__p += '", _ = eT((t.escape || ef).source + "|" + h.source + "|" + (h === $ ? eo : ef).source + "|" + (t.evaluate || ef).source + "|$", "g"), f = "//# sourceURL=" + (eL.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++eJ + "]") + "\n";
                e.replace(_, function(t, r, n, i, a, l) {
                    return n || (n = i), d += e.slice(c, l).replace(ep, tU), r && (s = !0, d += "' +\n__e(" + r + ") +\n'"), a && (o = !0, d += "';\n" + a + ";\n__p += '"), n && (d += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), c = l + t.length, t;
                }), d += "';\n";
                var p = eL.call(t, "variable") && t.variable;
                if (p) {
                    if (ei.test(p)) throw new eb("Invalid `variable` option passed into `_.template`");
                } else d = "with (obj) {\n" + d + "\n}\n";
                d = (o ? d.replace(B, "") : d).replace(V, "$1").replace(U, "$1;"), d = "function(" + (p || "obj") + ") {\n" + (p ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (s ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + d + "return __p\n}";
                var v = oN(function() {
                    return eE(l, f + "return " + d).apply(r, u);
                });
                if (v.source = d, sH(v)) throw v;
                return v;
            }, rf.times = function(e, t) {
                if ((e = s8(e)) < 1 || e > 0x1fffffffffffff) return [];
                var r = 0xffffffff, n = t3(e, 0xffffffff);
                t = ic(t), e -= 0xffffffff;
                for(var i = tO(n, t); ++r < e;)t(r);
                return i;
            }, rf.toFinite = s5, rf.toInteger = s8, rf.toLength = s9, rf.toLower = function(e) {
                return ot(e).toLowerCase();
            }, rf.toNumber = s7, rf.toSafeInteger = function(e) {
                return e ? rD(s8(e), -9007199254740991, 0x1fffffffffffff) : 0 === e ? e : 0;
            }, rf.toString = ot, rf.toUpper = function(e) {
                return ot(e).toUpperCase();
            }, rf.trim = function(e, t, n) {
                if ((e = ot(e)) && (n || t === r)) return tM(e);
                if (!e || !(t = nE(t))) return e;
                var i = t$(e), s = t$(t), o = tN(i, s), a = tx(i, s) + 1;
                return nL(i, o, a).join("");
            }, rf.trimEnd = function(e, t, n) {
                if ((e = ot(e)) && (n || t === r)) return e.slice(0, tY(e) + 1);
                if (!e || !(t = nE(t))) return e;
                var i = t$(e), s = tx(i, t$(t)) + 1;
                return nL(i, 0, s).join("");
            }, rf.trimStart = function(e, t, n) {
                if ((e = ot(e)) && (n || t === r)) return e.replace(Z, "");
                if (!e || !(t = nE(t))) return e;
                var i = t$(e), s = tN(i, t$(t));
                return nL(i, s).join("");
            }, rf.truncate = function(e, t) {
                var n = 30, i = "...";
                if (sY(t)) {
                    var s = "separator" in t ? t.separator : s;
                    n = "length" in t ? s8(t.length) : n, i = "omission" in t ? nE(t.omission) : i;
                }
                var o = (e = ot(e)).length;
                if (tj(e)) {
                    var a = t$(e);
                    o = a.length;
                }
                if (n >= o) return e;
                var l = n - tG(i);
                if (l < 1) return i;
                var u = a ? nL(a, 0, l).join("") : e.slice(0, l);
                if (s === r) return u + i;
                if (a && (l += u.length - l), sZ(s)) {
                    if (e.slice(l).search(s)) {
                        var c, h = u;
                        for(s.global || (s = eT(s.source, ot(ea.exec(s)) + "g")), s.lastIndex = 0; c = s.exec(h);)var d = c.index;
                        u = u.slice(0, d === r ? l : d);
                    }
                } else if (e.indexOf(nE(s), l) != l) {
                    var _ = u.lastIndexOf(s);
                    _ > -1 && (u = u.slice(0, _));
                }
                return u + i;
            }, rf.unescape = function(e) {
                return (e = ot(e)) && W.test(e) ? e.replace(j, tq) : e;
            }, rf.uniqueId = function(e) {
                var t = ++eD;
                return ot(e) + t;
            }, rf.upperCase = oL, rf.upperFirst = oD, rf.each = su, rf.eachRight = sc, rf.first = iY, oz(rf, (eg = {}, r$(rf, function(e, t) {
                eL.call(rf.prototype, t) || (eg[t] = e);
            }), eg), {
                chain: !1
            }), rf.VERSION = "4.17.21", tu([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(e) {
                rf[e].placeholder = rf;
            }), tu([
                "drop",
                "take"
            ], function(e, t) {
                rm.prototype[e] = function(n) {
                    n = n === r ? 1 : t2(s8(n), 0);
                    var i = this.__filtered__ && !t ? new rm(this) : this.clone();
                    return i.__filtered__ ? i.__takeCount__ = t3(n, i.__takeCount__) : i.__views__.push({
                        size: t3(n, 0xffffffff),
                        type: e + (i.__dir__ < 0 ? "Right" : "")
                    }), i;
                }, rm.prototype[e + "Right"] = function(t) {
                    return this.reverse()[e](t).reverse();
                };
            }), tu([
                "filter",
                "map",
                "takeWhile"
            ], function(e, t) {
                var r = t + 1, n = 1 == r || 3 == r;
                rm.prototype[e] = function(e) {
                    var t = this.clone();
                    return t.__iteratees__.push({
                        iteratee: ic(e, 3),
                        type: r
                    }), t.__filtered__ = t.__filtered__ || n, t;
                };
            }), tu([
                "head",
                "last"
            ], function(e, t) {
                var r = "take" + (t ? "Right" : "");
                rm.prototype[e] = function() {
                    return this[r](1).value()[0];
                };
            }), tu([
                "initial",
                "tail"
            ], function(e, t) {
                var r = "drop" + (t ? "" : "Right");
                rm.prototype[e] = function() {
                    return this.__filtered__ ? new rm(this) : this[r](1);
                };
            }), rm.prototype.compact = function() {
                return this.filter(oj);
            }, rm.prototype.find = function(e) {
                return this.filter(e).head();
            }, rm.prototype.findLast = function(e) {
                return this.reverse().find(e);
            }, rm.prototype.invokeMap = nh(function(e, t) {
                return "function" == typeof e ? new rm(this) : this.map(function(r) {
                    return r2(r, e, t);
                });
            }), rm.prototype.reject = function(e) {
                return this.filter(sR(ic(e)));
            }, rm.prototype.slice = function(e, t) {
                e = s8(e);
                var n = this;
                return n.__filtered__ && (e > 0 || t < 0) ? new rm(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), t !== r && (n = (t = s8(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
            }, rm.prototype.takeRightWhile = function(e) {
                return this.reverse().takeWhile(e).reverse();
            }, rm.prototype.toArray = function() {
                return this.take(0xffffffff);
            }, r$(rm.prototype, function(e, t) {
                var n = /^(?:filter|find|map|reject)|While$/.test(t), i = /^(?:head|last)$/.test(t), s = rf[i ? "take" + ("last" == t ? "Right" : "") : t], o = i || /^find/.test(t);
                s && (rf.prototype[t] = function() {
                    var t = this.__wrapped__, a = i ? [
                        1
                    ] : arguments, l = t instanceof rm, u = a[0], c = l || sB(t), h = function(e) {
                        var t = s.apply(rf, tp([
                            e
                        ], a));
                        return i && d ? t[0] : t;
                    };
                    c && n && "function" == typeof u && 1 != u.length && (l = c = !1);
                    var d = this.__chain__, _ = !!this.__actions__.length, f = o && !d, p = l && !_;
                    if (!o && c) {
                        t = p ? t : new rm(this);
                        var v = e.apply(t, a);
                        return v.__actions__.push({
                            func: si,
                            args: [
                                h
                            ],
                            thisArg: r
                        }), new rg(v, d);
                    }
                    return f && p ? e.apply(this, a) : (v = this.thru(h), f ? i ? v.value()[0] : v.value() : v);
                });
            }), tu([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(e) {
                var t = eP[e], r = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", n = /^(?:pop|shift)$/.test(e);
                rf.prototype[e] = function() {
                    var e = arguments;
                    if (n && !this.__chain__) {
                        var i = this.value();
                        return t.apply(sB(i) ? i : [], e);
                    }
                    return this[r](function(r) {
                        return t.apply(sB(r) ? r : [], e);
                    });
                };
            }), r$(rm.prototype, function(e, t) {
                var r = rf[t];
                if (r) {
                    var n = r.name + "";
                    eL.call(rs, n) || (rs[n] = []), rs[n].push({
                        name: t,
                        func: r
                    });
                }
            }), rs[nJ(r, 2).name] = [
                {
                    name: "wrapper",
                    func: r
                }
            ], rm.prototype.clone = function() {
                var e = new rm(this.__wrapped__);
                return e.__actions__ = nj(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = nj(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = nj(this.__views__), e;
            }, rm.prototype.reverse = function() {
                if (this.__filtered__) {
                    var e = new rm(this);
                    e.__dir__ = -1, e.__filtered__ = !0;
                } else e = this.clone(), e.__dir__ *= -1;
                return e;
            }, rm.prototype.value = function() {
                var e = this.__wrapped__.value(), t = this.__dir__, r = sB(e), n = t < 0, i = r ? e.length : 0, s = function(e, t, r) {
                    for(var n = -1, i = r.length; ++n < i;){
                        var s = r[n], o = s.size;
                        switch(s.type){
                            case "drop":
                                e += o;
                                break;
                            case "dropRight":
                                t -= o;
                                break;
                            case "take":
                                t = t3(t, e + o);
                                break;
                            case "takeRight":
                                e = t2(e, t - o);
                        }
                    }
                    return {
                        start: e,
                        end: t
                    };
                }(0, i, this.__views__), o = s.start, a = s.end, l = a - o, u = n ? a : o - 1, c = this.__iteratees__, h = c.length, d = 0, _ = t3(l, this.__takeCount__);
                if (!r || !n && i == l && _ == l) return nw(e, this.__actions__);
                var f = [];
                e: for(; l-- && d < _;){
                    for(var p = -1, v = e[u += t]; ++p < h;){
                        var g = c[p], m = g.iteratee, y = g.type, b = m(v);
                        if (2 == y) v = b;
                        else if (!b) {
                            if (1 == y) continue e;
                            else break e;
                        }
                    }
                    f[d++] = v;
                }
                return f;
            }, rf.prototype.at = ss, rf.prototype.chain = function() {
                return sn(this);
            }, rf.prototype.commit = function() {
                return new rg(this.value(), this.__chain__);
            }, rf.prototype.next = function() {
                this.__values__ === r && (this.__values__ = s6(this.value()));
                var e = this.__index__ >= this.__values__.length, t = e ? r : this.__values__[this.__index__++];
                return {
                    done: e,
                    value: t
                };
            }, rf.prototype.plant = function(e) {
                for(var t, n = this; n instanceof rv;){
                    var i = ij(n);
                    i.__index__ = 0, i.__values__ = r, t ? s.__wrapped__ = i : t = i;
                    var s = i;
                    n = n.__wrapped__;
                }
                return s.__wrapped__ = e, t;
            }, rf.prototype.reverse = function() {
                var e = this.__wrapped__;
                if (e instanceof rm) {
                    var t = e;
                    return this.__actions__.length && (t = new rm(this)), (t = t.reverse()).__actions__.push({
                        func: si,
                        args: [
                            i1
                        ],
                        thisArg: r
                    }), new rg(t, this.__chain__);
                }
                return this.thru(i1);
            }, rf.prototype.toJSON = rf.prototype.valueOf = rf.prototype.value = function() {
                return nw(this.__wrapped__, this.__actions__);
            }, rf.prototype.first = rf.prototype.head, e4 && (rf.prototype[e4] = function() {
                return this;
            }), rf;
        }();
        "function" == typeof define && "object" == typeof define.amd && define.amd ? (e6._ = tK, define(function() {
            return tK;
        })) : e8 ? ((e8.exports = tK)._ = tK, e5._ = tK) : e6._ = tK;
    }).call(this);
}), $e175c1d94c759890$var$m("cQezm", function(e, t) {
    e.exports = (parcelRequire("2wGx1")).then(()=>$e175c1d94c759890$var$g("jTOzh"));
}), $e175c1d94c759890$var$m("iI3uv", function(e, t) {
    e.exports = (parcelRequire("1Emwx")).then(()=>$e175c1d94c759890$var$g("8mF5Z"));
}), $e175c1d94c759890$var$m("gxrTY", function(e, t) {
    e.exports = (parcelRequire("ar1F1")).then(()=>$e175c1d94c759890$var$g("8UG7J"));
}), $e175c1d94c759890$var$m("djm2V", function(e, t) {
    e.exports = (parcelRequire("kq8sC")).then(()=>$e175c1d94c759890$var$g("dqcZH"));
});
var $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ"), $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$E = $e175c1d94c759890$var$g("5tFqc"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ"), $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ");
let $e175c1d94c759890$var$S = {
    ignoreDurationMs: 5e3,
    shouldStopPlayer: !1
};
var $e175c1d94c759890$var$E = $e175c1d94c759890$var$g("5tFqc");
class $e175c1d94c759890$var$C {
    constructor(e){
        this._eventBusInstance = e, this._playerType = null, this._lastPlayerTypeSwitchTimestamp = -1, this._config = {
            ...$e175c1d94c759890$var$S
        }, this._onAlivePlayerListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$E.EWatchDogEvent.ALIVE_PLAYER, this._onAlivePlayer);
    }
    destroy() {
        this._eventBusInstance.unsubscribe(this._onAlivePlayerListener);
    }
    updateConfig(e) {
        void 0 !== e.shouldStopPlayer && (this._config.shouldStopPlayer = e.shouldStopPlayer), void 0 !== e.ignoreDurationMs && (this._config.ignoreDurationMs = e.ignoreDurationMs);
    }
    changePlayerType(e) {
        this._playerType = e, this._lastPlayerTypeSwitchTimestamp = performance.now();
    }
    _onAlivePlayer({ playerType: e  }) {
        !(performance.now() - this._lastPlayerTypeSwitchTimestamp < this._config.ignoreDurationMs) && this._playerType !== e && this._config.shouldStopPlayer && this._eventBusInstance.publish($e175c1d94c759890$var$E.EWatchDogEvent.ANOTHER_ACTIVE_PLAYER, {
            wrongPlayer: e
        });
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$C.prototype, "_onAlivePlayer", null);
var $e175c1d94c759890$var$T = function(e, t) {
    return e === t || e != e && t != t;
}, $e175c1d94c759890$var$A = function(e, t) {
    for(var r = e.length; r--;)if ($e175c1d94c759890$var$T(e[r][0], t)) return r;
    return -1;
}, $e175c1d94c759890$var$w = Array.prototype.splice;
function $e175c1d94c759890$var$P(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.clear(); ++t < r;){
        var n = e[t];
        this.set(n[0], n[1]);
    }
}
$e175c1d94c759890$var$P.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
}, $e175c1d94c759890$var$P.prototype.delete = function(e) {
    var t = this.__data__, r = $e175c1d94c759890$var$A(t, e);
    return !(r < 0) && (r == t.length - 1 ? t.pop() : $e175c1d94c759890$var$w.call(t, r, 1), --this.size, !0);
}, $e175c1d94c759890$var$P.prototype.get = function(e) {
    var t = this.__data__, r = $e175c1d94c759890$var$A(t, e);
    return r < 0 ? void 0 : t[r][1];
}, $e175c1d94c759890$var$P.prototype.has = function(e) {
    return $e175c1d94c759890$var$A(this.__data__, e) > -1;
}, $e175c1d94c759890$var$P.prototype.set = function(e, t) {
    var r = this.__data__, n = $e175c1d94c759890$var$A(r, e);
    return n < 0 ? (++this.size, r.push([
        e,
        t
    ])) : r[n][1] = t, this;
};
var $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$I = $e175c1d94c759890$var$R.default.Symbol, $e175c1d94c759890$var$O = Object.prototype, $e175c1d94c759890$var$M = $e175c1d94c759890$var$O.hasOwnProperty, $e175c1d94c759890$var$L = $e175c1d94c759890$var$O.toString, $e175c1d94c759890$var$D = $e175c1d94c759890$var$I ? $e175c1d94c759890$var$I.toStringTag : void 0, $e175c1d94c759890$var$k = function(e) {
    var t = $e175c1d94c759890$var$M.call(e, $e175c1d94c759890$var$D), r = e[$e175c1d94c759890$var$D];
    try {
        e[$e175c1d94c759890$var$D] = void 0;
        var n = !0;
    } catch (e) {}
    var i = $e175c1d94c759890$var$L.call(e);
    return n && (t ? e[$e175c1d94c759890$var$D] = r : delete e[$e175c1d94c759890$var$D]), i;
}, $e175c1d94c759890$var$N = Object.prototype.toString, $e175c1d94c759890$var$x = $e175c1d94c759890$var$I ? $e175c1d94c759890$var$I.toStringTag : void 0, $e175c1d94c759890$var$B = function(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : $e175c1d94c759890$var$x && $e175c1d94c759890$var$x in Object(e) ? $e175c1d94c759890$var$k(e) : $e175c1d94c759890$var$N.call(e);
}, $e175c1d94c759890$var$V = function(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
}, $e175c1d94c759890$var$U = function(e) {
    if (!$e175c1d94c759890$var$V(e)) return !1;
    var t = $e175c1d94c759890$var$B(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}, $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$j = $e175c1d94c759890$var$R.default["__core-js_shared__"], $e175c1d94c759890$var$F = ($e175c1d94c759890$var$n = /[^.]+$/.exec($e175c1d94c759890$var$j && $e175c1d94c759890$var$j.keys && $e175c1d94c759890$var$j.keys.IE_PROTO || "")) ? "Symbol(src)_1." + $e175c1d94c759890$var$n : "", $e175c1d94c759890$var$W = Function.prototype.toString, $e175c1d94c759890$var$H = function(e) {
    if (null != e) {
        try {
            return $e175c1d94c759890$var$W.call(e);
        } catch (e) {}
        try {
            return e + "";
        } catch (e) {}
    }
    return "";
}, $e175c1d94c759890$var$z = /^\[object .+?Constructor\]$/, $e175c1d94c759890$var$G = Object.prototype, $e175c1d94c759890$var$$ = Function.prototype.toString, $e175c1d94c759890$var$Y = $e175c1d94c759890$var$G.hasOwnProperty, $e175c1d94c759890$var$q = RegExp("^" + $e175c1d94c759890$var$$.call($e175c1d94c759890$var$Y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), $e175c1d94c759890$var$K = function(e) {
    return !!$e175c1d94c759890$var$V(e) && (!$e175c1d94c759890$var$F || !($e175c1d94c759890$var$F in e)) && ($e175c1d94c759890$var$U(e) ? $e175c1d94c759890$var$q : $e175c1d94c759890$var$z).test($e175c1d94c759890$var$H(e));
}, $e175c1d94c759890$var$Q = function(e, t) {
    var r = null == e ? void 0 : e[t];
    return $e175c1d94c759890$var$K(r) ? r : void 0;
}, $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$J = $e175c1d94c759890$var$Q($e175c1d94c759890$var$R.default, "Map"), $e175c1d94c759890$var$Z = $e175c1d94c759890$var$Q(Object, "create"), $e175c1d94c759890$var$X = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$ee = Object.prototype.hasOwnProperty;
function $e175c1d94c759890$var$et(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.clear(); ++t < r;){
        var n = e[t];
        this.set(n[0], n[1]);
    }
}
$e175c1d94c759890$var$et.prototype.clear = function() {
    this.__data__ = $e175c1d94c759890$var$Z ? $e175c1d94c759890$var$Z(null) : {}, this.size = 0;
}, $e175c1d94c759890$var$et.prototype.delete = function(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= !!t, t;
}, $e175c1d94c759890$var$et.prototype.get = function(e) {
    var t = this.__data__;
    if ($e175c1d94c759890$var$Z) {
        var r = t[e];
        return "__lodash_hash_undefined__" === r ? void 0 : r;
    }
    return $e175c1d94c759890$var$X.call(t, e) ? t[e] : void 0;
}, $e175c1d94c759890$var$et.prototype.has = function(e) {
    var t = this.__data__;
    return $e175c1d94c759890$var$Z ? void 0 !== t[e] : $e175c1d94c759890$var$ee.call(t, e);
}, $e175c1d94c759890$var$et.prototype.set = function(e, t) {
    var r = this.__data__;
    return this.size += +!this.has(e), r[e] = $e175c1d94c759890$var$Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
var $e175c1d94c759890$var$er = function(e) {
    var t = typeof e;
    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
}, $e175c1d94c759890$var$en = function(e, t) {
    var r = e.__data__;
    return $e175c1d94c759890$var$er(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
};
function $e175c1d94c759890$var$ei(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.clear(); ++t < r;){
        var n = e[t];
        this.set(n[0], n[1]);
    }
}
function $e175c1d94c759890$var$es(e) {
    var t = this.__data__ = new $e175c1d94c759890$var$P(e);
    this.size = t.size;
}
function $e175c1d94c759890$var$eo(e) {
    var t = -1, r = null == e ? 0 : e.length;
    for(this.__data__ = new $e175c1d94c759890$var$ei; ++t < r;)this.add(e[t]);
}
$e175c1d94c759890$var$ei.prototype.clear = function() {
    this.size = 0, this.__data__ = {
        hash: new $e175c1d94c759890$var$et,
        map: new ($e175c1d94c759890$var$J || $e175c1d94c759890$var$P),
        string: new $e175c1d94c759890$var$et
    };
}, $e175c1d94c759890$var$ei.prototype.delete = function(e) {
    var t = $e175c1d94c759890$var$en(this, e).delete(e);
    return this.size -= !!t, t;
}, $e175c1d94c759890$var$ei.prototype.get = function(e) {
    return $e175c1d94c759890$var$en(this, e).get(e);
}, $e175c1d94c759890$var$ei.prototype.has = function(e) {
    return $e175c1d94c759890$var$en(this, e).has(e);
}, $e175c1d94c759890$var$ei.prototype.set = function(e, t) {
    var r = $e175c1d94c759890$var$en(this, e), n = r.size;
    return r.set(e, t), this.size += +(r.size != n), this;
}, $e175c1d94c759890$var$es.prototype.clear = function() {
    this.__data__ = new $e175c1d94c759890$var$P, this.size = 0;
}, $e175c1d94c759890$var$es.prototype.delete = function(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
}, $e175c1d94c759890$var$es.prototype.get = function(e) {
    return this.__data__.get(e);
}, $e175c1d94c759890$var$es.prototype.has = function(e) {
    return this.__data__.has(e);
}, $e175c1d94c759890$var$es.prototype.set = function(e, t) {
    var r = this.__data__;
    if (r instanceof $e175c1d94c759890$var$P) {
        var n = r.__data__;
        if (!$e175c1d94c759890$var$J || n.length < 199) return n.push([
            e,
            t
        ]), this.size = ++r.size, this;
        r = this.__data__ = new $e175c1d94c759890$var$ei(n);
    }
    return r.set(e, t), this.size = r.size, this;
}, $e175c1d94c759890$var$eo.prototype.add = $e175c1d94c759890$var$eo.prototype.push = function(e) {
    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, $e175c1d94c759890$var$eo.prototype.has = function(e) {
    return this.__data__.has(e);
};
var $e175c1d94c759890$var$ea = function(e, t) {
    for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
    return !1;
}, $e175c1d94c759890$var$el = function(e, t, r, n, i, s) {
    var o = 1 & r, a = e.length, l = t.length;
    if (a != l && !(o && l > a)) return !1;
    var u = s.get(e), c = s.get(t);
    if (u && c) return u == t && c == e;
    var h = -1, d = !0, _ = 2 & r ? new $e175c1d94c759890$var$eo : void 0;
    for(s.set(e, t), s.set(t, e); ++h < a;){
        var f = e[h], p = t[h];
        if (n) var v = o ? n(p, f, h, t, e, s) : n(f, p, h, e, t, s);
        if (void 0 !== v) {
            if (v) continue;
            d = !1;
            break;
        }
        if (_) {
            if (!$e175c1d94c759890$var$ea(t, function(e, t) {
                if (!_.has(t) && (f === e || i(f, e, r, n, s))) return _.push(t);
            })) {
                d = !1;
                break;
            }
        } else if (!(f === p || i(f, p, r, n, s))) {
            d = !1;
            break;
        }
    }
    return s.delete(e), s.delete(t), d;
}, $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$eu = $e175c1d94c759890$var$R.default.Uint8Array, $e175c1d94c759890$var$ec = function(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(e, n) {
        r[++t] = [
            n,
            e
        ];
    }), r;
}, $e175c1d94c759890$var$eh = function(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(e) {
        r[++t] = e;
    }), r;
}, $e175c1d94c759890$var$ed = $e175c1d94c759890$var$I ? $e175c1d94c759890$var$I.prototype : void 0, $e175c1d94c759890$var$e_ = $e175c1d94c759890$var$ed ? $e175c1d94c759890$var$ed.valueOf : void 0, $e175c1d94c759890$var$ef = function(e, t, r, n, i, s, o) {
    switch(r){
        case "[object DataView]":
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) break;
            e = e.buffer, t = t.buffer;
        case "[object ArrayBuffer]":
            if (e.byteLength != t.byteLength || !s(new $e175c1d94c759890$var$eu(e), new $e175c1d94c759890$var$eu(t))) break;
            return !0;
        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
            return $e175c1d94c759890$var$T(+e, +t);
        case "[object Error]":
            return e.name == t.name && e.message == t.message;
        case "[object RegExp]":
        case "[object String]":
            return e == t + "";
        case "[object Map]":
            var a = $e175c1d94c759890$var$ec;
        case "[object Set]":
            var l = 1 & n;
            if (a || (a = $e175c1d94c759890$var$eh), e.size != t.size && !l) break;
            var u = o.get(e);
            if (u) return u == t;
            n |= 2, o.set(e, t);
            var c = $e175c1d94c759890$var$el(a(e), a(t), n, i, s, o);
            return o.delete(e), c;
        case "[object Symbol]":
            if ($e175c1d94c759890$var$e_) return $e175c1d94c759890$var$e_.call(e) == $e175c1d94c759890$var$e_.call(t);
    }
    return !1;
}, $e175c1d94c759890$var$ep = function(e, t) {
    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
    return e;
}, $e175c1d94c759890$var$ev = Array.isArray, $e175c1d94c759890$var$eg = function(e, t, r) {
    var n = t(e);
    return $e175c1d94c759890$var$ev(e) ? n : $e175c1d94c759890$var$ep(n, r(e));
}, $e175c1d94c759890$var$em = function(e, t) {
    for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
        var o = e[r];
        t(o, r, e) && (s[i++] = o);
    }
    return s;
}, $e175c1d94c759890$var$ey = Object.prototype.propertyIsEnumerable, $e175c1d94c759890$var$eb = Object.getOwnPropertySymbols, $e175c1d94c759890$var$eE = $e175c1d94c759890$var$eb ? function(e) {
    return null == e ? [] : $e175c1d94c759890$var$em($e175c1d94c759890$var$eb(e = Object(e)), function(t) {
        return $e175c1d94c759890$var$ey.call(e, t);
    });
} : function() {
    return [];
}, $e175c1d94c759890$var$eS = function(e, t) {
    for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
    return n;
}, $e175c1d94c759890$var$eC = function(e) {
    return null != e && "object" == typeof e;
}, $e175c1d94c759890$var$eT = function(e) {
    return $e175c1d94c759890$var$eC(e) && "[object Arguments]" == $e175c1d94c759890$var$B(e);
}, $e175c1d94c759890$var$eA = Object.prototype, $e175c1d94c759890$var$ew = $e175c1d94c759890$var$eA.hasOwnProperty, $e175c1d94c759890$var$eP = $e175c1d94c759890$var$eA.propertyIsEnumerable, $e175c1d94c759890$var$eR = $e175c1d94c759890$var$eT(function() {
    return arguments;
}()) ? $e175c1d94c759890$var$eT : function(e) {
    return $e175c1d94c759890$var$eC(e) && $e175c1d94c759890$var$ew.call(e, "callee") && !$e175c1d94c759890$var$eP.call(e, "callee");
}, $e175c1d94c759890$var$eI = $e175c1d94c759890$var$g("iuHwr"), $e175c1d94c759890$var$eO = /^(?:0|[1-9]\d*)$/, $e175c1d94c759890$var$eM = function(e, t) {
    var r = typeof e;
    return !!(t = null == t ? 0x1fffffffffffff : t) && ("number" == r || "symbol" != r && $e175c1d94c759890$var$eO.test(e)) && e > -1 && e % 1 == 0 && e < t;
}, $e175c1d94c759890$var$eL = function(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 0x1fffffffffffff;
}, $e175c1d94c759890$var$eD = {};
$e175c1d94c759890$var$eD["[object Float32Array]"] = $e175c1d94c759890$var$eD["[object Float64Array]"] = $e175c1d94c759890$var$eD["[object Int8Array]"] = $e175c1d94c759890$var$eD["[object Int16Array]"] = $e175c1d94c759890$var$eD["[object Int32Array]"] = $e175c1d94c759890$var$eD["[object Uint8Array]"] = $e175c1d94c759890$var$eD["[object Uint8ClampedArray]"] = $e175c1d94c759890$var$eD["[object Uint16Array]"] = $e175c1d94c759890$var$eD["[object Uint32Array]"] = !0, $e175c1d94c759890$var$eD["[object Arguments]"] = $e175c1d94c759890$var$eD["[object Array]"] = $e175c1d94c759890$var$eD["[object ArrayBuffer]"] = $e175c1d94c759890$var$eD["[object Boolean]"] = $e175c1d94c759890$var$eD["[object DataView]"] = $e175c1d94c759890$var$eD["[object Date]"] = $e175c1d94c759890$var$eD["[object Error]"] = $e175c1d94c759890$var$eD["[object Function]"] = $e175c1d94c759890$var$eD["[object Map]"] = $e175c1d94c759890$var$eD["[object Number]"] = $e175c1d94c759890$var$eD["[object Object]"] = $e175c1d94c759890$var$eD["[object RegExp]"] = $e175c1d94c759890$var$eD["[object Set]"] = $e175c1d94c759890$var$eD["[object String]"] = $e175c1d94c759890$var$eD["[object WeakMap]"] = !1;
var $e175c1d94c759890$var$ek = $e175c1d94c759890$var$g("8tO4H"), $e175c1d94c759890$var$eN = $e175c1d94c759890$var$ek.default && $e175c1d94c759890$var$ek.default.isTypedArray, $e175c1d94c759890$var$ex = $e175c1d94c759890$var$eN ? function(e) {
    return $e175c1d94c759890$var$eN(e);
} : function(e) {
    return $e175c1d94c759890$var$eC(e) && $e175c1d94c759890$var$eL(e.length) && !!$e175c1d94c759890$var$eD[$e175c1d94c759890$var$B(e)];
}, $e175c1d94c759890$var$eB = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$eV = function(e, t) {
    var r = $e175c1d94c759890$var$ev(e), n = !r && $e175c1d94c759890$var$eR(e), i = !r && !n && (0, $e175c1d94c759890$var$eI.default)(e), s = !r && !n && !i && $e175c1d94c759890$var$ex(e), o = r || n || i || s, a = o ? $e175c1d94c759890$var$eS(e.length, String) : [], l = a.length;
    for(var u in e)(t || $e175c1d94c759890$var$eB.call(e, u)) && !(o && ("length" == u || i && ("offset" == u || "parent" == u) || s && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || $e175c1d94c759890$var$eM(u, l))) && a.push(u);
    return a;
}, $e175c1d94c759890$var$eU = Object.prototype, $e175c1d94c759890$var$ej = function(e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || $e175c1d94c759890$var$eU);
}, $e175c1d94c759890$var$eF = function(e, t) {
    return function(r) {
        return e(t(r));
    };
}, $e175c1d94c759890$var$eW = $e175c1d94c759890$var$eF(Object.keys, Object), $e175c1d94c759890$var$eH = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$ez = function(e) {
    if (!$e175c1d94c759890$var$ej(e)) return $e175c1d94c759890$var$eW(e);
    var t = [];
    for(var r in Object(e))$e175c1d94c759890$var$eH.call(e, r) && "constructor" != r && t.push(r);
    return t;
}, $e175c1d94c759890$var$eG = function(e) {
    return null != e && $e175c1d94c759890$var$eL(e.length) && !$e175c1d94c759890$var$U(e);
}, $e175c1d94c759890$var$e$ = function(e) {
    return $e175c1d94c759890$var$eG(e) ? $e175c1d94c759890$var$eV(e) : $e175c1d94c759890$var$ez(e);
}, $e175c1d94c759890$var$eY = function(e) {
    return $e175c1d94c759890$var$eg(e, $e175c1d94c759890$var$e$, $e175c1d94c759890$var$eE);
}, $e175c1d94c759890$var$eq = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$eK = function(e, t, r, n, i, s) {
    var o = 1 & r, a = $e175c1d94c759890$var$eY(e), l = a.length;
    if (l != $e175c1d94c759890$var$eY(t).length && !o) return !1;
    for(var u = l; u--;){
        var c = a[u];
        if (!(o ? c in t : $e175c1d94c759890$var$eq.call(t, c))) return !1;
    }
    var h = s.get(e), d = s.get(t);
    if (h && d) return h == t && d == e;
    var _ = !0;
    s.set(e, t), s.set(t, e);
    for(var f = o; ++u < l;){
        var p = e[c = a[u]], v = t[c];
        if (n) var g = o ? n(v, p, c, t, e, s) : n(p, v, c, e, t, s);
        if (!(void 0 === g ? p === v || i(p, v, r, n, s) : g)) {
            _ = !1;
            break;
        }
        f || (f = "constructor" == c);
    }
    if (_ && !f) {
        var m = e.constructor, y = t.constructor;
        m != y && "constructor" in e && "constructor" in t && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (_ = !1);
    }
    return s.delete(e), s.delete(t), _;
}, $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$eQ = $e175c1d94c759890$var$Q($e175c1d94c759890$var$R.default, "DataView"), $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$eJ = $e175c1d94c759890$var$Q($e175c1d94c759890$var$R.default, "Promise"), $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$eZ = $e175c1d94c759890$var$Q($e175c1d94c759890$var$R.default, "Set"), $e175c1d94c759890$var$R = $e175c1d94c759890$var$g("iCUkT"), $e175c1d94c759890$var$eX = $e175c1d94c759890$var$Q($e175c1d94c759890$var$R.default, "WeakMap"), $e175c1d94c759890$var$e0 = "[object Map]", $e175c1d94c759890$var$e1 = "[object Promise]", $e175c1d94c759890$var$e2 = "[object Set]", $e175c1d94c759890$var$e3 = "[object WeakMap]", $e175c1d94c759890$var$e4 = "[object DataView]", $e175c1d94c759890$var$e6 = $e175c1d94c759890$var$H($e175c1d94c759890$var$eQ), $e175c1d94c759890$var$e5 = $e175c1d94c759890$var$H($e175c1d94c759890$var$J), $e175c1d94c759890$var$e8 = $e175c1d94c759890$var$H($e175c1d94c759890$var$eJ), $e175c1d94c759890$var$e9 = $e175c1d94c759890$var$H($e175c1d94c759890$var$eZ), $e175c1d94c759890$var$e7 = $e175c1d94c759890$var$H($e175c1d94c759890$var$eX), $e175c1d94c759890$var$te = $e175c1d94c759890$var$B;
($e175c1d94c759890$var$eQ && $e175c1d94c759890$var$te(new $e175c1d94c759890$var$eQ(new ArrayBuffer(1))) != $e175c1d94c759890$var$e4 || $e175c1d94c759890$var$J && $e175c1d94c759890$var$te(new $e175c1d94c759890$var$J) != $e175c1d94c759890$var$e0 || $e175c1d94c759890$var$eJ && $e175c1d94c759890$var$te($e175c1d94c759890$var$eJ.resolve()) != $e175c1d94c759890$var$e1 || $e175c1d94c759890$var$eZ && $e175c1d94c759890$var$te(new $e175c1d94c759890$var$eZ) != $e175c1d94c759890$var$e2 || $e175c1d94c759890$var$eX && $e175c1d94c759890$var$te(new $e175c1d94c759890$var$eX) != $e175c1d94c759890$var$e3) && ($e175c1d94c759890$var$te = function(e) {
    var t = $e175c1d94c759890$var$B(e), r = "[object Object]" == t ? e.constructor : void 0, n = r ? $e175c1d94c759890$var$H(r) : "";
    if (n) switch(n){
        case $e175c1d94c759890$var$e6:
            return $e175c1d94c759890$var$e4;
        case $e175c1d94c759890$var$e5:
            return $e175c1d94c759890$var$e0;
        case $e175c1d94c759890$var$e8:
            return $e175c1d94c759890$var$e1;
        case $e175c1d94c759890$var$e9:
            return $e175c1d94c759890$var$e2;
        case $e175c1d94c759890$var$e7:
            return $e175c1d94c759890$var$e3;
    }
    return t;
});
var $e175c1d94c759890$var$tt = $e175c1d94c759890$var$te, $e175c1d94c759890$var$eI = $e175c1d94c759890$var$g("iuHwr"), $e175c1d94c759890$var$tr = "[object Arguments]", $e175c1d94c759890$var$tn = "[object Array]", $e175c1d94c759890$var$ti = "[object Object]", $e175c1d94c759890$var$ts = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$to = function(e, t, r, n, i, s) {
    var o = $e175c1d94c759890$var$ev(e), a = $e175c1d94c759890$var$ev(t), l = o ? $e175c1d94c759890$var$tn : $e175c1d94c759890$var$tt(e), u = a ? $e175c1d94c759890$var$tn : $e175c1d94c759890$var$tt(t);
    l = l == $e175c1d94c759890$var$tr ? $e175c1d94c759890$var$ti : l, u = u == $e175c1d94c759890$var$tr ? $e175c1d94c759890$var$ti : u;
    var c = l == $e175c1d94c759890$var$ti, h = u == $e175c1d94c759890$var$ti, d = l == u;
    if (d && (0, $e175c1d94c759890$var$eI.default)(e)) {
        if (!(0, $e175c1d94c759890$var$eI.default)(t)) return !1;
        o = !0, c = !1;
    }
    if (d && !c) return s || (s = new $e175c1d94c759890$var$es), o || $e175c1d94c759890$var$ex(e) ? $e175c1d94c759890$var$el(e, t, r, n, i, s) : $e175c1d94c759890$var$ef(e, t, l, r, n, i, s);
    if (!(1 & r)) {
        var _ = c && $e175c1d94c759890$var$ts.call(e, "__wrapped__"), f = h && $e175c1d94c759890$var$ts.call(t, "__wrapped__");
        if (_ || f) {
            var p = _ ? e.value() : e, v = f ? t.value() : t;
            return s || (s = new $e175c1d94c759890$var$es), i(p, v, r, n, s);
        }
    }
    return !!d && (s || (s = new $e175c1d94c759890$var$es), $e175c1d94c759890$var$eK(e, t, r, n, i, s));
}, $e175c1d94c759890$var$ta = function() {
    try {
        var e = $e175c1d94c759890$var$Q(Object, "defineProperty");
        return e({}, "", {}), e;
    } catch (e) {}
}(), $e175c1d94c759890$var$tl = function(e, t, r) {
    "__proto__" == t && $e175c1d94c759890$var$ta ? $e175c1d94c759890$var$ta(e, t, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
    }) : e[t] = r;
}, $e175c1d94c759890$var$tu = function(e, t, r) {
    (void 0 === r || $e175c1d94c759890$var$T(e[t], r)) && (void 0 !== r || t in e) || $e175c1d94c759890$var$tl(e, t, r);
}, $e175c1d94c759890$var$tc = function(e, t, r) {
    for(var n = -1, i = Object(e), s = r(e), o = s.length; o--;){
        var a = s[++n];
        if (!1 === t(i[a], a, i)) break;
    }
    return e;
}, $e175c1d94c759890$var$th = $e175c1d94c759890$var$g("h3fWd"), $e175c1d94c759890$var$td = function(e) {
    var t = new e.constructor(e.byteLength);
    return new $e175c1d94c759890$var$eu(t).set(new $e175c1d94c759890$var$eu(e)), t;
}, $e175c1d94c759890$var$t_ = function(e, t) {
    var r = t ? $e175c1d94c759890$var$td(e.buffer) : e.buffer;
    return new e.constructor(r, e.byteOffset, e.length);
}, $e175c1d94c759890$var$tf = function(e, t) {
    var r = -1, n = e.length;
    for(t || (t = Array(n)); ++r < n;)t[r] = e[r];
    return t;
}, $e175c1d94c759890$var$tp = Object.create, $e175c1d94c759890$var$tv = function() {
    function e() {}
    return function(t) {
        if (!$e175c1d94c759890$var$V(t)) return {};
        if ($e175c1d94c759890$var$tp) return $e175c1d94c759890$var$tp(t);
        e.prototype = t;
        var r = new e;
        return e.prototype = void 0, r;
    };
}(), $e175c1d94c759890$var$tg = $e175c1d94c759890$var$eF(Object.getPrototypeOf, Object), $e175c1d94c759890$var$eI = $e175c1d94c759890$var$g("iuHwr"), $e175c1d94c759890$var$tm = Object.prototype, $e175c1d94c759890$var$ty = Function.prototype.toString, $e175c1d94c759890$var$tb = $e175c1d94c759890$var$tm.hasOwnProperty, $e175c1d94c759890$var$tE = $e175c1d94c759890$var$ty.call(Object), $e175c1d94c759890$var$tS = function(e) {
    if (!$e175c1d94c759890$var$eC(e) || "[object Object]" != $e175c1d94c759890$var$B(e)) return !1;
    var t = $e175c1d94c759890$var$tg(e);
    if (null === t) return !0;
    var r = $e175c1d94c759890$var$tb.call(t, "constructor") && t.constructor;
    return "function" == typeof r && r instanceof r && $e175c1d94c759890$var$ty.call(r) == $e175c1d94c759890$var$tE;
}, $e175c1d94c759890$var$tC = function(e, t) {
    if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
}, $e175c1d94c759890$var$tT = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$tA = function(e, t, r) {
    var n = e[t];
    $e175c1d94c759890$var$tT.call(e, t) && $e175c1d94c759890$var$T(n, r) && (void 0 !== r || t in e) || $e175c1d94c759890$var$tl(e, t, r);
}, $e175c1d94c759890$var$tw = function(e, t, r, n) {
    var i = !r;
    r || (r = {});
    for(var s = -1, o = t.length; ++s < o;){
        var a = t[s], l = n ? n(r[a], e[a], a, r, e) : void 0;
        void 0 === l && (l = e[a]), i ? $e175c1d94c759890$var$tl(r, a, l) : $e175c1d94c759890$var$tA(r, a, l);
    }
    return r;
}, $e175c1d94c759890$var$tP = function(e) {
    var t = [];
    if (null != e) for(var r in Object(e))t.push(r);
    return t;
}, $e175c1d94c759890$var$tR = Object.prototype.hasOwnProperty, $e175c1d94c759890$var$tI = function(e) {
    if (!$e175c1d94c759890$var$V(e)) return $e175c1d94c759890$var$tP(e);
    var t = $e175c1d94c759890$var$ej(e), r = [];
    for(var n in e)"constructor" == n && (t || !$e175c1d94c759890$var$tR.call(e, n)) || r.push(n);
    return r;
}, $e175c1d94c759890$var$tO = function(e) {
    return $e175c1d94c759890$var$eG(e) ? $e175c1d94c759890$var$eV(e, !0) : $e175c1d94c759890$var$tI(e);
}, $e175c1d94c759890$var$tM = function(e, t, r, n, i, s, o) {
    var a = $e175c1d94c759890$var$tC(e, r), l = $e175c1d94c759890$var$tC(t, r), u = o.get(l);
    if (u) return void $e175c1d94c759890$var$tu(e, r, u);
    var c = s ? s(a, l, r + "", e, t, o) : void 0, h = void 0 === c;
    if (h) {
        var d = $e175c1d94c759890$var$ev(l), _ = !d && (0, $e175c1d94c759890$var$eI.default)(l), f = !d && !_ && $e175c1d94c759890$var$ex(l);
        (c = l, d || _ || f) ? $e175c1d94c759890$var$ev(a) ? c = a : $e175c1d94c759890$var$eC(a) && $e175c1d94c759890$var$eG(a) ? c = $e175c1d94c759890$var$tf(a) : _ ? (h = !1, c = (0, $e175c1d94c759890$var$th.default)(l, !0)) : f ? (h = !1, c = $e175c1d94c759890$var$t_(l, !0)) : c = [] : $e175c1d94c759890$var$tS(l) || $e175c1d94c759890$var$eR(l) ? (c = a, $e175c1d94c759890$var$eR(a)) ? c = $e175c1d94c759890$var$tw(a, $e175c1d94c759890$var$tO(a)) : (!$e175c1d94c759890$var$V(a) || $e175c1d94c759890$var$U(a)) && (c = "function" != typeof l.constructor || $e175c1d94c759890$var$ej(l) ? {} : $e175c1d94c759890$var$tv($e175c1d94c759890$var$tg(l))) : h = !1;
    }
    h && (o.set(l, c), i(c, l, n, s, o), o.delete(l)), $e175c1d94c759890$var$tu(e, r, c);
}, $e175c1d94c759890$var$tL = function e(t, r, n, i, s) {
    t !== r && $e175c1d94c759890$var$tc(r, function(o, a) {
        if (s || (s = new $e175c1d94c759890$var$es), $e175c1d94c759890$var$V(o)) $e175c1d94c759890$var$tM(t, r, a, n, e, i, s);
        else {
            var l = i ? i($e175c1d94c759890$var$tC(t, a), o, a + "", t, r, s) : void 0;
            void 0 === l && (l = o), $e175c1d94c759890$var$tu(t, a, l);
        }
    }, $e175c1d94c759890$var$tO);
}, $e175c1d94c759890$var$tD = function(e) {
    return e;
}, $e175c1d94c759890$var$tk = function(e, t, r) {
    switch(r.length){
        case 0:
            return e.call(t);
        case 1:
            return e.call(t, r[0]);
        case 2:
            return e.call(t, r[0], r[1]);
        case 3:
            return e.call(t, r[0], r[1], r[2]);
    }
    return e.apply(t, r);
}, $e175c1d94c759890$var$tN = Math.max, $e175c1d94c759890$var$tx = Date.now, $e175c1d94c759890$var$tB = ($e175c1d94c759890$var$i = $e175c1d94c759890$var$ta ? function(e, t) {
    return $e175c1d94c759890$var$ta(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: function() {
            return t;
        },
        writable: !0
    });
} : $e175c1d94c759890$var$tD, $e175c1d94c759890$var$s = 0, $e175c1d94c759890$var$o = 0, function() {
    var e = $e175c1d94c759890$var$tx(), t = 16 - (e - $e175c1d94c759890$var$o);
    if ($e175c1d94c759890$var$o = e, t > 0) {
        if (++$e175c1d94c759890$var$s >= 800) return arguments[0];
    } else $e175c1d94c759890$var$s = 0;
    return $e175c1d94c759890$var$i.apply(void 0, arguments);
}), $e175c1d94c759890$var$tV = function(e, t, r) {
    if (!$e175c1d94c759890$var$V(r)) return !1;
    var n = typeof t;
    return ("number" == n ? !!($e175c1d94c759890$var$eG(r) && $e175c1d94c759890$var$eM(t, r.length)) : "string" == n && t in r) && $e175c1d94c759890$var$T(r[t], e);
};
var $e175c1d94c759890$var$tU = ($e175c1d94c759890$var$a = function(e, t, r) {
    $e175c1d94c759890$var$tL(e, t, r);
}, $e175c1d94c759890$var$tB(($e175c1d94c759890$var$e = function(e, t) {
    var r = -1, n = t.length, i = n > 1 ? t[n - 1] : void 0, s = n > 2 ? t[2] : void 0;
    for(i = $e175c1d94c759890$var$a.length > 3 && "function" == typeof i ? (n--, i) : void 0, s && $e175c1d94c759890$var$tV(t[0], t[1], s) && (i = n < 3 ? void 0 : i, n = 1), e = Object(e); ++r < n;){
        var o = t[r];
        o && $e175c1d94c759890$var$a(e, o, r, i);
    }
    return e;
}, $e175c1d94c759890$var$r = $e175c1d94c759890$var$tN(void 0 === ($e175c1d94c759890$var$r = $e175c1d94c759890$var$t) ? $e175c1d94c759890$var$e.length - 1 : $e175c1d94c759890$var$r, 0), function() {
    for(var t = arguments, n = -1, i = $e175c1d94c759890$var$tN(t.length - $e175c1d94c759890$var$r, 0), s = Array(i); ++n < i;)s[n] = t[$e175c1d94c759890$var$r + n];
    n = -1;
    for(var o = Array($e175c1d94c759890$var$r + 1); ++n < $e175c1d94c759890$var$r;)o[n] = t[n];
    return o[$e175c1d94c759890$var$r] = $e175c1d94c759890$var$tD(s), $e175c1d94c759890$var$tk($e175c1d94c759890$var$e, this, o);
}), $e175c1d94c759890$var$e + "")), $e175c1d94c759890$var$tj = $e175c1d94c759890$var$g("1QtI2"), $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ");
function $e175c1d94c759890$var$tF(e) {
    return ($e175c1d94c759890$var$tF = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
}
function $e175c1d94c759890$var$tW(e, t) {
    var r = this.event && this.event.type, n = "XMLHttpRequest" in this ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP");
    (n.open("POST", e, "unload" !== r && "beforeunload" !== r), n.withCredentials = !0, n.setRequestHeader("Accept", "*/*"), "string" == typeof t) ? (n.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"), n.responseType = "text") : t instanceof Blob && t.type && n.setRequestHeader("Content-Type", t.type);
    try {
        n.send(t);
    } catch (e) {
        return !1;
    }
    return !0;
}
(function() {
    "navigator" in this || (this.navigator = {}), "function" != typeof this.navigator.sendBeacon && (this.navigator.sendBeacon = $e175c1d94c759890$var$tW.bind(this));
}).call(("undefined" == typeof window ? "undefined" : $e175c1d94c759890$var$tF(window)) === "object" ? window : {});
var $e175c1d94c759890$var$tj = $e175c1d94c759890$var$g("1QtI2");
class $e175c1d94c759890$var$tH {
    constructor(e){
        this._values = [], this._maxValue = -1 / 0, this._minValue = 1 / 0, this._avgValue = 0, this._count = 0, this._sum = 0, this._isMaxEnabled = !1, this._isMinEnabled = !1, this._isAvgEnabled = !1, this._isMedianEnabled = !1, this._isCountEnabled = !1, this._isSumEnabled = !1, e.includes("median") && (this._isMedianEnabled = !0), e.includes("min") && (this._isMinEnabled = !0), e.includes("max") && (this._isMaxEnabled = !0), e.includes("avg") && (this._isCountEnabled = !0, this._isAvgEnabled = !0), e.includes("count") && (this._isCountEnabled = !0), e.includes("sum") && (this._isSumEnabled = !0);
    }
    addValue(e) {
        this._isCountEnabled && this._increaseCounter(), this._isSumEnabled && this._addToSum(e), this._isMedianEnabled && this._values.push(e), this._isMaxEnabled && this._addMaxValue(e), this._isMinEnabled && this._addMinValue(e), this._isAvgEnabled && this._addAvgValue(e);
    }
    addValues(e) {
        e.forEach((e)=>{
            this.addValue(e);
        });
    }
    clear() {
        this._values = [], this._maxValue = -1 / 0, this._minValue = 1 / 0, this._avgValue = 0, this._count = 0, this._sum = 0;
    }
    clearMedian() {
        this._values = [];
    }
    clearMax() {
        this._maxValue = -1 / 0;
    }
    clearMin() {
        this._minValue = -1 / 0;
    }
    _increaseCounter() {
        this._count++;
    }
    _addMaxValue(e) {
        e > this._maxValue && (this._maxValue = e);
    }
    _addMinValue(e) {
        e < this._minValue && (this._minValue = e);
    }
    _addAvgValue(e) {
        this._avgValue += (e - this._avgValue) / this._count;
    }
    _addToSum(e) {
        this._sum += e;
    }
    get max() {
        return this._maxValue > -1 / 0 ? this._maxValue : null;
    }
    get min() {
        return this._minValue < 1 / 0 ? this._minValue : null;
    }
    get avg() {
        return this._count ? this._avgValue : null;
    }
    get count() {
        return this._count;
    }
    get sum() {
        return this._sum;
    }
    get median() {
        if (!this._values.length) return null;
        let e = [
            ...this._values
        ].sort((e, t)=>e - t), t = Math.floor(e.length / 2);
        return e.length % 2 == 0 ? (e[t - 1] + e[t]) / 2 : e[t];
    }
}
let $e175c1d94c759890$var$tz = {
    Latency: [
        {
            scope: "report",
            aggregates: [
                "max",
                "min",
                "avg",
                "median"
            ]
        },
        {
            scope: "session",
            aggregates: [
                "max",
                "min",
                "avg"
            ]
        }
    ]
}, $e175c1d94c759890$var$tG = {
    report: "",
    session: "Session"
};
class $e175c1d94c759890$var$t$ {
    constructor(){
        this._sessionAggregatedFields = {}, this._reportAggregatedFields = {}, Object.entries($e175c1d94c759890$var$tz).forEach(([e, t])=>{
            for (let r of t)"session" === r.scope ? this._sessionAggregatedFields[e] = new $e175c1d94c759890$var$tH(r.aggregates) : this._reportAggregatedFields[e] = new $e175c1d94c759890$var$tH(r.aggregates);
        });
    }
    addValue(e, t) {
        this._sessionAggregatedFields[e]?.addValue(t), this._reportAggregatedFields[e]?.addValue(t);
    }
    addValues(e, t) {
        this._sessionAggregatedFields[e]?.addValues(t), this._reportAggregatedFields[e]?.addValues(t);
    }
    clearValues(e) {
        this._sessionAggregatedFields[e]?.clear(), this._reportAggregatedFields[e]?.clear();
    }
    clearReportValues() {
        Object.values(this._reportAggregatedFields).forEach((e)=>e.clear());
    }
    clearSessionValues() {
        Object.values(this._sessionAggregatedFields).forEach((e)=>e.clear());
    }
    clearAllValues() {
        this.clearReportValues(), this.clearSessionValues();
    }
    getAllValues() {
        let e = {
            ...this._populateValuesByScope("session"),
            ...this._populateValuesByScope("report")
        };
        return this.clearReportValues(), e;
    }
    _populateValuesByScope(e) {
        let t = {}, r = "session" === e ? this._sessionAggregatedFields : this._reportAggregatedFields;
        return Object.keys(r).forEach((n)=>{
            let i = $e175c1d94c759890$var$tz[n].find(({ scope: t  })=>t === e);
            if (i) for (let s of i.aggregates)r[n] && r[n]?.[s] !== null && (t[`${s}${n}${$e175c1d94c759890$var$tG[e]}`] = r[n]?.[s]);
        }), t;
    }
}
var $e175c1d94c759890$var$tY = {};
"undefined" != typeof self && self, $e175c1d94c759890$var$tY = function() {
    var e = [
        function(e, t, r) {
            var n = r(5), i = r(1), s = i.toHex, o = i.ceilHeapSize, a = r(6), l = function(e) {
                for(e += 9; e % 64 > 0; e += 1);
                return e;
            }, u = function(e, t) {
                var r = new Uint8Array(e.buffer), n = t % 4, i = t - n;
                switch(n){
                    case 0:
                        r[i + 3] = 0;
                    case 1:
                        r[i + 2] = 0;
                    case 2:
                        r[i + 1] = 0;
                    case 3:
                        r[i + 0] = 0;
                }
                for(var s = (t >> 2) + 1; s < e.length; s++)e[s] = 0;
            }, c = function(e, t, r) {
                e[t >> 2] |= 128 << 24 - (t % 4 << 3), e[((t >> 2) + 2 & -16) + 14] = r / 0x20000000 | 0, e[((t >> 2) + 2 & -16) + 15] = r << 3;
            }, h = function(e, t) {
                var r = new Int32Array(e, t + 320, 5), n = new Int32Array(5), i = new DataView(n.buffer);
                return i.setInt32(0, r[0], !1), i.setInt32(4, r[1], !1), i.setInt32(8, r[2], !1), i.setInt32(12, r[3], !1), i.setInt32(16, r[4], !1), n;
            };
            e.exports = function() {
                function e(t) {
                    if (!(this instanceof e)) throw TypeError("Cannot call a class as a function");
                    if ((t = t || 65536) % 64 > 0) throw Error("Chunk size must be a multiple of 128 bit");
                    this._offset = 0, this._maxChunkLen = t, this._padMaxChunkLen = l(t), this._heap = new ArrayBuffer(o(this._padMaxChunkLen + 320 + 20)), this._h32 = new Int32Array(this._heap), this._h8 = new Int8Array(this._heap), this._core = new n({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                return e.prototype._initState = function(e, t) {
                    this._offset = 0;
                    var r = new Int32Array(e, t + 320, 5);
                    r[0] = 0x67452301, r[1] = -271733879, r[2] = -1732584194, r[3] = 0x10325476, r[4] = -1009589776;
                }, e.prototype._padChunk = function(e, t) {
                    var r = l(e), n = new Int32Array(this._heap, 0, r >> 2);
                    return u(n, e), c(n, e, t), r;
                }, e.prototype._write = function(e, t, r, n) {
                    a(e, this._h8, this._h32, t, r, n || 0);
                }, e.prototype._coreCall = function(e, t, r, n, i) {
                    var s = r;
                    this._write(e, t, r), i && (s = this._padChunk(r, n)), this._core.hash(s, this._padMaxChunkLen);
                }, e.prototype.rawDigest = function(e) {
                    var t = e.byteLength || e.length || e.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var r = 0, n = this._maxChunkLen;
                    for(r = 0; t > r + n; r += n)this._coreCall(e, r, n, t, !1);
                    return this._coreCall(e, r, t - r, t, !0), h(this._heap, this._padMaxChunkLen);
                }, e.prototype.digest = function(e) {
                    return s(this.rawDigest(e).buffer);
                }, e.prototype.digestFromString = function(e) {
                    return this.digest(e);
                }, e.prototype.digestFromBuffer = function(e) {
                    return this.digest(e);
                }, e.prototype.digestFromArrayBuffer = function(e) {
                    return this.digest(e);
                }, e.prototype.resetState = function() {
                    return this._initState(this._heap, this._padMaxChunkLen), this;
                }, e.prototype.append = function(e) {
                    var t = 0, r = e.byteLength || e.length || e.size || 0, n = this._offset % this._maxChunkLen, i = void 0;
                    for(this._offset += r; t < r;)i = Math.min(r - t, this._maxChunkLen - n), this._write(e, t, i, n), n += i, t += i, n === this._maxChunkLen && (this._core.hash(this._maxChunkLen, this._padMaxChunkLen), n = 0);
                    return this;
                }, e.prototype.getState = function() {
                    var e = this._offset % this._maxChunkLen, t = void 0;
                    if (e) t = this._heap.slice(0);
                    else {
                        var r = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        t = r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength);
                    }
                    return {
                        offset: this._offset,
                        heap: t
                    };
                }, e.prototype.setState = function(e) {
                    return this._offset = e.offset, 20 === e.heap.byteLength ? new Int32Array(this._heap, this._padMaxChunkLen + 320, 5).set(new Int32Array(e.heap)) : this._h32.set(new Int32Array(e.heap)), this;
                }, e.prototype.rawEnd = function() {
                    var e = this._offset, t = e % this._maxChunkLen, r = this._padChunk(t, e);
                    this._core.hash(r, this._padMaxChunkLen);
                    var n = h(this._heap, this._padMaxChunkLen);
                    return this._initState(this._heap, this._padMaxChunkLen), n;
                }, e.prototype.end = function() {
                    return s(this.rawEnd().buffer);
                }, e;
            }(), e.exports._core = n;
        },
        function(e, t) {
            for(var r = Array(256), n = 0; n < 256; n++)r[n] = (n < 16 ? "0" : "") + n.toString(16);
            e.exports.toHex = function(e) {
                for(var t = new Uint8Array(e), n = Array(e.byteLength), i = 0; i < n.length; i++)n[i] = r[t[i]];
                return n.join("");
            }, e.exports.ceilHeapSize = function(e) {
                var t = 0;
                if (e <= 65536) return 65536;
                if (e < 0x1000000) for(t = 1; t < e; t <<= 1);
                else for(t = 0x1000000; t < e; t += 0x1000000);
                return t;
            }, e.exports.isDedicatedWorkerScope = function(e) {
                var t = "WorkerGlobalScope" in e && e instanceof e.WorkerGlobalScope, r = "SharedWorkerGlobalScope" in e && e instanceof e.SharedWorkerGlobalScope, n = "ServiceWorkerGlobalScope" in e && e instanceof e.ServiceWorkerGlobalScope;
                return t && !r && !n;
            };
        },
        function(e, t, r) {
            e.exports = function() {
                var e = r(0), t = function(e, t, r) {
                    try {
                        return r(null, e.digest(t));
                    } catch (e) {
                        return r(e);
                    }
                }, n = function(e, t, r, i, s) {
                    var o = new self.FileReader;
                    o.onloadend = function() {
                        if (o.error) return s(o.error);
                        var a = o.result;
                        t += o.result.byteLength;
                        try {
                            e.append(a);
                        } catch (e) {
                            s(e);
                            return;
                        }
                        t < i.size ? n(e, t, r, i, s) : s(null, e.end());
                    }, o.readAsArrayBuffer(i.slice(t, t + r));
                }, i = !0;
                return self.onmessage = function(r) {
                    if (i) {
                        var s = r.data.data, o = r.data.file, a = r.data.id;
                        if (void 0 !== a && (o || s)) {
                            var l = r.data.blockSize || 4194304, u = new e(l);
                            u.resetState();
                            var c = function(e, t) {
                                e ? self.postMessage({
                                    id: a,
                                    error: e.name
                                }) : self.postMessage({
                                    id: a,
                                    hash: t
                                });
                            };
                            s && t(u, s, c), o && n(u, 0, l, o, c);
                        }
                    }
                }, function() {
                    i = !1;
                };
            };
        },
        function(e, t, r) {
            var n = r(4), i = r(0), s = r(7), o = r(2), a = r(1).isDedicatedWorkerScope;
            i.disableWorkerBehaviour = "undefined" != typeof self && a(self) ? o() : function() {}, i.createWorker = function() {
                var e = n(2), t = e.terminate;
                return e.terminate = function() {
                    URL.revokeObjectURL(e.objectURL), t.call(e);
                }, e;
            }, i.createHash = s, e.exports = i;
        },
        function(e, t, r) {
            function n(e) {
                var t = {};
                function r(n) {
                    if (t[n]) return t[n].exports;
                    var i = t[n] = {
                        i: n,
                        l: !1,
                        exports: {}
                    };
                    return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                }
                r.m = e, r.c = t, r.i = function(e) {
                    return e;
                }, r.d = function(e, t, n) {
                    r.o(e, t) || Object.defineProperty(e, t, {
                        configurable: !1,
                        enumerable: !0,
                        get: n
                    });
                }, r.r = function(e) {
                    Object.defineProperty(e, "__esModule", {
                        value: !0
                    });
                }, r.n = function(e) {
                    var t = e && e.__esModule ? function() {
                        return e.default;
                    } : function() {
                        return e;
                    };
                    return r.d(t, "a", t), t;
                }, r.o = function(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }, r.p = "/", r.oe = function(e) {
                    throw console.error(e), e;
                };
                var n = r(r.s = ENTRY_MODULE);
                return n.default || n;
            }
            var i = "[\\.|\\-|\\+|\\w|/|@]+", s = "\\((/\\*.*?\\*/)?s?.*?(" + i + ").*?\\)";
            function o(e) {
                return (e + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
            }
            e.exports = function(e, t) {
                t = t || {};
                var a = {
                    main: r.m
                }, l = t.all ? {
                    main: Object.keys(a)
                } : function(e, t) {
                    for(var n = {
                        main: [
                            t
                        ]
                    }, a = {
                        main: []
                    }, l = {
                        main: {}
                    }; Object.keys(n).reduce(function(e, t) {
                        return e || n[t].length > 0;
                    }, !1);)for(var u = Object.keys(n), c = 0; c < u.length; c++){
                        var h = u[c], d = n[h].pop();
                        if (l[h] = l[h] || {}, !l[h][d] && e[h][d]) {
                            l[h][d] = !0, a[h] = a[h] || [], a[h].push(d);
                            for(var _ = function(e, t, n) {
                                var a, l = {};
                                l[n] = [];
                                var u = t.toString(), c = u.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                                if (!c) return l;
                                for(var h = c[1], d = RegExp("(\\\\n|\\W)" + o(h) + s, "g"); a = d.exec(u);)"dll-reference" !== a[3] && l[n].push(a[3]);
                                for(d = RegExp("\\(" + o(h) + '\\("(dll-reference\\s(' + i + '))"\\)\\)' + s, "g"); a = d.exec(u);)e[a[2]] || (l[n].push(a[1]), e[a[2]] = r(a[1]).m), l[a[2]] = l[a[2]] || [], l[a[2]].push(a[4]);
                                return l;
                            }(e, e[h][d], h), f = Object.keys(_), p = 0; p < f.length; p++)n[f[p]] = n[f[p]] || [], n[f[p]] = n[f[p]].concat(_[f[p]]);
                        }
                    }
                    return a;
                }(a, e), u = "";
                Object.keys(l).filter(function(e) {
                    return "main" !== e;
                }).forEach(function(e) {
                    for(var t = 0; l[e][t];)t++;
                    l[e].push(t), a[e][t] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", u = u + "var " + e + " = (" + n.toString().replace("ENTRY_MODULE", JSON.stringify(t)) + ")({" + l[e].map(function(t) {
                        return "" + JSON.stringify(t) + ": " + a[e][t].toString();
                    }).join(",") + "});\n";
                }), u = u + "(" + n.toString().replace("ENTRY_MODULE", JSON.stringify(e)) + ")({" + l.main.map(function(e) {
                    return "" + JSON.stringify(e) + ": " + a.main[e].toString();
                }).join(",") + "})(self);";
                var c = new window.Blob([
                    u
                ], {
                    type: "text/javascript"
                });
                if (t.bare) return c;
                var h = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(c), d = new window.Worker(h);
                return d.objectURL = h, d;
            };
        },
        function(e, t) {
            e.exports = function(e, t, r) {
                "use asm";
                var n = new e.Int32Array(r);
                function i(e, t) {
                    e = e | 0;
                    t = t | 0;
                    var r = 0, i = 0, s = 0, o = 0, a = 0, l = 0, u = 0, c = 0, h = 0, d = 0, _ = 0, f = 0, p = 0, v = 0;
                    s = n[t + 320 >> 2] | 0;
                    a = n[t + 324 >> 2] | 0;
                    u = n[t + 328 >> 2] | 0;
                    h = n[t + 332 >> 2] | 0;
                    _ = n[t + 336 >> 2] | 0;
                    for(r = 0; (r | 0) < (e | 0); r = r + 64 | 0){
                        o = s;
                        l = a;
                        c = u;
                        d = h;
                        f = _;
                        for(i = 0; (i | 0) < 64; i = i + 4 | 0){
                            v = n[r + i >> 2] | 0;
                            p = ((s << 5 | s >>> 27) + (a & u | ~a & h) | 0) + ((v + _ | 0) + 0x5a827999 | 0) | 0;
                            _ = h;
                            h = u;
                            u = a << 30 | a >>> 2;
                            a = s;
                            s = p;
                            n[e + i >> 2] = v;
                        }
                        for(i = e + 64 | 0; (i | 0) < (e + 80 | 0); i = i + 4 | 0){
                            v = (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) << 1 | (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) >>> 31;
                            p = ((s << 5 | s >>> 27) + (a & u | ~a & h) | 0) + ((v + _ | 0) + 0x5a827999 | 0) | 0;
                            _ = h;
                            h = u;
                            u = a << 30 | a >>> 2;
                            a = s;
                            s = p;
                            n[i >> 2] = v;
                        }
                        for(i = e + 80 | 0; (i | 0) < (e + 160 | 0); i = i + 4 | 0){
                            v = (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) << 1 | (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) >>> 31;
                            p = ((s << 5 | s >>> 27) + (a ^ u ^ h) | 0) + ((v + _ | 0) + 0x6ed9eba1 | 0) | 0;
                            _ = h;
                            h = u;
                            u = a << 30 | a >>> 2;
                            a = s;
                            s = p;
                            n[i >> 2] = v;
                        }
                        for(i = e + 160 | 0; (i | 0) < (e + 240 | 0); i = i + 4 | 0){
                            v = (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) << 1 | (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) >>> 31;
                            p = ((s << 5 | s >>> 27) + (a & u | a & h | u & h) | 0) + ((v + _ | 0) - 0x70e44324 | 0) | 0;
                            _ = h;
                            h = u;
                            u = a << 30 | a >>> 2;
                            a = s;
                            s = p;
                            n[i >> 2] = v;
                        }
                        for(i = e + 240 | 0; (i | 0) < (e + 320 | 0); i = i + 4 | 0){
                            v = (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) << 1 | (n[i - 12 >> 2] ^ n[i - 32 >> 2] ^ n[i - 56 >> 2] ^ n[i - 64 >> 2]) >>> 31;
                            p = ((s << 5 | s >>> 27) + (a ^ u ^ h) | 0) + ((v + _ | 0) - 0x359d3e2a | 0) | 0;
                            _ = h;
                            h = u;
                            u = a << 30 | a >>> 2;
                            a = s;
                            s = p;
                            n[i >> 2] = v;
                        }
                        s = s + o | 0;
                        a = a + l | 0;
                        u = u + c | 0;
                        h = h + d | 0;
                        _ = _ + f | 0;
                    }
                    n[t + 320 >> 2] = s;
                    n[t + 324 >> 2] = a;
                    n[t + 328 >> 2] = u;
                    n[t + 332 >> 2] = h;
                    n[t + 336 >> 2] = _;
                }
                return {
                    hash: i
                };
            };
        },
        function(e, t) {
            var r = this, n = void 0;
            "undefined" != typeof self && void 0 !== self.FileReaderSync && (n = new self.FileReaderSync);
            var i = function(e, t, r, n, i, s) {
                var o = void 0, a = s % 4, l = (i + a) % 4, u = i - l;
                switch(a){
                    case 0:
                        t[s] = e.charCodeAt(n + 3);
                    case 1:
                        t[s + 1 - (a << 1) | 0] = e.charCodeAt(n + 2);
                    case 2:
                        t[s + 2 - (a << 1) | 0] = e.charCodeAt(n + 1);
                    case 3:
                        t[s + 3 - (a << 1) | 0] = e.charCodeAt(n);
                }
                if (!(i < l + (4 - a))) {
                    for(o = 4 - a; o < u; o = o + 4 | 0)r[s + o >> 2] = e.charCodeAt(n + o) << 24 | e.charCodeAt(n + o + 1) << 16 | e.charCodeAt(n + o + 2) << 8 | e.charCodeAt(n + o + 3);
                    switch(l){
                        case 3:
                            t[s + u + 1 | 0] = e.charCodeAt(n + u + 2);
                        case 2:
                            t[s + u + 2 | 0] = e.charCodeAt(n + u + 1);
                        case 1:
                            t[s + u + 3 | 0] = e.charCodeAt(n + u);
                    }
                }
            }, s = function(e, t, r, n, i, s) {
                var o = void 0, a = s % 4, l = (i + a) % 4, u = i - l;
                switch(a){
                    case 0:
                        t[s] = e[n + 3];
                    case 1:
                        t[s + 1 - (a << 1) | 0] = e[n + 2];
                    case 2:
                        t[s + 2 - (a << 1) | 0] = e[n + 1];
                    case 3:
                        t[s + 3 - (a << 1) | 0] = e[n];
                }
                if (!(i < l + (4 - a))) {
                    for(o = 4 - a; o < u; o = o + 4 | 0)r[s + o >> 2] = e[n + o] << 24 | e[n + o + 1] << 16 | e[n + o + 2] << 8 | e[n + o + 3];
                    switch(l){
                        case 3:
                            t[s + u + 1 | 0] = e[n + u + 2];
                        case 2:
                            t[s + u + 2 | 0] = e[n + u + 1];
                        case 1:
                            t[s + u + 3 | 0] = e[n + u];
                    }
                }
            }, o = function(e, t, r, i, s, o) {
                var a = void 0, l = o % 4, u = (s + l) % 4, c = s - u, h = new Uint8Array(n.readAsArrayBuffer(e.slice(i, i + s)));
                switch(l){
                    case 0:
                        t[o] = h[3];
                    case 1:
                        t[o + 1 - (l << 1) | 0] = h[2];
                    case 2:
                        t[o + 2 - (l << 1) | 0] = h[1];
                    case 3:
                        t[o + 3 - (l << 1) | 0] = h[0];
                }
                if (!(s < u + (4 - l))) {
                    for(a = 4 - l; a < c; a = a + 4 | 0)r[o + a >> 2] = h[a] << 24 | h[a + 1] << 16 | h[a + 2] << 8 | h[a + 3];
                    switch(u){
                        case 3:
                            t[o + c + 1 | 0] = h[c + 2];
                        case 2:
                            t[o + c + 2 | 0] = h[c + 1];
                        case 1:
                            t[o + c + 3 | 0] = h[c];
                    }
                }
            };
            e.exports = function(e, t, n, a, l, u) {
                if ("string" == typeof e) return i(e, t, n, a, l, u);
                if (e instanceof Array || r && r.Buffer && r.Buffer.isBuffer(e)) return s(e, t, n, a, l, u);
                if (e instanceof ArrayBuffer) return s(new Uint8Array(e), t, n, a, l, u);
                if (e.buffer instanceof ArrayBuffer) return s(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t, n, a, l, u);
                if (e instanceof Blob) return o(e, t, n, a, l, u);
                throw Error("Unsupported data type.");
            };
        },
        function(e, t, r) {
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }(), i = r(0), s = r(1).toHex, o = function() {
                function e() {
                    if (!(this instanceof e)) throw TypeError("Cannot call a class as a function");
                    this._rusha = new i, this._rusha.resetState();
                }
                return e.prototype.update = function(e) {
                    return this._rusha.append(e), this;
                }, e.prototype.digest = function(e) {
                    var t = this._rusha.rawEnd().buffer;
                    if (!e) return t;
                    if ("hex" === e) return s(t);
                    throw Error("unsupported digest encoding");
                }, n(e, [
                    {
                        key: "state",
                        get: function() {
                            return this._rusha.getState();
                        },
                        set: function(e) {
                            this._rusha.setState(e);
                        }
                    }
                ]), e;
            }();
            e.exports = function() {
                return new o;
            };
        }
    ], t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var i = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: n
        });
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 3);
}();
let $e175c1d94c759890$var$tq = (e)=>{
    var t;
    return ((t = $e175c1d94c759890$var$tY) && t.__esModule ? t.default : t).createHash().update(e.substring(0, 100) + "saltsaltsalt").digest("hex");
};
var $e175c1d94c759890$var$tK = (($e175c1d94c759890$var$u = {}).SESSION_ID_RECREATED = "sessionIdRecreated", $e175c1d94c759890$var$u.UPSCALE_CALCULATED = "upscaleCalculated", $e175c1d94c759890$var$u.VIDEO_ELEMENT_DIMENSIONS_CALCULATED = "videoElementDimensionsCalculated", $e175c1d94c759890$var$u);
let $e175c1d94c759890$var$tQ = "__mmp_metrics_session_start_time__", $e175c1d94c759890$var$tJ = "__mmp_metrics_user_id__", $e175c1d94c759890$var$tZ = "__mmp_metrics_stream_id__", $e175c1d94c759890$var$tX = "__mmp_metrics_page_url__", $e175c1d94c759890$var$t0 = "__mmp_metrics_project_id__", $e175c1d94c759890$var$t1 = sessionStorage.getItem($e175c1d94c759890$var$tZ) || "", $e175c1d94c759890$var$t2 = Number(sessionStorage.getItem($e175c1d94c759890$var$tQ) || "0"), $e175c1d94c759890$var$t3 = sessionStorage.getItem($e175c1d94c759890$var$tJ), $e175c1d94c759890$var$t4 = Number($e175c1d94c759890$var$t3).toString() === $e175c1d94c759890$var$t3 ? Number($e175c1d94c759890$var$t3) : $e175c1d94c759890$var$t3 || "", $e175c1d94c759890$var$t6 = sessionStorage.getItem($e175c1d94c759890$var$tX), $e175c1d94c759890$var$t5 = sessionStorage.getItem($e175c1d94c759890$var$t0) || "", $e175c1d94c759890$var$t8 = (e)=>{
    sessionStorage.setItem($e175c1d94c759890$var$tX, e);
}, $e175c1d94c759890$var$t9 = (e)=>{
    sessionStorage.setItem($e175c1d94c759890$var$tZ, e), $e175c1d94c759890$var$t8(window.location.toString());
}, $e175c1d94c759890$var$t7 = (e)=>{
    sessionStorage.setItem($e175c1d94c759890$var$tJ, e.toString());
}, $e175c1d94c759890$var$re = (e)=>{
    sessionStorage.setItem($e175c1d94c759890$var$t0, e.toString());
}, $e175c1d94c759890$var$rt = (e)=>{
    sessionStorage.setItem($e175c1d94c759890$var$tQ, e.toString());
}, $e175c1d94c759890$var$rr = ()=>!!$e175c1d94c759890$var$t1 && !!$e175c1d94c759890$var$t2 && !!$e175c1d94c759890$var$t4 && !!$e175c1d94c759890$var$t5 && window?.location.toString() === $e175c1d94c759890$var$t6, $e175c1d94c759890$var$rn = ()=>$e175c1d94c759890$var$t2, $e175c1d94c759890$var$ri = ()=>$e175c1d94c759890$var$t4, $e175c1d94c759890$var$rs = ()=>$e175c1d94c759890$var$t1, $e175c1d94c759890$var$ro = ()=>$e175c1d94c759890$var$t5;
class $e175c1d94c759890$var$ra {
    addValue(e, t) {
        this._aggregatedFields[e]?.addValue(t);
    }
    addValues(e, t) {
        this._aggregatedFields[e]?.addValues(t);
    }
    clearValues(e) {
        this._aggregatedFields[e]?.clear();
    }
    clearAllValues() {
        Object.values(this._aggregatedFields).forEach((e)=>e.clear());
    }
    getMax(e) {
        this._aggregatedFields[e].max;
    }
    getMedian(e) {
        this._aggregatedFields[e].median;
    }
    getAllValues() {
        let e = {};
        return Object.keys(this._aggregatedFields).forEach((t)=>{
            let r = this._aggregatedFields[t].max;
            null !== r && r > -1 / 0 && (e[`max${t}`] = r);
            let n = this._aggregatedFields[t].median;
            null !== n && (e[`median${t}`] = n);
            let i = this._aggregatedFields[t].sum;
            i && (e[`sum${t}`] = i);
            let s = this._aggregatedFields[t].count;
            s && (e[`count${t}`] = s);
        }), e;
    }
    constructor(){
        this._aggregatedFields = {
            RTT: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            AudioJitter: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            VideoJitter: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            Buffer: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            TargetBuffer: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            FramesEncoded: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            FramesSent: new $e175c1d94c759890$var$tH([
                "max",
                "median"
            ]),
            ChunkLoadDuration: new $e175c1d94c759890$var$tH([
                "max",
                "median",
                "sum"
            ]),
            ChunkLoadTTFB: new $e175c1d94c759890$var$tH([
                "max",
                "median",
                "sum"
            ]),
            PlaylistLoadDuration: new $e175c1d94c759890$var$tH([
                "max",
                "median",
                "sum"
            ]),
            PlaylistLoadTTFB: new $e175c1d94c759890$var$tH([
                "max",
                "median",
                "sum"
            ]),
            PlaylistSize: new $e175c1d94c759890$var$tH([
                "sum",
                "count"
            ]),
            ChunkSize: new $e175c1d94c759890$var$tH([
                "sum",
                "count"
            ])
        };
    }
}
var $e175c1d94c759890$var$rl = (($e175c1d94c759890$var$c = {})[$e175c1d94c759890$var$c.PLANNED = 1] = "PLANNED", $e175c1d94c759890$var$c[$e175c1d94c759890$var$c.PRECLOSE = 2] = "PRECLOSE", $e175c1d94c759890$var$c[$e175c1d94c759890$var$c.PRECLEAR = 3] = "PRECLEAR", $e175c1d94c759890$var$c);
let $e175c1d94c759890$export$28c82a02d50f6df3 = "v1.21.2", $e175c1d94c759890$var$rc = {
    audioJitter: "AudioJitter",
    videoJitter: "VideoJitter",
    buffer: "Buffer",
    framesEncoded: "FramesEncoded",
    framesSent: "FramesSent",
    targetBuffer: "TargetBuffer",
    chunkLoadDuration: "ChunkLoadDuration",
    chunkLoadTTFB: "ChunkLoadTTFB",
    playlistLoadDuration: "PlaylistLoadDuration",
    playlistLoadTTFB: "PlaylistLoadTTFB",
    chunkSize: "ChunkSize",
    playlistSize: "PlaylistSize"
}, $e175c1d94c759890$var$rh = {
    latency: "Latency"
}, $e175c1d94c759890$var$rd = {
    framesDecoded: "framesDecoded",
    nackCount: "nackCount",
    totalFreezesDuration: "totalFreezesDuration",
    totalPausesDuration: "totalPausesDuration",
    fecPacketsReceived: "fecPacketsReceived",
    fecPacketsDiscarded: "fecPacketsDiscarded",
    framesReceived: "framesReceived",
    packetsLost: "packetsLost",
    packetsDiscarded: "packetsDiscarded",
    packetsReceived: "packetsReceived",
    totalFramesDecoded: "totalFramesDecoded",
    totalFramesDropped: "totalFramesDropped",
    upscaleFactorAvg: "upscaleFactorAvg",
    upscaleFactorMax: "upscaleFactorMax"
};
class $e175c1d94c759890$var$r_ {
    constructor(e, t, r){
        this._userId = null, this._sessionStartTime = null, this._playerType = null, this._streamId = null, this._currentMetricsState = {}, this._currentDomain = "", this._sendMetricsInterval = null, this._eventsCache = [], this._currentManualResolution = null, this._currentRenditionSwitchMode = null, this._abTestsMap = {}, this._abTestsSupport = {}, this._additionalFields = {}, this._urlPostfix = "", this._timeOrigin = performance.timeOrigin, this._eventSequenceNumber = 0, this._userType = "unknown", this._regularBroadcastStopReason = "", this._sessionId = "", this._aggregatedMetrics = new $e175c1d94c759890$var$ra, this._aggregatedMetricsV2 = new $e175c1d94c759890$var$t$, this._baseUrl = e, this._projectId = t, this._eventBus = r, $e175c1d94c759890$var$rr() && this._registerReloadEvent();
    }
    destroy() {
        this.stop();
    }
    stop() {
        this._disarmMetricsSend(), this.immediatelySendMetrics(!0), this._sessionStartTime = null, this._streamId = null, $e175c1d94c759890$var$t9(""), this._eventSequenceNumber = 0;
    }
    registerMetrics(e) {
        let t = Object.keys({
            ...$e175c1d94c759890$var$rc,
            ...$e175c1d94c759890$var$rh
        }).concat([
            "totalRoundTripTime",
            "responsesReceived"
        ]);
        void 0 !== e.totalRoundTripTime && void 0 !== e.responsesReceived && (this._aggregatedMetrics.addValue("RTT", e.totalRoundTripTime / e.responsesReceived), delete e.totalRoundTripTime, delete e.responsesReceived), Object.entries(e).forEach(([e, r])=>{
            if (t.includes(e)) this._aggregatedMetrics.addValue($e175c1d94c759890$var$rc[e], r), this._aggregatedMetricsV2.addValue($e175c1d94c759890$var$rh[e], r);
            else {
                let t = $e175c1d94c759890$var$rd[e];
                this._currentMetricsState[t] = r;
            }
        });
    }
    setAbTests(e) {
        this._abTestsMap = e;
    }
    setAbTestsSupport(e) {
        this._abTestsSupport = e;
    }
    setAdditionalFields(e) {
        this._additionalFields = e;
    }
    updateCDNUrl(e) {
        let { host: t  } = new URL(e);
        this._currentDomain !== t && (this._currentDomain = t);
    }
    setTimeOrigin(e) {
        this._timeOrigin = e;
    }
    setUserId(e) {
        this._userId !== e && this._recreateSessionId(e);
    }
    setProjectId(e) {
        this._projectId !== e && this._recreateSessionId(void 0, e);
    }
    setUserType(e) {
        this._userType = e;
    }
    setPlayerType(e) {
        e !== this._playerType && (this._playerType && this.registerEvent("PlayerTypeSwitched", {
            prevPlayerType: this._playerType,
            nextPlayerType: e
        }), e === $e175c1d94c759890$var$tj.EPlayerType.BROADCAST ? this._urlPostfix = "_broadcast" : this._userId && (this._urlPostfix = Number(this._userId) % 2 == 0 ? "_user" : "_guest"), this._playerType = e, this._recreateSessionId());
    }
    setStreamId(e) {
        e !== this._streamId && ($e175c1d94c759890$var$t9(e), this._streamId = e, this._recreateSessionId());
    }
    setManualResolution(e) {
        this._currentManualResolution !== e && (this._currentManualResolution && this.registerEvent("RenditionSwitchedManual", {
            prevResolution: this._currentManualResolution,
            nextResolution: e
        }), this._currentManualResolution = e);
    }
    setRenditionSwitchMode(e) {
        this._currentRenditionSwitchMode !== e && (this._currentRenditionSwitchMode && this.registerEvent("RenditionSelectModeSwitched", {
            prevMode: this._currentRenditionSwitchMode,
            nextMode: e
        }), this._currentRenditionSwitchMode = e);
    }
    prepareMetrics() {
        return {
            ...this._currentMetricsState,
            ...this._aggregatedMetrics.getAllValues(),
            ...this._aggregatedMetricsV2.getAllValues()
        };
    }
    registerEvent(e, t = {}) {
        if (!this.hasEnoughInfoForMetricsAndEvents) return;
        let r = this._buildEventsSingleMessage(e, t);
        this._registerRawEvent(r);
    }
    clear() {
        this._aggregatedMetrics.clearAllValues(), this._currentMetricsState = {};
    }
    setRegularBroadcastStopReason(e) {
        this._regularBroadcastStopReason = e;
    }
    immediatelySendMetrics(e = !1) {
        this.hasEnoughInfoForMetricsAndEvents && (this.registerEvent(e ? "SessionTerminated" : "TabBlurred", {
            reason: this._regularBroadcastStopReason
        }), e || this._armMetricsSendInterval(), this._sendCurrentState("all", !0));
    }
    _possiblyCreateSessionId() {
        this._playerType && this._streamId && !this._sessionStartTime && (this._sessionStartTime = performance.now() + this._timeOrigin, this._armMetricsSendInterval(), this.registerEvent("SessionStarted"), $e175c1d94c759890$var$rt(this._sessionStartTime), this._sessionId = `${this._sessionStartTime}:${this._userId}`, this._eventBus.publish($e175c1d94c759890$var$tK.SESSION_ID_RECREATED, {}));
    }
    _registerRawEvent(e) {
        this._eventsCache.push(e), this._eventSequenceNumber++;
    }
    _registerReloadEvent() {
        this._registerRawEvent(this._buildEventsSingleMessage("PageReloaded", {}, {
            streamId: $e175c1d94c759890$var$rs().toString(),
            userId: $e175c1d94c759890$var$ri(),
            sessionStartTime: $e175c1d94c759890$var$rn(),
            projectId: $e175c1d94c759890$var$ro()
        }));
    }
    _recreateSessionId(e, t) {
        if (!this._sessionStartTime) {
            void 0 !== e && this._applyUserId(e), void 0 !== t && this._applyProjectId(t), this._possiblyCreateSessionId();
            return;
        }
        this.registerEvent("SessionTerminated", {
            reason: this._regularBroadcastStopReason
        }), this._sendCurrentState("metrics"), this._eventSequenceNumber = 0, this._sessionStartTime = performance.now() + this._timeOrigin, this._sessionId = `${this._sessionStartTime}:${this._userId}`, this._aggregatedMetricsV2.clearReportValues(), void 0 !== e && this._applyUserId(e), void 0 !== t && this._applyProjectId(t), this.registerEvent("SessionStarted"), this._eventBus.publish($e175c1d94c759890$var$tK.SESSION_ID_RECREATED, {});
    }
    _armMetricsSendInterval() {
        this._disarmMetricsSend(), this._sendMetricsInterval = setInterval(this._sendCurrentState, 3e4);
    }
    _disarmMetricsSend() {
        this._sendMetricsInterval && (clearInterval(this._sendMetricsInterval), this._sendMetricsInterval = null);
    }
    async _sendCurrentState(e = "all", t = !1) {
        if ([
            "events",
            "all"
        ].includes(e)) {
            let e = [
                ...this._eventsCache
            ];
            e.length && (this._eventsCache = [], await this._performFetchRequest({
                url: `${this._baseUrl}/events${this._urlPostfix}`,
                data: {
                    events: e
                },
                onError: ()=>{
                    this._eventsCache.push(...e);
                },
                isTerminating: t
            }));
        }
        if ([
            "metrics",
            "all"
        ].includes(e)) {
            if (!this.hasEnoughInfoForMetricsAndEvents) return void this.clear();
            let e = this._buildSingleMetricsMessage(this.prepareMetrics());
            await this._performFetchRequest({
                url: `${this._baseUrl}/metrics${this._urlPostfix}`,
                data: e,
                onSuccess: ()=>{
                    this.clear();
                },
                isTerminating: t
            });
        }
    }
    get currentRenditionSelectMode() {
        return this._currentRenditionSwitchMode;
    }
    get hasEnoughInfoForMetricsAndEvents() {
        return !!this._playerType && !!this._streamId && !!this._sessionStartTime && !!this._userId;
    }
    get missingFieldsForMetricsAndEvents() {
        return Object.entries({
            playerType: this._playerType,
            streamId: this._streamId,
            sessionStartTime: this._sessionStartTime,
            userId: this._userId
        }).filter(([e, t])=>!!t).map(([e])=>e);
    }
    _buildEventsSingleMessage(e, t = {}, r = {}) {
        return {
            eventType: e,
            payload: t,
            sessionStartTime: this._sessionStartTime,
            userId: this._userId,
            streamId: this._streamId,
            playerImpl: "MMP",
            playerType: this._playerType,
            timestamp: Date.now(),
            projectId: this._projectId,
            cdnDomain: this._currentDomain,
            abTests: this._abTestsMap,
            abTestsSupport: this._abTestsSupport,
            mmpVersion: $e175c1d94c759890$export$28c82a02d50f6df3,
            sequenceNumber: this._eventSequenceNumber,
            userType: "unknown" !== this._userType ? this._userType : void 0,
            ...this._additionalFields || {},
            ...r
        };
    }
    _buildSingleMetricsMessage(e, t = {}) {
        return {
            ...e,
            sessionStartTime: this._sessionStartTime,
            userId: this._userId,
            streamId: this._streamId,
            playerImpl: "MMP",
            playerType: this._playerType,
            timestamp: Date.now(),
            projectId: this._projectId,
            cdnDomain: this._currentDomain,
            reportType: $e175c1d94c759890$var$rl.PRECLEAR,
            abTests: this._abTestsMap,
            abTestsSupport: this._abTestsSupport,
            mmpVersion: $e175c1d94c759890$export$28c82a02d50f6df3,
            userType: "unknown" !== this._userType ? this._userType : void 0,
            ...this._additionalFields || {},
            ...t
        };
    }
    async _performFetchRequest({ url: e , data: t , onError: r = ()=>{} , onSuccess: n = ()=>{} , isTerminating: i = !1  }) {
        let s = JSON.stringify(t), o = new AbortController, a = setTimeout(()=>{
            o.abort("Timeout");
        }, 5e3), l = `${$e175c1d94c759890$var$tq(s)}${s}`;
        if (i) navigator.sendBeacon(e, l);
        else try {
            let t = await fetch(e, {
                body: l,
                signal: o.signal,
                method: "POST",
                cache: "no-cache"
            });
            t.ok || this._onFetchError({
                payloadSize: l.length,
                responseCode: t.status,
                responseBody: await t.text(),
                requestUrl: e,
                nativeError: ""
            }), clearTimeout(a), n();
        } catch (t) {
            this._onFetchError({
                payloadSize: l.length,
                responseCode: 0,
                responseBody: "N/A",
                requestUrl: e,
                nativeError: t.toString()
            }), r(t);
        }
    }
    async _onFetchError(e) {
        try {
            await fetch(`${this._baseUrl}/logs`, {
                body: JSON.stringify({
                    ...e,
                    userId: this._userId ?? -1,
                    sessionStartTime: this._sessionStartTime ?? -1
                }),
                method: "POST",
                cache: "no-cache"
            });
        } catch (e) {
            console.warn("Could not report fetch error:", e);
        }
    }
    get baseUrl() {
        return this._baseUrl;
    }
    get projectId() {
        return this._projectId;
    }
    get sessionId() {
        return this._sessionId;
    }
    _applyUserId(e) {
        this._playerType && this._playerType === $e175c1d94c759890$var$tj.EPlayerType.BROADCAST ? this._urlPostfix = "_broadcast" : this._urlPostfix = Number(e) % 2 == 0 ? "_user" : "_guest", this._userId = e, $e175c1d94c759890$var$t7(e);
    }
    _applyProjectId(e) {
        this._projectId = e, $e175c1d94c759890$var$re(e);
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$r_.prototype, "_sendCurrentState", null);
var $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ");
class $e175c1d94c759890$var$rf {
    addValue(e) {
        this._count++, this._avg += (e - this._avg) / this._count;
    }
    reset() {
        let e = this._avg;
        return this._avg = 0, this._count = 0, e;
    }
    get avg() {
        return this._avg;
    }
    constructor(){
        this._avg = 0, this._count = 0;
    }
}
class $e175c1d94c759890$var$rp {
    addValue(e) {
        e > this._lastMax && (this._lastMax = e);
    }
    reset() {
        let e = this._lastMax;
        return this._lastMax = -1 / 0, e;
    }
    get max() {
        return this._lastMax;
    }
    constructor(){
        this._lastMax = -1 / 0;
    }
}
class $e175c1d94c759890$var$rv {
    constructor(e, t, r){
        this._collectMetricsInterval = null, this._videoElement = null, this._isPageVisible = !1, this._isStalledByCurrentTime = !0, this._prevPlaybackPosition = null, this._checkCurrentTimeInterval = null, this._isPaused = !1, this._resolutions = [], this._upscaleAvg = new $e175c1d94c759890$var$rf, this._upscaleMax = new $e175c1d94c759890$var$rp, this._metricsCollector = e, this._eventBus = t, this._upscaleCalculationService = r, this._onSessionIdRecreatedListener = t.subscribe($e175c1d94c759890$var$tK.SESSION_ID_RECREATED, this._onSessionIdRecreated);
    }
    destroy() {
        this._detachEventListeners(), this._disarmMetricsCollectionInterval(), this._disarmCurrentTimeCheck(), this._eventBus.unsubscribe(this._onSessionIdRecreatedListener);
    }
    setVideoElement(e) {
        this._detachEventListeners(), this._disarmMetricsCollectionInterval(), this._disarmCurrentTimeCheck(), this._videoElement = e, this._attachEventListeners(), e && (this._armMetricsCollectionInterval(), this._armCurrentTimeCheck()), this._resendOngoingState();
    }
    setResolutions(e) {
        this._resolutions = [
            ...e
        ].sort((e, t)=>t.height - e.height);
    }
    setIsPaused(e) {
        this._isPaused = e;
    }
    _armMetricsCollectionInterval() {
        this._disarmMetricsCollectionInterval(), this._collectMetricsInterval = setInterval(this._collectVideoElementMetrics, 500);
    }
    _disarmMetricsCollectionInterval() {
        this._collectMetricsInterval && clearInterval(this._collectMetricsInterval);
    }
    _armCurrentTimeCheck() {
        this._disarmCurrentTimeCheck(), this._checkCurrentTimeInterval = setInterval(this._checkCurrentTime, 50);
    }
    _disarmCurrentTimeCheck() {
        this._checkCurrentTimeInterval && clearInterval(this._checkCurrentTimeInterval);
    }
    _attachEventListeners() {
        this._videoElement && (this._videoElement.addEventListener("canplay", this._onCanPlay), this._videoElement.addEventListener("play", this._onPlay), this._videoElement.addEventListener("pause", this._onPause), this._videoElement.addEventListener("stalled", this._onStalledNative), this._videoElement.addEventListener("waiting", this._onStalledNative), this._videoElement.addEventListener("error", this._onErrorReported), document.addEventListener("visibilitychange", this._onVisibilityChanged), this._isPageVisible = "visible" === document.visibilityState);
    }
    _detachEventListeners() {
        this._videoElement && (this._videoElement.removeEventListener("canplay", this._onCanPlay), this._videoElement.removeEventListener("play", this._onPlay), this._videoElement.removeEventListener("pause", this._onPause), this._videoElement.removeEventListener("stalled", this._onStalledNative), this._videoElement.removeEventListener("waiting", this._onStalledNative), this._videoElement.removeEventListener("error", this._onErrorReported), document.removeEventListener("visibilitychange", this._onVisibilityChanged));
    }
    _collectVideoElementMetrics() {
        if (!this._videoElement) return;
        let { videoWidth: e , videoHeight: t  } = this._videoElement, r = this._resolutions.length > 0 ? e >= t ? this._resolutions[0].width : this._resolutions[0].height : void 0, n = this._upscaleCalculationService.getCurrentUpscaleFactor(r);
        this._eventBus.publish($e175c1d94c759890$var$tK.UPSCALE_CALCULATED, {
            upscaleFactor: n
        }), null !== n && (this._upscaleAvg.addValue(n), this._upscaleMax.addValue(n));
        let { totalVideoFrames: i , droppedVideoFrames: s  } = (0, $e175c1d94c759890$var$y.getVideoPlaybackQuality)(this._videoElement), o = 0;
        try {
            Array(this._videoElement.buffered.length).fill(null).forEach((e, t)=>{
                let [r = 0, n = 0] = [
                    this._videoElement?.buffered.start(t),
                    this._videoElement?.buffered.end(t)
                ];
                n <= (this._videoElement?.currentTime || 0) || (o += n - Math.max(this._videoElement?.currentTime || 0, r));
            });
        } catch (e) {}
        let a = {
            totalFramesDecoded: i,
            totalFramesDropped: s,
            buffer: o
        };
        this._upscaleMax.max > -1 / 0 && (a.upscaleFactorAvg = this._upscaleAvg.avg, a.upscaleFactorMax = this._upscaleMax.max), this._registerMetrics(a);
    }
    _onCanPlay() {
        this._registerEvent("ReadyToPlay");
    }
    _onPlay() {
        this._videoElement && this._videoElement.readyState > 1 && this._registerEvent("Played");
    }
    _onPause() {
        this._registerEvent("Paused");
    }
    _onStalledNative() {
        this._registerEvent("StalledNative");
    }
    _onVisibilityChanged() {
        let e = "visible" === document.visibilityState;
        e !== this._isPageVisible && (e ? this._registerEvent("TabFocused") : this._isPaused || this._metricsCollector.immediatelySendMetrics(), this._isPageVisible = e);
    }
    _onErrorReported() {
        this._videoElement?.error?.code && ![
            1,
            2
        ].includes(this._videoElement.error.code) && this._registerEvent("MediaDecodingError", {
            errorMessage: this._videoElement.error.message
        });
    }
    _checkCurrentTime() {
        if (!this._videoElement) {
            this._prevPlaybackPosition = null, this._isStalledByCurrentTime || (this._isStalledByCurrentTime = !0, this._registerEvent("Stalled"));
            return;
        }
        if (!this._prevPlaybackPosition || !this._videoElement.currentTime || this._videoElement.currentTime < this._prevPlaybackPosition) {
            this._prevPlaybackPosition = this._videoElement.currentTime;
            return;
        }
        let e = this._prevPlaybackPosition === this._videoElement.currentTime;
        this._prevPlaybackPosition = this._videoElement.currentTime, this._isStalledByCurrentTime !== e && (this._isStalledByCurrentTime = e, e ? this._registerEvent("Stalled") : this._registerEvent("Played", {
            reason: "exitFromStallByCurrentTime"
        }));
    }
    _registerEvent(e, t = {}) {
        this._isPaused || this._metricsCollector.registerEvent(e, t);
    }
    _registerMetrics(e) {
        this._isPaused || this._metricsCollector.registerMetrics(e);
    }
    _onSessionIdRecreated() {
        this._upscaleMax.reset(), this._upscaleAvg.reset();
    }
    _resendOngoingState() {
        this._videoElement && this._videoElement.readyState > this._videoElement.HAVE_CURRENT_DATA && (this._registerEvent("OngoingSessionDetected"), this._registerEvent("ReadyToPlay"), !this._videoElement.paused && this._videoElement.played.length > 0 && this._videoElement.currentTime > 0 && this._registerEvent("Played"));
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_collectVideoElementMetrics", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onCanPlay", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onPlay", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onPause", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onStalledNative", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onVisibilityChanged", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onErrorReported", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_checkCurrentTime", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rv.prototype, "_onSessionIdRecreated", null);
var $e175c1d94c759890$var$rg = $e175c1d94c759890$var$g("giOKx"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ"), $e175c1d94c759890$var$tj = $e175c1d94c759890$var$g("1QtI2");
let $e175c1d94c759890$var$rm = {
    [$e175c1d94c759890$var$tj.EPlayerType.NATIVE]: ()=>Promise.resolve(!0),
    [$e175c1d94c759890$var$tj.EPlayerType.WEBRTC]: async ()=>$e175c1d94c759890$var$y.WebRTCCommonHelpers.getIsWebRTCApiSupported() && await $e175c1d94c759890$var$y.WebRTCCommonHelpers.isH264PlayingSupported(),
    [$e175c1d94c759890$var$tj.EPlayerType.BROADCAST]: async ()=>$e175c1d94c759890$var$y.WebRTCCommonHelpers.getIsWebRTCApiSupported() && await $e175c1d94c759890$var$y.WebRTCCommonHelpers.isH264BroadcastSupported(),
    [$e175c1d94c759890$var$tj.EPlayerType.HLS]: async ()=>$e175c1d94c759890$var$y.HLSCommon.isHLSSupported(),
    [$e175c1d94c759890$var$tj.EPlayerType.UNKNOWN]: ()=>Promise.resolve(!1)
};
var $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ");
let $e175c1d94c759890$var$ry = (e)=>{
    let t, r = [], n = /(\w+)\(([^)]+)\)/g;
    for(; null !== (t = n.exec(e));){
        let e = t[1], n = t[2].split(",").map((e)=>parseFloat(e.trim()));
        r.push({
            fn: e,
            args: n
        });
    }
    return r;
}, $e175c1d94c759890$var$rb = (e)=>{
    let t = 1, r = 1;
    for (let { fn: n , args: i  } of $e175c1d94c759890$var$ry(e))switch(n){
        case "scale":
            1 === i.length ? (t *= i[0], r *= i[0]) : (t *= i[0], r *= i[1]);
            break;
        case "scaleX":
            t *= i[0];
            break;
        case "scaleY":
            r *= i[0];
            break;
        case "scale3d":
            t *= i[0], r *= i[1];
            break;
        case "matrix":
            t *= i[0], r *= i[3];
            break;
        case "matrix3d":
            t *= i[0], r *= i[5];
    }
    return {
        scaleX: t,
        scaleY: r
    };
};
class $e175c1d94c759890$var$rE {
    constructor(e){
        this._containerDimensions = null, this._devicePixelRatio = 1, this._videoElement = null, this._videoResizeObserver = null, this._userCap = null, this._resolutions = [], this._userSelectedResolution = null, this._dimencionVideo = {
            width: 0,
            height: 0
        }, this._eventBus = e, this._updateDevicePixelRatio(), this._debouncedUpdateContainerDimensions = function(e, t) {
            let r, n = function(...t) {
                r && clearTimeout(r), r = setTimeout(()=>{
                    e.apply(this, t);
                }, 100);
            };
            return n.cancel = ()=>{
                r && (clearTimeout(r), r = void 0);
            }, n;
        }(this._updateContainerDimensions, 0);
    }
    setVideoElement(e) {
        if (this._videoResizeObserver?.disconnect(), this._videoResizeObserver = null, this._debouncedUpdateContainerDimensions.cancel(), this._videoElement && this._videoElement.removeEventListener("timeupdate", this._onVideoTimeUpdate), this._videoElement = e, !e) {
            this._containerDimensions = null, this._dimencionVideo = {
                width: 0,
                height: 0
            };
            return;
        }
        this._onVideoElementResized(), e.addEventListener("timeupdate", this._onVideoTimeUpdate), "ResizeObserver" in globalThis && (this._videoResizeObserver = new ResizeObserver(()=>{
            this._onVideoElementResized();
        }), this._videoResizeObserver.observe(e));
    }
    setResolutions(e) {
        this._resolutions = [
            ...e
        ].sort((e, t)=>t.height - e.height), this._recalculateUserCap();
    }
    setUserSelectedResolution(e) {
        this._userSelectedResolution = e, this._recalculateUserCap();
    }
    getUpscaleFactor(e, t, r) {
        if (!this._containerDimensions || !e || !t) return null;
        let { width: n , height: i  } = this._containerDimensions;
        if (n < 50 || i < 50) return null;
        let s = n, o = i;
        if (!e || !t) return null;
        let a = e / t;
        a > n / i ? o = n / a : s = i * a;
        let l = s >= o, u = (l ? s : o) * this._devicePixelRatio, c = this._userCap ? l ? this._userCap.width : this._userCap.height : u;
        return Math.max((r ? Math.min(u, r, c) : Math.min(u, c)) / (l ? e : t) - 1, 0);
    }
    getCurrentUpscaleFactor(e) {
        if (!this._videoElement) return null;
        let { videoWidth: t , videoHeight: r  } = this._videoElement;
        return t && r ? this.getUpscaleFactor(t, r, e) : null;
    }
    getMaxAllowedResolution(e) {
        if (!this._containerDimensions || !this._resolutions.length || e < 0) return null;
        let { width: t , height: r  } = this._containerDimensions, n = this._containerDimensions.width >= this._containerDimensions.height;
        if (t < 50 || r < 50) return null;
        let i = this._resolutions.filter((t)=>{
            let r = this.getUpscaleFactor(t.width, t.height);
            return null !== r && r >= e;
        });
        if (0 === i.length) {
            let e = this._resolutions.at(-1);
            return e ? {
                width: e.width
            } : null;
        }
        let s = i[0];
        return n ? {
            width: s.width
        } : {
            height: s.height
        };
    }
    getContainerDimensions() {
        return this._containerDimensions;
    }
    getDevicePixelRatio() {
        return this._devicePixelRatio;
    }
    getVideoElementData() {
        return {
            containerDimensions: this._containerDimensions,
            devicePixelRatio: this._devicePixelRatio
        };
    }
    _recalculateUserCap() {
        if (this._userSelectedResolution && this._resolutions.length) {
            let e = this._resolutions.find(({ name: e  })=>e === this._userSelectedResolution);
            e ? this._userCap = {
                width: e.width,
                height: e.height
            } : this._userCap = null;
        } else this._userCap = null;
    }
    _onVideoElementResized() {
        this._videoElement && this._debouncedUpdateContainerDimensions();
    }
    _updateContainerDimensions() {
        if (this._videoElement) {
            if (this._videoElement.style.width?.includes("px") && this._videoElement.style.height?.includes("px") && this._videoElement.style.transform) {
                let e = parseFloat(this._videoElement.style.width), t = parseFloat(this._videoElement.style.height), r = $e175c1d94c759890$var$rb(this._videoElement.style.transform);
                this._containerDimensions = {
                    width: e * r.scaleX,
                    height: t * r.scaleY
                };
            } else {
                let { width: e , height: t  } = this._videoElement.getBoundingClientRect();
                this._containerDimensions = {
                    width: e,
                    height: t
                };
            }
            this._containerDimensions && this._eventBus.publish($e175c1d94c759890$var$tK.VIDEO_ELEMENT_DIMENSIONS_CALCULATED, this._containerDimensions);
        }
    }
    _updateDevicePixelRatio() {
        this._devicePixelRatio = globalThis.window?.devicePixelRatio || 1;
    }
    _onVideoTimeUpdate() {
        if (!this._videoElement) return;
        let { videoWidth: e , videoHeight: t  } = this._videoElement;
        if (e < 50 || t < 50) return;
        let { width: r , height: n  } = this._dimencionVideo;
        (e !== r || t !== n) && (this._dimencionVideo = {
            width: e,
            height: t
        }, this._debouncedUpdateContainerDimensions(), this._eventBus.publish($e175c1d94c759890$var$tK.VIDEO_ELEMENT_DIMENSIONS_CALCULATED, this._containerDimensions || {
            width: 0,
            height: 0
        }));
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rE.prototype, "_onVideoTimeUpdate", null);
let $e175c1d94c759890$var$rS = {
    MediaStream: [
        "addTrack",
        "removeTrack",
        "getTracks",
        "getVideoTracks",
        "getAudioTracks",
        "clone"
    ],
    MediaSource: [
        "addSourceBuffer",
        "removeSourceBuffer",
        "endOfStream",
        "setLiveSeekableRange",
        "clearLiveSeekableRange"
    ]
};
function $e175c1d94c759890$var$rC(e, t, r) {
    let n = !!t, i = !!r, s = !!n && function(e) {
        try {
            if ("function" != typeof e) return !1;
            let t = Function.prototype.toString.call(e);
            return /\[native code\]/.test(t);
        } catch (e) {
            return !1;
        }
    }(t);
    return n && i ? {
        ...function(e, t, r) {
            let n = [], i = [], s = [], o = Function.prototype.toString;
            try {
                let a = Object.getOwnPropertyNames(e.prototype), l = Object.getOwnPropertyNames(t.prototype), u = new Set(a), c = new Set(l);
                for (let e of a)c.has(e) || i.push(e);
                for (let e of l)u.has(e) || s.push(e);
                for (let i of r.filter((e)=>!s.includes(e))){
                    let r = e.prototype[i], s = t.prototype[i];
                    if (!r || !s) {
                        n.push(i);
                        continue;
                    }
                    let a = o.call(r), l = o.call(s);
                    a !== l && n.push(i);
                }
                return {
                    methodsMatch: 0 === n.length && 0 === i.length && 0 === s.length,
                    differentMethods: n,
                    addedMethods: i,
                    removedMethods: s
                };
            } catch (e) {
                return {
                    methodsMatch: !1,
                    differentMethods: [],
                    addedMethods: [],
                    removedMethods: []
                };
            }
        }(t, r, $e175c1d94c759890$var$rS[e]),
        hasCleanConstructor: i,
        hasConstructorInWindow: n,
        isNative: s
    } : {
        methodsMatch: !0,
        differentMethods: [],
        addedMethods: [],
        removedMethods: [],
        hasCleanConstructor: i,
        hasConstructorInWindow: n,
        isNative: s
    };
}
function $e175c1d94c759890$var$rT(e) {
    return e.hasConstructorInWindow && (!e.methodsMatch || !e.isNative);
}
var $e175c1d94c759890$var$tj = $e175c1d94c759890$var$g("1QtI2");
let $e175c1d94c759890$var$rA = (e)=>{
    let t = [];
    return e.HLSStreamUrl && t.push($e175c1d94c759890$var$tj.EPlayerType.HLS), e.WebRTCStreamId && e.WebRTCSignallingUrl && (t.push($e175c1d94c759890$var$tj.EPlayerType.WEBRTC), e.MediaStream && t.push($e175c1d94c759890$var$tj.EPlayerType.BROADCAST)), e.NativeStreamURL && t.push($e175c1d94c759890$var$tj.EPlayerType.NATIVE), t;
};
var $e175c1d94c759890$export$7cafc4c0fcafdd05 = (($e175c1d94c759890$var$h = {}).PLAYBACK_STATE_CHANGED = "playbackStateChanged", $e175c1d94c759890$var$h.VIDEO_PLAYBACK_STATE_CHANGED = "videoPlaybackStateChanged", $e175c1d94c759890$var$h.AVAILABLE_PLAYER_TYPES_UPDATED = "availablePlayerModesUpdated", $e175c1d94c759890$var$h.DEBUGGER_CONNECTED = "debuggerConnected", $e175c1d94c759890$var$h.ERROR = "error", $e175c1d94c759890$var$h.NATIVE_EVENT = "nativeEvent", $e175c1d94c759890$var$h.RESOLUTIONS_AVAILABLE = "resolutionsAvailable", $e175c1d94c759890$var$h.UPDATE_PLAYER_RESOLUTION = "updatePlayerResolution", $e175c1d94c759890$var$h.AUTO_RESOLUTION_SWITCHED = "autoResolutionSwitched", $e175c1d94c759890$var$h.RESOLUTION_SWITCHED = "resolutionSwitched", $e175c1d94c759890$var$h.TIME_UPDATE = "timeUpdate", $e175c1d94c759890$var$h.MODULE_LOADING_STATE_CHANGED = "moduleLoadingStateChanged", $e175c1d94c759890$var$h.PLAYING = "playing", $e175c1d94c759890$var$h.RESOLUTION_NOT_FOUND = "resolutionNotFound", $e175c1d94c759890$var$h.BROADCAST_SUPPORTED_CHANGE = "broadcastSupportedChange", $e175c1d94c759890$var$h.STREAM_LOAD_ERROR = "streamLoadError", $e175c1d94c759890$var$h), $e175c1d94c759890$export$b11132158c03c5d = (($e175c1d94c759890$var$d = {}).LOADING = "loading", $e175c1d94c759890$var$d.LOADED = "loaded", $e175c1d94c759890$var$d), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ");
let $e175c1d94c759890$var$rR = {
    videoControllerConfig: {
        autoplay: !1,
        isRemote: !0
    },
    hlsConfig: {},
    webRTCConfig: {},
    nativeConfig: {},
    minUpscaleFactor: 0,
    persistent: !1,
    establishWSOnStart: !1,
    reportModifiedMSE: !1,
    forbidModifiedMSE: !1,
    isShouldWatchDogStopStream: !1
}, { setConfig: $e175c1d94c759890$var$rI , ConfigConsumer: $e175c1d94c759890$var$rO  } = (0, $e175c1d94c759890$var$y.createConfig)($e175c1d94c759890$var$rR);
var $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ"), $e175c1d94c759890$var$rg = $e175c1d94c759890$var$g("giOKx");
class $e175c1d94c759890$var$rM extends $e175c1d94c759890$var$y.CustomEventTarget {
    constructor(e){
        super(), this._eventBusInstance = e, this._onPlaybackStateChangedListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.PLAYBACK_STATE_CHANGED, this._onPlaybackStateChanged), this._onResolutionSwitchedAutoListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.AUTO_RESOLUTION_SWITCHED, this._onResolutionSwitchedAuto), this._onVideoPlaybackStateChangedListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.VIDEO_PLAYBACK_STATE_CHANGED, this._onVideoPlaybackStateChanged), this._onDebuggerConnectedListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.DEBUGGER_CONNECTED, this._onDebuggerConnected), this._onErrorListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.ERROR, this._onError), this._onResolutionsAvailableListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.RESOLUTIONS_AVAILABLE, this._onResolutionsAvailable), this._onResolutionSwitchedListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.RESOLUTION_SWITCHED, this._onResolutionSwitched), this._onResolutionNotFoundListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.RESOLUTION_NOT_FOUND, this._onResolutionNotFound), this._onBroadcastSupportedChangeListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.BROADCAST_SUPPORTED_CHANGE, this._onBroadcastSupportedChange), this._onStreamLoadErrorListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.STREAM_LOAD_ERROR, this._onStreamLoadError);
    }
    destroy() {
        this._eventBusInstance.unsubscribe(this._onPlaybackStateChangedListener), this._eventBusInstance.unsubscribe(this._onDebuggerConnectedListener), this._eventBusInstance.unsubscribe(this._onErrorListener), this._eventBusInstance.unsubscribe(this._onResolutionsAvailableListener), this._eventBusInstance.unsubscribe(this._onVideoPlaybackStateChangedListener), this._eventBusInstance.unsubscribe(this._onResolutionSwitchedAutoListener), this._eventBusInstance.unsubscribe(this._onResolutionSwitchedListener), this._eventBusInstance.unsubscribe(this._onResolutionNotFoundListener), this._eventBusInstance.unsubscribe(this._onBroadcastSupportedChangeListener), this._eventBusInstance.unsubscribe(this._onStreamLoadErrorListener);
    }
    reemitEvent(e, t) {
        this.emitEvent(e, t);
    }
    _onPlaybackStateChanged({ prevState: e , nextState: t  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.PLAYBACK_STATE_CHANGED, {
            prevState: e,
            nextState: t
        });
    }
    _onDebuggerConnected({ debuggerUrl: e  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.DEBUGGER_CONNECTED, {
            debuggerUrl: e
        });
    }
    _onError({ error: e , playerType: t , isFatal: r , errorType: n  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.ERROR, {
            error: e,
            playerType: t,
            isFatal: r,
            errorType: n
        });
    }
    _onResolutionsAvailable({ resolutions: e  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.RESOLUTIONS_AVAILABLE, {
            resolutions: e
        });
    }
    _onResolutionSwitchedAuto({ name: e  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.AUTO_RESOLUTION_SWITCHED, {
            name: e
        });
    }
    _onResolutionSwitched({ name: e  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.RESOLUTION_SWITCHED, {
            resolutionName: e
        });
    }
    _onVideoPlaybackStateChanged(e) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.VIDEO_PLAYBACK_STATE_CHANGED, e);
    }
    _onResolutionNotFound() {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.RESOLUTION_NOT_FOUND, {});
    }
    _onBroadcastSupportedChange({ isSupported: e  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.BROADCAST_SUPPORTED_CHANGE, {
            isSupported: e
        });
    }
    _onStreamLoadError({ reason: e , httpStatusCode: t , wsStatusCode: r , signallingMessage: n  }) {
        this.emitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.STREAM_LOAD_ERROR, {
            reason: e,
            httpStatusCode: t,
            wsStatusCode: r,
            signallingMessage: n
        });
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onPlaybackStateChanged", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onDebuggerConnected", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onError", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onResolutionsAvailable", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onResolutionSwitchedAuto", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onResolutionSwitched", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onVideoPlaybackStateChanged", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onResolutionNotFound", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onBroadcastSupportedChange", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rM.prototype, "_onStreamLoadError", null);
var $e175c1d94c759890$var$b = $e175c1d94c759890$var$g("bsvQL"), $e175c1d94c759890$var$y = $e175c1d94c759890$var$g("hJ7nZ"), $e175c1d94c759890$var$rL = $e175c1d94c759890$var$g("apP9s"), $e175c1d94c759890$var$rg = $e175c1d94c759890$var$g("giOKx");
class $e175c1d94c759890$var$rD {
    constructor(e){
        this._panelContainer = document.createElement("div"), this._resolutionRow = this._createPanelRow({
            labelText: "Resolution:"
        }), this._aspectRatioRow = this._createPanelRow({
            labelText: "Aspect ratio:"
        }), this._fpsRow = this._createPanelRow({
            labelText: "FPS:"
        }), this._latencyRow = this._createPanelRow({
            labelText: "Latency estimation:"
        }), this._upscaleRow = this._createPanelRow({
            labelText: "Upscale factor:"
        }), this._droppedFramesRow = this._createPanelRow({
            labelText: "Frames (dropped/total):"
        }), this._turnServersRow = this._createPanelRow({
            labelText: "TURN servers:",
            valueContent: {
                innerHTML: "Disable TURN Servers",
                style: {
                    padding: "5px 10px",
                    border: "1px solid",
                    borderRadius: "5px"
                }
            }
        }), this._playerTypesRow = this._createPanelRow({
            labelText: "Players:",
            valueContent: {
                style: {
                    display: "flex"
                }
            }
        }), this._streamOverridesRow = this._createPanelRow({
            labelText: "Overrides:",
            rowStyle: {
                display: "flex",
                alignItems: "center"
            }
        }), this._domainOverrideInput = document.createElement("input"), this._streamNameOverrideInput = document.createElement("input"), this._videoElement = null, this._prevFramesCount = -1, this._prevFramesCountTs = -1, this._availablePlayerTypes = [], this._currentPlayerType = null, this._shouldUseTURNServersState = !0, this._domainOverride = "", this._lastPartOverride = "", this._currentStreamConfig = null, this._lastKnownVideoElementDimensions = {
            width: 0,
            height: 0
        }, this._eventBusInstance = e, this._onVideoElementUpdatedListener = e.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.VIDEO_ELEMENT_UPDATED, this._onVideoElementUpdated), this._onPlayerTypesAvailableListener = e.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.PLAYER_TYPES_AVAILABLE, this._onPlayerTypesAvailable), this._onPlayerTypeChangedListener = e.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.PLAYER_TYPE_CHANGED, this._onPlayerTypeChanged), this._onStreamConfigUpdatedListener = e.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.STREAM_CONFIG_UPDATED, this._onStreamConfigUpdated), this._onLatencyEstimationAvailableListener = e.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.LATENCY_ESTIMATION_AVAILABLE, this._onLatencyEstimationAvailable), this._onUpscaleCalculatedListener = e.subscribe($e175c1d94c759890$var$tK.UPSCALE_CALCULATED, this._onUpscaleCalculated), this._onVideoElementDimensionsCalculatedListener = e.subscribe($e175c1d94c759890$var$tK.VIDEO_ELEMENT_DIMENSIONS_CALCULATED, this._onVideoElementDimensionsCalculated), this._streamOverridesRow.appendRowChild(this._domainOverrideInput), this._streamOverridesRow.appendRowChild(this._streamNameOverrideInput);
        let t = (0, $e175c1d94c759890$var$rL.debounce)(this._onDomainOverrideChanged, 200), r = (0, $e175c1d94c759890$var$rL.debounce)(this._onlastPartOverrideChanged, 200);
        this._domainOverrideInput.addEventListener("change", t), this._streamNameOverrideInput.addEventListener("change", r), this._panelContainer.style.display = "flex", this._panelContainer.style.fontSize = ".625rem", this._panelContainer.style.flexDirection = "column", this._domainOverrideInput.style.background = "inherit", this._domainOverrideInput.style.color = "inherit", this._domainOverrideInput.style.marginRight = "10px", this._domainOverrideInput.style.border = "1px solid", this._streamNameOverrideInput.style.background = "inherit", this._streamNameOverrideInput.style.color = "inherit", this._streamNameOverrideInput.style.border = "1px solid", this._turnServersRow.addRowEventListener("click", this._toggleTURNServers), this._refreshInterval = setInterval(this._refreshDebugData, 1e3);
    }
    destroy() {
        this._eventBusInstance.unsubscribe(this._onPlayerTypesAvailableListener), this._eventBusInstance.unsubscribe(this._onVideoElementUpdatedListener), this._eventBusInstance.unsubscribe(this._onPlayerTypeChangedListener), this._eventBusInstance.unsubscribe(this._onStreamConfigUpdatedListener), this._eventBusInstance.unsubscribe(this._onLatencyEstimationAvailableListener), this._eventBusInstance.unsubscribe(this._onUpscaleCalculatedListener), this._eventBusInstance.unsubscribe(this._onVideoElementDimensionsCalculatedListener), clearInterval(this._refreshInterval);
    }
    _onDomainOverrideChanged() {
        this._domainOverride = this._domainOverrideInput.value, this._rebuildStreamConfig();
    }
    _onlastPartOverrideChanged() {
        this._lastPartOverride = this._streamNameOverrideInput.value, this._rebuildStreamConfig();
    }
    _rebuildStreamConfig() {
        if (!this._currentStreamConfig) return;
        let e = {
            ...this._currentStreamConfig
        };
        if ((this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && e.HLSStreamUrl || this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.NATIVE && e.NativeStreamURL) && this._domainOverride && this._lastPartOverride) {
            let t = new URL(this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.NATIVE ? e.NativeStreamURL : e.HLSStreamUrl);
            t.host = this._domainOverride;
            let [r, n] = this._lastPartOverride.split("?"), i = t.pathname.split("/").slice(-1)[0];
            t.pathname = t.pathname.replace(i, r), n && (t.search = `?${n}`), this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS ? e.HLSStreamUrl = t.toString() : e.NativeStreamURL = t.toString();
        }
        this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.WEBRTC && e.WebRTCStreamId && e.WebRTCSignallingUrl && (e.WebRTCSignallingUrl = this._domainOverride, e.WebRTCStreamId = this._lastPartOverride), this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.STREAM_CONFIG_UPDATED_INTERNAL, {
            streamConfig: e
        });
    }
    _createPanelRow({ labelText: e , rowStyle: t , valueContent: r  }) {
        let n = document.createElement("div");
        Object.assign(n.style, t ?? {
            display: "flex",
            alignItems: "center",
            margin: "5px 0"
        });
        let i = document.createElement("div");
        i.style.minWidth = "130px", i.innerHTML = e, n.appendChild(i);
        let s = document.createElement("div");
        return r?.innerHTML && (s.innerHTML = r?.innerHTML), r?.style && Object.assign(s.style, r?.style), n.appendChild(s), this._panelContainer.appendChild(n), {
            setRowValue: (e)=>{
                s.innerHTML = e;
            },
            appendRowChild: (e)=>{
                s.appendChild(e);
            },
            getRowChildren: ()=>s.childNodes,
            addRowEventListener: (e, t, r)=>{
                s.addEventListener(e, t, r);
            },
            removeRowEventListener: (e, t, r)=>{
                s.removeEventListener(e, t, r);
            }
        };
    }
    _resetOverridenValues() {
        if (this._currentStreamConfig && this._currentPlayerType) {
            if (this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && this._currentStreamConfig.HLSStreamUrl || this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.NATIVE && this._currentStreamConfig.NativeStreamURL) {
                let e = new URL(this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.NATIVE ? this._currentStreamConfig.NativeStreamURL : this._currentStreamConfig.HLSStreamUrl);
                this._domainOverrideInput.value = e.host, this._domainOverride = e.host;
                let t = e.pathname.split("/").slice(-1)[0];
                this._streamNameOverrideInput.value = `${t}${e.search}`, this._lastPartOverride = t;
            }
            this._currentStreamConfig.WebRTCSignallingUrl && this._currentStreamConfig.WebRTCStreamId && this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.WEBRTC && (this._domainOverrideInput.value = this._currentStreamConfig.WebRTCSignallingUrl, this._domainOverride = this._currentStreamConfig.WebRTCSignallingUrl, this._streamNameOverrideInput.value = this._currentStreamConfig.WebRTCStreamId, this._lastPartOverride = this._currentStreamConfig.WebRTCStreamId);
        }
    }
    _onStreamConfigUpdated({ streamConfig: e  }) {
        this._currentStreamConfig = e, this._resetOverridenValues();
    }
    _onVideoElementUpdated({ videoElement: e  }) {
        this._videoElement = e, this._prevFramesCount = -1;
    }
    _onPlayerTypesAvailable({ availablePlayerTypes: e  }) {
        this._availablePlayerTypes = e, [
            ...this._playerTypesRow.getRowChildren()
        ].forEach((e)=>{
            e.removeEventListener("click", this._onPlayerTypeButtonClicked);
        }), this._playerTypesRow.setRowValue(""), this._availablePlayerTypes.forEach((e)=>{
            let t = document.createElement("div");
            t.style.border = "1px solid", t.style.borderRadius = "5px", t.style.padding = "5px 10px", t.style.marginRight = "10px", t.innerText = e, t.dataset.playerType = e, t.addEventListener("click", this._onPlayerTypeButtonClicked), this._playerTypesRow.appendRowChild(t);
        });
    }
    _refreshDebugData() {
        let e = this._hydrateVideoElementMetrics();
        this._resolutionRow.setRowValue(`Video: ${e.videoResolution};<br />Container: ${e.elementResolution}<br /> DPR container: ${e.dprElementResolution}`), this._aspectRatioRow.setRowValue(`Video: ${e.videoAspectRatio}; Container: ${e.elementAspectRatio}`), this._fpsRow.setRowValue(e.fps), this._droppedFramesRow.setRowValue(e.framesCount), this._renderCurrentPlayerType();
    }
    _hydrateVideoElementMetrics() {
        if (!this._videoElement) return {
            videoResolution: "N/A",
            elementResolution: "N/A",
            dprElementResolution: "N/A",
            videoAspectRatio: "N/A",
            elementAspectRatio: "N/A",
            fps: "N/A",
            framesCount: "N/A"
        };
        let e = (0, $e175c1d94c759890$var$y.getVideoPlaybackQuality)(this._videoElement), { videoWidth: t , videoHeight: r  } = this._videoElement, { width: n , height: i  } = this._lastKnownVideoElementDimensions, s = "N/A";
        return e && (this._prevFramesCount > -1 && (s = `${Math.round((e.totalVideoFrames - this._prevFramesCount) / ((Date.now() - this._prevFramesCountTs) / 1e3))}`), this._prevFramesCount = e.totalVideoFrames, this._prevFramesCountTs = Date.now()), {
            videoResolution: `${t}x${r}`,
            elementResolution: `${n}x${i}`,
            dprElementResolution: `${n * window.devicePixelRatio}x${i * window.devicePixelRatio}`,
            videoAspectRatio: t && r ? `${Math.round(t / r * 100) / 100}` : "N/A",
            elementAspectRatio: n && i ? `${Math.round(n / i * 100) / 100}` : "N/A",
            fps: s,
            framesCount: e ? `${e.totalVideoFrames}/${e.droppedVideoFrames}` : "N/A"
        };
    }
    _renderCurrentPlayerType() {
        [
            ...this._playerTypesRow.getRowChildren()
        ].forEach((e)=>{
            e.dataset.playerType === this._currentPlayerType ? e.style.background = "#1491ff" : e.style.background = "inherit";
        });
    }
    _toggleTURNServers() {
        this._shouldUseTURNServersState = !this._shouldUseTURNServersState, this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.TOGGLE_TURN_SERVERS, {
            shouldUseTURNServers: this._shouldUseTURNServersState
        }), this._turnServersRow.setRowValue(this._shouldUseTURNServersState ? "Disable TURN Servers" : "Enable TURN servers");
    }
    _onPlayerTypeButtonClicked(e) {
        let t = e.target;
        this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.FORCE_PLAYER_TYPE, {
            playerType: t.dataset.playerType
        });
    }
    _onPlayerTypeChanged({ playerType: e  }) {
        this._currentPlayerType = e, this._resetOverridenValues();
    }
    _onLatencyEstimationAvailable({ medianLatency: e , EWMALatency: t  }) {
        this._latencyRow.setRowValue(`${e.toFixed(2)} med, ${t.toFixed(2)} EWMA`);
    }
    _onUpscaleCalculated({ upscaleFactor: e  }) {
        this._upscaleRow.setRowValue(null !== e ? e.toFixed(4) : "N/A");
    }
    _onVideoElementDimensionsCalculated({ width: e , height: t  }) {
        this._lastKnownVideoElementDimensions = {
            width: e,
            height: t
        };
    }
    get rootContainer() {
        return this._panelContainer;
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onDomainOverrideChanged", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onlastPartOverrideChanged", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onStreamConfigUpdated", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onVideoElementUpdated", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onPlayerTypesAvailable", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_refreshDebugData", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_toggleTURNServers", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onPlayerTypeButtonClicked", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onPlayerTypeChanged", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onLatencyEstimationAvailable", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onUpscaleCalculated", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$var$rD.prototype, "_onVideoElementDimensionsCalculated", null);
let $e175c1d94c759890$var$rk = (e)=>new Promise((t)=>{
        setTimeout(()=>{
            t();
        }, e);
    }), $e175c1d94c759890$var$rN = (e)=>{
    if (!e) return {};
    try {
        let t = new URL(e).pathname.split("/"), r = t[2], n = t[t.length - 1], i = n.match(/\d+_(\w+)/)?.[1] || "source";
        return {
            streamId: r,
            resolution: i
        };
    } catch (e) {
        return {};
    }
}, $e175c1d94c759890$var$rx = (0, $e175c1d94c759890$var$y.queued)();
class $e175c1d94c759890$export$57663087b8d9f5a6 {
    constructor(){
        this._doppioWrapperConstructor = null, this._videoElement = null, this._ristrettoPlayerWrapperConstructor = null, this._ristrettoBroadcasterWrapperConstructor = null, this._nativeWrapperConstructor = null, this._supportedPlayerTypeCache = null, this._currentPlayerType = null, this._currentPlayerWrapperInstance = null, this._currentStreamConfig = {}, this._isAbrEnabled = !1, this._isStartDelayed = !1, this._currentResolution = null, this._currentResolutionBitrate = null, this._metricsUserIdCache = null, this._metricsTimeOriginCache = null, this._abrResolutions = [], this._config = {
            ...$e175c1d94c759890$var$rR
        }, this._appKey = "", this._metricsCollector = null, this._videoElementMetrics = null, this._logLevels = [], this._isDestroyed = !1, this._hasStarted = !1, this._abTestsCache = {}, this._abTestsSupportCache = {}, this._additionalFieldsCache = {}, this._playerInstancesMap = {}, this._userTypeCache = "unknown", this._resolutionsCache = [], this._resolutionLimitsCache = null, this._watchDog = null, this._eventBusInstance = new $e175c1d94c759890$var$y.EventBus, this._playerWrapperResolversMap = {
            [$e175c1d94c759890$var$y.EPlayerType.HLS]: this._resolveDoppioWrapper,
            [$e175c1d94c759890$var$y.EPlayerType.WEBRTC]: this._resolveRistrettoWrapper,
            [$e175c1d94c759890$var$y.EPlayerType.NATIVE]: this._resolveNativeWrapper,
            [$e175c1d94c759890$var$y.EPlayerType.BROADCAST]: this._resolveRistrettoBroadcasterWrapper
        }, this._debugPanel = new $e175c1d94c759890$var$rD(this._eventBusInstance), this._eventEmitter = new $e175c1d94c759890$var$rM(this._eventBusInstance), this._videoElementController = new $e175c1d94c759890$var$y.VideoElementController, this._watchDog = new $e175c1d94c759890$var$C(this._eventBusInstance), this._upscaleCalculationService = new $e175c1d94c759890$var$rE(this._eventBusInstance), localStorage && localStorage.getItem("__mmpLoggerLevel__") && (this._logLevels = (localStorage.getItem("__mmpLoggerLevel__") || "").split(","), this._videoElementController.setLoggerLevels(this._logLevels)), this._config.videoControllerConfig && this._videoElementController.updateConfig(this._config.videoControllerConfig), this._videoElementController.addEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.VIDEO_PLAYBACK_STATE_CHANGE, this._handleVideoPlaybackStateChange), this._videoElementController.addEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.UPDATE_PLAYER_RESOLUTION, this._handleUpdatePlayerResolution), this._videoElementController.addEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.NATIVE_EVENT, this._handleNativeEvent), this._videoElementController.addEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.TIME_UPDATE, this._handleTimeUpdate), this._videoElementController.addEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.PLAYING, this._handlePlaying), this._playerTypeForcedListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.FORCE_PLAYER_TYPE, this._onPlayerTypeForced), this._streamConfigUpdatedInternalListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.STREAM_CONFIG_UPDATED_INTERNAL, this._updateStreamConfigInternal), this._onLatencyEstimationAvailableListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.LATENCY_ESTIMATION_AVAILABLE, this._onLatencyEstimationAvailable), this._onResolutionsAvailableListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$rg.EPlayersEvents.RESOLUTIONS_AVAILABLE, this._onResolutionsAvailable), this._videoElementDimensionsListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$tK.VIDEO_ELEMENT_DIMENSIONS_CALCULATED, this._onVideoElementDimensionsCalculated), this._onAnotherActivePlayerListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$E.EWatchDogEvent.ANOTHER_ACTIVE_PLAYER, this._onAnotherActivePlayer), this._onSessionIdRecreatedListener = this._eventBusInstance.subscribe($e175c1d94c759890$var$tK.SESSION_ID_RECREATED, this._onSessionIdRecreated);
    }
    get instanceVersion() {
        return `${this._currentPlayerType} ${this._currentPlayerWrapperInstance?.version}`;
    }
    get version() {
        return $e175c1d94c759890$export$28c82a02d50f6df3;
    }
    on(e, t, r) {
        this._eventEmitter.addEventListener(e, t, r);
    }
    off(e, t, r) {
        this._eventEmitter.removeEventListener(e, t, r);
    }
    once(e, t, r) {
        let n = "object" == typeof r ? {
            ...r,
            once: !0
        } : {
            once: !0,
            capture: "boolean" == typeof r && r
        };
        this._eventEmitter.addEventListener(e, t, n);
    }
    sendCustomEvent(e) {
        this._metricsCollector?.registerEvent("CustomEvent", {
            customEventName: e
        });
    }
    destroy() {
        this._isDestroyed = !0, this._hasStarted = !1, this._isStartDelayed = !1, this._currentPlayerWrapperInstance?.destroy(), this._eventEmitter.destroy(), this._debugPanel.destroy(), this._metricsCollector?.destroy(), this._videoElementMetrics?.destroy(), this._videoElementController.removeEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.VIDEO_PLAYBACK_STATE_CHANGE, this._handleVideoPlaybackStateChange), this._videoElementController.removeEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.UPDATE_PLAYER_RESOLUTION, this._handleUpdatePlayerResolution), this._videoElementController.removeEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.NATIVE_EVENT, this._handleNativeEvent), this._videoElementController.removeEventListener($e175c1d94c759890$var$y.EVideoControllerCustomEvent.TIME_UPDATE, this._handleTimeUpdate), this._videoElementController.destroy(), this._watchDog?.destroy(), this._eventBusInstance.unsubscribe(this._playerTypeForcedListener), this._eventBusInstance.unsubscribe(this._streamConfigUpdatedInternalListener), this._eventBusInstance.unsubscribe(this._onResolutionsAvailableListener), this._eventBusInstance.unsubscribe(this._onLatencyEstimationAvailableListener), this._eventBusInstance.unsubscribe(this._videoElementDimensionsListener), this._eventBusInstance.unsubscribe(this._onAnotherActivePlayerListener), this._eventBusInstance.unsubscribe(this._onSessionIdRecreatedListener);
    }
    enableAbr() {
        this._isAbrEnabled = !0, this._currentPlayerWrapperInstance?.enableAbr(), this._metricsCollector?.setRenditionSwitchMode("auto"), this._upscaleCalculationService.setUserSelectedResolution(null);
    }
    disableAbr() {
        this._isAbrEnabled = !1, this._currentPlayerWrapperInstance?.disableAbr(), this._metricsCollector?.setRenditionSwitchMode("manual");
    }
    setMetricsUserId(e) {
        this._metricsCollector?.setUserId(e), this._metricsUserIdCache = e;
    }
    setMetricsProjectId(e) {
        this._metricsCollector?.setProjectId(e);
    }
    setMetricsTimeOrigin(e) {
        this._metricsTimeOriginCache = e, this._metricsCollector?.setTimeOrigin(e);
    }
    deconfigureMetrics() {
        this._videoElementMetrics?.destroy(), this._videoElementMetrics = null, this._metricsCollector?.destroy(), this._metricsCollector = null;
    }
    configureMetrics(e, t) {
        if (this._metricsCollector) {
            if (this._metricsCollector.baseUrl === e && this._metricsCollector.projectId === t) return;
            this._videoElementMetrics?.destroy(), this._videoElementMetrics = null, this._metricsCollector.destroy(), this._metricsCollector = null;
        }
        this._metricsCollector = new $e175c1d94c759890$var$r_(e, t, this._eventBusInstance), this._metricsCollector.setAbTests(this._abTestsCache), this._currentPlayerType && this._metricsCollector.setPlayerType(this._currentPlayerType), this._metricsCollector.setAdditionalFields(this._additionalFieldsCache), this._videoElementMetrics = new $e175c1d94c759890$var$rv(this._metricsCollector, this._eventBusInstance, this._upscaleCalculationService), this._videoElementMetrics.setIsPaused(this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.BROADCAST), this._currentPlayerWrapperInstance?.setMetricsCollector(this._metricsCollector), this._videoElement && this._videoElementMetrics.setVideoElement(this._videoElement), this._videoElementMetrics.setResolutions(this._resolutionsCache), this._upscaleCalculationService.setResolutions(this._resolutionsCache), this._currentResolution && !this._isAbrEnabled ? this._upscaleCalculationService.setUserSelectedResolution(this._currentResolution) : this._upscaleCalculationService.setUserSelectedResolution(null), this._metricsTimeOriginCache && this._metricsCollector.setTimeOrigin(this._metricsTimeOriginCache), this._metricsUserIdCache && this._metricsCollector.setUserId(this._metricsUserIdCache), "unknown" !== this._userTypeCache && this._metricsCollector.setUserType(this._userTypeCache), this._reemitCDNDomain();
    }
    setConfig(e) {
        let t = $e175c1d94c759890$var$tU({}, this._config, e);
        if (function e(t, r, n, i, s) {
            return t === r || (null != t && null != r && ($e175c1d94c759890$var$eC(t) || $e175c1d94c759890$var$eC(r)) ? $e175c1d94c759890$var$to(t, r, n, i, e, s) : t != t && r != r);
        }(t, this._config)) return;
        let r = (0, $e175c1d94c759890$var$y.ObjectDeepDiff)(this._config, t);
        this._config = {
            ...t
        }, (r.hlsConfig || r.webRTCConfig || r.nativeConfig) && this._reapplyPlayerConfig(), r.videoControllerConfig && this._config.videoControllerConfig && this._videoElementController.updateConfig(this._config.videoControllerConfig), r.persistent ? this._prepareDependencies() : !1 === r.persistent && this._clearDependencies(), void 0 !== r.minUpscaleFactor && this._updateResolutionLimits();
    }
    setVideoElement(e) {
        this._videoElement = e, this._upscaleCalculationService.setVideoElement(e), this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.VIDEO_ELEMENT_UPDATED, {
            videoElement: e
        }), this._videoElementController && e && this._videoElementController.setVideoElement(e), this._videoElementMetrics?.setVideoElement(e), this._currentPlayerWrapperInstance?.setVideoElement(this._videoElement), this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.BROADCAST && this.setVolume(0);
    }
    setStreamConfig(e) {
        let t = {
            ...this._currentStreamConfig,
            ...e
        };
        this._updateStreamConfigInternal({
            streamConfig: t
        });
    }
    setShouldStopPlayer(e) {
        this._watchDog?.updateConfig({
            shouldStopPlayer: e
        });
    }
    setAbTests(e) {
        this._abTestsCache = e || {}, this._metricsCollector?.setAbTests(e || {});
    }
    setAbTestsSupport(e) {
        this._abTestsSupportCache = e || {}, this._metricsCollector?.setAbTestsSupport(this._abTestsSupportCache);
    }
    setAdditionalMetricsFields(e) {
        this._additionalFieldsCache = e || {}, this._metricsCollector?.setAdditionalFields(e);
    }
    setUserType(e) {
        this._userTypeCache = e, this._metricsCollector?.setUserType(e);
    }
    setResolutionByName(e) {
        this._currentResolutionBitrate = null, this._currentResolution = e, this._currentPlayerWrapperInstance?.setResolutionByName(e), this._metricsCollector?.currentRenditionSelectMode === "manual" && (this._metricsCollector.setManualResolution(e), this._upscaleCalculationService.setUserSelectedResolution(e));
    }
    setResolutionByBitrate(e) {
        this._currentResolution = null, this._currentResolutionBitrate = e, this._currentPlayerWrapperInstance?.setResolutionByBitrate(e);
    }
    setAbrResolutions(e) {
        this._abrResolutions = e, this._currentPlayerWrapperInstance?.setAbrResolutions(e);
    }
    setAppKey(e) {
        this._appKey = e, this._currentPlayerWrapperInstance && this._currentPlayerWrapperInstance.setAppKey(e);
    }
    async getSupportedPlayerTypes() {
        return this._supportedPlayerTypeCache ? this._supportedPlayerTypeCache : (this._supportedPlayerTypeCache = (await Promise.all($e175c1d94c759890$var$tj.AVAILABLE_PLAYER_TYPES.map(async (e)=>({
                playerType: e,
                isSupported: await $e175c1d94c759890$var$rm[e]()
            })))).filter((e)=>e.isSupported).map(({ playerType: e  })=>e), this._supportedPlayerTypeCache || []);
    }
    async setPlayerType(e) {
        if (e === this._currentPlayerType) return;
        this._videoElementMetrics?.setIsPaused(e === $e175c1d94c759890$var$y.EPlayerType.BROADCAST), this._videoElement && this._currentPlayerType && this._videoElement.load();
        let t = this._currentPlayerType;
        if (this._currentPlayerType = e, !(await this.getSupportedPlayerTypes()).includes(e)) throw this._currentPlayerType = t, Error(`Player type ${e} is unsupported`);
        this._metricsCollector?.setPlayerType(e), this._videoElement && e === $e175c1d94c759890$var$y.EPlayerType.BROADCAST && this.setVolume(0), this._reemitStreamId(), this._reemitCDNDomain(), await this.recreatePlayer(), this._watchDog?.changePlayerType(e), this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.PLAYER_TYPE_CHANGED, {
            playerType: e
        });
    }
    async recreatePlayer() {
        if (!this._currentPlayerType) return;
        this._currentPlayerWrapperInstance && (this._config.persistent ? this._currentPlayerWrapperInstance.stop() : this._currentPlayerWrapperInstance.destroy()), this._currentPlayerWrapperInstance = null, this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.MODULE_LOADING_STATE_CHANGED, {
            newState: $e175c1d94c759890$export$b11132158c03c5d.LOADING
        });
        let [e] = await Promise.all([
            this._playerWrapperResolversMap[this._currentPlayerType](),
            $e175c1d94c759890$var$rk(50)
        ]);
        this._isDestroyed || (this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.MODULE_LOADING_STATE_CHANGED, {
            newState: $e175c1d94c759890$export$b11132158c03c5d.LOADED
        }), this._playerInstancesMap[this._currentPlayerType] ? this._currentPlayerWrapperInstance = this._playerInstancesMap[this._currentPlayerType] : (this._currentPlayerWrapperInstance = new e(this._eventBusInstance, {
            persistent: this._config.persistent
        }), this._config.persistent && (this._playerInstancesMap[this._currentPlayerType] = this._currentPlayerWrapperInstance)), await this._retuneNewPlayerInstance());
    }
    renderDebugPanelIntoContainer(e) {
        e.appendChild(this._debugPanel.rootContainer);
    }
    start(e = !1) {
        !e && (this._hasStarted || this._isStartDelayed) || (this._isCurrentConfigValid() && this._currentPlayerWrapperInstance ? (this._isStartDelayed = !1, this._hasStarted = !0, this._config.persistent || this._currentPlayerWrapperInstance.stop(), this._currentPlayerWrapperInstance.start(), this._reemitStreamId()) : this._isStartDelayed = !0);
    }
    stop() {
        this._hasStarted = !1, this._isStartDelayed = !1, this._currentPlayerWrapperInstance?.stop(), this.recreatePlayer(), this._metricsCollector?.stop();
    }
    setVolume(e) {
        this._videoElementController?.setVolume(e);
    }
    setLoggerLevel(e) {
        this._currentPlayerWrapperInstance?.setLoggerLevel?.(e), this._videoElementController?.setLoggerLevels(this._logLevels), this._logLevels = e;
    }
    setResolutionLimits(e) {
        this._resolutionLimitsCache = e, this._currentPlayerWrapperInstance?.setResolutionLimits(e);
    }
    setRegularBroadcastStopReason(e) {
        this._metricsCollector?.setRegularBroadcastStopReason(e), this._currentPlayerWrapperInstance && "setRegularBroadcastStopReason" in this._currentPlayerWrapperInstance && "function" == typeof this._currentPlayerWrapperInstance.setRegularBroadcastStopReason && this._currentPlayerWrapperInstance?.setRegularBroadcastStopReason?.(e);
    }
    async _retuneNewPlayerInstance() {
        if (this._currentPlayerType) {
            switch(this._currentPlayerType){
                case $e175c1d94c759890$var$y.EPlayerType.HLS:
                    await this._currentPlayerWrapperInstance.setVideoElement(this._videoElement).setPlayerConfig(this._config.hlsConfig || {}).setStreamConfig(this._currentStreamConfig).recreatePlayerInstance();
                    break;
                case $e175c1d94c759890$var$y.EPlayerType.WEBRTC:
                case $e175c1d94c759890$var$y.EPlayerType.BROADCAST:
                    await this._currentPlayerWrapperInstance.setVideoElement(this._videoElement).setAbrResolutions(this._abrResolutions).setPlayerConfig(this._config.webRTCConfig || {}).setStreamConfig(this._currentStreamConfig).setAppKey(this._appKey).recreatePlayerInstance();
                    break;
                case $e175c1d94c759890$var$y.EPlayerType.NATIVE:
                    await this._currentPlayerWrapperInstance.setVideoElement(this._videoElement).setStreamConfig(this._currentStreamConfig).recreatePlayerInstance();
            }
            this._isAbrEnabled ? this.enableAbr() : this.disableAbr(), this._logLevels && (this._currentPlayerWrapperInstance?.setLoggerLevel(this._logLevels), this._videoElementController?.setLoggerLevels(this._logLevels)), this._currentResolution && ![
                $e175c1d94c759890$var$y.EPlayerType.BROADCAST,
                $e175c1d94c759890$var$y.EPlayerType.NATIVE
            ].includes(this._currentPlayerType) && this._currentPlayerWrapperInstance?.setResolutionByName(this._currentResolution), this._currentResolutionBitrate && ![
                $e175c1d94c759890$var$y.EPlayerType.BROADCAST,
                $e175c1d94c759890$var$y.EPlayerType.NATIVE
            ].includes(this._currentPlayerType) && this._currentPlayerWrapperInstance?.setResolutionByBitrate(this._currentResolutionBitrate), this._metricsCollector && this._currentPlayerWrapperInstance?.setMetricsCollector(this._metricsCollector), this._currentPlayerWrapperInstance?.setResolutionLimits(this._resolutionLimitsCache), (this._isStartDelayed || this._hasStarted) && this.start(!0);
        }
    }
    async _prepareDependencies() {
        for (let e of [
            $e175c1d94c759890$var$y.EPlayerType.HLS,
            $e175c1d94c759890$var$y.EPlayerType.WEBRTC
        ]){
            if (this._playerInstancesMap[e]) continue;
            if (e === this._currentPlayerType && this._currentPlayerWrapperInstance) {
                this._playerInstancesMap[e] = this._currentPlayerWrapperInstance;
                continue;
            }
            let t = await this._playerWrapperResolversMap[e]();
            this._playerInstancesMap[e] = new t(this._eventBusInstance, {
                persistent: !0
            });
        }
        this._config.establishWSOnStart && (this._playerInstancesMap[$e175c1d94c759890$var$y.EPlayerType.WEBRTC]?.setStreamConfig({
            WebRTCSignallingUrl: this._currentStreamConfig.WebRTCSignallingUrl,
            ...this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.WEBRTC ? this._currentStreamConfig : {}
        }), this._playerInstancesMap[$e175c1d94c759890$var$y.EPlayerType.WEBRTC]?.start());
    }
    _clearDependencies() {
        Object.values(this._playerInstancesMap).forEach((e)=>{
            e !== this._currentPlayerWrapperInstance && e.destroy();
        }), this._playerInstancesMap = {};
    }
    _reapplyPlayerConfig() {
        if (this._currentPlayerWrapperInstance) switch(this._currentPlayerType){
            case $e175c1d94c759890$var$y.EPlayerType.HLS:
                this._config.hlsConfig && this._currentPlayerWrapperInstance.setPlayerConfig(this._config.hlsConfig);
                break;
            case $e175c1d94c759890$var$y.EPlayerType.BROADCAST:
            case $e175c1d94c759890$var$y.EPlayerType.WEBRTC:
                this._config.webRTCConfig && this._currentPlayerWrapperInstance.setPlayerConfig(this._config.webRTCConfig);
                break;
            case $e175c1d94c759890$var$y.EPlayerType.NATIVE:
                this._config.nativeConfig && this._currentPlayerWrapperInstance.setPlayerConfig(this._config.nativeConfig);
        }
    }
    async _resolveDoppioWrapper() {
        return this._doppioWrapperConstructor || (this._doppioWrapperConstructor = (await $e175c1d94c759890$var$g("cQezm")).DoppioWrapper), this._doppioWrapperConstructor;
    }
    async _resolveRistrettoWrapper() {
        return this._ristrettoPlayerWrapperConstructor || (this._ristrettoPlayerWrapperConstructor = (await $e175c1d94c759890$var$g("iI3uv")).RistrettoPlayerWrapper), this._ristrettoPlayerWrapperConstructor;
    }
    async _resolveRistrettoBroadcasterWrapper() {
        return this._ristrettoBroadcasterWrapperConstructor || (this._ristrettoBroadcasterWrapperConstructor = (await $e175c1d94c759890$var$g("gxrTY")).RistrettoBroadcastWrapper), this._ristrettoBroadcasterWrapperConstructor;
    }
    async _resolveNativeWrapper() {
        return this._nativeWrapperConstructor || (this._nativeWrapperConstructor = (await $e175c1d94c759890$var$g("djm2V")).NativeWrapper), this._nativeWrapperConstructor;
    }
    async _emitAvailablePlayerTypes() {
        let e = await this.getSupportedPlayerTypes(), t = $e175c1d94c759890$var$rA(this._currentStreamConfig), r = e.filter((e)=>t.includes(e));
        this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.AVAILABLE_PLAYER_TYPES_UPDATED, {
            availablePlayerTypes: r
        }), this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.PLAYER_TYPES_AVAILABLE, {
            availablePlayerTypes: r
        });
    }
    _handleVideoPlaybackStateChange(e) {
        this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.VIDEO_PLAYBACK_STATE_CHANGED, e.detail);
    }
    _handleUpdatePlayerResolution(e) {
        this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.UPDATE_PLAYER_RESOLUTION, e.detail);
    }
    _handleNativeEvent({ detail: { event: e , eventName: t  }  }) {
        this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.NATIVE_EVENT, {
            event: e,
            eventName: t
        });
    }
    _handleTimeUpdate() {
        this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.TIME_UPDATE, {});
    }
    _handlePlaying(e) {
        this._eventEmitter.reemitEvent($e175c1d94c759890$export$7cafc4c0fcafdd05.PLAYING, e.detail);
    }
    _isCurrentConfigValid() {
        return !!(this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && this._currentStreamConfig.HLSStreamUrl) || !!(this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.WEBRTC && this._currentStreamConfig.WebRTCSignallingUrl) || !!(this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.BROADCAST && this._currentStreamConfig.WebRTCStreamId && this._currentStreamConfig.WebRTCSignallingUrl);
    }
    _reemitStreamId() {
        if (this._hasStarted) {
            if (this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && this._currentStreamConfig.HLSStreamUrl) {
                let { streamId: e  } = $e175c1d94c759890$var$rN(this._currentStreamConfig.HLSStreamUrl);
                this._metricsCollector?.setStreamId(e || "");
            }
            (this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.BROADCAST || this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.WEBRTC) && this._currentStreamConfig.WebRTCStreamId && this._metricsCollector?.setStreamId(this._currentStreamConfig.WebRTCStreamId), this._reeemitRenditionSwitchMode();
        }
    }
    _reeemitRenditionSwitchMode() {
        if (this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && this._currentStreamConfig.HLSStreamUrl) {
            let { resolution: e  } = $e175c1d94c759890$var$rN(this._currentStreamConfig.HLSStreamUrl);
            "auto" !== e && this._metricsCollector?.setRenditionSwitchMode("manual");
        }
        this._metricsCollector?.currentRenditionSelectMode === "manual" && this._reemitManualRendition();
    }
    _reemitManualRendition() {
        if (this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && this._currentStreamConfig.HLSStreamUrl) {
            let { resolution: e  } = $e175c1d94c759890$var$rN(this._currentStreamConfig.HLSStreamUrl);
            e && "auto" !== e && (this._metricsCollector?.setManualResolution(e), this._upscaleCalculationService.setUserSelectedResolution(e));
        }
    }
    _reemitCDNDomain() {
        this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.HLS && this._currentStreamConfig.HLSStreamUrl && this._metricsCollector?.updateCDNUrl(this._currentStreamConfig.HLSStreamUrl), this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.NATIVE && this._currentStreamConfig.NativeStreamURL && this._metricsCollector?.updateCDNUrl(this._currentStreamConfig.NativeStreamURL), this._currentPlayerType === $e175c1d94c759890$var$y.EPlayerType.WEBRTC && this._currentStreamConfig.WebRTCSignallingUrl && this._metricsCollector?.updateCDNUrl(this._currentStreamConfig.WebRTCSignallingUrl);
    }
    _onPlayerTypeForced({ playerType: e  }) {
        this.setPlayerType(e);
    }
    _onResolutionsAvailable({ resolutions: e  }) {
        this._resolutionsCache = e, this._videoElementMetrics?.setResolutions(e), this._upscaleCalculationService.setResolutions(e), this._updateResolutionLimits();
    }
    _onAnotherActivePlayer({ wrongPlayer: e  }) {
        this._config.isShouldWatchDogStopStream && this._playerInstancesMap[e]?.stop(), this._metricsCollector?.registerEvent("WrongPlayerActive", {
            wrongPlayerType: e,
            activePlayerType: this._currentPlayerType
        });
    }
    _onSessionIdRecreated() {
        this._checkAndReportMediaApiTampering();
    }
    _checkAndReportMediaApiTampering() {
        if (!this._config.reportModifiedMSE && !this._config.forbidModifiedMSE) return;
        let e = function() {
            let { MediaStream: e , MediaSource: t  } = function() {
                try {
                    let e = window, t = e.ManagedMediaSource || e.MediaSource, r = e.MediaStream;
                    return {
                        MediaStream: "function" == typeof r ? r : void 0,
                        MediaSource: "function" == typeof t ? t : void 0
                    };
                } catch (e) {
                    return {};
                }
            }(), { MediaStream: r , MediaSource: n  } = function() {
                try {
                    let e = document.createElement("iframe");
                    e.style.display = "none", e.style.position = "absolute", e.style.left = "-9999px", document.documentElement.appendChild(e);
                    let t = e.contentWindow;
                    if (!t) return e.remove(), {};
                    let r = {};
                    "function" == typeof t.MediaStream && (r.MediaStream = t.MediaStream);
                    let n = t.ManagedMediaSource || t.MediaSource;
                    return "function" == typeof n && (r.MediaSource = n), e.remove(), r;
                } catch (e) {
                    return {};
                }
            }(), i = $e175c1d94c759890$var$rC("MediaStream", e, r), s = $e175c1d94c759890$var$rC("MediaSource", t, n), o = $e175c1d94c759890$var$rT(i) || $e175c1d94c759890$var$rT(s);
            return {
                MediaStream: i,
                MediaSource: s,
                hasTampering: o
            };
        }();
        if (e.hasTampering) {
            let t = performance.now(), r = {
                MediaStream: e.MediaStream,
                MediaSource: e.MediaSource,
                detectionTimestamp: t
            };
            this._config.forbidModifiedMSE ? (this._metricsCollector?.registerEvent("MediaApiTamperingForbidden", {
                customEventName: "MediaApiTamperingForbidden",
                ...r
            }), this.destroy()) : this._config.reportModifiedMSE && this._metricsCollector?.registerEvent("MediaApiTamperingReported", {
                customEventName: "MediaApiTamperingReported",
                ...r
            });
        }
    }
    _updateStreamConfigInternal({ streamConfig: e  }) {
        let t = (0, $e175c1d94c759890$var$y.ObjectDeepDiff)(this._currentStreamConfig, e), r = !!e.MediaStream != !!this._currentStreamConfig.MediaStream || e.MediaStream?.id !== this._currentStreamConfig.MediaStream?.id;
        (Object.keys(t).length || r) && (this._currentStreamConfig = e, this._eventBusInstance.publish($e175c1d94c759890$var$rg.EPlayersEvents.STREAM_CONFIG_UPDATED, {
            streamConfig: this._currentStreamConfig
        }), this._config.establishWSOnStart && this._currentPlayerType !== $e175c1d94c759890$var$y.EPlayerType.WEBRTC && this._playerInstancesMap[$e175c1d94c759890$var$y.EPlayerType.WEBRTC]?.setStreamConfig({
            WebRTCSignallingUrl: this._currentStreamConfig.WebRTCSignallingUrl
        }), this._currentPlayerWrapperInstance?.setStreamConfig(this._currentStreamConfig), this._emitAvailablePlayerTypes(), this._isStartDelayed && this.start(!0), this._reemitStreamId(), this._reemitCDNDomain());
    }
    _onLatencyEstimationAvailable({ medianLatency: e  }) {
        e > 0 && this._metricsCollector?.registerMetrics({
            latency: e
        });
    }
    _onVideoElementDimensionsCalculated() {
        this._updateResolutionLimits();
    }
    _updateResolutionLimits() {
        let e = this._config.minUpscaleFactor ?? null;
        if (null === e || e < 0) return void this.setResolutionLimits(null);
        let t = this._upscaleCalculationService.getMaxAllowedResolution(e);
        t && this.setResolutionLimits(t);
    }
    get debugPanelRootContainer() {
        return this._debugPanel.rootContainer;
    }
    get isStarted() {
        return this._hasStarted || this._isStartDelayed;
    }
    get sessionId() {
        return this._metricsCollector?.sessionId;
    }
}
(0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$rx
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "setPlayerType", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$rx
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "start", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$rx
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "stop", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_handleVideoPlaybackStateChange", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_handleUpdatePlayerResolution", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_handleNativeEvent", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_handleTimeUpdate", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_handlePlaying", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_onPlayerTypeForced", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_onResolutionsAvailable", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_onAnotherActivePlayer", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_onSessionIdRecreated", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_updateStreamConfigInternal", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_onLatencyEstimationAvailable", null), (0, $e175c1d94c759890$var$b.__decorate)([
    $e175c1d94c759890$var$y.bind
], $e175c1d94c759890$export$57663087b8d9f5a6.prototype, "_onVideoElementDimensionsCalculated", null);
var $e175c1d94c759890$var$tj = $e175c1d94c759890$var$g("1QtI2");
let $e175c1d94c759890$var$rV = null, $e175c1d94c759890$export$ccb78460aa37b1d6 = ()=>$e175c1d94c759890$var$rV || ($e175c1d94c759890$var$rV = document.createElement("video")), $e175c1d94c759890$export$2e47fab1429dbb4f = ()=>$e175c1d94c759890$export$ccb78460aa37b1d6().play();
var $e175c1d94c759890$export$41789205b2aea69e = $e175c1d94c759890$var$g("hJ7nZ").EPlayerType, $e175c1d94c759890$export$af29ccb356acd9fc = $e175c1d94c759890$var$g("hJ7nZ").EPlaybackState, $e175c1d94c759890$export$fadb1eea8aff454b = $e175c1d94c759890$var$g("hJ7nZ").EPlaybackStartType, $e175c1d94c759890$export$b0dc2e3b984d8891 = $e175c1d94c759890$var$g("1QtI2").EPlayerErrorType;


function $cdb872cfc8d057e0$var$e(e, t, i, r) {
    Object.defineProperty(e, t, {
        get: i,
        set: r,
        enumerable: !0,
        configurable: !0
    });
}
var $cdb872cfc8d057e0$var$t, $cdb872cfc8d057e0$var$i, $cdb872cfc8d057e0$export$5de0c2f48b03ac5c, $cdb872cfc8d057e0$export$41789205b2aea69e, $cdb872cfc8d057e0$export$af29ccb356acd9fc, $cdb872cfc8d057e0$export$fadb1eea8aff454b, $cdb872cfc8d057e0$var$o, $cdb872cfc8d057e0$export$7999b4a47f0af35e, $cdb872cfc8d057e0$var$d, $cdb872cfc8d057e0$export$559043f40a876a16, $cdb872cfc8d057e0$export$1f8aff248f4faedf, $cdb872cfc8d057e0$var$h, $cdb872cfc8d057e0$var$g, $cdb872cfc8d057e0$var$f, $cdb872cfc8d057e0$var$p = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : {}, $cdb872cfc8d057e0$var$_ = {}, $cdb872cfc8d057e0$var$v = {}, $cdb872cfc8d057e0$var$b = $cdb872cfc8d057e0$var$p.parcelRequire6891_vldu9;
function $cdb872cfc8d057e0$var$m() {
    return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== $cdb872cfc8d057e0$var$p ? $cdb872cfc8d057e0$var$p : void 0;
}
null == $cdb872cfc8d057e0$var$b && (($cdb872cfc8d057e0$var$b = function(e) {
    if (e in $cdb872cfc8d057e0$var$_) return $cdb872cfc8d057e0$var$_[e].exports;
    if (e in $cdb872cfc8d057e0$var$v) {
        var t = $cdb872cfc8d057e0$var$v[e];
        delete $cdb872cfc8d057e0$var$v[e];
        var i = {
            id: e,
            exports: {}
        };
        return $cdb872cfc8d057e0$var$_[e] = i, t.call(i.exports, i, i.exports), i.exports;
    }
    var r = Error("Cannot find module '" + e + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
}).register = function(e, t) {
    $cdb872cfc8d057e0$var$v[e] = t;
}, $cdb872cfc8d057e0$var$p.parcelRequire6891_vldu9 = $cdb872cfc8d057e0$var$b), $cdb872cfc8d057e0$var$b.register("iuHwr", function(t, i) {
    $cdb872cfc8d057e0$var$e(t.exports, "default", function() {
        return l;
    });
    var r = $cdb872cfc8d057e0$var$b("iCUkT"), n = $cdb872cfc8d057e0$var$b("eEfty"), s = i && !i.nodeType && i, a = s && t && !t.nodeType && t, o = a && a.exports === s ? r.default.Buffer : void 0, l = (o ? o.isBuffer : void 0) || n.default;
}), $cdb872cfc8d057e0$var$b.register("iCUkT", function(t, i) {
    $cdb872cfc8d057e0$var$e(t.exports, "default", function() {
        return s;
    });
    var r = $cdb872cfc8d057e0$var$b("39qEx"), n = "object" == typeof self && self && self.Object === Object && self, s = r.default || n || Function("return this")();
}), $cdb872cfc8d057e0$var$b.register("39qEx", function(t, i) {
    $cdb872cfc8d057e0$var$e(t.exports, "default", function() {
        return r;
    });
    var r = "object" == typeof $cdb872cfc8d057e0$var$p && $cdb872cfc8d057e0$var$p && $cdb872cfc8d057e0$var$p.Object === Object && $cdb872cfc8d057e0$var$p;
}), $cdb872cfc8d057e0$var$b.register("eEfty", function(t, i) {
    $cdb872cfc8d057e0$var$e(t.exports, "default", function() {
        return r;
    });
    var r = function() {
        return !1;
    };
}), $cdb872cfc8d057e0$var$b.register("8tO4H", function(t, i) {
    $cdb872cfc8d057e0$var$e(t.exports, "default", function() {
        return o;
    });
    var r = $cdb872cfc8d057e0$var$b("39qEx"), n = i && !i.nodeType && i, s = n && t && !t.nodeType && t, a = s && s.exports === n && r.default.process, o = function() {
        try {
            var e = s && s.require && s.require("util").types;
            if (e) return e;
            return a && a.binding && a.binding("util");
        } catch (e) {}
    }();
}), "undefined" == typeof globalThis && (globalThis = $cdb872cfc8d057e0$var$m());
let $cdb872cfc8d057e0$var$E = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== $cdb872cfc8d057e0$var$p && $cdb872cfc8d057e0$var$p;
function $cdb872cfc8d057e0$var$y(e) {
    try {
        new e("");
    } catch (e) {
        return !1;
    }
    return !0;
}
"function" == typeof $cdb872cfc8d057e0$var$E.Event && $cdb872cfc8d057e0$var$y($cdb872cfc8d057e0$var$E.Event) || ($cdb872cfc8d057e0$var$E.Event = function(e, t) {
    this.bubbles = !!t && !!t.bubbles, this.cancelable = !!t && !!t.cancelable, this.composed = !!t && !!t.composed, this.type = e;
}), void 0 !== $cdb872cfc8d057e0$var$E.EventTarget && $cdb872cfc8d057e0$var$y($cdb872cfc8d057e0$var$E.EventTarget) || ($cdb872cfc8d057e0$var$E.EventTarget = function() {
    function e() {
        this.__listeners = new Map;
    }
    return e.prototype = Object.create(Object.prototype), e.prototype.addEventListener = function(e, t, i) {
        if (arguments.length < 2) throw TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        let r = this.__listeners, n = e.toString();
        r.has(n) || r.set(n, new Map);
        let s = r.get(n);
        s.has(t) || s.set(t, i);
    }, e.prototype.removeEventListener = function(e, t, i) {
        if (arguments.length < 2) throw TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        let r = this.__listeners, n = e.toString();
        if (r.has(n)) {
            let e = r.get(n);
            e.has(t) && e.delete(t);
        }
    }, e.prototype.dispatchEvent = function(e) {
        if (!(e instanceof Event)) throw TypeError("Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.");
        let t = e.type, i = this.__listeners, r = i.get(t);
        if (r) for (let [t, i] of r.entries()){
            try {
                "function" == typeof t ? t.call(this, e) : t && "function" == typeof t.handleEvent && t.handleEvent(e);
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
            }
            i && i.once && r.delete(t);
        }
        return !0;
    }, e;
}());
let $cdb872cfc8d057e0$var$$3cfe36083fdf784d$var$Emitter = class $3cfe36083fdf784d$var$Emitter {
    constructor(){
        Object.defineProperty(this, "listeners", {
            value: {},
            writable: !0,
            configurable: !0
        });
    }
    addEventListener(e, t, i) {
        e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
            callback: t,
            options: i
        });
    }
    removeEventListener(e, t) {
        if (!(e in this.listeners)) return;
        let i = this.listeners[e];
        for(let e = 0, r = i.length; e < r; e++)if (i[e].callback === t) {
            i.splice(e, 1);
            return;
        }
    }
    dispatchEvent(e) {
        if (!(e.type in this.listeners)) return;
        let t = this.listeners[e.type], i = t.slice();
        for(let t = 0, r = i.length; t < r; t++){
            let r = i[t];
            try {
                r.callback.call(this, e);
            } catch (e) {
                Promise.resolve().then(()=>{
                    throw e;
                });
            }
            r.options && r.options.once && this.removeEventListener(e.type, r.callback);
        }
        return !e.defaultPrevented;
    }
};
let $cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$e42c54032314dc1d = class $3cfe36083fdf784d$export$e42c54032314dc1d extends $cdb872cfc8d057e0$var$$3cfe36083fdf784d$var$Emitter {
    constructor(){
        super(), this.listeners || $cdb872cfc8d057e0$var$$3cfe36083fdf784d$var$Emitter.call(this), Object.defineProperty(this, "aborted", {
            value: !1,
            writable: !0,
            configurable: !0
        }), Object.defineProperty(this, "onabort", {
            value: null,
            writable: !0,
            configurable: !0
        }), Object.defineProperty(this, "reason", {
            value: void 0,
            writable: !0,
            configurable: !0
        });
    }
    toString() {
        return "[object AbortSignal]";
    }
    dispatchEvent(e) {
        "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), super.dispatchEvent(e);
    }
};
let $cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$48f7e099c149af88 = class $3cfe36083fdf784d$export$48f7e099c149af88 {
    constructor(){
        Object.defineProperty(this, "signal", {
            value: new $cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$e42c54032314dc1d,
            writable: !0,
            configurable: !0
        });
    }
    abort(e) {
        let t;
        t = new Event("abort");
        let i = e;
        void 0 === i && ((i = Error("This operation was aborted")).name = "AbortError"), this.signal.reason = i, this.signal.dispatchEvent(t);
    }
    toString() {
        return "[object AbortController]";
    }
};
!function(e) {
    "use strict";
    ("function" != typeof e.Request || e.Request.prototype.hasOwnProperty("signal")) && e.AbortController || ("undefined" != typeof Symbol && Symbol.toStringTag && ($cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$48f7e099c149af88.prototype[Symbol.toStringTag] = "AbortController", $cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$e42c54032314dc1d.prototype[Symbol.toStringTag] = "AbortSignal"), e.AbortController = $cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$48f7e099c149af88, e.AbortSignal = $cdb872cfc8d057e0$var$$3cfe36083fdf784d$export$e42c54032314dc1d);
}("undefined" != typeof self ? self : $cdb872cfc8d057e0$var$p);
let $cdb872cfc8d057e0$var$S = $cdb872cfc8d057e0$var$m();
"function" != typeof $cdb872cfc8d057e0$var$S.queueMicrotask && ($cdb872cfc8d057e0$var$S.queueMicrotask = function(e) {
    Promise.resolve().then(e).catch((e)=>setTimeout(()=>{
            throw e;
        }));
}), Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", {
    configurable: !0,
    value: function e() {
        let t = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
        return t ? Array.prototype.reduce.call(this, function(i, r) {
            return Array.isArray(r) ? i.push.apply(i, e.call(r, t - 1)) : i.push(r), i;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: !0
}), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", {
    configurable: !0,
    value: function(e) {
        return Array.prototype.map.apply(this, arguments).flat();
    },
    writable: !0
}), function(e) {
    e.CLICK = "videoElement.click", e.PLAYING = "videoElement.playing", e.LOADING = "videoElement.loading", e.PAUSE = "videoElement.pause", e.VIDEO_PLAYBACK_STATE_CHANGE = "videoElement.videoPlaybackStateChange", e.NATIVE_EVENT = "videoElement.nativeEvent", e.UPDATE_PLAYER_RESOLUTION = "videoElement.updatePlayerResolution", e.TIME_UPDATE = "videoElement.timeUpdate";
}($cdb872cfc8d057e0$export$5de0c2f48b03ac5c || ($cdb872cfc8d057e0$export$5de0c2f48b03ac5c = {}));
let $cdb872cfc8d057e0$export$5087227eb54526 = class $ae21521d6337de01$export$5087227eb54526 {
    constructor(e = !0){
        this.appId = null, this._lastUid = -1, this._messages = {}, this._immediateExceptions = !1, this._allSubscribingMsg = "*", this._immediateExceptions = e;
    }
    setAppId(e) {
        this.appId = e;
    }
    getAppId() {
        return this.appId;
    }
    publish(e, t) {
        return this._publish(e, t, !1, this._immediateExceptions);
    }
    publishSync(e, t) {
        return this._publish(e, t, !0, this._immediateExceptions);
    }
    subscribe(e, t) {
        if ("function" != typeof t) return "";
        let i = "uid_" + String(++this._lastUid);
        this._messages[e] || (this._messages[e] = {});
        let r = this._messages[e] || {};
        return r[i] = t, i;
    }
    toggleSubscriptionBulk(e) {
        "subscribe" === e.action ? Object.entries(e.callbacks).forEach(([e, t])=>{
            this.subscribe.call(this, e, t);
        }) : Object.entries(e.callbacks).forEach(([e, t])=>{
            this.unsubscribe.call(this, t);
        });
    }
    subscribeAll(e) {
        return this.subscribe(this._allSubscribingMsg, e);
    }
    subscribeOnce(e, t) {
        let i = this.subscribe(e, (...e)=>{
            this.unsubscribe(i), t.apply(this, e);
        });
        return this;
    }
    clearAllSubscriptions() {
        this._messages = {};
    }
    clearSubscriptions(e) {
        for(let t in this._messages)Object.prototype.hasOwnProperty.call(this._messages, t) && 0 === t.indexOf(e) && delete this._messages[t];
    }
    unsubscribe(e) {
        let t = "string" == typeof e && (Object.prototype.hasOwnProperty.call(this._messages, e) || this._descendantTopicExists(e)), i = !t && "string" == typeof e, r = "function" == typeof e, n = !1;
        if (t) {
            this.clearSubscriptions(e);
            return;
        }
        for(let t in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, t)) {
            let s = this._messages[t] || {};
            if (i && s[e]) {
                delete s[e], n = e;
                break;
            }
            if (r) for(let t in s)Object.prototype.hasOwnProperty.call(s, t) && s[t] === e && (delete s[t], n = !0);
        }
        return n;
    }
    _hasKeys(e) {
        for(let t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !0;
        return !1;
    }
    _throwException(e) {
        return ()=>{
            throw e;
        };
    }
    _callSubscriberWithDelayedExceptions(e, t) {
        try {
            e(t);
        } catch (e) {
            setTimeout(this._throwException(e), 0);
        }
    }
    _callSubscriberWithImmediateExceptions(e, t) {
        e(t);
    }
    _deliverMessage(e, t, i, r) {
        let n = this._messages[t] || {}, s = r ? this._callSubscriberWithImmediateExceptions : this._callSubscriberWithDelayedExceptions;
        if (Object.prototype.hasOwnProperty.call(this._messages, t)) for(let e in n)Object.prototype.hasOwnProperty.call(n, e) && s(n[e], i);
    }
    _createDeliveryFunction(e, t, i) {
        return ()=>{
            let r = String(e), n = r.lastIndexOf(".");
            for(this._deliverMessage(e, e, t, i); n > -1;)n = (r = r.substr(0, n)).lastIndexOf("."), this._deliverMessage(e, r, t, i);
            this._deliverMessage(e, this._allSubscribingMsg, t, i);
        };
    }
    _hasDirectSubscribersFor(e) {
        let t = String(e);
        return !!(Object.prototype.hasOwnProperty.call(this._messages, t) && this._hasKeys(this._messages[t] || {}));
    }
    _messageHasSubscribers(e) {
        let t = String(e), i = this._hasDirectSubscribersFor(t) || this._hasDirectSubscribersFor(this._allSubscribingMsg), r = t.lastIndexOf(".");
        for(; !i && -1 !== r;)r = (t = t.substr(0, r)).lastIndexOf("."), i = this._hasDirectSubscribersFor(t);
        return i;
    }
    _publish(e, t, i, r) {
        let n = "symbol" == typeof e ? e.toString() : e, s = this._createDeliveryFunction(n, t, r), a = this._messageHasSubscribers(n);
        return !!a && (i ? s() : setTimeout(s, 0), !0);
    }
    _descendantTopicExists(e) {
        for(let t in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, t) && 0 === t.indexOf(e)) return !0;
        return !1;
    }
};
new $cdb872cfc8d057e0$export$5087227eb54526, new $cdb872cfc8d057e0$export$5087227eb54526;
let $cdb872cfc8d057e0$var$$ = {
    configUpdated: "configProvider.configUpdated"
}, $cdb872cfc8d057e0$var$A = (e)=>`${$cdb872cfc8d057e0$var$$.configUpdated}.${e}`, $cdb872cfc8d057e0$var$w = (e)=>{
    let t = {}, i = class ConfigConsumer {
        constructor(i, r){
            this._onConfigUpdatedWithContext = this._onConfigUpdated.bind(this), this._configKey = i, this._eventBus = r || e;
            let n = $cdb872cfc8d057e0$var$A(i);
            this._onConfigUpdatedListener = this._eventBus.subscribe(n, this._onConfigUpdatedWithContext), this.config = t[i];
        }
        destroy() {
            this._eventBus.unsubscribe(this._onConfigUpdatedListener);
        }
        _handleConfigUpdated(e, t) {}
        _onConfigUpdated(e) {
            t = e.newConfig;
            let i = e.newConfig[this._configKey];
            this.config = i, this._handleConfigUpdated(e.updatedValues, i);
        }
    };
    return {
        configConsumerConstructor: i,
        setConsumerConfig: (e)=>{
            t = e;
        }
    };
}, $cdb872cfc8d057e0$var$C = (e)=>e instanceof Date, $cdb872cfc8d057e0$var$T = (e)=>e instanceof Element || e instanceof Document, $cdb872cfc8d057e0$var$M = (e)=>0 === Object.keys(e).length, $cdb872cfc8d057e0$var$P = (e)=>null != e && "object" == typeof e, $cdb872cfc8d057e0$var$O = (e, ...t)=>Object.prototype.hasOwnProperty.call(e, ...t), $cdb872cfc8d057e0$var$R = (e)=>$cdb872cfc8d057e0$var$P(e) && $cdb872cfc8d057e0$var$M(e), $cdb872cfc8d057e0$var$k = (e)=>(t)=>new Promise((i, r)=>{
            e(t, (e)=>{
                i(e);
            }, (e)=>{
                r(e);
            });
        }), $cdb872cfc8d057e0$export$925cb066f75a1c3e = (e, t)=>{
    if (e === t) return {};
    if (!$cdb872cfc8d057e0$var$P(e) || !$cdb872cfc8d057e0$var$P(t) || $cdb872cfc8d057e0$var$T(e) || $cdb872cfc8d057e0$var$T(t)) return t;
    let i = Object.keys(e).reduce((e, i)=>($cdb872cfc8d057e0$var$O(t, i) || (e[i] = void 0), e), {});
    return $cdb872cfc8d057e0$var$C(e) || $cdb872cfc8d057e0$var$C(t) ? e.valueOf() == t.valueOf() ? {} : t : Object.keys(t).reduce((i, r)=>{
        if (!$cdb872cfc8d057e0$var$O(e, r)) return i[r] = t[r], i;
        let n = $cdb872cfc8d057e0$export$925cb066f75a1c3e(e[r], t[r]);
        return $cdb872cfc8d057e0$var$R(n) && !$cdb872cfc8d057e0$var$C(n) && ($cdb872cfc8d057e0$var$R(e[r]) || !$cdb872cfc8d057e0$var$R(t[r])) || (i[r] = n), i;
    }, i);
}, $cdb872cfc8d057e0$export$45a69314cf48a3eb = (e)=>{
    let t = {
        ...e
    }, i = new $cdb872cfc8d057e0$export$5087227eb54526, { configConsumerConstructor: r , setConsumerConfig: n  } = $cdb872cfc8d057e0$var$w(i);
    return n(e), {
        getConfigField: (e)=>t[e],
        setConfig: (e, i, r = !1)=>{
            let s = Object.entries(e).reduce((e, [t, i])=>(e[t] = {
                    ...e[t],
                    ...i
                }, e), {
                ...t
            }), a = $cdb872cfc8d057e0$export$925cb066f75a1c3e(t, s);
            t = s, Object.entries(a).forEach(([e, t])=>{
                let n = $cdb872cfc8d057e0$var$A(e);
                r ? i.publishSync(n, {
                    updatedValues: t,
                    newConfig: s
                }) : i.publish(n, {
                    updatedValues: t,
                    newConfig: s
                });
            }), n(t);
        },
        getConfig: ()=>t,
        resetConfig: ()=>{
            t = {
                ...e
            };
        },
        ConfigConsumer: r
    };
};
function $cdb872cfc8d057e0$export$2385a24977818dd0(e, t, i) {
    if (!i || "function" != typeof i.value) throw TypeError(`Only methods can be decorated with @bind. <${t}> is not a method!`);
    return {
        configurable: !0,
        get () {
            let e = i.value?.bind(this);
            return Object.defineProperty(this, t, {
                value: e,
                configurable: !0,
                writable: !0
            }), e;
        }
    };
}
!function(e) {
    e.HLS = "hls", e.WEBRTC = "webrtc", e.NATIVE = "native", e.BROADCAST = "broadcast";
}($cdb872cfc8d057e0$export$41789205b2aea69e || ($cdb872cfc8d057e0$export$41789205b2aea69e = {})), function(e) {
    e.IDLE = "idle", e.LOADING = "loading", e.PAUSED = "paused", e.PLAYING = "playing", e.ERROR = "error";
}($cdb872cfc8d057e0$export$af29ccb356acd9fc || ($cdb872cfc8d057e0$export$af29ccb356acd9fc = {})), function(e) {
    e.WAITING = "waiting", e.AUTO = "auto", e.MANUAL = "manual";
}($cdb872cfc8d057e0$export$fadb1eea8aff454b || ($cdb872cfc8d057e0$export$fadb1eea8aff454b = {})), function(e) {
    e.BROADCAST_STATE_CHANGED = "commonEvents.broadcastStateChanged", e.BROADCAST_REMOTE_STATS_AVAILABLE = "commonEvents.broadcastRemoteStatsAvailable", e.PLAYING_STATE_CHANGED = "commonEvents.playingStateChanged", e.COMMON_ERROR = "commonEvents.commonError";
}($cdb872cfc8d057e0$var$o || ($cdb872cfc8d057e0$var$o = {}));
function $cdb872cfc8d057e0$var$N(e, t, i, r) {
    var n, s = arguments.length, a = s < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, i) : r;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, i, r);
    else for(var o = e.length - 1; o >= 0; o--)(n = e[o]) && (a = (s < 3 ? n(a) : s > 3 ? n(t, i, a) : n(t, i)) || a);
    return s > 3 && a && Object.defineProperty(t, i, a), a;
}
new $cdb872cfc8d057e0$export$5087227eb54526, ($cdb872cfc8d057e0$export$7999b4a47f0af35e || ($cdb872cfc8d057e0$export$7999b4a47f0af35e = {})).LOG = "logger.log";
let $cdb872cfc8d057e0$var$V = (e, t, i)=>(r, n)=>{
        e.publish($cdb872cfc8d057e0$export$7999b4a47f0af35e.LOG, {
            domain: t,
            timestamp: performance.now(),
            level: i,
            message: r,
            payload: n
        });
    }, $cdb872cfc8d057e0$export$efa9a398d6368992 = (e, t)=>{
    let i = `${t}{${(Math.random() + 1).toString(36).substring(2, 6)}}`;
    return {
        debug: $cdb872cfc8d057e0$var$V(e, i, "debug"),
        verbose: $cdb872cfc8d057e0$var$V(e, i, "verbose"),
        info: $cdb872cfc8d057e0$var$V(e, i, "info"),
        warn: $cdb872cfc8d057e0$var$V(e, i, "warn"),
        error: $cdb872cfc8d057e0$var$V(e, i, "error"),
        fatal: $cdb872cfc8d057e0$var$V(e, i, "fatal")
    };
}, $cdb872cfc8d057e0$var$L = (...e)=>console.log(...e.filter((e)=>void 0 !== e)), $cdb872cfc8d057e0$var$U = {
    debug: (e, t)=>$cdb872cfc8d057e0$var$L(`%c${e}`, "color: rgb(102, 102, 102)", t),
    verbose: (e, t)=>$cdb872cfc8d057e0$var$L(`%c${e}`, "color: rgb(36, 114, 200)", t),
    info: (e, t)=>$cdb872cfc8d057e0$var$L(`%c${e}`, "color: rgb(13, 188, 121)", t),
    warn: (e, t)=>$cdb872cfc8d057e0$var$L(`%c${e}`, "color: rgb(229, 229, 16)", t),
    error: (e, t)=>$cdb872cfc8d057e0$var$L(`%c${e}`, "color: rgb(241, 76, 76)", t),
    fatal: (e, t)=>$cdb872cfc8d057e0$var$L(`%c${e}`, "background: rgb(241, 76, 76); color: #fff", t)
}, $cdb872cfc8d057e0$var$F = [];
let $cdb872cfc8d057e0$export$8734a8c908553955 = class $6b88f92c0e0219d7$export$8734a8c908553955 {
    constructor(e, t = $cdb872cfc8d057e0$var$F, i = [], r = [], n = !0){
        this._levels = t, this._eventBus = e, this._enableErrorAutoLog = n, this._onLogMessageReceivedToken = this._eventBus.subscribe($cdb872cfc8d057e0$export$7999b4a47f0af35e.LOG, this._onMessageReceived), this._onErrorReceivedToken = this._eventBus.subscribe($cdb872cfc8d057e0$var$o.COMMON_ERROR, this._onErrorReceived), this._ignoreDomains = r, this._additionalScopeSubscriptions = i.map((e)=>this._eventBus.subscribe(e, (t)=>{
                this._onAdditionalScopeMessageReceived(e, t);
            })), this._appId = `${(Math.random() + 1).toString(36).substring(2, 6)}`;
    }
    destroy() {
        this._eventBus.unsubscribe(this._onLogMessageReceivedToken), this._eventBus.unsubscribe(this._onErrorReceivedToken), this._additionalScopeSubscriptions.forEach(this._eventBus.unsubscribe);
    }
    _onMessageReceived(e) {
        let { domain: t , timestamp: i , level: r , message: n , payload: s  } = e;
        if (!this._levels.includes(r) || this._ignoreDomains.includes(t)) return;
        let a = $cdb872cfc8d057e0$var$U[r] || $cdb872cfc8d057e0$var$U.info;
        a(`(${this._appId}) :: [${t}] ${r.toUpperCase()}:
${n}@${i}`, s);
    }
    _onAdditionalScopeMessageReceived(e, t) {
        let i = $cdb872cfc8d057e0$var$U.verbose;
        i(`[${e}] Event receiver with payload ${t} @ ${performance.now()}`);
    }
    _onErrorReceived({ error: e  }) {
        this._enableErrorAutoLog && $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "COMMON ERROR").error(`Error in ${e.domain}: ${e.message} ${e.info && " (" + e.info + ")"}`);
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$8734a8c908553955.prototype, "_onMessageReceived", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$8734a8c908553955.prototype, "_onAdditionalScopeMessageReceived", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$8734a8c908553955.prototype, "_onErrorReceived", null);
let $cdb872cfc8d057e0$var$j = {
    videoElementControllerConfig: {
        limitCheckingAutoplay: 5,
        minimalPossibleVideoDimension: 50,
        timeoutUpdateStatusPlaying: 2e3,
        timeoutUpdateVideoDuration: 500
    }
}, { ConfigConsumer: $cdb872cfc8d057e0$var$G , setConfig: $cdb872cfc8d057e0$var$H , resetConfig: $cdb872cfc8d057e0$var$W  } = $cdb872cfc8d057e0$export$45a69314cf48a3eb($cdb872cfc8d057e0$var$j);
!function(e) {
    e.NATIVE_EVENT = "videoElementController.nativeEvent", e.CLICK = "videoElementController.click", e.FORCE_PLAY_AFTER_PAUSE = "videoElementController.forcePlayAfterPause", e.VIDEO_START = "videoElementController.videoStart", e.VIDEO_PAUSE = "videoElementController.videoPause", e.VIDEO_RESET = "videoElementController.videoReset", e.PAUSED = "videoElementController.paused", e.PLAYING = "videoElementController.playing", e.LOADING = "videoElementController.loading", e.LOADED = "videoElementController.loaded", e.UPDATED = "videoElementController.updated", e.DESTROY = "videoElementController.destroy", e.STREAM_RESET = "videoElementController.streamReset", e.CAN_PLAY = "videoElementController.canPlay", e.REMOVE_MEDIA_STREAM = "videoElementController.removeMediaStream", e.ERROR = "videoElementController.error", e.ABORT = "videoElementController.abort", e.STALLED = "videoElementController.stalled", e.WAITING = "videoElementController.waiting", e.UPDATE_PLAYER_RESOLUTION = "videoElementController.updatePlayerResolution", e.RESET_CHECKING_AUTOPLAY_COUNT = "videoElementController.resetCheckingAutoplayCount", e.CANCEL_RESET_STREAM = "videoElementController.cancelResetStream", e.RESTART = "videoElementController.restart", e.TIME_UPDATE_NATIVE = "videoElementController.native", e.UPDATE_MEDIA_STREAM = "videoElementController.updateMediaStream", e.VIDEO_ELEMENT_RECREATED = "videoElementController.videoElementRecreated", e.VIDEO_PLAYBACK_STATE_CHANGED = "videoElementController.videoPlaybackStateChanged", e.SET_VOLUME = "videoElementController.setVolume";
}($cdb872cfc8d057e0$var$d || ($cdb872cfc8d057e0$var$d = {}));
let $cdb872cfc8d057e0$var$z = 0;
let $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5 = class $13e0e8c55e207599$export$a9a0b55bc0093be5 {
    constructor(e){
        this._config = {}, this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.CAN_PLAY]: this._checkAutoplayEnabled,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this.destroy,
            [$cdb872cfc8d057e0$var$d.FORCE_PLAY_AFTER_PAUSE]: this._forcePlayAfterPause,
            [$cdb872cfc8d057e0$var$d.RESET_CHECKING_AUTOPLAY_COUNT]: this._resetCheckingAutoplayCount
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - AutoplayController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._logger.debug("Initial state", this._state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e;
    }
    destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _handleConfigUpdated() {}
    _forcePlayAfterPause(e) {
        if (void 0 !== this._config.autoplay && !this._config.autoplay) {
            this._logger.verbose("Autoplay is disabled.");
            return;
        }
        this._logger.verbose(`Trying to force video to play.
    Reason: ${e.reason}`);
        let t = this._state.getState();
        if (!t.startedPlaying || t.isPlaying || this._config.canBePaused) {
            this._logger.verbose("Currently unable to autoplay the video");
            return;
        }
        this._checkAutoplayEnabled();
    }
    _checkAutoplayEnabled() {
        if (this._logger.debug("Checking if autoplay is possible"), !this._state.getState().canPlay) {
            this._logger.verbose("No canPlay event caught, skipping check");
            return;
        }
        if (void 0 !== this._config.autoplay && !this._config.autoplay) {
            this._logger.verbose("Autoplay is disabled.");
            return;
        }
        if ($cdb872cfc8d057e0$var$z > this._config.limitCheckingAutoplay) {
            this._logger.verbose(`Unable to autoplay the video. The limit of autoplay checking (${this._config.limitCheckingAutoplay}) is exceeded`), this._eventBus.publish($cdb872cfc8d057e0$var$d.PAUSED, {});
            return;
        }
        $cdb872cfc8d057e0$var$z += 1, this._logger.verbose("Autoplay is used to play the video"), this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_START, {});
    }
    _resetCheckingAutoplayCount() {
        $cdb872cfc8d057e0$var$z = 0;
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "destroy", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "_forcePlayAfterPause", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "_checkAutoplayEnabled", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5.prototype, "_resetCheckingAutoplayCount", null);
let $cdb872cfc8d057e0$export$493b9b82400bc18 = class $2698823e1558ee6a$export$493b9b82400bc18 extends EventTarget {
    constructor(){
        super();
    }
    emitEvent(e, t) {
        this.dispatchEvent(new CustomEvent(e, {
            detail: t
        }));
    }
};
let $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b = class $b8fa44c52cf48ebe$export$17bfd6b0f11e369b extends $cdb872cfc8d057e0$export$493b9b82400bc18 {
    constructor(e){
        super(), this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.PLAYING]: this._handlePlaying,
            [$cdb872cfc8d057e0$var$d.LOADING]: this._handleLoading,
            [$cdb872cfc8d057e0$var$d.VIDEO_PAUSE]: this._handlePause,
            [$cdb872cfc8d057e0$var$d.CLICK]: this._handleClick,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this.destroy,
            [$cdb872cfc8d057e0$var$d.NATIVE_EVENT]: this._handleNativeEvent,
            [$cdb872cfc8d057e0$var$d.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
            [$cdb872cfc8d057e0$var$d.VIDEO_PLAYBACK_STATE_CHANGED]: this._handleVideoPlaybackStateChange,
            [$cdb872cfc8d057e0$var$d.TIME_UPDATE_NATIVE]: this._handleTimeUpdate
        }, this._eventBus = e.eventBus, this.init();
    }
    destroy() {
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _handlePlaying(e) {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.PLAYING, e);
    }
    _handleLoading() {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.LOADING, {});
    }
    _handlePause() {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.PAUSE, {});
    }
    _handleClick(e) {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.CLICK, {
            originalEvent: e.originalEvent
        });
    }
    _handleNativeEvent(e) {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.NATIVE_EVENT, e);
    }
    _handleUpdatePlayerResolution(e) {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.UPDATE_PLAYER_RESOLUTION, e);
    }
    _handleTimeUpdate(e) {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.TIME_UPDATE, e);
    }
    _handleVideoPlaybackStateChange(e) {
        this.emitEvent($cdb872cfc8d057e0$export$5de0c2f48b03ac5c.VIDEO_PLAYBACK_STATE_CHANGE, {
            prevState: e.prevState,
            nextState: e.nextState
        });
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "destroy", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handlePlaying", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleLoading", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handlePause", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleClick", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleNativeEvent", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleUpdatePlayerResolution", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleTimeUpdate", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b.prototype, "_handleVideoPlaybackStateChange", null);
var $cdb872cfc8d057e0$var$q = {};
$cdb872cfc8d057e0$var$q = function(e) {
    var t = {};
    function i(r) {
        if (t[r]) return t[r].exports;
        var n = t[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e[r].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
    }
    return i.m = e, i.c = t, i.d = function(e, t, r) {
        i.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, i.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, i.t = function(e, t) {
        if (1 & t && (e = i(e)), 8 & t || 4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (i.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var n in e)i.d(r, n, (function(t) {
            return e[t];
        }).bind(null, n));
        return r;
    }, i.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return i.d(t, "a", t), t;
    }, i.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "", i(i.s = 90);
}({
    17: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r = i(18), n = function() {
            function e() {}
            return e.getFirstMatch = function(e, t) {
                var i = t.match(e);
                return i && i.length > 0 && i[1] || "";
            }, e.getSecondMatch = function(e, t) {
                var i = t.match(e);
                return i && i.length > 1 && i[2] || "";
            }, e.matchAndReturnConst = function(e, t, i) {
                if (e.test(t)) return i;
            }, e.getWindowsVersionName = function(e) {
                switch(e){
                    case "NT":
                        return "NT";
                    case "XP":
                    case "NT 5.1":
                        return "XP";
                    case "NT 5.0":
                        return "2000";
                    case "NT 5.2":
                        return "2003";
                    case "NT 6.0":
                        return "Vista";
                    case "NT 6.1":
                        return "7";
                    case "NT 6.2":
                        return "8";
                    case "NT 6.3":
                        return "8.1";
                    case "NT 10.0":
                        return "10";
                    default:
                        return;
                }
            }, e.getMacOSVersionName = function(e) {
                var t = e.split(".").splice(0, 2).map(function(e) {
                    return parseInt(e, 10) || 0;
                });
                if (t.push(0), 10 === t[0]) switch(t[1]){
                    case 5:
                        return "Leopard";
                    case 6:
                        return "Snow Leopard";
                    case 7:
                        return "Lion";
                    case 8:
                        return "Mountain Lion";
                    case 9:
                        return "Mavericks";
                    case 10:
                        return "Yosemite";
                    case 11:
                        return "El Capitan";
                    case 12:
                        return "Sierra";
                    case 13:
                        return "High Sierra";
                    case 14:
                        return "Mojave";
                    case 15:
                        return "Catalina";
                    default:
                        return;
                }
            }, e.getAndroidVersionName = function(e) {
                var t = e.split(".").splice(0, 2).map(function(e) {
                    return parseInt(e, 10) || 0;
                });
                if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
            }, e.getVersionPrecision = function(e) {
                return e.split(".").length;
            }, e.compareVersions = function(t, i, r) {
                void 0 === r && (r = !1);
                var n = e.getVersionPrecision(t), s = e.getVersionPrecision(i), a = Math.max(n, s), o = 0, l = e.map([
                    t,
                    i
                ], function(t) {
                    var i = a - e.getVersionPrecision(t), r = t + Array(i + 1).join(".0");
                    return e.map(r.split("."), function(e) {
                        return Array(20 - e.length).join("0") + e;
                    }).reverse();
                });
                for(r && (o = a - Math.min(n, s)), a -= 1; a >= o;){
                    if (l[0][a] > l[1][a]) return 1;
                    if (l[0][a] === l[1][a]) {
                        if (a === o) return 0;
                        a -= 1;
                    } else if (l[0][a] < l[1][a]) return -1;
                }
            }, e.map = function(e, t) {
                var i, r = [];
                if (Array.prototype.map) return Array.prototype.map.call(e, t);
                for(i = 0; i < e.length; i += 1)r.push(t(e[i]));
                return r;
            }, e.find = function(e, t) {
                var i, r;
                if (Array.prototype.find) return Array.prototype.find.call(e, t);
                for(i = 0, r = e.length; i < r; i += 1){
                    var n = e[i];
                    if (t(n, i)) return n;
                }
            }, e.assign = function(e) {
                for(var t, i, r = arguments.length, n = Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)n[s - 1] = arguments[s];
                if (Object.assign) return Object.assign.apply(Object, [
                    e
                ].concat(n));
                for(t = 0, i = n.length; t < i; t += 1)(function() {
                    var i = n[t];
                    "object" == typeof i && null !== i && Object.keys(i).forEach(function(t) {
                        e[t] = i[t];
                    });
                })();
                return e;
            }, e.getBrowserAlias = function(e) {
                return r.BROWSER_ALIASES_MAP[e];
            }, e.getBrowserTypeByAlias = function(e) {
                return r.BROWSER_MAP[e] || "";
            }, e;
        }();
        t.default = n, e.exports = t.default;
    },
    18: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
            "Amazon Silk": "amazon_silk",
            "Android Browser": "android",
            Bada: "bada",
            BlackBerry: "blackberry",
            Chrome: "chrome",
            Chromium: "chromium",
            Electron: "electron",
            Epiphany: "epiphany",
            Firefox: "firefox",
            Focus: "focus",
            Generic: "generic",
            "Google Search": "google_search",
            Googlebot: "googlebot",
            "Internet Explorer": "ie",
            "K-Meleon": "k_meleon",
            Maxthon: "maxthon",
            "Microsoft Edge": "edge",
            "MZ Browser": "mz",
            "NAVER Whale Browser": "naver",
            Opera: "opera",
            "Opera Coast": "opera_coast",
            PhantomJS: "phantomjs",
            Puffin: "puffin",
            QupZilla: "qupzilla",
            QQ: "qq",
            QQLite: "qqlite",
            Safari: "safari",
            Sailfish: "sailfish",
            "Samsung Internet for Android": "samsung_internet",
            SeaMonkey: "seamonkey",
            Sleipnir: "sleipnir",
            Swing: "swing",
            Tizen: "tizen",
            "UC Browser": "uc",
            Vivaldi: "vivaldi",
            "WebOS Browser": "webos",
            WeChat: "wechat",
            "Yandex Browser": "yandex",
            Roku: "roku"
        }, t.BROWSER_MAP = {
            amazon_silk: "Amazon Silk",
            android: "Android Browser",
            bada: "Bada",
            blackberry: "BlackBerry",
            chrome: "Chrome",
            chromium: "Chromium",
            electron: "Electron",
            epiphany: "Epiphany",
            firefox: "Firefox",
            focus: "Focus",
            generic: "Generic",
            googlebot: "Googlebot",
            google_search: "Google Search",
            ie: "Internet Explorer",
            k_meleon: "K-Meleon",
            maxthon: "Maxthon",
            edge: "Microsoft Edge",
            mz: "MZ Browser",
            naver: "NAVER Whale Browser",
            opera: "Opera",
            opera_coast: "Opera Coast",
            phantomjs: "PhantomJS",
            puffin: "Puffin",
            qupzilla: "QupZilla",
            qq: "QQ Browser",
            qqlite: "QQ Browser Lite",
            safari: "Safari",
            sailfish: "Sailfish",
            samsung_internet: "Samsung Internet for Android",
            seamonkey: "SeaMonkey",
            sleipnir: "Sleipnir",
            swing: "Swing",
            tizen: "Tizen",
            uc: "UC Browser",
            vivaldi: "Vivaldi",
            webos: "WebOS Browser",
            wechat: "WeChat",
            yandex: "Yandex Browser"
        }, t.PLATFORMS_MAP = {
            tablet: "tablet",
            mobile: "mobile",
            desktop: "desktop",
            tv: "tv"
        }, t.OS_MAP = {
            WindowsPhone: "Windows Phone",
            Windows: "Windows",
            MacOS: "macOS",
            iOS: "iOS",
            Android: "Android",
            WebOS: "WebOS",
            BlackBerry: "BlackBerry",
            Bada: "Bada",
            Tizen: "Tizen",
            Linux: "Linux",
            ChromeOS: "Chrome OS",
            PlayStation4: "PlayStation 4",
            Roku: "Roku"
        }, t.ENGINE_MAP = {
            EdgeHTML: "EdgeHTML",
            Blink: "Blink",
            Trident: "Trident",
            Presto: "Presto",
            Gecko: "Gecko",
            WebKit: "WebKit"
        };
    },
    90: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r, n = (r = i(91)) && r.__esModule ? r : {
            default: r
        }, s = i(18), a = function() {
            function e() {}
            return e.getParser = function(e, t) {
                if (void 0 === t && (t = !1), "string" != typeof e) throw Error("UserAgent should be a string");
                return new n.default(e, t);
            }, e.parse = function(e) {
                return new n.default(e).getResult();
            }, function(e, t) {
                for(var i = 0; i < t.length; i++){
                    var r = t[i];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }(e, [
                {
                    key: "BROWSER_MAP",
                    get: function() {
                        return s.BROWSER_MAP;
                    }
                },
                {
                    key: "ENGINE_MAP",
                    get: function() {
                        return s.ENGINE_MAP;
                    }
                },
                {
                    key: "OS_MAP",
                    get: function() {
                        return s.OS_MAP;
                    }
                },
                {
                    key: "PLATFORMS_MAP",
                    get: function() {
                        return s.PLATFORMS_MAP;
                    }
                }
            ]), e;
        }();
        t.default = a, e.exports = t.default;
    },
    91: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r = l(i(92)), n = l(i(93)), s = l(i(94)), a = l(i(95)), o = l(i(17));
        function l(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var d = function() {
            function e(e, t) {
                if (void 0 === t && (t = !1), null == e || "" === e) throw Error("UserAgent parameter can't be empty");
                this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
            }
            var t = e.prototype;
            return t.getUA = function() {
                return this._ua;
            }, t.test = function(e) {
                return e.test(this._ua);
            }, t.parseBrowser = function() {
                var e = this;
                this.parsedResult.browser = {};
                var t = o.default.find(r.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
            }, t.getBrowser = function() {
                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
            }, t.getBrowserName = function(e) {
                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
            }, t.getBrowserVersion = function() {
                return this.getBrowser().version;
            }, t.getOS = function() {
                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
            }, t.parseOS = function() {
                var e = this;
                this.parsedResult.os = {};
                var t = o.default.find(n.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
            }, t.getOSName = function(e) {
                var t = this.getOS().name;
                return e ? String(t).toLowerCase() || "" : t || "";
            }, t.getOSVersion = function() {
                return this.getOS().version;
            }, t.getPlatform = function() {
                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
            }, t.getPlatformType = function(e) {
                void 0 === e && (e = !1);
                var t = this.getPlatform().type;
                return e ? String(t).toLowerCase() || "" : t || "";
            }, t.parsePlatform = function() {
                var e = this;
                this.parsedResult.platform = {};
                var t = o.default.find(s.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
            }, t.getEngine = function() {
                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
            }, t.getEngineName = function(e) {
                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
            }, t.parseEngine = function() {
                var e = this;
                this.parsedResult.engine = {};
                var t = o.default.find(a.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
            }, t.parse = function() {
                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
            }, t.getResult = function() {
                return o.default.assign({}, this.parsedResult);
            }, t.satisfies = function(e) {
                var t = this, i = {}, r = 0, n = {}, s = 0;
                if (Object.keys(e).forEach(function(t) {
                    var a = e[t];
                    "string" == typeof a ? (n[t] = a, s += 1) : "object" == typeof a && (i[t] = a, r += 1);
                }), r > 0) {
                    var a = Object.keys(i), l = o.default.find(a, function(e) {
                        return t.isOS(e);
                    });
                    if (l) {
                        var d = this.satisfies(i[l]);
                        if (void 0 !== d) return d;
                    }
                    var c = o.default.find(a, function(e) {
                        return t.isPlatform(e);
                    });
                    if (c) {
                        var u = this.satisfies(i[c]);
                        if (void 0 !== u) return u;
                    }
                }
                if (s > 0) {
                    var h = Object.keys(n), g = o.default.find(h, function(e) {
                        return t.isBrowser(e, !0);
                    });
                    if (void 0 !== g) return this.compareVersion(n[g]);
                }
            }, t.isBrowser = function(e, t) {
                void 0 === t && (t = !1);
                var i = this.getBrowserName().toLowerCase(), r = e.toLowerCase(), n = o.default.getBrowserTypeByAlias(r);
                return t && n && (r = n.toLowerCase()), r === i;
            }, t.compareVersion = function(e) {
                var t = [
                    0
                ], i = e, r = !1, n = this.getBrowserVersion();
                if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (i = e.substr(1), "=" === e[1] ? (r = !0, i = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? i = e.substr(1) : "~" === e[0] && (r = !0, i = e.substr(1)), t.indexOf(o.default.compareVersions(n, i, r)) > -1;
            }, t.isOS = function(e) {
                return this.getOSName(!0) === String(e).toLowerCase();
            }, t.isPlatform = function(e) {
                return this.getPlatformType(!0) === String(e).toLowerCase();
            }, t.isEngine = function(e) {
                return this.getEngineName(!0) === String(e).toLowerCase();
            }, t.is = function(e, t) {
                return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
            }, t.some = function(e) {
                var t = this;
                return void 0 === e && (e = []), e.some(function(e) {
                    return t.is(e);
                });
            }, e;
        }();
        t.default = d, e.exports = t.default;
    },
    92: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r, n = (r = i(17)) && r.__esModule ? r : {
            default: r
        }, s = /version\/(\d+(\.?_?\d+)+)/i, a = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Googlebot"
                    }, i = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /opera/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /opr\/|opios/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera"
                    }, i = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /SamsungBrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Samsung Internet for Android"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /Whale/i
                ],
                describe: function(e) {
                    var t = {
                        name: "NAVER Whale Browser"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /MZBrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "MZ Browser"
                    }, i = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /focus/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Focus"
                    }, i = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /swing/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Swing"
                    }, i = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /coast/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera Coast"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /opt\/\d+(?:.?_?\d+)+/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera Touch"
                    }, i = n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /yabrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Yandex Browser"
                    }, i = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /ucbrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "UC Browser"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /Maxthon|mxios/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Maxthon"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /epiphany/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Epiphany"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /puffin/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Puffin"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /sleipnir/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Sleipnir"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /k-meleon/i
                ],
                describe: function(e) {
                    var t = {
                        name: "K-Meleon"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /micromessenger/i
                ],
                describe: function(e) {
                    var t = {
                        name: "WeChat"
                    }, i = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /qqbrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                    }, i = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /msie|trident/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Internet Explorer"
                    }, i = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /\sedg\//i
                ],
                describe: function(e) {
                    var t = {
                        name: "Microsoft Edge"
                    }, i = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /edg([ea]|ios)/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Microsoft Edge"
                    }, i = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /vivaldi/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Vivaldi"
                    }, i = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /seamonkey/i
                ],
                describe: function(e) {
                    var t = {
                        name: "SeaMonkey"
                    }, i = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /sailfish/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Sailfish"
                    }, i = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Amazon Silk"
                    }, i = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /phantom/i
                ],
                describe: function(e) {
                    var t = {
                        name: "PhantomJS"
                    }, i = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /slimerjs/i
                ],
                describe: function(e) {
                    var t = {
                        name: "SlimerJS"
                    }, i = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function(e) {
                    var t = {
                        name: "BlackBerry"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function(e) {
                    var t = {
                        name: "WebOS Browser"
                    }, i = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Bada"
                    }, i = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Tizen"
                    }, i = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /qupzilla/i
                ],
                describe: function(e) {
                    var t = {
                        name: "QupZilla"
                    }, i = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /firefox|iceweasel|fxios/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Firefox"
                    }, i = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /electron/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Electron"
                    }, i = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /MiuiBrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Miui"
                    }, i = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /chromium/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Chromium"
                    }, i = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /chrome|crios|crmo/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Chrome"
                    }, i = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /GSA/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Google Search"
                    }, i = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: function(e) {
                    var t = !e.test(/like android/i), i = e.test(/android/i);
                    return t && i;
                },
                describe: function(e) {
                    var t = {
                        name: "Android Browser"
                    }, i = n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /playstation 4/i
                ],
                describe: function(e) {
                    var t = {
                        name: "PlayStation 4"
                    }, i = n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /safari|applewebkit/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Safari"
                    }, i = n.default.getFirstMatch(s, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /.*/i
                ],
                describe: function(e) {
                    var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                    return {
                        name: n.default.getFirstMatch(t, e),
                        version: n.default.getSecondMatch(t, e)
                    };
                }
            }
        ];
        t.default = a, e.exports = t.default;
    },
    93: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r, n = (r = i(17)) && r.__esModule ? r : {
            default: r
        }, s = i(18), a = [
            {
                test: [
                    /Roku\/DVP/
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                    return {
                        name: s.OS_MAP.Roku,
                        version: t
                    };
                }
            },
            {
                test: [
                    /windows phone/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.WindowsPhone,
                        version: t
                    };
                }
            },
            {
                test: [
                    /windows /i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), i = n.default.getWindowsVersionName(t);
                    return {
                        name: s.OS_MAP.Windows,
                        version: t,
                        versionName: i
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function(e) {
                    var t = {
                        name: s.OS_MAP.iOS
                    }, i = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /macintosh/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), i = n.default.getMacOSVersionName(t), r = {
                        name: s.OS_MAP.MacOS,
                        version: t
                    };
                    return i && (r.versionName = i), r;
                }
            },
            {
                test: [
                    /(ipod|iphone|ipad)/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                    return {
                        name: s.OS_MAP.iOS,
                        version: t
                    };
                }
            },
            {
                test: function(e) {
                    var t = !e.test(/like android/i), i = e.test(/android/i);
                    return t && i;
                },
                describe: function(e) {
                    var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), i = n.default.getAndroidVersionName(t), r = {
                        name: s.OS_MAP.Android,
                        version: t
                    };
                    return i && (r.versionName = i), r;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), i = {
                        name: s.OS_MAP.WebOS
                    };
                    return t && t.length && (i.version = t), i;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                    return {
                        name: s.OS_MAP.BlackBerry,
                        version: t
                    };
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.Bada,
                        version: t
                    };
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.Tizen,
                        version: t
                    };
                }
            },
            {
                test: [
                    /linux/i
                ],
                describe: function() {
                    return {
                        name: s.OS_MAP.Linux
                    };
                }
            },
            {
                test: [
                    /CrOS/
                ],
                describe: function() {
                    return {
                        name: s.OS_MAP.ChromeOS
                    };
                }
            },
            {
                test: [
                    /PlayStation 4/
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.PlayStation4,
                        version: t
                    };
                }
            }
        ];
        t.default = a, e.exports = t.default;
    },
    94: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r, n = (r = i(17)) && r.__esModule ? r : {
            default: r
        }, s = i(18), a = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function() {
                    return {
                        type: "bot",
                        vendor: "Google"
                    };
                }
            },
            {
                test: [
                    /huawei/i
                ],
                describe: function(e) {
                    var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", i = {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Huawei"
                    };
                    return t && (i.model = t), i;
                }
            },
            {
                test: [
                    /nexus\s*(?:7|8|9|10).*/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /ipad/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /kftt build/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Amazon",
                        model: "Kindle Fire HD 7"
                    };
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Amazon"
                    };
                }
            },
            {
                test: [
                    /tablet(?! pc)/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function(e) {
                    var t = e.test(/ipod|iphone/i), i = e.test(/like (ipod|iphone)/i);
                    return t && !i;
                },
                describe: function(e) {
                    var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Apple",
                        model: t
                    };
                }
            },
            {
                test: [
                    /nexus\s*[0-6].*/i,
                    /galaxy nexus/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /[^-]mobi/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(e) {
                    return "blackberry" === e.getBrowserName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "BlackBerry"
                    };
                }
            },
            {
                test: function(e) {
                    return "bada" === e.getBrowserName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(e) {
                    return "windows phone" === e.getBrowserName();
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Microsoft"
                    };
                }
            },
            {
                test: function(e) {
                    var t = Number(String(e.getOSVersion()).split(".")[0]);
                    return "android" === e.getOSName(!0) && t >= 3;
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function(e) {
                    return "android" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(e) {
                    return "macos" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.desktop,
                        vendor: "Apple"
                    };
                }
            },
            {
                test: function(e) {
                    return "windows" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function(e) {
                    return "linux" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function(e) {
                    return "playstation 4" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tv
                    };
                }
            },
            {
                test: function(e) {
                    return "roku" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tv
                    };
                }
            }
        ];
        t.default = a, e.exports = t.default;
    },
    95: function(e, t, i) {
        "use strict";
        t.__esModule = !0, t.default = void 0;
        var r, n = (r = i(17)) && r.__esModule ? r : {
            default: r
        }, s = i(18), a = [
            {
                test: function(e) {
                    return "microsoft edge" === e.getBrowserName(!0);
                },
                describe: function(e) {
                    if (/\sedg\//i.test(e)) return {
                        name: s.ENGINE_MAP.Blink
                    };
                    var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                    return {
                        name: s.ENGINE_MAP.EdgeHTML,
                        version: t
                    };
                }
            },
            {
                test: [
                    /trident/i
                ],
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.Trident
                    }, i = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: function(e) {
                    return e.test(/presto/i);
                },
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.Presto
                    }, i = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: function(e) {
                    var t = e.test(/gecko/i), i = e.test(/like gecko/i);
                    return t && !i;
                },
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.Gecko
                    }, i = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            },
            {
                test: [
                    /(apple)?webkit\/537\.36/i
                ],
                describe: function() {
                    return {
                        name: s.ENGINE_MAP.Blink
                    };
                }
            },
            {
                test: [
                    /(apple)?webkit/i
                ],
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.WebKit
                    }, i = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                    return i && (t.version = i), t;
                }
            }
        ];
        t.default = a, e.exports = t.default;
    }
});
let $cdb872cfc8d057e0$var$Y = globalThis?.navigator?.userAgent ? (function(e) {
    return e && e.__esModule ? e.default : e;
})($cdb872cfc8d057e0$var$q).getParser(globalThis.navigator.userAgent) : null, $cdb872cfc8d057e0$var$K = (e)=>!!$cdb872cfc8d057e0$var$Y && ($cdb872cfc8d057e0$var$Y.satisfies(e) || !1), $cdb872cfc8d057e0$var$Q = {
    safari15OrHigher: $cdb872cfc8d057e0$var$K({
        safari: ">=15"
    }),
    firefox: $cdb872cfc8d057e0$var$K({
        firefox: ">0"
    }),
    safari: $cdb872cfc8d057e0$var$K({
        safari: ">0"
    }),
    chrome: $cdb872cfc8d057e0$var$K({
        chrome: ">0"
    }),
    edge: $cdb872cfc8d057e0$var$K({
        edge: ">0"
    })
}, $cdb872cfc8d057e0$var$Z = new WeakMap, $cdb872cfc8d057e0$var$J = {
    EMPTY: 0,
    IDLE: 1,
    LOADING: 2,
    NO_SOURCE: 3
}, $cdb872cfc8d057e0$var$X = {
    HAVE_NOTHING: 0,
    HAVE_METADATA: 1,
    HAVE_CURRENT_DATA: 2,
    HAVE_FUTURE_DATA: 3,
    HAVE_ENOUGH_DATA: 4
}, $cdb872cfc8d057e0$var$ee = (e, t)=>{
    let i = e.readyState === $cdb872cfc8d057e0$var$X.HAVE_NOTHING, r = e.networkState !== $cdb872cfc8d057e0$var$J.LOADING && e.networkState !== $cdb872cfc8d057e0$var$J.IDLE;
    if ($cdb872cfc8d057e0$var$Q.firefox && "play" === t && i && r) throw Error("Can not play audio");
}, $cdb872cfc8d057e0$var$et = (e, t)=>e instanceof HTMLMediaElement ? ($cdb872cfc8d057e0$var$ee(e, t), "function" == typeof t) ? t(e) : e[t]() : null, $cdb872cfc8d057e0$export$7f7f07871384d60f = (e, t)=>{
    let i = $cdb872cfc8d057e0$var$Z.get(e), r = i || Promise.resolve(), n = r.then(()=>{
        let i = $cdb872cfc8d057e0$var$et(e, t);
        return i?.then ? Promise.resolve(i) : new Promise((e)=>{
            setTimeout(()=>{
                e(i);
            }, 150);
        });
    }).then(()=>{
        $cdb872cfc8d057e0$var$Z.delete(e);
    }).catch((t)=>{
        throw $cdb872cfc8d057e0$var$Z.delete(e), t;
    });
    return $cdb872cfc8d057e0$var$Z.set(e, n), n;
};
let $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1 = class $0e423be0c289d786$export$900e53962f1f4ab1 {
    constructor(e){
        this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.VIDEO_START]: this._startVideo,
            [$cdb872cfc8d057e0$var$d.VIDEO_PAUSE]: this._pauseVideo,
            [$cdb872cfc8d057e0$var$d.VIDEO_RESET]: this._resetVideo,
            [$cdb872cfc8d057e0$var$d.RESTART]: this._restart,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this._destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - PlaybackController"), this._logger.info("Created"), this._logger.debug("Initial state", this._state), this.init();
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _startVideo() {
        let e = this._state.getState().videoElement;
        if (this._logger.verbose("Starting the video"), e) return e.playbackRate || (e.playbackRate = 1), this._logger.debug("Play call is added to the promises queue"), $cdb872cfc8d057e0$export$7f7f07871384d60f(e, "play").then(()=>{
            this._logger.debug("Play call resolved"), this._state.getState().canPlay && this._eventBus.publish($cdb872cfc8d057e0$var$d.PLAYING, {});
        }).catch((e)=>{
            this._state.setState({
                isAutoplayError: !0
            }), this._logger.error("An error occured when trying to play the video.", {
                error: e
            }), this._state.getState().canPlay && this._eventBus.publish($cdb872cfc8d057e0$var$d.PAUSED, {});
        });
    }
    _pauseVideo() {
        this._logger.debug("Pausing the video");
        let e = this._state.getState().videoElement;
        if (e) return this._logger.debug("Pause call is added to the promises queue"), $cdb872cfc8d057e0$export$7f7f07871384d60f(e, "pause").then(()=>{
            this._logger.debug("Pause call resolved");
        }).catch((e)=>{
            this._logger.warn("Could not pause video", e);
        });
    }
    _loadVideo() {
        this._logger.verbose("Loading the video");
        let e = this._state.getState().videoElement;
        if (e?.src && e.src.startsWith("blob")) {
            this._logger.debug("Stream seems to be blob. Skipping load");
            return;
        }
        if (e) return this._logger.debug("Load call is added to the promises queue"), $cdb872cfc8d057e0$export$7f7f07871384d60f(e, "load").then(()=>{
            this._logger.debug("Load call resolved");
        }).catch((e)=>{
            this._logger.warn("Could not load video", e);
        });
    }
    _resetVideo() {
        this._logger.verbose("Resetting the video");
        let e = this._state.getState().videoElement;
        e && (this._eventBus.publish($cdb872cfc8d057e0$var$d.LOADING, {}), this._loadVideo());
    }
    async _restart() {
        this._logger.verbose("Restarting the video"), await this._pauseVideo(), this._startVideo();
    }
    _destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_startVideo", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_pauseVideo", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_loadVideo", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_resetVideo", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_restart", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1.prototype, "_destroy", null);
let $cdb872cfc8d057e0$var$er = (e, t)=>{
    if (!t || t < 0) e.muted = !0, e.volume = 0;
    else {
        let i = Math.min(t, 1);
        isNaN(i) || (e.muted = !1, e.volume = i);
    }
}, $cdb872cfc8d057e0$var$en = (e)=>{
    e && e.parentNode && e.parentNode.removeChild(e);
}, $cdb872cfc8d057e0$var$es = `
  width: 100%;
`;
let $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9 = class $c148f595ba898186$export$ff45b5d0a0c535a9 {
    constructor(e){
        this._knownVideoElementStyles = "", this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.PLAYING]: this.startAnimationFrame,
            [$cdb872cfc8d057e0$var$d.LOADING]: this.cancelAnimationFrame,
            [$cdb872cfc8d057e0$var$d.REMOVE_MEDIA_STREAM]: this.cancelAnimationFrame
        }, this._applyStyles = ()=>{
            this._logger.debug("Apply styles for canvas and video elements");
            let { canvasElement: e , videoElement: t  } = this._getElements();
            e && t && (this._knownVideoElementStyles = t.style.cssText, e.style.cssText = $cdb872cfc8d057e0$var$es, t.style.cssText = `
      ${$cdb872cfc8d057e0$var$es}
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
    `);
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - CanvasVideoRenderer");
        let t = document.createElement("canvas");
        this._canvasContext = t.getContext("2d"), e.className && (t.className = e.className), this.init(), this._state.setState({
            canvasElement: t
        }), this._applyStyles(), this._logger.verbose("Canvas renderer has been created");
    }
    startAnimationFrame() {
        let { canvasElement: e , videoElement: t  } = this._getElements();
        if (this.cancelAnimationFrame(), !e || !t) return;
        let { width: i , height: r  } = e.getBoundingClientRect(), { videoWidth: n , videoHeight: s  } = t, a = i / r, o = n / s;
        if (a < 1 && o > 1) {
            let a = Math.max(i, n), o = s * (i / n), l = i > a ? (i - a) / 2 : 0, d = (r - o) / 2;
            if (this._canvasContext) {
                let t = devicePixelRatio;
                e.width = a * t, e.height = r * t, this._canvasContext.scale(t, t);
            }
            this._canvasContext?.drawImage(t, l, d, a, o);
        } else {
            let a = Math.max(r, s), o = n * (r / s), l = r > a ? (r - a) / 2 : 0, d = (i - o) / 2;
            if (this._canvasContext) {
                let t = devicePixelRatio;
                e.width = i * t, e.height = a * t, this._canvasContext.scale(t, t);
            }
            this._canvasContext?.drawImage(t, d, l, o, a);
        }
        this._state.getState().isLoading || (this._canvasAnimationFrameId = requestAnimationFrame(this.startAnimationFrame));
    }
    getCanvasElement() {
        return this._getElements().canvasElement;
    }
    destroy() {
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
        let { canvasElement: e , videoElement: t  } = this._getElements();
        e && e.parentNode && e.parentNode.removeChild(e), t && (t.style.cssText = this._knownVideoElementStyles, this._knownVideoElementStyles = ""), this._state.setState({
            canvasElement: null
        }), this._logger.verbose("Canvas renderer was destroyed");
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    cancelAnimationFrame() {
        this._canvasAnimationFrameId && (cancelAnimationFrame(this._canvasAnimationFrameId), this._canvasAnimationFrameId = null);
    }
    _getElements() {
        let { videoElement: e , canvasElement: t  } = this._state.getState();
        return {
            videoElement: e,
            canvasElement: t
        };
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "startAnimationFrame", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "destroy", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "cancelAnimationFrame", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9.prototype, "_getElements", null);
let $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de = class $bdd9a250938bedd7$export$61525c45d39f05de {
    constructor(e){
        this._canvasVideoRenderer = null, this._config = {}, this._isLocalVideo = !1, this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.SET_VOLUME]: this._setVolume,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this._destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - RenderController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._logger.debug("Initial state", this._state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e, this.applyConfigToVideoElement();
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    getElements() {
        let { videoElement: e , canvasElement: t , ownContainer: i  } = this._state.getState();
        return {
            videoElement: e,
            canvasElement: t,
            ownContainer: i
        };
    }
    getVideoElement() {
        return this.getElements().videoElement;
    }
    getCanvasElement() {
        return this.getElements().canvasElement;
    }
    renderVideoInto(e) {
        let { ownContainer: t , videoElement: i  } = this.getElements();
        this._logger.debug("renderVideoInto method was called");
        let r = !1;
        if (e && i) {
            let n = t || e;
            i.parentElement !== n && (r = !0, n.appendChild(i));
            let s = this._canvasVideoRenderer?.getCanvasElement();
            this._canvasVideoRenderer && s?.parentElement !== n && (r = !0, n.appendChild(s), this._logger.info("Canvas element has been rendered to DOM")), n === t && t.parentElement !== e && (r = !0, e.appendChild(t)), r ? this._logger.info("Video element has been rendered to DOM") : this._logger.verbose("Skipping video element render: video element is already mounted to the DOM.");
        }
    }
    setVideoElement(e, t) {
        if (this._logger.debug("Video element updated", {
            videoElement: e
        }), e === this.getVideoElement()) {
            this._logger.verbose("Received video element is equal to the previous one. Skipping");
            return;
        }
        this._isLocalVideo && (this._logger.verbose("Removing video element and container from document"), $cdb872cfc8d057e0$var$en(this.getElements().videoElement), $cdb872cfc8d057e0$var$en(this.getElements().ownContainer)), this._state.setState({
            videoElement: e,
            ownContainer: t
        }), this.applyConfigToVideoElement();
    }
    applyConfigToVideoElement() {
        if (this._logger.debug("Applying config to the video element"), !this.getVideoElement()) {
            this._logger.verbose("No video element known, could not apply config");
            return;
        }
        let e = this.getVideoElement();
        if (!e) return;
        let { isNonAnonymous: t , isMuted: i , nativeControls: r , videoElementClassName: n , canvasElementClassName: s , shouldUseCanvas: a , rootElement: o , autoplay: l  } = this._config;
        this._logger.verbose("Applied config", this._config), l && (e.autoplay = !0), e.playsInline = !0, void 0 !== r && (e.controls = !!r), void 0 !== i && (e.muted = !!i), void 0 !== t && (t ? e.removeAttribute("crossOrigin") : e.crossOrigin = "anonymous"), n && (e.className = n);
        let c = [
            this._state.getState().volume,
            this._config.volume
        ].find((e)=>void 0 !== e);
        if (void 0 !== c && this._setVolume({
            volume: c
        }), a && !this._canvasVideoRenderer && (this._logger.verbose("Adding canvas as requested"), this._addCanvasVideoRenderer(), this._state.getState().isPlaying && this._canvasVideoRenderer.startAnimationFrame()), !a && this._canvasVideoRenderer) {
            let e = this._state.getState().stream;
            this._logger.verbose("Removing canvas renderer"), e && this._eventBus.publish($cdb872cfc8d057e0$var$d.UPDATE_MEDIA_STREAM, e), this._destroyCanvasRenderer();
        }
        let u = this.getCanvasElement();
        u && (e.className = "", s && (u.className = s)), o && this.renderVideoInto(o);
    }
    destroy() {
        if (this._logger.info("Destroying"), this._destroyCanvasRenderer(), this._isLocalVideo) {
            this._logger.debug("Removing video element and container from document in destroy");
            let { videoElement: e , ownContainer: t  } = this.getElements();
            $cdb872cfc8d057e0$var$en(e), $cdb872cfc8d057e0$var$en(t);
        }
    }
    createVideoElement() {
        let e, t;
        this._logger.info("Creating video element"), this._config.videoElement ? (this._logger.debug("External video element passed from config - using existing one", this._config.videoElement), this._isLocalVideo = !1, e = this._config.videoElement) : (this._isLocalVideo = !0, e = document.createElement("video"), t = document.createElement("div"), this._logger.debug("No external video element provided in config - created the new one", {
            videoElement: e,
            ownContainer: t
        }), t.style.position = "relative"), this.setVideoElement(e, t), this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_ELEMENT_RECREATED, {
            videoElement: this.getVideoElement()
        });
    }
    _addCanvasVideoRenderer() {
        this._logger.debug("Adding canvas renderer"), this._canvasVideoRenderer || (this._canvasVideoRenderer = new $cdb872cfc8d057e0$var$$c148f595ba898186$export$ff45b5d0a0c535a9({
            videoElement: this.getVideoElement(),
            className: this._config.videoElementClassName,
            state: this._state,
            eventBus: this._eventBus
        }));
    }
    _destroyCanvasRenderer() {
        this._logger.debug("Destroying canvas renderer"), this._canvasVideoRenderer && (this._canvasVideoRenderer.destroy(), this._canvasVideoRenderer = null);
    }
    _setVolume({ volume: e  }) {
        let t = this.getVideoElement();
        t && ($cdb872cfc8d057e0$var$er(t, e), this._logger.verbose(`Video volume level has been set to ${e}`));
    }
    _destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "getElements", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "getVideoElement", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "getCanvasElement", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "renderVideoInto", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "setVideoElement", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "applyConfigToVideoElement", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "createVideoElement", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_addCanvasVideoRenderer", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_destroyCanvasRenderer", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_setVolume", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de.prototype, "_destroy", null);
let $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac = class $04304713e5d9da2c$export$9456d357203666ac {
    constructor(e){
        this._config = {}, this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.PLAYING]: this._handlePlaying,
            [$cdb872cfc8d057e0$var$d.LOADING]: this._handleLoading,
            [$cdb872cfc8d057e0$var$d.VIDEO_PAUSE]: this._handlePause,
            [$cdb872cfc8d057e0$var$d.CAN_PLAY]: this._handleCanPlay,
            [$cdb872cfc8d057e0$var$d.PAUSED]: this._handlePaused,
            [$cdb872cfc8d057e0$var$d.RESTART]: this._handleRestart,
            [$cdb872cfc8d057e0$var$d.UPDATED]: this._handleUpdate,
            [$cdb872cfc8d057e0$var$d.STALLED]: this._handleStalled,
            [$cdb872cfc8d057e0$var$d.WAITING]: this._handleWaiting,
            [$cdb872cfc8d057e0$var$d.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
            [$cdb872cfc8d057e0$var$d.ERROR]: this._handleError,
            [$cdb872cfc8d057e0$var$d.SET_VOLUME]: this._handleSetVolume,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this.destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - StateController"), this._logger.info("Created"), this._logger.verbose("Initial state", e.state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e;
    }
    destroy() {
        this._logger.info("Destroy"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        }), this._state.resetState(), this._state.setState({
            isDestroyed: !0
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _updateState(e) {
        let t = this._state.getState().videoPlaybackState, i = t;
        e.isPlaying ? i = $cdb872cfc8d057e0$export$af29ccb356acd9fc.PLAYING : e.isLoading ? i = $cdb872cfc8d057e0$export$af29ccb356acd9fc.LOADING : e.isPaused ? i = $cdb872cfc8d057e0$export$af29ccb356acd9fc.PAUSED : e.isError && (i = $cdb872cfc8d057e0$export$af29ccb356acd9fc.ERROR), this._logger.debug(`State updated: ${t} -> ${i}`), this._state.setState({
            ...e,
            videoPlaybackState: i
        }), t !== i && this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_PLAYBACK_STATE_CHANGED, {
            prevState: t,
            nextState: i
        });
    }
    _handlePlaying() {
        this._logger.debug("Playing event received"), this._updateState({
            isPlaying: !0,
            startedPlaying: !0,
            isLoading: !1,
            isStalled: !1,
            isWaiting: !1,
            isPaused: !1,
            isError: !1
        });
    }
    _handleLoading() {
        this._logger.debug("Loading event received"), this._updateState({
            isLoading: !0,
            isPlaying: !1
        });
    }
    _handlePause() {
        this._logger.debug("Pause event received"), this._updateState({
            isPlaying: !1,
            isPaused: !0
        });
    }
    _handlePaused() {
        this._logger.debug("Paused event received"), this._updateState({
            isPlaying: !1,
            isLoading: !1,
            isPaused: !0
        });
    }
    _handleCanPlay() {
        this._logger.debug("CanPlay event received"), this._updateState({
            canPlay: !0,
            isDestroyed: !1
        });
    }
    _handleRestart() {
        this._logger.debug("Restart event received"), this._updateState({
            isRestarted: !0
        });
    }
    _handleStalled() {
        this._logger.debug("Stalled event received"), this._updateState({
            isStalled: !0
        });
    }
    _handleWaiting() {
        this._logger.debug("Waiting event received"), this._updateState({
            isWaiting: !0
        });
    }
    _handleError() {
        this._logger.debug("Error event received"), this._updateState({
            isError: !0
        });
    }
    _handleSetVolume({ volume: e  }) {
        this._logger.debug("Volume event received", {
            volume: e
        }), this._updateState({
            volume: e
        });
    }
    _handleUpdatePlayerResolution(e) {
        this._logger.debug("Player resolution event received", {
            height: e.height,
            width: e.width
        }), this._updateState({
            videoElementResolution: {
                height: e.height,
                width: e.width
            }
        });
    }
    _handleUpdate() {
        this._logger.debug("Update event received"), this._updateState({
            canPlay: !1,
            isLoading: !0,
            isPlaying: !1,
            isRestarted: !1,
            isPaused: !1,
            isError: !1
        });
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "destroy", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_updateState", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handlePlaying", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleLoading", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handlePause", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handlePaused", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleCanPlay", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleRestart", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleStalled", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleWaiting", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleError", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleSetVolume", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleUpdatePlayerResolution", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac.prototype, "_handleUpdate", null);
let $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8 = class $fa81a3aa7a22efa4$export$450c54b9e8861ae8 {
    constructor(e){
        this._config = {}, this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.PLAYING]: this._cancelResetStream,
            [$cdb872cfc8d057e0$var$d.LOADING]: this._cancelResetStream,
            [$cdb872cfc8d057e0$var$d.LOADED]: this._cancelResetStream,
            [$cdb872cfc8d057e0$var$d.PAUSED]: this._cancelResetStream,
            [$cdb872cfc8d057e0$var$d.UPDATED]: this._cancelResetStream,
            [$cdb872cfc8d057e0$var$d.CANCEL_RESET_STREAM]: this._cancelResetStream,
            [$cdb872cfc8d057e0$var$d.STREAM_RESET]: this._resetStream,
            [$cdb872cfc8d057e0$var$d.UPDATE_MEDIA_STREAM]: this.updateMediaStream,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this.destroy
        }, this._getIsSrcObjectAvailable = ()=>this._props.getVideoElement()?.srcObject !== void 0, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - StreamController"), this._props = e, this._logger.info("Created"), this._logger.verbose("Initial state", e.state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e;
    }
    updateMediaStream(e) {
        this._logger.info("Updating media stream", {
            stream: e
        });
        let t = this._props.getVideoElement();
        if (!t) {
            this._logger.debug("No video element known. Skipping media stream update");
            return;
        }
        this._attachStream(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_START, {});
    }
    removeMediaStream() {
        this._logger.info("Removing media stream");
        let e = this._props.getVideoElement();
        if (!e) {
            this._logger.debug("No video element known. Skipping media stream remove");
            return;
        }
        this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_PAUSE, {}), this._eventBus.publish($cdb872cfc8d057e0$var$d.REMOVE_MEDIA_STREAM, {}), this._getIsSrcObjectAvailable() ? (this._logger.debug("Setting srcObject to null"), e.srcObject = null) : (this._logger.debug("Revoking object url", {
            url: e.src
        }), window.URL.revokeObjectURL(e.src)), e.src && (this._logger.debug("Removing src attribute from video"), e.removeAttribute("src"));
    }
    destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _attachStream(e) {
        this._logger.info("Attaching media stream", {
            stream: e
        });
        let t = this._props.getVideoElement();
        if (!t || !e) {
            this._logger.debug("No video element or stream defined. Skipping stream set");
            return;
        }
        if (t.src === e) {
            this._logger.debug("Current video element src attribute value is equal to the new stream. Skipping stream set");
            return;
        }
        "string" == typeof e ? (this._logger.debug("Setting video element src attribute"), t.src = e) : this._getIsSrcObjectAvailable() ? (this._logger.debug("Setting video element srcObject attribute"), t.srcObject = e) : (t.src = window.URL.createObjectURL(e), this._logger.debug(`Got MediaStream as stream, but srcObject is not available. Created new object URL: ${t.src}`));
    }
    _cancelResetStream() {
        this._logger.debug("Stream reset action cancel required"), this._streamResetDelayId && (clearTimeout(this._streamResetDelayId), this._logger.debug("Stream reset action cancelled"));
    }
    _resetStream({ timeout: e  }) {
        if (this._logger.debug("Reset stream required"), !e) {
            this._logger.verbose("No timeout set, skipping stream reset", {
                timeout: e
            });
            return;
        }
        this._cancelResetStream(), this._streamResetDelayId = setTimeout(()=>{
            this._logger.debug("Resetting stream timeout fired");
            let e = !1;
            this._config.onResetStream && (e = this._config.onResetStream());
            let t = this._state.getState().stream;
            if (t && !e) {
                if ("string" == typeof t && t.startsWith("blob")) {
                    this._logger.debug("Streams seems to be object url. Skipping reset");
                    return;
                }
                this._logger.debug("Resetting stream"), this.removeMediaStream(), this.updateMediaStream(t);
            }
        }, e);
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "updateMediaStream", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "removeMediaStream", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "destroy", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "_attachStream", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "_cancelResetStream", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8.prototype, "_resetStream", null);
var $cdb872cfc8d057e0$var$ea = function(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
}, $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$el = function() {
    return (0, $cdb872cfc8d057e0$var$eo.default).Date.now();
}, $cdb872cfc8d057e0$var$ed = /\s/, $cdb872cfc8d057e0$var$ec = function(e) {
    for(var t = e.length; t-- && $cdb872cfc8d057e0$var$ed.test(e.charAt(t)););
    return t;
}, $cdb872cfc8d057e0$var$eu = /^\s+/, $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$eh = $cdb872cfc8d057e0$var$eo.default.Symbol, $cdb872cfc8d057e0$var$eg = Object.prototype, $cdb872cfc8d057e0$var$ef = $cdb872cfc8d057e0$var$eg.hasOwnProperty, $cdb872cfc8d057e0$var$ep = $cdb872cfc8d057e0$var$eg.toString, $cdb872cfc8d057e0$var$e_ = $cdb872cfc8d057e0$var$eh ? $cdb872cfc8d057e0$var$eh.toStringTag : void 0, $cdb872cfc8d057e0$var$ev = function(e) {
    var t = $cdb872cfc8d057e0$var$ef.call(e, $cdb872cfc8d057e0$var$e_), i = e[$cdb872cfc8d057e0$var$e_];
    try {
        e[$cdb872cfc8d057e0$var$e_] = void 0;
        var r = !0;
    } catch (e) {}
    var n = $cdb872cfc8d057e0$var$ep.call(e);
    return r && (t ? e[$cdb872cfc8d057e0$var$e_] = i : delete e[$cdb872cfc8d057e0$var$e_]), n;
}, $cdb872cfc8d057e0$var$eb = Object.prototype.toString, $cdb872cfc8d057e0$var$em = $cdb872cfc8d057e0$var$eh ? $cdb872cfc8d057e0$var$eh.toStringTag : void 0, $cdb872cfc8d057e0$var$eE = function(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : $cdb872cfc8d057e0$var$em && $cdb872cfc8d057e0$var$em in Object(e) ? $cdb872cfc8d057e0$var$ev(e) : $cdb872cfc8d057e0$var$eb.call(e);
}, $cdb872cfc8d057e0$var$ey = function(e) {
    return null != e && "object" == typeof e;
}, $cdb872cfc8d057e0$var$eS = 0 / 0, $cdb872cfc8d057e0$var$e$ = /^[-+]0x[0-9a-f]+$/i, $cdb872cfc8d057e0$var$eA = /^0b[01]+$/i, $cdb872cfc8d057e0$var$ew = /^0o[0-7]+$/i, $cdb872cfc8d057e0$var$eC = parseInt, $cdb872cfc8d057e0$var$eT = function(e) {
    if ("number" == typeof e) return e;
    if ("symbol" == typeof (t = e) || $cdb872cfc8d057e0$var$ey(t) && "[object Symbol]" == $cdb872cfc8d057e0$var$eE(t)) return $cdb872cfc8d057e0$var$eS;
    if ($cdb872cfc8d057e0$var$ea(e)) {
        var t, i, r = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = $cdb872cfc8d057e0$var$ea(r) ? r + "" : r;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = (i = e) ? i.slice(0, $cdb872cfc8d057e0$var$ec(i) + 1).replace($cdb872cfc8d057e0$var$eu, "") : i;
    var n = $cdb872cfc8d057e0$var$eA.test(e);
    return n || $cdb872cfc8d057e0$var$ew.test(e) ? $cdb872cfc8d057e0$var$eC(e.slice(2), n ? 2 : 8) : $cdb872cfc8d057e0$var$e$.test(e) ? $cdb872cfc8d057e0$var$eS : +e;
}, $cdb872cfc8d057e0$var$eM = Math.max, $cdb872cfc8d057e0$var$eP = Math.min, $cdb872cfc8d057e0$var$eO = function(e, t, i) {
    var r, n, s, a, o, l, d = 0, c = !1, u = !1, h = !0;
    if ("function" != typeof e) throw TypeError("Expected a function");
    function g(t) {
        var i = r, s = n;
        return r = n = void 0, d = t, a = e.apply(s, i);
    }
    function f(e) {
        var i = e - l, r = e - d;
        return void 0 === l || i >= t || i < 0 || u && r >= s;
    }
    function p() {
        var e, i, r, n = $cdb872cfc8d057e0$var$el();
        if (f(n)) return _(n);
        o = setTimeout(p, (e = n - l, i = n - d, r = t - e, u ? $cdb872cfc8d057e0$var$eP(r, s - i) : r));
    }
    function _(e) {
        return (o = void 0, h && r) ? g(e) : (r = n = void 0, a);
    }
    function v() {
        var e, i = $cdb872cfc8d057e0$var$el(), s = f(i);
        if (r = arguments, n = this, l = i, s) {
            if (void 0 === o) return d = e = l, o = setTimeout(p, t), c ? g(e) : a;
            if (u) return clearTimeout(o), o = setTimeout(p, t), g(l);
        }
        return void 0 === o && (o = setTimeout(p, t)), a;
    }
    return t = $cdb872cfc8d057e0$var$eT(t) || 0, $cdb872cfc8d057e0$var$ea(i) && (c = !!i.leading, s = (u = "maxWait" in i) ? $cdb872cfc8d057e0$var$eM($cdb872cfc8d057e0$var$eT(i.maxWait) || 0, t) : s, h = "trailing" in i ? !!i.trailing : h), v.cancel = function() {
        void 0 !== o && clearTimeout(o), d = 0, r = l = n = o = void 0;
    }, v.flush = function() {
        return void 0 === o ? a : _($cdb872cfc8d057e0$var$el());
    }, v;
}, $cdb872cfc8d057e0$var$eR = function(e, t, i) {
    var r = !0, n = !0;
    if ("function" != typeof e) throw TypeError("Expected a function");
    return $cdb872cfc8d057e0$var$ea(i) && (r = "leading" in i ? !!i.leading : r, n = "trailing" in i ? !!i.trailing : n), $cdb872cfc8d057e0$var$eO(e, t, {
        leading: r,
        maxWait: t,
        trailing: n
    });
};
let $cdb872cfc8d057e0$var$ek = "ristrettoWasRestarted", $cdb872cfc8d057e0$var$ex = 0, $cdb872cfc8d057e0$var$eD = 0;
let $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9 = class $0b302ff0925c3ef2$export$25e21b090bbc69f9 {
    constructor(e){
        this._shouldSetNextUpdateVideoDurationId = !0, this._config = {}, this._onNativeTimeUpdateHandlerThrottled = $cdb872cfc8d057e0$var$eR(this._onNativeTimeUpdateHandler, 2e3, {
            trailing: !1
        }), this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.TIME_UPDATE_NATIVE]: this._onNativeTimeUpdateHandlerThrottled,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this._destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - TimeUpdateController"), this._props = e, this._logger.info("Created"), this._logger.debug("Initial state", e.state), this._logger.debug("Initial props", e);
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e);
        let t = e.timeoutUpdateStatusPlaying !== this._config.timeoutUpdateStatusPlaying;
        this._config = e, t && (this._eventsMap[$cdb872cfc8d057e0$var$d.TIME_UPDATE_NATIVE] = $cdb872cfc8d057e0$var$eR(this._onNativeTimeUpdateHandler, e.timeoutUpdateStatusPlaying, {
            trailing: !1
        }), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        }), this.init());
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    startTimeUpdate() {
        if (this._stopTimeUpdate(), !this._shouldSetNextUpdateVideoDurationId || !this._config) {
            this._shouldSetNextUpdateVideoDurationId = !0;
            return;
        }
        this._updateVideoDurationId = setTimeout(this._onTimeUpdate, this._config.timeoutUpdateVideoDuration), this._publishUpdatePlayerResolutionIfNeeded();
    }
    _onNativeTimeUpdateHandler(e) {
        if (this._logger.debug("Native video timeUpdate caught"), e?.originalEvent?.defaultPrevented) return;
        let t = this._props.getVideoElement(), { canPlay: i , isPlaying: r , isLoading: n , isRestarted: s  } = this._state.getState();
        if (this._publishUpdatePlayerResolutionIfNeeded(), !i) {
            this._logger.verbose("CanPlay shared state is false. Skipping");
            return;
        }
        this._eventBus.publish($cdb872cfc8d057e0$var$d.RESET_CHECKING_AUTOPLAY_COUNT, {});
        let a = $cdb872cfc8d057e0$var$ex !== t?.currentTime;
        this._logger.verbose(`Video current time is ${a ? "" : "not"} changed`), a ? (this._eventBus.publish($cdb872cfc8d057e0$var$d.CANCEL_RESET_STREAM, {}), !$cdb872cfc8d057e0$var$Q.safari15OrHigher || s || localStorage?.getItem($cdb872cfc8d057e0$var$ek) || (localStorage.setItem($cdb872cfc8d057e0$var$ek, "1"), this._eventBus.publish($cdb872cfc8d057e0$var$d.RESTART, {})), t && ($cdb872cfc8d057e0$var$ex = t.currentTime), (!r || n) && this._eventBus.publish($cdb872cfc8d057e0$var$d.PLAYING, {})) : n ? this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_RESET, {}) : this._eventBus.publish($cdb872cfc8d057e0$var$d.LOADING, {});
    }
    _stopTimeUpdate() {
        clearTimeout(this._updateVideoDurationId);
    }
    _onTimeUpdate() {
        if (!this._state.getState().canPlay) {
            this.startTimeUpdate();
            return;
        }
        let e = this._props.getVideoElement();
        e && $cdb872cfc8d057e0$var$eD !== e.currentTime && ($cdb872cfc8d057e0$var$eD = e.currentTime), this.startTimeUpdate();
    }
    _publishUpdatePlayerResolutionIfNeeded() {
        let e = this._props.getVideoElement();
        if (e) {
            let { videoWidth: t , videoHeight: i  } = e, { videoElementResolution: r  } = this._state.getState();
            (!r || r.height !== i || r.width !== t) && this._config.minimalPossibleVideoDimension && Math.min(i, t) > this._config.minimalPossibleVideoDimension && (this._logger.verbose(`Stored resolution is ${r?.width}x${r?.height}, current is ${t}x${i}`), this._eventBus.publish($cdb872cfc8d057e0$var$d.UPDATE_PLAYER_RESOLUTION, {
                width: t,
                height: i
            }));
        }
    }
    _destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        }), this._shouldSetNextUpdateVideoDurationId = !1, this._stopTimeUpdate();
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "startTimeUpdate", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_onNativeTimeUpdateHandler", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_stopTimeUpdate", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_onTimeUpdate", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_publishUpdatePlayerResolutionIfNeeded", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9.prototype, "_destroy", null);
let $cdb872cfc8d057e0$var$$12f7c2f2c1b55bfc$export$3a521cb24f143cc8 = class $12f7c2f2c1b55bfc$export$3a521cb24f143cc8 {
    constructor(e){
        this._config = {}, this._timeUpdateEventWasLogged = !1, this._eventsMap = {
            [$cdb872cfc8d057e0$var$d.VIDEO_ELEMENT_RECREATED]: this._handleVideoElementRecreated,
            [$cdb872cfc8d057e0$var$d.DESTROY]: this._handleDestroy
        }, this._onVideoClick = (e)=>{
            this._logger.verbose('"click" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.CLICK, {
                originalEvent: e
            });
        }, this._onSeeked = (e)=>{
            this._logger.verbose('"seeked" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.FORCE_PLAY_AFTER_PAUSE, {
                reason: "seeked video native event"
            });
        }, this._onRateChange = (e)=>{
            this._logger.verbose('"ratechange" video native event fired'), this._handleNativeEvent(e), e.target && !e.target.playbackRate && this._eventBus.publish($cdb872cfc8d057e0$var$d.FORCE_PLAY_AFTER_PAUSE, {
                reason: "video playbackRate is 0"
            });
        }, this._onCanPlayThrough = (e)=>{
            this._logger.verbose('"canplaythrough" video native event fired');
            let t = this._state.getState();
            this._handleNativeEvent(e), (t.isStalled || t.isWaiting) && this._eventBus.publish($cdb872cfc8d057e0$var$d.FORCE_PLAY_AFTER_PAUSE, {
                reason: "canplaythrough video native event fired, and video is in the state of either stalled or waiting"
            });
        }, this._onPlayingHandler = (e)=>{
            this._logger.verbose('"playing" video native event fired'), this._logger.info("Video has started playing"), this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.PLAYING, {
                isAutoplay: !this._state.getState().isAutoplayError
            });
        }, this._onAbortHandler = (e)=>{
            this._logger.verbose('"abort" video native event fired'), this._handleNativeEvent(e), e.defaultPrevented || this._eventBus.publish($cdb872cfc8d057e0$var$d.LOADING, {});
        }, this._onPauseHandler = (e)=>{
            this._logger.verbose('"pause" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_PAUSE, {}), this._eventBus.publish($cdb872cfc8d057e0$var$d.FORCE_PLAY_AFTER_PAUSE, {
                reason: "pause video event fired (most likely user paused the video manually)"
            });
        }, this._onCanPlayHandler = (e)=>{
            this._logger.verbose('"canplay" video native event fired'), this._handleNativeEvent(e), e.defaultPrevented || (this._state.setState({
                canPlay: !0
            }), this._eventBus.publish($cdb872cfc8d057e0$var$d.CAN_PLAY, {}));
        }, this._onErrorHandler = (e)=>{
            if (this._logger.error('"error" video native event fired', {
                error: e
            }), this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.ERROR, {
                originalEvent: e
            }), !e.defaultPrevented) {
                let { MEDIA_ERR_SRC_NOT_SUPPORTED: e  } = MediaError, t = this._props.getVideoElement()?.error, i = t?.code;
                i !== e && (this._logger.verbose("Video element error is not of MEDIA_ERR_SRC_NOT_SUPPORTED kind. Requesting reset"), this._eventBus.publish($cdb872cfc8d057e0$var$d.VIDEO_RESET, {}));
            }
        }, this._onTimeUpdateHandler = (e)=>{
            this._handleNativeEvent(e), this._timeUpdateEventWasLogged || (this._logger.verbose('"timeupdate" video native event fired for the first time'), this._timeUpdateEventWasLogged = !0), this._eventBus.publishSync($cdb872cfc8d057e0$var$d.TIME_UPDATE_NATIVE, {
                originalEvent: e
            });
        }, this._onLoadStartHandler = (e)=>{
            this._handleNativeEvent(e), this._logger.verbose('"loadstart" video native event fired');
            let { timeoutUpdateStream: t  } = this._config;
            this._eventBus.publish($cdb872cfc8d057e0$var$d.LOADING, {}), this._eventBus.publish($cdb872cfc8d057e0$var$d.STREAM_RESET, {
                reason: "onLoadStartHandler",
                timeout: t
            });
        }, this._onLoadedDataHandler = (e)=>{
            this._logger.verbose('"loadeddata" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.LOADED, {});
        }, this._onWaiting = (e)=>{
            this._logger.verbose('"waiting" video native event fired');
            let { timeoutWaitingStream: t  } = this._config;
            this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.WAITING, {}), this._eventBus.publish($cdb872cfc8d057e0$var$d.LOADING, {}), this._eventBus.publish($cdb872cfc8d057e0$var$d.STREAM_RESET, {
                reason: "onWaiting",
                timeout: t
            });
        }, this._onStalled = (e)=>{
            this._logger.verbose('"stalled" video native event fired');
            let { timeoutWaitingStream: t  } = this._config;
            this._handleNativeEvent(e), this._eventBus.publish($cdb872cfc8d057e0$var$d.STALLED, {}), this._eventBus.publish($cdb872cfc8d057e0$var$d.STREAM_RESET, {
                reason: "onStalled",
                timeout: t
            });
        }, this._onEndFullscreenHandler = (e)=>{
            this._handleNativeEvent(e);
        }, this._props = e, this._state = e.state, this._eventBus = e.eventBus, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoElementController - VideoEventsHandler"), this.init();
    }
    setConfig(e) {
        this._config = e;
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    toggleEvents(e, t) {
        let i = t || this._props.getVideoElement();
        if (!i) return;
        let r = "attach" === e ? "addEventListener" : "removeEventListener";
        i[r]("click", this._onVideoClick), i[r]("playing", this._onPlayingHandler), i[r]("abort", this._onAbortHandler), i[r]("pause", this._onPauseHandler), i[r]("canplay", this._onCanPlayHandler), i[r]("error", this._onErrorHandler), i[r]("timeupdate", this._onTimeUpdateHandler), i[r]("loadstart", this._onLoadStartHandler), i[r]("loadeddata", this._onLoadedDataHandler), i[r]("waiting", this._onWaiting), i[r]("stalled", this._onStalled), i[r]("canplaythrough", this._onCanPlayThrough), i[r]("seeked", this._onSeeked), i[r]("ratechange", this._onRateChange), i[r]("webkitendfullscreen", this._onEndFullscreenHandler), "addEventListener" === r ? this._logger.verbose("event listeners are ATTACHED to the video element") : this._logger.verbose("event listeners are DETACHED from the video element");
    }
    _handleVideoElementRecreated() {
        this.toggleEvents("attach");
    }
    _handleDestroy() {
        this.toggleEvents("detach"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    _handleNativeEvent(e) {
        this._eventBus.publishSync($cdb872cfc8d057e0$var$d.NATIVE_EVENT, {
            eventName: e.type,
            event: e
        });
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$12f7c2f2c1b55bfc$export$3a521cb24f143cc8.prototype, "init", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$12f7c2f2c1b55bfc$export$3a521cb24f143cc8.prototype, "_handleVideoElementRecreated", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$var$$12f7c2f2c1b55bfc$export$3a521cb24f143cc8.prototype, "_handleDestroy", null);
let $cdb872cfc8d057e0$var$eI = {
    canPlay: !1,
    isLoading: !0,
    isError: !1,
    isAutoplayError: !1,
    isPaused: !1,
    isPlaying: !1,
    isRestarted: !1,
    isStalled: !1,
    isWaiting: !1,
    isDestroyed: !1,
    videoPlaybackState: $cdb872cfc8d057e0$export$af29ccb356acd9fc.IDLE,
    startedPlaying: !1
};
let $cdb872cfc8d057e0$export$4d5c8163a511d38a = class $442b7bba03edb347$export$4d5c8163a511d38a {
    constructor(e){
        this._initState = {
            ...e
        }, this._state = {
            ...e
        };
    }
    setState(e, t) {
        Object.assign(this._state, e), t && t(this._state);
    }
    getState() {
        return this._state;
    }
    resetState() {
        this.setState(this._initState);
    }
};
let $cdb872cfc8d057e0$export$6dab3502ba426410 = class $4ec065df5e9ead04$export$6dab3502ba426410 {
    constructor(){
        this._config = {
            ...$cdb872cfc8d057e0$var$j.videoElementControllerConfig
        }, this.attachVideoElementEvents = ()=>{
            this._logger.debug("Attach event listeners"), this._eventsHandler.toggleEvents("attach"), this._timeUpdateController.startTimeUpdate();
        }, this.detachVideoElementEvents = (e)=>{
            this._logger.debug("Detach event listeners"), this._eventsHandler.toggleEvents("detach", e);
        }, this._updated = ()=>{
            this._eventBus.publish($cdb872cfc8d057e0$var$d.UPDATED, {});
        }, this._eventBus = new $cdb872cfc8d057e0$export$5087227eb54526, this._loggerTransport = new $cdb872cfc8d057e0$export$8734a8c908553955(this._eventBus), this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "VideoController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._createControllers();
    }
    addEventListener(e, t) {
        this._logger.verbose(`Attaching ${e} event listener`), this._customEventsEmitter.addEventListener(e, t);
    }
    removeEventListener(e, t) {
        this._logger.verbose(`Detaching ${e} event listener`), this._customEventsEmitter.removeEventListener(e, t);
    }
    getIsPlaying() {
        return this._state.getState().isPlaying;
    }
    getVideoElement() {
        return this._state.getState().videoElement;
    }
    getCanvasElement() {
        return this._state.getState().canvasElement;
    }
    updateConfig(e) {
        this._config = {
            ...this._config,
            ...e
        }, this._logger.debug("Config update received, the new one: ", this._config), e.isRemote && this.attachVideoElementEvents(), this._syncConfig();
    }
    setVideoElement(e) {
        let t = this._state.getState().videoElement;
        e !== t && (t && this.detachVideoElementEvents(t), this._logger.info("Video element set", {
            videoElement: e
        }), this._renderController.setVideoElement(e), this.attachVideoElementEvents());
    }
    createVideoElement() {
        return this._logger.info("Creating video element"), this._renderController.createVideoElement(), this.getVideoElement();
    }
    setStream(e) {
        this._logger.info("Setting media stream");
        let t = this._state.getState().stream;
        if (t === e) {
            this._logger.verbose("Previous stream is equal to the new one. Skipping.");
            return;
        }
        return e ? this._streamController.updateMediaStream(e) : this._streamController.removeMediaStream(), this._updated(), this._state.setState({
            stream: e
        }), this;
    }
    renderVideoInto(e) {
        this._logger.info("Rendering video element into container", e), this._renderController.renderVideoInto(e);
    }
    setVolume(e) {
        this._logger.info("Setting volume of the video element", {
            volume: e
        }), this._eventBus.publish($cdb872cfc8d057e0$var$d.SET_VOLUME, {
            volume: e
        });
    }
    getState() {
        return this._state.getState();
    }
    destroy() {
        this._logger.info("Destroying"), this._config = {
            ...$cdb872cfc8d057e0$var$j.videoElementControllerConfig
        }, this.detachVideoElementEvents(), this._streamController.removeMediaStream(), this._renderController.destroy(), this._eventBus.publishSync($cdb872cfc8d057e0$var$d.DESTROY, {}), this._logger.info("VideoElementController was destroyed"), this._loggerTransport?.destroy();
    }
    reinit() {
        this._logger.info("Reinit requested"), [
            this._autoplayController,
            this._customEventsEmitter,
            this._playbackController,
            this._streamController,
            this._stateController,
            this._timeUpdateController,
            this._renderController,
            this._eventsHandler
        ].forEach((e)=>{
            e && e.init();
        }), this.attachVideoElementEvents(), this._logger.info("VideoElementController was reinited");
    }
    setLoggerLevels(e, t = [], i = []) {
        this._logger.info("Setting new log level", {
            levels: e
        }), this._loggerTransport && (this._loggerTransport.destroy(), this._loggerTransport = null), e.length && (this._loggerTransport = new $cdb872cfc8d057e0$export$8734a8c908553955(this._eventBus, e, t, i));
    }
    _syncConfig() {
        this._logger.verbose("Sycronizing configs across all controllers"), this._autoplayController?.setConfig(this._config), this._eventsHandler.setConfig(this._config), this._streamController.setConfig(this._config), this._timeUpdateController.setConfig(this._config), this._renderController.setConfig(this._config), this._stateController.setConfig(this._config);
    }
    _createControllers() {
        this._logger.verbose("Creating all controllers"), this._state = new $cdb872cfc8d057e0$export$4d5c8163a511d38a($cdb872cfc8d057e0$var$eI);
        let e = {
            getVideoElement: this.getVideoElement,
            state: this._state,
            eventBus: this._eventBus
        };
        this._autoplayController = new $cdb872cfc8d057e0$var$$13e0e8c55e207599$export$a9a0b55bc0093be5(e), this._customEventsEmitter = new $cdb872cfc8d057e0$var$$b8fa44c52cf48ebe$export$17bfd6b0f11e369b(e), this._eventsHandler = new $cdb872cfc8d057e0$var$$12f7c2f2c1b55bfc$export$3a521cb24f143cc8(e), this._playbackController = new $cdb872cfc8d057e0$var$$0e423be0c289d786$export$900e53962f1f4ab1(e), this._streamController = new $cdb872cfc8d057e0$var$$fa81a3aa7a22efa4$export$450c54b9e8861ae8(e), this._stateController = new $cdb872cfc8d057e0$var$$04304713e5d9da2c$export$9456d357203666ac(e), this._timeUpdateController = new $cdb872cfc8d057e0$var$$0b302ff0925c3ef2$export$25e21b090bbc69f9(e), this._renderController = new $cdb872cfc8d057e0$var$$bdd9a250938bedd7$export$61525c45d39f05de(e), this._logger.verbose("Controllers created");
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$6dab3502ba426410.prototype, "addEventListener", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$6dab3502ba426410.prototype, "removeEventListener", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$6dab3502ba426410.prototype, "getIsPlaying", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$6dab3502ba426410.prototype, "getVideoElement", null), $cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$6dab3502ba426410.prototype, "getCanvasElement", null), function(e) {
    e[e.FATAL = 0] = "FATAL", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e[e.VERBOSE = 5] = "VERBOSE";
}($cdb872cfc8d057e0$export$559043f40a876a16 || ($cdb872cfc8d057e0$export$559043f40a876a16 = {}));
let $cdb872cfc8d057e0$var$eN = {
    fatal: $cdb872cfc8d057e0$export$559043f40a876a16.FATAL,
    error: $cdb872cfc8d057e0$export$559043f40a876a16.ERROR,
    warn: $cdb872cfc8d057e0$export$559043f40a876a16.WARN,
    info: $cdb872cfc8d057e0$export$559043f40a876a16.INFO,
    debug: $cdb872cfc8d057e0$export$559043f40a876a16.DEBUG,
    verbose: $cdb872cfc8d057e0$export$559043f40a876a16.VERBOSE
}, $cdb872cfc8d057e0$export$16884720e2f7a4b7 = (e)=>"number" == typeof e ? e : $cdb872cfc8d057e0$var$eN[e], $cdb872cfc8d057e0$export$2fd275ff363b1e1d = {
    [$cdb872cfc8d057e0$export$559043f40a876a16.FATAL]: "Fatal",
    [$cdb872cfc8d057e0$export$559043f40a876a16.WARN]: "Warning",
    [$cdb872cfc8d057e0$export$559043f40a876a16.ERROR]: "Error",
    [$cdb872cfc8d057e0$export$559043f40a876a16.INFO]: "Info",
    [$cdb872cfc8d057e0$export$559043f40a876a16.DEBUG]: "Debug",
    [$cdb872cfc8d057e0$export$559043f40a876a16.VERBOSE]: "Verbose"
}, $cdb872cfc8d057e0$export$d9d573f04653e528 = [
    "verbose",
    "debug",
    "info",
    "warn",
    "error",
    "fatal"
], $cdb872cfc8d057e0$var$eU = (e)=>{
    e && (e.getTracks().forEach((t)=>{
        t.stop(), e.removeTrack(t);
    }), e.stop && e.stop());
};
let $cdb872cfc8d057e0$var$$613a7139a60aac41$export$877ea3cc9a274bb = class $613a7139a60aac41$export$877ea3cc9a274bb {
    get fakeTrack() {
        return this._audioStream || this._initFakeStream(), this._statPlaying(), this._audioStream?.getAudioTracks()[0];
    }
    stopFakeStream() {
        this._audioStream && (this._oscillator?.stop(), this._oscillator = null, $cdb872cfc8d057e0$var$eU(this._audioStream), this._audioStream = null, this._audioContext?.close(), this._audioContext = null);
    }
    _statPlaying() {
        let e = this._audioContext?.createOscillator();
        this._dest && (e?.connect(this._dest), e?.start());
    }
    _initFakeStream() {
        this._audioStream && this.stopFakeStream(), this._audioContext = new AudioContext, this._dest = this._audioContext.createMediaStreamDestination(), this._audioStream = this._dest.stream;
    }
    constructor(){
        this._oscillator = null;
    }
};
let $cdb872cfc8d057e0$var$$24c3ce4f408c0760$export$eb5c6c5031f2bd43 = class $24c3ce4f408c0760$export$eb5c6c5031f2bd43 {
    get fakeTrack() {
        return this._canvasStream || this._initFakeStream(), this._statPlaying(), this._canvasStream?.getVideoTracks()[0];
    }
    stopFakeStream() {
        this._canvasStream && (null !== this._drawIntervalId && (clearInterval(this._drawIntervalId), this._drawIntervalId = null), $cdb872cfc8d057e0$var$eU(this._canvasStream), this._canvasStream = null, this._canvasDomElement?.parentElement && (this._canvasDomElement.remove(), this._canvasDomElement = null));
    }
    _statPlaying() {
        if (!this._canvasDomElement) return;
        let e = this._canvasDomElement.getContext("2d");
        e && (this._drawIntervalId = setInterval(()=>{
            e.fillStyle = `rgb(${255 * Math.random()},0,0)`, e?.fillRect(0, 0, 1, 1);
            let t = this._canvasStream?.getVideoTracks()[0];
            t.requestFrame();
        }, 1e3 / 30));
    }
    _initFakeStream() {
        this._canvasStream && this.stopFakeStream(), this._canvasDomElement = document.createElement("canvas"), this._canvasDomElement.width = 240, this._canvasDomElement.height = 240, this._canvasStream = this._canvasDomElement.captureStream(29);
    }
};
!function(e) {
    e[e.MEDIA_DEVICES_UPDATED = 0] = "MEDIA_DEVICES_UPDATED";
}($cdb872cfc8d057e0$export$1f8aff248f4faedf || ($cdb872cfc8d057e0$export$1f8aff248f4faedf = {}));
var $cdb872cfc8d057e0$var$eF = function(e, t) {
    return e === t || e != e && t != t;
}, $cdb872cfc8d057e0$var$ej = function(e, t) {
    for(var i = e.length; i--;)if ($cdb872cfc8d057e0$var$eF(e[i][0], t)) return i;
    return -1;
}, $cdb872cfc8d057e0$var$eG = Array.prototype.splice;
function $cdb872cfc8d057e0$var$eH(e) {
    var t = -1, i = null == e ? 0 : e.length;
    for(this.clear(); ++t < i;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
$cdb872cfc8d057e0$var$eH.prototype.clear = function() {
    this.__data__ = [], this.size = 0;
}, $cdb872cfc8d057e0$var$eH.prototype.delete = function(e) {
    var t = this.__data__, i = $cdb872cfc8d057e0$var$ej(t, e);
    return !(i < 0) && (i == t.length - 1 ? t.pop() : $cdb872cfc8d057e0$var$eG.call(t, i, 1), --this.size, !0);
}, $cdb872cfc8d057e0$var$eH.prototype.get = function(e) {
    var t = this.__data__, i = $cdb872cfc8d057e0$var$ej(t, e);
    return i < 0 ? void 0 : t[i][1];
}, $cdb872cfc8d057e0$var$eH.prototype.has = function(e) {
    return $cdb872cfc8d057e0$var$ej(this.__data__, e) > -1;
}, $cdb872cfc8d057e0$var$eH.prototype.set = function(e, t) {
    var i = this.__data__, r = $cdb872cfc8d057e0$var$ej(i, e);
    return r < 0 ? (++this.size, i.push([
        e,
        t
    ])) : i[r][1] = t, this;
};
var $cdb872cfc8d057e0$var$eW = function(e) {
    if (!$cdb872cfc8d057e0$var$ea(e)) return !1;
    var t = $cdb872cfc8d057e0$var$eE(e);
    return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}, $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$ez = $cdb872cfc8d057e0$var$eo.default["__core-js_shared__"], $cdb872cfc8d057e0$var$eq = function() {
    var e = /[^.]+$/.exec($cdb872cfc8d057e0$var$ez && $cdb872cfc8d057e0$var$ez.keys && $cdb872cfc8d057e0$var$ez.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
}(), $cdb872cfc8d057e0$var$eY = Function.prototype.toString, $cdb872cfc8d057e0$var$eK = function(e) {
    if (null != e) {
        try {
            return $cdb872cfc8d057e0$var$eY.call(e);
        } catch (e) {}
        try {
            return e + "";
        } catch (e) {}
    }
    return "";
}, $cdb872cfc8d057e0$var$eQ = /^\[object .+?Constructor\]$/, $cdb872cfc8d057e0$var$eZ = Object.prototype, $cdb872cfc8d057e0$var$eJ = Function.prototype.toString, $cdb872cfc8d057e0$var$eX = $cdb872cfc8d057e0$var$eZ.hasOwnProperty, $cdb872cfc8d057e0$var$e0 = RegExp("^" + $cdb872cfc8d057e0$var$eJ.call($cdb872cfc8d057e0$var$eX).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), $cdb872cfc8d057e0$var$e1 = function(e) {
    return !(!$cdb872cfc8d057e0$var$ea(e) || $cdb872cfc8d057e0$var$eq && $cdb872cfc8d057e0$var$eq in e) && ($cdb872cfc8d057e0$var$eW(e) ? $cdb872cfc8d057e0$var$e0 : $cdb872cfc8d057e0$var$eQ).test($cdb872cfc8d057e0$var$eK(e));
}, $cdb872cfc8d057e0$var$e5 = function(e, t) {
    var i = null == e ? void 0 : e[t];
    return $cdb872cfc8d057e0$var$e1(i) ? i : void 0;
}, $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$e2 = $cdb872cfc8d057e0$var$e5($cdb872cfc8d057e0$var$eo.default, "Map"), $cdb872cfc8d057e0$var$e4 = $cdb872cfc8d057e0$var$e5(Object, "create"), $cdb872cfc8d057e0$var$e3 = Object.prototype.hasOwnProperty, $cdb872cfc8d057e0$var$e9 = Object.prototype.hasOwnProperty;
function $cdb872cfc8d057e0$var$e8(e) {
    var t = -1, i = null == e ? 0 : e.length;
    for(this.clear(); ++t < i;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
$cdb872cfc8d057e0$var$e8.prototype.clear = function() {
    this.__data__ = $cdb872cfc8d057e0$var$e4 ? $cdb872cfc8d057e0$var$e4(null) : {}, this.size = 0;
}, $cdb872cfc8d057e0$var$e8.prototype.delete = function(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
}, $cdb872cfc8d057e0$var$e8.prototype.get = function(e) {
    var t = this.__data__;
    if ($cdb872cfc8d057e0$var$e4) {
        var i = t[e];
        return "__lodash_hash_undefined__" === i ? void 0 : i;
    }
    return $cdb872cfc8d057e0$var$e3.call(t, e) ? t[e] : void 0;
}, $cdb872cfc8d057e0$var$e8.prototype.has = function(e) {
    var t = this.__data__;
    return $cdb872cfc8d057e0$var$e4 ? void 0 !== t[e] : $cdb872cfc8d057e0$var$e9.call(t, e);
}, $cdb872cfc8d057e0$var$e8.prototype.set = function(e, t) {
    var i = this.__data__;
    return this.size += this.has(e) ? 0 : 1, i[e] = $cdb872cfc8d057e0$var$e4 && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
var $cdb872cfc8d057e0$var$e6 = function(e) {
    var t = typeof e;
    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
}, $cdb872cfc8d057e0$var$e7 = function(e, t) {
    var i = e.__data__;
    return $cdb872cfc8d057e0$var$e6(t) ? i["string" == typeof t ? "string" : "hash"] : i.map;
};
function $cdb872cfc8d057e0$var$te(e) {
    var t = -1, i = null == e ? 0 : e.length;
    for(this.clear(); ++t < i;){
        var r = e[t];
        this.set(r[0], r[1]);
    }
}
function $cdb872cfc8d057e0$var$tt(e) {
    var t = this.__data__ = new $cdb872cfc8d057e0$var$eH(e);
    this.size = t.size;
}
function $cdb872cfc8d057e0$var$ti(e) {
    var t = -1, i = null == e ? 0 : e.length;
    for(this.__data__ = new $cdb872cfc8d057e0$var$te; ++t < i;)this.add(e[t]);
}
$cdb872cfc8d057e0$var$te.prototype.clear = function() {
    this.size = 0, this.__data__ = {
        hash: new $cdb872cfc8d057e0$var$e8,
        map: new ($cdb872cfc8d057e0$var$e2 || $cdb872cfc8d057e0$var$eH),
        string: new $cdb872cfc8d057e0$var$e8
    };
}, $cdb872cfc8d057e0$var$te.prototype.delete = function(e) {
    var t = $cdb872cfc8d057e0$var$e7(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
}, $cdb872cfc8d057e0$var$te.prototype.get = function(e) {
    return $cdb872cfc8d057e0$var$e7(this, e).get(e);
}, $cdb872cfc8d057e0$var$te.prototype.has = function(e) {
    return $cdb872cfc8d057e0$var$e7(this, e).has(e);
}, $cdb872cfc8d057e0$var$te.prototype.set = function(e, t) {
    var i = $cdb872cfc8d057e0$var$e7(this, e), r = i.size;
    return i.set(e, t), this.size += i.size == r ? 0 : 1, this;
}, $cdb872cfc8d057e0$var$tt.prototype.clear = function() {
    this.__data__ = new $cdb872cfc8d057e0$var$eH, this.size = 0;
}, $cdb872cfc8d057e0$var$tt.prototype.delete = function(e) {
    var t = this.__data__, i = t.delete(e);
    return this.size = t.size, i;
}, $cdb872cfc8d057e0$var$tt.prototype.get = function(e) {
    return this.__data__.get(e);
}, $cdb872cfc8d057e0$var$tt.prototype.has = function(e) {
    return this.__data__.has(e);
}, $cdb872cfc8d057e0$var$tt.prototype.set = function(e, t) {
    var i = this.__data__;
    if (i instanceof $cdb872cfc8d057e0$var$eH) {
        var r = i.__data__;
        if (!$cdb872cfc8d057e0$var$e2 || r.length < 199) return r.push([
            e,
            t
        ]), this.size = ++i.size, this;
        i = this.__data__ = new $cdb872cfc8d057e0$var$te(r);
    }
    return i.set(e, t), this.size = i.size, this;
}, $cdb872cfc8d057e0$var$ti.prototype.add = $cdb872cfc8d057e0$var$ti.prototype.push = function(e) {
    return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, $cdb872cfc8d057e0$var$ti.prototype.has = function(e) {
    return this.__data__.has(e);
};
var $cdb872cfc8d057e0$var$tr = function(e, t) {
    for(var i = -1, r = null == e ? 0 : e.length; ++i < r;)if (t(e[i], i, e)) return !0;
    return !1;
}, $cdb872cfc8d057e0$var$tn = function(e, t, i, r, n, s) {
    var a = 1 & i, o = e.length, l = t.length;
    if (o != l && !(a && l > o)) return !1;
    var d = s.get(e), c = s.get(t);
    if (d && c) return d == t && c == e;
    var u = -1, h = !0, g = 2 & i ? new $cdb872cfc8d057e0$var$ti : void 0;
    for(s.set(e, t), s.set(t, e); ++u < o;){
        var f = e[u], p = t[u];
        if (r) var _ = a ? r(p, f, u, t, e, s) : r(f, p, u, e, t, s);
        if (void 0 !== _) {
            if (_) continue;
            h = !1;
            break;
        }
        if (g) {
            if (!$cdb872cfc8d057e0$var$tr(t, function(e, t) {
                if (!g.has(t) && (f === e || n(f, e, i, r, s))) return g.push(t);
            })) {
                h = !1;
                break;
            }
        } else if (!(f === p || n(f, p, i, r, s))) {
            h = !1;
            break;
        }
    }
    return s.delete(e), s.delete(t), h;
}, $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$ts = $cdb872cfc8d057e0$var$eo.default.Uint8Array, $cdb872cfc8d057e0$var$ta = function(e) {
    var t = -1, i = Array(e.size);
    return e.forEach(function(e, r) {
        i[++t] = [
            r,
            e
        ];
    }), i;
}, $cdb872cfc8d057e0$var$to = function(e) {
    var t = -1, i = Array(e.size);
    return e.forEach(function(e) {
        i[++t] = e;
    }), i;
}, $cdb872cfc8d057e0$var$tl = $cdb872cfc8d057e0$var$eh ? $cdb872cfc8d057e0$var$eh.prototype : void 0, $cdb872cfc8d057e0$var$td = $cdb872cfc8d057e0$var$tl ? $cdb872cfc8d057e0$var$tl.valueOf : void 0, $cdb872cfc8d057e0$var$tc = function(e, t, i, r, n, s, a) {
    switch(i){
        case "[object DataView]":
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) break;
            e = e.buffer, t = t.buffer;
        case "[object ArrayBuffer]":
            if (e.byteLength != t.byteLength || !s(new $cdb872cfc8d057e0$var$ts(e), new $cdb872cfc8d057e0$var$ts(t))) break;
            return !0;
        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
            return $cdb872cfc8d057e0$var$eF(+e, +t);
        case "[object Error]":
            return e.name == t.name && e.message == t.message;
        case "[object RegExp]":
        case "[object String]":
            return e == t + "";
        case "[object Map]":
            var o = $cdb872cfc8d057e0$var$ta;
        case "[object Set]":
            var l = 1 & r;
            if (o || (o = $cdb872cfc8d057e0$var$to), e.size != t.size && !l) break;
            var d = a.get(e);
            if (d) return d == t;
            r |= 2, a.set(e, t);
            var c = $cdb872cfc8d057e0$var$tn(o(e), o(t), r, n, s, a);
            return a.delete(e), c;
        case "[object Symbol]":
            if ($cdb872cfc8d057e0$var$td) return $cdb872cfc8d057e0$var$td.call(e) == $cdb872cfc8d057e0$var$td.call(t);
    }
    return !1;
}, $cdb872cfc8d057e0$var$tu = function(e, t) {
    for(var i = -1, r = t.length, n = e.length; ++i < r;)e[n + i] = t[i];
    return e;
}, $cdb872cfc8d057e0$var$th = Array.isArray, $cdb872cfc8d057e0$var$tg = function(e, t, i) {
    var r = t(e);
    return $cdb872cfc8d057e0$var$th(e) ? r : $cdb872cfc8d057e0$var$tu(r, i(e));
}, $cdb872cfc8d057e0$var$tf = function(e, t) {
    for(var i = -1, r = null == e ? 0 : e.length, n = 0, s = []; ++i < r;){
        var a = e[i];
        t(a, i, e) && (s[n++] = a);
    }
    return s;
}, $cdb872cfc8d057e0$var$tp = Object.prototype.propertyIsEnumerable, $cdb872cfc8d057e0$var$t_ = Object.getOwnPropertySymbols, $cdb872cfc8d057e0$var$tv = $cdb872cfc8d057e0$var$t_ ? function(e) {
    return null == e ? [] : $cdb872cfc8d057e0$var$tf($cdb872cfc8d057e0$var$t_(e = Object(e)), function(t) {
        return $cdb872cfc8d057e0$var$tp.call(e, t);
    });
} : function() {
    return [];
}, $cdb872cfc8d057e0$var$tb = function(e, t) {
    for(var i = -1, r = Array(e); ++i < e;)r[i] = t(i);
    return r;
}, $cdb872cfc8d057e0$var$tm = function(e) {
    return $cdb872cfc8d057e0$var$ey(e) && "[object Arguments]" == $cdb872cfc8d057e0$var$eE(e);
}, $cdb872cfc8d057e0$var$tE = Object.prototype, $cdb872cfc8d057e0$var$ty = $cdb872cfc8d057e0$var$tE.hasOwnProperty, $cdb872cfc8d057e0$var$tS = $cdb872cfc8d057e0$var$tE.propertyIsEnumerable, $cdb872cfc8d057e0$var$t$ = $cdb872cfc8d057e0$var$tm(function() {
    return arguments;
}()) ? $cdb872cfc8d057e0$var$tm : function(e) {
    return $cdb872cfc8d057e0$var$ey(e) && $cdb872cfc8d057e0$var$ty.call(e, "callee") && !$cdb872cfc8d057e0$var$tS.call(e, "callee");
}, $cdb872cfc8d057e0$var$tA = $cdb872cfc8d057e0$var$b("iuHwr"), $cdb872cfc8d057e0$var$tw = /^(?:0|[1-9]\d*)$/, $cdb872cfc8d057e0$var$tC = function(e, t) {
    var i = typeof e;
    return !!(t = null == t ? 9007199254740991 : t) && ("number" == i || "symbol" != i && $cdb872cfc8d057e0$var$tw.test(e)) && e > -1 && e % 1 == 0 && e < t;
}, $cdb872cfc8d057e0$var$tT = function(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}, $cdb872cfc8d057e0$var$tM = {};
$cdb872cfc8d057e0$var$tM["[object Float32Array]"] = $cdb872cfc8d057e0$var$tM["[object Float64Array]"] = $cdb872cfc8d057e0$var$tM["[object Int8Array]"] = $cdb872cfc8d057e0$var$tM["[object Int16Array]"] = $cdb872cfc8d057e0$var$tM["[object Int32Array]"] = $cdb872cfc8d057e0$var$tM["[object Uint8Array]"] = $cdb872cfc8d057e0$var$tM["[object Uint8ClampedArray]"] = $cdb872cfc8d057e0$var$tM["[object Uint16Array]"] = $cdb872cfc8d057e0$var$tM["[object Uint32Array]"] = !0, $cdb872cfc8d057e0$var$tM["[object Arguments]"] = $cdb872cfc8d057e0$var$tM["[object Array]"] = $cdb872cfc8d057e0$var$tM["[object ArrayBuffer]"] = $cdb872cfc8d057e0$var$tM["[object Boolean]"] = $cdb872cfc8d057e0$var$tM["[object DataView]"] = $cdb872cfc8d057e0$var$tM["[object Date]"] = $cdb872cfc8d057e0$var$tM["[object Error]"] = $cdb872cfc8d057e0$var$tM["[object Function]"] = $cdb872cfc8d057e0$var$tM["[object Map]"] = $cdb872cfc8d057e0$var$tM["[object Number]"] = $cdb872cfc8d057e0$var$tM["[object Object]"] = $cdb872cfc8d057e0$var$tM["[object RegExp]"] = $cdb872cfc8d057e0$var$tM["[object Set]"] = $cdb872cfc8d057e0$var$tM["[object String]"] = $cdb872cfc8d057e0$var$tM["[object WeakMap]"] = !1;
var $cdb872cfc8d057e0$var$tP = $cdb872cfc8d057e0$var$b("8tO4H"), $cdb872cfc8d057e0$var$tO = $cdb872cfc8d057e0$var$tP.default && $cdb872cfc8d057e0$var$tP.default.isTypedArray, $cdb872cfc8d057e0$var$tR = $cdb872cfc8d057e0$var$tO ? function(e) {
    return $cdb872cfc8d057e0$var$tO(e);
} : function(e) {
    return $cdb872cfc8d057e0$var$ey(e) && $cdb872cfc8d057e0$var$tT(e.length) && !!$cdb872cfc8d057e0$var$tM[$cdb872cfc8d057e0$var$eE(e)];
}, $cdb872cfc8d057e0$var$tk = Object.prototype.hasOwnProperty, $cdb872cfc8d057e0$var$tx = function(e, t) {
    var i = $cdb872cfc8d057e0$var$th(e), r = !i && $cdb872cfc8d057e0$var$t$(e), n = !i && !r && (0, $cdb872cfc8d057e0$var$tA.default)(e), s = !i && !r && !n && $cdb872cfc8d057e0$var$tR(e), a = i || r || n || s, o = a ? $cdb872cfc8d057e0$var$tb(e.length, String) : [], l = o.length;
    for(var d in e)(t || $cdb872cfc8d057e0$var$tk.call(e, d)) && !(a && ("length" == d || n && ("offset" == d || "parent" == d) || s && ("buffer" == d || "byteLength" == d || "byteOffset" == d) || $cdb872cfc8d057e0$var$tC(d, l))) && o.push(d);
    return o;
}, $cdb872cfc8d057e0$var$tD = Object.prototype, $cdb872cfc8d057e0$var$tI = function(e) {
    var t = e && e.constructor, i = "function" == typeof t && t.prototype || $cdb872cfc8d057e0$var$tD;
    return e === i;
}, $cdb872cfc8d057e0$var$tN = ($cdb872cfc8d057e0$var$t = Object.keys, $cdb872cfc8d057e0$var$i = Object, function(e) {
    return $cdb872cfc8d057e0$var$t($cdb872cfc8d057e0$var$i(e));
}), $cdb872cfc8d057e0$var$tV = Object.prototype.hasOwnProperty, $cdb872cfc8d057e0$var$tB = function(e) {
    if (!$cdb872cfc8d057e0$var$tI(e)) return $cdb872cfc8d057e0$var$tN(e);
    var t = [];
    for(var i in Object(e))$cdb872cfc8d057e0$var$tV.call(e, i) && "constructor" != i && t.push(i);
    return t;
}, $cdb872cfc8d057e0$var$tL = function(e) {
    return null != e && $cdb872cfc8d057e0$var$tT(e.length) && !$cdb872cfc8d057e0$var$eW(e) ? $cdb872cfc8d057e0$var$tx(e) : $cdb872cfc8d057e0$var$tB(e);
}, $cdb872cfc8d057e0$var$tU = function(e) {
    return $cdb872cfc8d057e0$var$tg(e, $cdb872cfc8d057e0$var$tL, $cdb872cfc8d057e0$var$tv);
}, $cdb872cfc8d057e0$var$tF = Object.prototype.hasOwnProperty, $cdb872cfc8d057e0$var$tj = function(e, t, i, r, n, s) {
    var a = 1 & i, o = $cdb872cfc8d057e0$var$tU(e), l = o.length;
    if (l != $cdb872cfc8d057e0$var$tU(t).length && !a) return !1;
    for(var d = l; d--;){
        var c = o[d];
        if (!(a ? c in t : $cdb872cfc8d057e0$var$tF.call(t, c))) return !1;
    }
    var u = s.get(e), h = s.get(t);
    if (u && h) return u == t && h == e;
    var g = !0;
    s.set(e, t), s.set(t, e);
    for(var f = a; ++d < l;){
        var p = e[c = o[d]], _ = t[c];
        if (r) var v = a ? r(_, p, c, t, e, s) : r(p, _, c, e, t, s);
        if (!(void 0 === v ? p === _ || n(p, _, i, r, s) : v)) {
            g = !1;
            break;
        }
        f || (f = "constructor" == c);
    }
    if (g && !f) {
        var b = e.constructor, m = t.constructor;
        b != m && "constructor" in e && "constructor" in t && !("function" == typeof b && b instanceof b && "function" == typeof m && m instanceof m) && (g = !1);
    }
    return s.delete(e), s.delete(t), g;
}, $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$tG = $cdb872cfc8d057e0$var$e5($cdb872cfc8d057e0$var$eo.default, "DataView"), $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$tH = $cdb872cfc8d057e0$var$e5($cdb872cfc8d057e0$var$eo.default, "Promise"), $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$tW = $cdb872cfc8d057e0$var$e5($cdb872cfc8d057e0$var$eo.default, "Set"), $cdb872cfc8d057e0$var$eo = $cdb872cfc8d057e0$var$b("iCUkT"), $cdb872cfc8d057e0$var$tz = $cdb872cfc8d057e0$var$e5($cdb872cfc8d057e0$var$eo.default, "WeakMap"), $cdb872cfc8d057e0$var$tq = "[object Map]", $cdb872cfc8d057e0$var$tY = "[object Promise]", $cdb872cfc8d057e0$var$tK = "[object Set]", $cdb872cfc8d057e0$var$tQ = "[object WeakMap]", $cdb872cfc8d057e0$var$tZ = "[object DataView]", $cdb872cfc8d057e0$var$tJ = $cdb872cfc8d057e0$var$eK($cdb872cfc8d057e0$var$tG), $cdb872cfc8d057e0$var$tX = $cdb872cfc8d057e0$var$eK($cdb872cfc8d057e0$var$e2), $cdb872cfc8d057e0$var$t0 = $cdb872cfc8d057e0$var$eK($cdb872cfc8d057e0$var$tH), $cdb872cfc8d057e0$var$t1 = $cdb872cfc8d057e0$var$eK($cdb872cfc8d057e0$var$tW), $cdb872cfc8d057e0$var$t5 = $cdb872cfc8d057e0$var$eK($cdb872cfc8d057e0$var$tz), $cdb872cfc8d057e0$var$t2 = $cdb872cfc8d057e0$var$eE;
($cdb872cfc8d057e0$var$tG && $cdb872cfc8d057e0$var$t2(new $cdb872cfc8d057e0$var$tG(new ArrayBuffer(1))) != $cdb872cfc8d057e0$var$tZ || $cdb872cfc8d057e0$var$e2 && $cdb872cfc8d057e0$var$t2(new $cdb872cfc8d057e0$var$e2) != $cdb872cfc8d057e0$var$tq || $cdb872cfc8d057e0$var$tH && $cdb872cfc8d057e0$var$t2($cdb872cfc8d057e0$var$tH.resolve()) != $cdb872cfc8d057e0$var$tY || $cdb872cfc8d057e0$var$tW && $cdb872cfc8d057e0$var$t2(new $cdb872cfc8d057e0$var$tW) != $cdb872cfc8d057e0$var$tK || $cdb872cfc8d057e0$var$tz && $cdb872cfc8d057e0$var$t2(new $cdb872cfc8d057e0$var$tz) != $cdb872cfc8d057e0$var$tQ) && ($cdb872cfc8d057e0$var$t2 = function(e) {
    var t = $cdb872cfc8d057e0$var$eE(e), i = "[object Object]" == t ? e.constructor : void 0, r = i ? $cdb872cfc8d057e0$var$eK(i) : "";
    if (r) switch(r){
        case $cdb872cfc8d057e0$var$tJ:
            return $cdb872cfc8d057e0$var$tZ;
        case $cdb872cfc8d057e0$var$tX:
            return $cdb872cfc8d057e0$var$tq;
        case $cdb872cfc8d057e0$var$t0:
            return $cdb872cfc8d057e0$var$tY;
        case $cdb872cfc8d057e0$var$t1:
            return $cdb872cfc8d057e0$var$tK;
        case $cdb872cfc8d057e0$var$t5:
            return $cdb872cfc8d057e0$var$tQ;
    }
    return t;
});
var $cdb872cfc8d057e0$var$t4 = $cdb872cfc8d057e0$var$t2, $cdb872cfc8d057e0$var$tA = $cdb872cfc8d057e0$var$b("iuHwr"), $cdb872cfc8d057e0$var$t3 = "[object Arguments]", $cdb872cfc8d057e0$var$t9 = "[object Array]", $cdb872cfc8d057e0$var$t8 = "[object Object]", $cdb872cfc8d057e0$var$t6 = Object.prototype.hasOwnProperty, $cdb872cfc8d057e0$var$t7 = function(e, t, i, r, n, s) {
    var a = $cdb872cfc8d057e0$var$th(e), o = $cdb872cfc8d057e0$var$th(t), l = a ? $cdb872cfc8d057e0$var$t9 : $cdb872cfc8d057e0$var$t4(e), d = o ? $cdb872cfc8d057e0$var$t9 : $cdb872cfc8d057e0$var$t4(t);
    l = l == $cdb872cfc8d057e0$var$t3 ? $cdb872cfc8d057e0$var$t8 : l, d = d == $cdb872cfc8d057e0$var$t3 ? $cdb872cfc8d057e0$var$t8 : d;
    var c = l == $cdb872cfc8d057e0$var$t8, u = d == $cdb872cfc8d057e0$var$t8, h = l == d;
    if (h && (0, $cdb872cfc8d057e0$var$tA.default)(e)) {
        if (!(0, $cdb872cfc8d057e0$var$tA.default)(t)) return !1;
        a = !0, c = !1;
    }
    if (h && !c) return s || (s = new $cdb872cfc8d057e0$var$tt), a || $cdb872cfc8d057e0$var$tR(e) ? $cdb872cfc8d057e0$var$tn(e, t, i, r, n, s) : $cdb872cfc8d057e0$var$tc(e, t, l, i, r, n, s);
    if (!(1 & i)) {
        var g = c && $cdb872cfc8d057e0$var$t6.call(e, "__wrapped__"), f = u && $cdb872cfc8d057e0$var$t6.call(t, "__wrapped__");
        if (g || f) {
            var p = g ? e.value() : e, _ = f ? t.value() : t;
            return s || (s = new $cdb872cfc8d057e0$var$tt), n(p, _, i, r, s);
        }
    }
    return !!h && (s || (s = new $cdb872cfc8d057e0$var$tt), $cdb872cfc8d057e0$var$tj(e, t, i, r, n, s));
};
let $cdb872cfc8d057e0$var$ie = {
    H264: "H264/90000",
    VP8: "VP8/90000",
    VP9: "VP9/90000",
    OPUS: "opus/48000"
}, $cdb872cfc8d057e0$var$it = /a=rtpmap:\d+\s/, $cdb872cfc8d057e0$var$ii = ({ sdp: e  })=>{
    if (!e) return [];
    let t = e.split(/\r?\n/), i = t.filter((e)=>e.match($cdb872cfc8d057e0$var$it));
    return [
        ...new Set(i.map((e)=>e.replace($cdb872cfc8d057e0$var$it, "")))
    ];
}, $cdb872cfc8d057e0$var$ir = async (e, t)=>{
    try {
        let i = "play" === e ? "recvonly" : "sendonly", r = $cdb872cfc8d057e0$var$is(), n = new r({
            iceServers: []
        });
        n.addTransceiver && (n.addTransceiver("audio", {
            direction: i
        }), n.addTransceiver("video", {
            direction: i
        }));
        let s = await n.createOffer({}), a = $cdb872cfc8d057e0$var$ii(s);
        return n.close(), t.filter((e)=>a.includes(e));
    } catch (e) {
        return [];
    }
}, $cdb872cfc8d057e0$var$is = ()=>window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection, $cdb872cfc8d057e0$var$ia = ()=>window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate, $cdb872cfc8d057e0$var$io = ()=>window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription, $cdb872cfc8d057e0$var$il = ()=>{
    let e = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices) || navigator.getUserMedia && $cdb872cfc8d057e0$var$k(navigator.getUserMedia.bind(navigator)) || navigator.webkitGetUserMedia && $cdb872cfc8d057e0$var$k(navigator.webkitGetUserMedia.bind(navigator)) || navigator.mozGetUserMedia && $cdb872cfc8d057e0$var$k(navigator.mozGetUserMedia.bind(navigator));
    return (t)=>e.call(navigator, t);
}, $cdb872cfc8d057e0$var$id = async ()=>{
    let e = await $cdb872cfc8d057e0$var$ir("play", [
        $cdb872cfc8d057e0$var$ie.H264,
        $cdb872cfc8d057e0$var$ie.VP8
    ]);
    return e.some((e)=>[
            $cdb872cfc8d057e0$var$ie.H264,
            $cdb872cfc8d057e0$var$ie.VP8
        ].includes(e));
}, $cdb872cfc8d057e0$var$ic = async ()=>{
    let e = await $cdb872cfc8d057e0$var$ir("broadcast", [
        $cdb872cfc8d057e0$var$ie.H264,
        $cdb872cfc8d057e0$var$ie.VP8
    ]);
    return e.some((e)=>[
            $cdb872cfc8d057e0$var$ie.H264,
            $cdb872cfc8d057e0$var$ie.VP8
        ].includes(e));
}, $cdb872cfc8d057e0$export$a6560a2ba6ceb992 = {
    getIsWebRTCApiSupported: ()=>!!($cdb872cfc8d057e0$var$is() && $cdb872cfc8d057e0$var$ia() && $cdb872cfc8d057e0$var$io()),
    resolveGetUserMedia: $cdb872cfc8d057e0$var$il,
    resolveRTCPeerConnection: $cdb872cfc8d057e0$var$is,
    resolveRTCIceCandidate: $cdb872cfc8d057e0$var$ia,
    resolveRTCSessionDescription: $cdb872cfc8d057e0$var$io,
    isH264BroadcastSupported: $cdb872cfc8d057e0$var$ic,
    isH264PlayingSupported: $cdb872cfc8d057e0$var$id
}, $cdb872cfc8d057e0$var$ih = (e)=>{
    if (!e) return !1;
    if ("boolean" == typeof e) return e;
    if (e.deviceId) {
        let t = $cdb872cfc8d057e0$var$Q.safari ? e.deviceId : {
            exact: e.deviceId
        };
        return {
            deviceId: t,
            channelCount: 2
        };
    }
    return !1;
}, $cdb872cfc8d057e0$var$ig = (e, t)=>{
    if (!e) return !1;
    if ("boolean" == typeof e) return !0;
    let i = e.width && e.height ? Number(e.width) / Number(e.height) : t.baseAspectRatio, r = {};
    if (e.frameRate && (r.frameRate = {
        ideal: e.frameRate,
        min: 15
    }), e.facingMode) {
        let t = navigator.mediaDevices.getSupportedConstraints();
        t.facingMode && (r.facingMode = {
            exact: e.facingMode
        });
    }
    return e.width && (r.width = {
        ideal: e.width
    }), e.height && (r.height = {
        ideal: e.height
    }), e.width && e.height && i && (r.aspectRatio = i), e.deviceId && (r.deviceId = $cdb872cfc8d057e0$var$Q.safari ? e.deviceId : {
        exact: e.deviceId
    }), e.width && e.height && !r.facingMode && (r.advanced = [
        {
            width: {
                min: e.width - t.sizeThreshold,
                max: e.width + t.sizeThreshold
            },
            height: {
                min: e.height - t.sizeThreshold,
                max: e.height + t.sizeThreshold
            }
        },
        {
            aspectRatio: i
        }
    ]), 0 !== Object.keys(r).length && r;
};
!function(e) {
    e.VIDEO_INPUT = "videoinput", e.AUDIO_INPUT = "audioinput", e.AUDIO_OUTPUT = "audiooutput";
}($cdb872cfc8d057e0$var$h || ($cdb872cfc8d057e0$var$h = {}));
let $cdb872cfc8d057e0$var$ip = (e, t)=>e.filter((e)=>e.kind === t), $cdb872cfc8d057e0$var$i_ = async ()=>{
    let e = await navigator.mediaDevices.enumerateDevices();
    return {
        audioInputs: $cdb872cfc8d057e0$var$ip(e, $cdb872cfc8d057e0$var$h.AUDIO_INPUT),
        audioOutputs: $cdb872cfc8d057e0$var$ip(e, $cdb872cfc8d057e0$var$h.AUDIO_OUTPUT),
        videoInputs: $cdb872cfc8d057e0$var$ip(e, $cdb872cfc8d057e0$var$h.VIDEO_INPUT)
    };
};
!function(e) {
    e.SYSTEM_PERMISSION_DENIED = "SystemPermissionDenied", e.USER_PERMISSION_DENIED = "UserPermissionDenied", e.COULD_NOT_START_VIDEO_SOURCE = "CouldNotStartVideoSource", e.GENERIC = "Generic";
}($cdb872cfc8d057e0$var$g || ($cdb872cfc8d057e0$var$g = {}));
let $cdb872cfc8d057e0$var$iv = async (e)=>new Promise((t, i)=>{
        navigator.mediaDevices.getUserMedia(e ?? {
            audio: !0,
            video: !0
        }).then((e)=>{
            e.getTracks().forEach((e)=>{
                e.stop();
            }), t(!0);
        }).catch((e)=>{
            let t = e.name, r = e.message, n = $cdb872cfc8d057e0$var$g.GENERIC;
            $cdb872cfc8d057e0$var$Q.chrome ? "NotAllowedError" === t ? "Permission denied by system" === r ? n = $cdb872cfc8d057e0$var$g.SYSTEM_PERMISSION_DENIED : "Permission denied" === r && (n = $cdb872cfc8d057e0$var$g.USER_PERMISSION_DENIED) : "NotReadableError" === t && (n = $cdb872cfc8d057e0$var$g.COULD_NOT_START_VIDEO_SOURCE) : $cdb872cfc8d057e0$var$Q.safari ? "NotAllowedError" === t && (n = $cdb872cfc8d057e0$var$g.USER_PERMISSION_DENIED) : $cdb872cfc8d057e0$var$Q.edge ? "NotAllowedError" === t ? n = $cdb872cfc8d057e0$var$g.USER_PERMISSION_DENIED : "NotReadableError" === t && (n = $cdb872cfc8d057e0$var$g.COULD_NOT_START_VIDEO_SOURCE) : $cdb872cfc8d057e0$var$Q.firefox && ("NotFoundError" === t ? n = $cdb872cfc8d057e0$var$g.SYSTEM_PERMISSION_DENIED : "NotReadableError" === t ? n = $cdb872cfc8d057e0$var$g.SYSTEM_PERMISSION_DENIED : "NotAllowedError" === t ? n = $cdb872cfc8d057e0$var$g.USER_PERMISSION_DENIED : "AbortError" === t && (n = $cdb872cfc8d057e0$var$g.COULD_NOT_START_VIDEO_SOURCE)), i({
                type: n,
                name: e.name,
                message: e.message
            });
        });
    });
!function(e) {
    e.LIVE = "live", e.ENDED = "ended";
}($cdb872cfc8d057e0$var$f || ($cdb872cfc8d057e0$var$f = {}));
let $cdb872cfc8d057e0$var$ib = (e)=>{
    if (!e) return !0;
    let { muted: t , enabled: i , readyState: r  } = e;
    return t || !i || r === $cdb872cfc8d057e0$var$f.ENDED;
}, $cdb872cfc8d057e0$var$im = (e)=>!e.active || e.getTracks().every($cdb872cfc8d057e0$var$ib);
let $cdb872cfc8d057e0$export$187d60d76727d102 = class $bf3f4aeafb4efc61$export$187d60d76727d102 extends $cdb872cfc8d057e0$export$493b9b82400bc18 {
    constructor(){
        super(), this._currentMediaStream = null, this._mediaCheckCache = null, this._allowedDevice = {
            audioinput: void 0,
            videoinput: void 0
        }, this._mediaDevices = null, this._fakeVideoTrack = null, this._fakeAudioTrack = null, this._eventBus = new $cdb872cfc8d057e0$export$5087227eb54526, this._logger = $cdb872cfc8d057e0$export$efa9a398d6368992(this._eventBus, "UserMedia"), this._loggerTransport = new $cdb872cfc8d057e0$export$8734a8c908553955(this._eventBus), this._logger.info("Created"), navigator.mediaDevices.addEventListener("devicechange", this._onDevicesChanged);
    }
    destroy() {
        navigator.mediaDevices.removeEventListener("devicechange", this._onDevicesChanged), this._logger.info("Destroyed"), this._stopCurrentStream();
    }
    async requestPermissions(e) {
        if (this._logger.info("Requesting permissions"), this._mediaCheckCache && function e(t, i, r, n, s) {
            return t === i || (null != t && null != i && ($cdb872cfc8d057e0$var$ey(t) || $cdb872cfc8d057e0$var$ey(i)) ? $cdb872cfc8d057e0$var$t7(t, i, r, n, e, s) : t != t && i != i);
        }(e, this._cachedRequestedDevices)) return this._logger.debug("Has previous check results cached. Returning it"), this._logger.info("Check results", {
            ...this._mediaCheckCache
        }), this._mediaCheckCache;
        let t = e || {
            video: !0,
            audio: !0
        };
        try {
            return this._logger.verbose("Request both video and audio permissions"), await $cdb872cfc8d057e0$var$iv(t), this._cachedRequestedDevices = e, await this._findAllowedDevices(t), this._logger.debug("No exceptions thrown while checking permissions. Saving both as available in cache"), this._mediaCheckCache = {
                video: {
                    isAvailable: !0,
                    error: null
                },
                audio: {
                    isAvailable: !0,
                    error: null
                },
                allowedDevices: this._allowedDevice
            }, this._logger.info("Check results", {
                ...this._mediaCheckCache
            }), this._mediaCheckCache;
        } catch (i) {
            this._logger.debug("Got an exception while checking both audio and video permissions. Checking them individually", {
                exception: i.toString()
            });
            let t = {
                video: {
                    isAvailable: !1,
                    error: null
                },
                audio: {
                    isAvailable: !1,
                    error: null
                },
                allowedDevices: this._allowedDevice
            };
            return e?.audio && (t.audio = await this._checkKindPermissions({
                video: !1,
                audio: !0
            }), this._logger.verbose(`Audio permissions result: ${t.audio.isAvailable}`)), e?.video && (t.video = await this._checkKindPermissions({
                video: !0,
                audio: !1
            }), this._logger.verbose(`Video permissions result: ${t.video.isAvailable}`)), this._mediaCheckCache = t, this._logger.debug("Got individual check results", {
                ...t
            }), this._logger.info("Check results", {
                ...this._mediaCheckCache
            }), this._mediaCheckCache;
        }
    }
    async getVideoDevices() {
        this._logger.info("Getting video devices list");
        let e = await this._getMediaDevices();
        return this._logger.info("Got video devices", e), e.videoInputs;
    }
    async getAudioInputDevices() {
        this._logger.info("Getting audio input devices list");
        let e = await this._getMediaDevices();
        return this._logger.info("Got audio input devices", e), e.audioInputs;
    }
    async getAudioOutputDevices() {
        this._logger.info("Getting audio output devices list");
        let e = await this._getMediaDevices();
        return this._logger.info("Got audio output devices", e), e.audioOutputs;
    }
    async getMediaStream(e, t, i) {
        this._logger.info("Getting media stream", {
            constraints: e,
            defaults: t
        });
        let r = {};
        if (e.audio && (this._logger.debug("Audio constraints are specified in requested constraints. Mapping it"), r.audio = $cdb872cfc8d057e0$var$ih(e.audio), this._logger.debug("Audio constraints mapped", {
            constraints: r.audio
        })), e.video && (this._logger.debug("Video constraints are specified in requested constraints. Mapping it"), r.video = $cdb872cfc8d057e0$var$ig(e.video, t), this._logger.debug("Video constraints mapped", {
            constraints: r.video
        })), this._logger.info("Final constraints for media stream", {
            mappedConstraints: r
        }), !this._currentMediaStream) {
            this._logger.debug("No current media stream known. Creating new stream");
            let e = await this._createNewStream(r, i);
            return this._logger.info("Media stream is ready", {
                mediaStream: e
            }), e;
        }
        let n = !$cdb872cfc8d057e0$var$im(this._currentMediaStream.stream);
        if (n && await this._isCurrentStreamSatisfiesConstraints(r)) return this._logger.debug("Current stream is active and satisfies constraints. Returning cached one"), this._logger.info("Media stream is ready", {
            mediaStream: this._currentMediaStream.stream
        }), this._currentMediaStream.stream;
        this._logger.debug(`Current stream ${n ? "does not satisfies constraints" : "is inactive"}. Creating new stream`), await this._stopCurrentStream();
        let s = await this._createNewStream(r);
        return this._logger.info("Media stream is ready", {
            mediaStream: s
        }), s;
    }
    async _stopCurrentStream() {
        if (this._logger.debug("Stopping current media stream"), !this._currentMediaStream) {
            this._logger.verbose("No current stream known. Skipping");
            return;
        }
        this._stopFakeStreams(), await $cdb872cfc8d057e0$var$eU(this._currentMediaStream.stream), this._currentMediaStream = null;
    }
    async _findAllowedDevices(e) {
        let t;
        try {
            t = await navigator.mediaDevices.getUserMedia({
                audio: e?.audio,
                video: e?.video
            });
            let i = new Set(t.getTracks().map((e)=>e.getSettings().deviceId)), r = await navigator.mediaDevices.enumerateDevices();
            return r.forEach((e)=>{
                let t = i.has(e.deviceId);
                t && ("videoinput" === e.kind || "audioinput" === e.kind) && (this._allowedDevice[e.kind] = e.deviceId);
            }), this._allowedDevice;
        } catch (e) {
            return this._allowedDevice;
        } finally{
            t && $cdb872cfc8d057e0$var$eU(t);
        }
    }
    async _checkKindPermissions(e) {
        this._logger.debug("Checking kind permissions", {
            constraints: e
        });
        let t = {
            isAvailable: !1,
            error: null
        };
        try {
            this._logger.verbose("Requesting media permissions for constraints", {
                constraints: e
            }), t.isAvailable = await $cdb872cfc8d057e0$var$iv(e), this._logger.verbose("Successfully got permissions for constraints", {
                constraints: e
            });
        } catch (i) {
            this._logger.verbose("Could not get permissions for constraints", {
                constraints: e,
                error: i
            }), t.isAvailable = !1, t.error = i;
        }
        return this._logger.debug("Final result of permissions check", {
            constraints: e,
            checkResults: t
        }), t;
    }
    async _getMediaStream(e) {
        this._logger.debug("Getting media stream with constraints", {
            constraints: e
        });
        let t = $cdb872cfc8d057e0$var$il(), i = await t(e);
        return this._currentMediaStream = {
            constraints: e,
            stream: i
        }, this._logger.debug("Resulting media stream", {
            mediaStream: this._currentMediaStream.stream
        }), this._currentMediaStream.stream;
    }
    async _createNewStream(e, t) {
        this._logger.debug("Creating new media stream with constraints", {
            constraints: e
        });
        try {
            let i = await this._getMediaStream(e);
            return this._appendFakeTracks(i, t), i;
        } catch (t) {
            if (this._logger.warn("Got an error while creating new media stream", {
                error: t,
                constraints: e
            }), "OverconstrainedError" === t.name && "deviceId" === t.constraint) {
                this._logger.verbose("Trying to get stream with no audio deviceId specified");
                let t = {
                    ...e,
                    audio: !0
                };
                return await this._getMediaStream(t);
            }
            throw t;
        }
    }
    _appendFakeTracks(e, t) {
        if (t?.useVideoFakeTrack && 0 === e.getVideoTracks().length) {
            this._fakeVideoTrack = new $cdb872cfc8d057e0$var$$24c3ce4f408c0760$export$eb5c6c5031f2bd43;
            let t = this._fakeVideoTrack?.fakeTrack;
            t && e.addTrack(t);
        }
        if (t?.useAudioFakeTrack && 0 === e.getAudioTracks().length) {
            this._fakeAudioTrack = new $cdb872cfc8d057e0$var$$613a7139a60aac41$export$877ea3cc9a274bb;
            let t = this._fakeAudioTrack?.fakeTrack;
            t && e.addTrack(t);
        }
    }
    _stopFakeStreams() {
        let e = this._fakeVideoTrack?.fakeTrack, t = this._fakeAudioTrack?.fakeTrack;
        e && (this._currentMediaStream?.stream.removeTrack(e), this._fakeVideoTrack?.stopFakeStream()), t && (this._currentMediaStream?.stream.removeTrack(t), this._fakeAudioTrack?.stopFakeStream());
    }
    async _getMediaDevices() {
        return (this._logger.verbose("Getting media devices"), this._mediaDevices) ? (this._logger.verbose("Has media devices in cache, returning them", {
            devices: this._mediaDevices
        }), this._mediaDevices) : (this._mediaDevices = await $cdb872cfc8d057e0$var$i_(), this._mediaDevices);
    }
    async _isCurrentStreamSatisfiesConstraints(e) {
        if (this._logger.debug("Checking if current media stream satisfies constraints", {
            constraints: e,
            mediaStream: this._currentMediaStream
        }), !this._currentMediaStream) return this._logger.verbose("No current media stream available"), !1;
        try {
            if (e.video) {
                this._logger.verbose("Checking video track constraints");
                let t = this._currentMediaStream.stream.getVideoTracks()[0];
                if (!t && e.video) return this._logger.verbose("No video track in media stream and constraints has video"), !1;
                if (t && !e.video) return this._logger.verbose("There is video track in media stream and constraints has no video"), !1;
                if ("object" == typeof e.video && e.video.deviceId && t.getCapabilities().deviceId !== e.video.deviceId) return this._logger.verbose("Constraints has video device ID and it not matches current device id"), !1;
                t && "boolean" != typeof e.video && (this._logger.verbose("Trying to apply new constraints for video"), await t.applyConstraints(e.video));
            }
        } catch (e) {
            return this._logger.debug("Could not apply constraints or get capabilities of video track", {
                error: e
            }), !1;
        }
        try {
            if (e.audio) {
                this._logger.verbose("Checking audio track constraints");
                let t = this._currentMediaStream.stream.getAudioTracks()[0];
                if (!t && e.audio) return this._logger.verbose("No audio track in media stream and constraints has audio"), !1;
                if (t && !e.audio) return this._logger.verbose("There is audio track in media stream and constraints has no audio"), !1;
                if ("object" == typeof e.audio && e.audio.deviceId && t.getCapabilities().deviceId !== e.audio.deviceId) return this._logger.verbose("Constraints has audio device ID and it not matches current device id"), !1;
                t && "boolean" != typeof e.audio && (this._logger.verbose("Trying to apply new constraints for audio"), await t.applyConstraints(e.audio));
            }
        } catch (e) {
            return this._logger.debug("Could not apply constraints or get capabilities of audio track", {
                error: e
            }), !1;
        }
        return !0;
    }
    async _onDevicesChanged() {
        this._logger.debug("Media devices has changed"), this._mediaDevices = null;
        let e = await this._getMediaDevices();
        this._mediaDevices = e, this.emitEvent($cdb872cfc8d057e0$export$1f8aff248f4faedf.MEDIA_DEVICES_UPDATED, e);
    }
    get streamFPS() {
        if (!this._currentMediaStream?.stream) return null;
        let e = this._currentMediaStream.stream.getVideoTracks()[0];
        if (!e) return null;
        try {
            return e.getSettings().frameRate || null;
        } catch (e) {
            return null;
        }
    }
};
$cdb872cfc8d057e0$var$N([
    $cdb872cfc8d057e0$export$2385a24977818dd0
], $cdb872cfc8d057e0$export$187d60d76727d102.prototype, "_onDevicesChanged", null);
let $cdb872cfc8d057e0$var$iE = ()=>window.MediaSource || window.WebKitMediaSource || window.ManagedMediaSource, $cdb872cfc8d057e0$var$iy = ()=>window.SourceBuffer || window.WebKitSourceBuffer || window.ManagedSourceBuffer, $cdb872cfc8d057e0$export$affafd53970e84fb = {
    isHLSSupported: ()=>{
        let e = $cdb872cfc8d057e0$var$iE();
        if (!e) return !1;
        let t = $cdb872cfc8d057e0$var$iy(), i = "function" == typeof e.isTypeSupported && e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), r = !t || t.prototype && "function" == typeof t.prototype.appendBuffer && "function" == typeof t.prototype.remove;
        return i && r;
    }
}, $cdb872cfc8d057e0$export$deea386614a3c23c = (e)=>{
    if (!e) return {};
    try {
        let t = new URL(e), i = t.pathname.split("/"), r = i[2], n = i[i.length - 1], s = n.match(/\d+_(\w+)/)?.[1] || "source", a = "master" === i[3];
        return {
            streamId: r,
            resolution: s,
            isMaster: a
        };
    } catch (e) {
        return {};
    }
}, $cdb872cfc8d057e0$export$53e796f17ca77411 = "v1.10.1";
let $cdb872cfc8d057e0$var$$b6bc6d40983aff7e$export$8e3a33bcb5e540bd = class $b6bc6d40983aff7e$export$8e3a33bcb5e540bd {
    enqueue(e) {
        this._queue.push(e), this._runNext();
    }
    _runNext() {
        if (this._isRunning) return;
        let e = this._queue.shift();
        if (e) {
            this._isRunning = !0;
            try {
                let t = e();
                Promise.resolve(t).catch((e)=>console.error("QueueLocker error: ", e)).finally(()=>{
                    this._isRunning = !1, this._runNext();
                });
            } catch (e) {
                this._isRunning = !1, this._runNext();
            }
        }
    }
    constructor(){
        this._queue = [], this._isRunning = !1;
    }
};
let $cdb872cfc8d057e0$export$11b5f216823d88a3 = ()=>{
    let e = new WeakMap;
    return function(t, i, r) {
        let n = r.value;
        return r.value = function(...t) {
            let i = e.get(this);
            i || (i = new $cdb872cfc8d057e0$var$$b6bc6d40983aff7e$export$8e3a33bcb5e540bd, e.set(this, i)), i.enqueue(()=>n.apply(this, t));
        }, r;
    };
};
let $cdb872cfc8d057e0$var$$c49a8be26abe34b8$export$59314a2e9fd08cd4 = class $c49a8be26abe34b8$export$59314a2e9fd08cd4 {
    run(e) {
        return this._currentPromise || (this._currentPromise = new Promise((t, i)=>{
            Promise.resolve().then(()=>e()).then((e)=>{
                this._currentPromise = null, t(e);
            }).catch((e)=>{
                this._currentPromise = null, i(e);
            });
        })), this._currentPromise;
    }
    constructor(){
        this._currentPromise = null;
    }
};
function $cdb872cfc8d057e0$export$7427768fbd3b49d0(e, t, i) {
    let r = i.value, n = Symbol(t.toString());
    return i.value = function(...e) {
        let t = this[n];
        t || (t = new $cdb872cfc8d057e0$var$$c49a8be26abe34b8$export$59314a2e9fd08cd4, this[n] = t), t.run(()=>{
            try {
                let t = r.apply(this, e);
                return Promise.resolve(t);
            } catch (e) {
                return Promise.reject(e);
            }
        });
    }, i;
}
let $cdb872cfc8d057e0$var$iT = ()=>"undefined" != typeof window && "HTMLVideoElement" in window, $cdb872cfc8d057e0$var$iM = ()=>$cdb872cfc8d057e0$var$iT() && "function" == typeof window.HTMLVideoElement?.prototype?.getVideoPlaybackQuality, $cdb872cfc8d057e0$var$iP = ()=>$cdb872cfc8d057e0$var$iT() && "webkitDroppedFrameCount" in window.HTMLVideoElement.prototype, $cdb872cfc8d057e0$var$iO = ()=>$cdb872cfc8d057e0$var$iT() && "mozPaintedFrames" in window.HTMLVideoElement.prototype;
function $cdb872cfc8d057e0$export$922b9b8e8545ee90(e) {
    return $cdb872cfc8d057e0$var$iM() ? e.getVideoPlaybackQuality() : $cdb872cfc8d057e0$var$iP() ? {
        corruptedVideoFrames: 0,
        creationTime: window.performance?.now?.() ?? Date.now(),
        droppedVideoFrames: e.webkitDroppedFrameCount || 0,
        totalVideoFrames: e.webkitDecodedFrameCount || 0
    } : $cdb872cfc8d057e0$var$iO() ? {
        corruptedVideoFrames: 0,
        creationTime: window.performance?.now?.() ?? Date.now(),
        droppedVideoFrames: 0,
        totalVideoFrames: e.mozPaintedFrames || 0
    } : {
        corruptedVideoFrames: 0,
        creationTime: window.performance?.now?.() ?? Date.now(),
        droppedVideoFrames: 0,
        totalVideoFrames: 0
    };
}


/* eslint-disable @typescript-eslint/explicit-function-return-type */ 

const $7bee1a93fb5bc362$export$28c82a02d50f6df3 = `<MMP_VERSION>`;


const $a5b117aca3c08d12$export$35d029da0d03482e = (props = {})=>{
    const playerRef = (0, ($parcel$interopDefault($akeyK$react))).useRef(null);
    // TODO: Get features from connect message
    const [abrPolicy] = (0, ($parcel$interopDefault($akeyK$react))).useState("client");
    const [smoothQualityChangeSupported] = (0, ($parcel$interopDefault($akeyK$react))).useState(true);
    const [resolutions, setResolutions] = (0, ($parcel$interopDefault($akeyK$react))).useState([]);
    const [currentResolution, setCurrentResolution] = (0, ($parcel$interopDefault($akeyK$react))).useState(null);
    const [availablePlayerTypes, setAvailablePlayerTypes] = (0, ($parcel$interopDefault($akeyK$react))).useState([]);
    const [playbackState, setPlaybackState] = (0, ($parcel$interopDefault($akeyK$react))).useState();
    const [playbackStartType, setPlaybackStartType] = (0, ($parcel$interopDefault($akeyK$react))).useState((0, $e175c1d94c759890$export$fadb1eea8aff454b).WAITING);
    const [isModuleLoading, setIsModuleLoading] = (0, ($parcel$interopDefault($akeyK$react))).useState(false);
    const [videoPlaybackState, setVideoPlaybackState] = (0, ($parcel$interopDefault($akeyK$react))).useState({
        isPlaying: false,
        isLoading: false,
        isErrored: false
    });
    const handleAvailablePlayerTypes = (e)=>{
        setAvailablePlayerTypes(e.detail.availablePlayerTypes);
    };
    const handlePlaybackStateChange = (e)=>{
        const nextState = e.detail.nextState;
        setPlaybackState(nextState);
    };
    const handleUpdatePlayerResolution = (e)=>{
        if (props.onUpdatePlayerResolution) props.onUpdatePlayerResolution(e.detail);
    };
    const handleModuleLoadingStateChanged = (e)=>{
        setIsModuleLoading(e.detail.newState === (0, $e175c1d94c759890$export$b11132158c03c5d).LOADING);
    };
    const handleVideoPlaybackStateChange = (e)=>{
        const nextState = e.detail.nextState;
        const isPlaying = nextState === (0, $e175c1d94c759890$export$af29ccb356acd9fc).PLAYING;
        const isLoading = nextState === (0, $e175c1d94c759890$export$af29ccb356acd9fc).LOADING;
        const isErrored = nextState === (0, $e175c1d94c759890$export$af29ccb356acd9fc).ERROR;
        setVideoPlaybackState({
            state: nextState,
            isPlaying: isPlaying,
            isLoading: isLoading,
            isErrored: isErrored
        });
    };
    const handleResolutionsAvailable = (e)=>{
        setResolutions(e.detail.resolutions);
    };
    const handlePlaying = (e)=>{
        if (e.detail.isAutoplay === false) setPlaybackStartType((0, $e175c1d94c759890$export$fadb1eea8aff454b).MANUAL);
        else setPlaybackStartType((0, $e175c1d94c759890$export$fadb1eea8aff454b).AUTO);
    };
    const handleTimeUpdate = ()=>{
        if (props.onTimeUpdate) props.onTimeUpdate();
    };
    const handleError = ({ detail: detail  })=>{
        if (props.onError) props.onError({
            error: detail.error,
            playerType: detail.playerType
        });
    };
    const handleResolutionNotFound = ()=>{
        if (props.onResolutionNotFound) props.onResolutionNotFound();
    };
    const handleResolutionSwitched = ({ detail: detail  })=>{
        setCurrentResolution({
            name: detail.resolutionName
        });
    };
    const toggleEvents = (action)=>{
        if (playerRef.current) {
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).AVAILABLE_PLAYER_TYPES_UPDATED, handleAvailablePlayerTypes);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).PLAYBACK_STATE_CHANGED, handlePlaybackStateChange);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).VIDEO_PLAYBACK_STATE_CHANGED, handleVideoPlaybackStateChange);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).RESOLUTIONS_AVAILABLE, handleResolutionsAvailable);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).UPDATE_PLAYER_RESOLUTION, handleUpdatePlayerResolution);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).MODULE_LOADING_STATE_CHANGED, handleModuleLoadingStateChanged);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).RESOLUTION_SWITCHED, handleResolutionSwitched);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).PLAYING, handlePlaying);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).ERROR, handleError);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).TIME_UPDATE, handleTimeUpdate);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).RESOLUTION_NOT_FOUND, handleResolutionNotFound);
        }
    };
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (playerRef.current) {
            toggleEvents("on");
            return ()=>{
                toggleEvents("off");
            };
        }
    }, [
        playerRef.current,
        handleResolutionNotFound
    ]);
    (0, $akeyK$react.useEffect)(()=>{
        const { isPlaying: isPlaying  } = videoPlaybackState;
        if (isPlaying && props.onPlaying) props.onPlaying();
    }, [
        videoPlaybackState
    ]);
    return {
        playerRef: playerRef,
        availablePlayerTypes: availablePlayerTypes,
        playbackState: playbackState,
        playbackStartType: playbackStartType,
        videoPlaybackState: videoPlaybackState.state,
        abrPolicy: abrPolicy,
        smoothQualityChangeSupported: smoothQualityChangeSupported,
        resolutions: resolutions,
        isPlaying: videoPlaybackState.isPlaying,
        isLoading: videoPlaybackState.isLoading,
        isErrored: videoPlaybackState.isErrored,
        isModuleLoading: isModuleLoading,
        currentResolution: currentResolution,
        version: (0, $7bee1a93fb5bc362$export$28c82a02d50f6df3)
    };
};


/* eslint-disable @typescript-eslint/explicit-function-return-type */ 

/* eslint-disable @typescript-eslint/typedef */ 


const $a33fc491e3e07def$export$f4b266cd2aae9cb1 = (callback, delay)=>{
    const savedCallback = (0, $akeyK$react.useRef)(null);
    (0, $akeyK$react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $akeyK$react.useEffect)(()=>{
        const cb = ()=>{
            if (savedCallback.current) savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(cb, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};


const $55a398c49169473b$export$640a19eb3ed66b95 = ({ HLSStreamUrl: HLSStreamUrl , WebRTCSignallingUrl: WebRTCSignallingUrl , WebRTCPublishCustomData: WebRTCPublishCustomData , WebRTCStreamId: WebRTCStreamId , WebRTCACLToken: WebRTCACLToken , NativeStreamURL: NativeStreamURL , MediaStream: MediaStream , playerType: playerType , playerConfig: playerConfig , abTests: abTests , abrPresets: abrPresets , isABREnabled: isABREnabled , volume: volume , additionalMetricFields: additionalMetricFields , appKey: appKey , metricsProjectId: metricsProjectId , quality: quality , videoElement: videoElement , metricsCollectionEndpoint: metricsCollectionEndpoint , WebRTCQuality: WebRTCQuality , playerRef: playerRef , autoplay: autoplay , ProbingCacheKey: ProbingCacheKey , shouldWatchDogStopPlayer: shouldWatchDogStopPlayer  })=>{
    const mouflonPlayerRef = (0, ($parcel$interopDefault($akeyK$react))).useRef(null);
    const [currentStreamConfig, setCurrentStreamConfig] = (0, ($parcel$interopDefault($akeyK$react))).useState({});
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        setCurrentStreamConfig({
            HLSStreamUrl: HLSStreamUrl,
            WebRTCSignallingUrl: WebRTCSignallingUrl,
            WebRTCPublishCustomData: WebRTCPublishCustomData,
            WebRTCStreamId: WebRTCStreamId,
            WebRTCACLToken: WebRTCACLToken,
            NativeStreamURL: NativeStreamURL,
            MediaStream: MediaStream,
            ProbingCacheKey: ProbingCacheKey
        });
    }, [
        HLSStreamUrl,
        WebRTCSignallingUrl,
        WebRTCPublishCustomData,
        WebRTCStreamId,
        WebRTCACLToken,
        NativeStreamURL,
        MediaStream,
        ProbingCacheKey
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        mouflonPlayerRef.current?.setStreamConfig(currentStreamConfig);
    }, [
        currentStreamConfig
    ]);
    const isNativePlayer = playerType === (0, $e175c1d94c759890$export$41789205b2aea69e).NATIVE;
    const retune = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        if (!mouflonPlayerRef.current || !playerType) return;
        if (isNativePlayer) {
            if (isABREnabled) mouflonPlayerRef.current.enableAbr();
            else mouflonPlayerRef.current.disableAbr();
        }
        if (abTests) mouflonPlayerRef.current.setAbTests(abTests);
        if (playerConfig) mouflonPlayerRef.current.setConfig(playerConfig);
        if (appKey) mouflonPlayerRef.current.setAppKey(appKey);
        if (videoElement) mouflonPlayerRef.current.setVideoElement(videoElement);
        mouflonPlayerRef.current.setStreamConfig(currentStreamConfig);
        mouflonPlayerRef.current.setPlayerType(playerType);
        mouflonPlayerRef.current.setAbrResolutions(abrPresets?.filter((preset)=>!preset.name.includes("blurred")) || []);
        if (WebRTCQuality && !isNativePlayer) mouflonPlayerRef.current?.setResolutionByName(WebRTCQuality);
        if (shouldWatchDogStopPlayer !== undefined) mouflonPlayerRef.current.setShouldStopPlayer?.(shouldWatchDogStopPlayer);
        if (volume !== undefined) mouflonPlayerRef.current?.setVolume(volume);
    }, [
        mouflonPlayerRef.current,
        videoElement,
        playerType,
        isABREnabled,
        abrPresets,
        appKey,
        shouldWatchDogStopPlayer
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        let isNewlyCreated = false;
        if (!playerType || [
            (0, $e175c1d94c759890$export$41789205b2aea69e).BROADCAST,
            (0, $e175c1d94c759890$export$41789205b2aea69e).WEBRTC
        ].includes(playerType) && !appKey) return;
        if (mouflonPlayerRef.current) return;
        if (!mouflonPlayerRef.current) {
            isNewlyCreated = true;
            mouflonPlayerRef.current = new (0, $e175c1d94c759890$export$57663087b8d9f5a6)();
            if (playerRef) playerRef.current = mouflonPlayerRef.current;
        }
        retune();
        if (isNewlyCreated && autoplay) mouflonPlayerRef.current?.start();
    }, [
        mouflonPlayerRef.current,
        videoElement,
        playerType,
        abrPresets,
        isABREnabled,
        appKey,
        shouldWatchDogStopPlayer
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        mouflonPlayerRef.current?.setVolume(volume);
    }, [
        volume
    ]);
    const resetAdditionalFields = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        const connectionInfo = navigator.connection;
        mouflonPlayerRef.current?.setAdditionalMetricsFields({
            ...additionalMetricFields,
            reportedDownlink: connectionInfo?.downlink,
            reportedRTT: connectionInfo?.rtt,
            reportedNetworkType: connectionInfo?.type
        });
    }, [
        additionalMetricFields,
        mouflonPlayerRef.current
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        resetAdditionalFields();
    }, [
        additionalMetricFields
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        return ()=>{
            mouflonPlayerRef.current?.destroy();
        };
    }, []);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (playerConfig) mouflonPlayerRef?.current?.setConfig(playerConfig);
    }, [
        playerConfig
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (playerType) mouflonPlayerRef.current?.setPlayerType(playerType);
    }, [
        playerType
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (metricsCollectionEndpoint && metricsProjectId && playerRef?.current) playerRef.current?.configureMetrics(metricsCollectionEndpoint, metricsProjectId);
    }, [
        playerRef?.current,
        metricsProjectId,
        metricsCollectionEndpoint
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        mouflonPlayerRef.current?.setVideoElement(videoElement || null);
    }, [
        videoElement
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        mouflonPlayerRef.current?.setAbrResolutions(abrPresets?.filter((preset)=>!preset.name.includes("blurred")) || []);
    }, [
        abrPresets
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (appKey) mouflonPlayerRef.current?.setAppKey(appKey);
    }, [
        appKey
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (abTests) mouflonPlayerRef.current?.setAbTests(abTests);
    }, [
        abTests
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (!mouflonPlayerRef.current) return;
        if (quality) mouflonPlayerRef.current.setResolutionByName(quality);
        else if (WebRTCQuality && playerType === (0, $e175c1d94c759890$export$41789205b2aea69e).WEBRTC) mouflonPlayerRef.current.setResolutionByName(WebRTCQuality);
        if (isABREnabled) mouflonPlayerRef.current.enableAbr();
        else mouflonPlayerRef.current.disableAbr();
    }, [
        isABREnabled,
        WebRTCQuality,
        quality
    ]);
    (0, $a33fc491e3e07def$export$f4b266cd2aae9cb1)(resetAdditionalFields, 2000);
};



const $88026686cd5bfe8a$export$76f5745079d42a31 = (props)=>{
    const playerRef = (0, ($parcel$interopDefault($akeyK$react))).useRef(null);
    (0, $55a398c49169473b$export$640a19eb3ed66b95)({
        ...props,
        playerRef: playerRef
    });
    // TODO: Get features from connect message
    const [abrPolicy] = (0, ($parcel$interopDefault($akeyK$react))).useState("client");
    const [smoothQualityChangeSupported] = (0, ($parcel$interopDefault($akeyK$react))).useState(true);
    const [resolutions, setResolutions] = (0, ($parcel$interopDefault($akeyK$react))).useState([]);
    const [currentResolution, setCurrentResolution] = (0, ($parcel$interopDefault($akeyK$react))).useState(null);
    const [availablePlayerTypes, setAvailablePlayerTypes] = (0, ($parcel$interopDefault($akeyK$react))).useState([]);
    const [playbackState, setPlaybackState] = (0, ($parcel$interopDefault($akeyK$react))).useState();
    const [playbackStartType, setPlaybackStartType] = (0, ($parcel$interopDefault($akeyK$react))).useState((0, $e175c1d94c759890$export$fadb1eea8aff454b).WAITING);
    const [isModuleLoading, setIsModuleLoading] = (0, ($parcel$interopDefault($akeyK$react))).useState(false);
    const [videoPlaybackState, setVideoPlaybackState] = (0, ($parcel$interopDefault($akeyK$react))).useState({
        isPlaying: false,
        isLoading: false,
        isErrored: false
    });
    const handleAvailablePlayerTypes = (e)=>{
        setAvailablePlayerTypes(e.detail.availablePlayerTypes);
    };
    const handlePlaybackStateChange = (e)=>{
        const nextState = e.detail.nextState;
        setPlaybackState(nextState);
    };
    const handleUpdatePlayerResolution = (e)=>{
        if (props.onUpdatePlayerResolution) props.onUpdatePlayerResolution(e.detail);
    };
    const handleModuleLoadingStateChanged = (e)=>{
        setIsModuleLoading(e.detail.newState === (0, $e175c1d94c759890$export$b11132158c03c5d).LOADING);
    };
    const handleVideoPlaybackStateChange = (e)=>{
        const nextState = e.detail.nextState;
        const isPlaying = nextState === (0, $e175c1d94c759890$export$af29ccb356acd9fc).PLAYING;
        const isLoading = nextState === (0, $e175c1d94c759890$export$af29ccb356acd9fc).LOADING;
        const isErrored = nextState === (0, $e175c1d94c759890$export$af29ccb356acd9fc).ERROR;
        setVideoPlaybackState({
            state: nextState,
            isPlaying: isPlaying,
            isLoading: isLoading,
            isErrored: isErrored
        });
    };
    const handleResolutionsAvailable = (e)=>{
        setResolutions(e.detail.resolutions);
    };
    const handleResolutionSwitched = ({ detail: detail  })=>{
        setCurrentResolution({
            name: detail.resolutionName
        });
    };
    const handlePlaying = (e)=>{
        if (e.detail.isAutoplay === false) setPlaybackStartType((0, $e175c1d94c759890$export$fadb1eea8aff454b).MANUAL);
        else setPlaybackStartType((0, $e175c1d94c759890$export$fadb1eea8aff454b).AUTO);
    };
    const handleBroadcastSupportedChange = (e)=>{
        if (props.onBroadcastSupportedChange) props.onBroadcastSupportedChange(e.detail);
    };
    const handleTimeUpdate = ()=>{
        if (props.onTimeUpdate) props.onTimeUpdate();
    };
    const handleError = ({ detail: detail  })=>{
        if (props.onError) props.onError({
            error: detail.error,
            playerType: detail.playerType,
            isFatal: detail.isFatal,
            errorType: detail.errorType
        });
    };
    const handleResolutionNotFound = ()=>{
        if (props.onResolutionNotFound) props.onResolutionNotFound();
    };
    const toggleEvents = (action)=>{
        if (playerRef.current) {
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).AVAILABLE_PLAYER_TYPES_UPDATED, handleAvailablePlayerTypes);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).PLAYBACK_STATE_CHANGED, handlePlaybackStateChange);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).VIDEO_PLAYBACK_STATE_CHANGED, handleVideoPlaybackStateChange);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).RESOLUTIONS_AVAILABLE, handleResolutionsAvailable);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).RESOLUTION_SWITCHED, handleResolutionSwitched);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).UPDATE_PLAYER_RESOLUTION, handleUpdatePlayerResolution);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).MODULE_LOADING_STATE_CHANGED, handleModuleLoadingStateChanged);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).PLAYING, handlePlaying);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).ERROR, handleError);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).TIME_UPDATE, handleTimeUpdate);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).RESOLUTION_NOT_FOUND, handleResolutionNotFound);
            playerRef.current[action]((0, $e175c1d94c759890$export$7cafc4c0fcafdd05).BROADCAST_SUPPORTED_CHANGE, handleBroadcastSupportedChange);
        }
    };
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (playerRef.current) {
            toggleEvents("on");
            return ()=>{
                toggleEvents("off");
            };
        }
    }, [
        playerRef.current,
        handleResolutionNotFound
    ]);
    (0, $akeyK$react.useEffect)(()=>{
        const { isPlaying: isPlaying  } = videoPlaybackState;
        if (isPlaying && props.onPlaying) props.onPlaying();
    }, [
        videoPlaybackState
    ]);
    return {
        playerRef: playerRef,
        availablePlayerTypes: availablePlayerTypes,
        playbackState: playbackState,
        playbackStartType: playbackStartType,
        videoPlaybackState: videoPlaybackState.state,
        abrPolicy: abrPolicy,
        smoothQualityChangeSupported: smoothQualityChangeSupported,
        resolutions: resolutions,
        isPlaying: videoPlaybackState.isPlaying,
        isLoading: videoPlaybackState.isLoading,
        isErrored: videoPlaybackState.isErrored,
        isModuleLoading: isModuleLoading,
        version: (0, $7bee1a93fb5bc362$export$28c82a02d50f6df3),
        currentResolution: currentResolution
    };
};


/* eslint-disable @typescript-eslint/typedef */ 



const $b274644de02feaf1$export$57663087b8d9f5a6 = ({ videoElement: videoElement , playerType: playerType , HLSStreamUrl: HLSStreamUrl , WebRTCSignallingUrl: WebRTCSignallingUrl , WebRTCStreamId: WebRTCStreamId , WebRTCPublishCustomData: WebRTCPublishCustomData , WebRTCACLToken: WebRTCACLToken = "token" , NativeStreamURL: NativeStreamURL , MediaStream: MediaStream , isABREnabled: isABREnabled , playerRef: playerRef , volume: volume , playerConfig: playerConfig , children: children , WebRTCQuality: WebRTCQuality , abrPresets: abrPresets , appKey: appKey , metricsCollectionEndpoint: metricsCollectionEndpoint , metricsProjectId: metricsProjectId , abTests: abTests , abTestsSupport: abTestsSupport , quality: quality , qualityBitrate: qualityBitrate , additionalMetricFields: additionalMetricFields = {} , shouldWatchDogStopPlayer: shouldWatchDogStopPlayer  })=>{
    const mouflonPlayerRef = (0, ($parcel$interopDefault($akeyK$react))).useRef(null);
    const [currentStreamConfig, setCurrentStreamConfig] = (0, ($parcel$interopDefault($akeyK$react))).useState({});
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        setCurrentStreamConfig({
            HLSStreamUrl: HLSStreamUrl,
            WebRTCSignallingUrl: WebRTCSignallingUrl,
            WebRTCPublishCustomData: WebRTCPublishCustomData,
            WebRTCStreamId: WebRTCStreamId,
            WebRTCACLToken: WebRTCACLToken,
            NativeStreamURL: NativeStreamURL,
            MediaStream: MediaStream
        });
    }, [
        HLSStreamUrl,
        WebRTCSignallingUrl,
        WebRTCPublishCustomData,
        WebRTCStreamId,
        WebRTCACLToken,
        NativeStreamURL,
        MediaStream
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        mouflonPlayerRef.current?.setStreamConfig(currentStreamConfig);
    }, [
        currentStreamConfig
    ]);
    const isNativePlayer = playerType === (0, $e175c1d94c759890$export$41789205b2aea69e).NATIVE;
    const retune = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        if (!mouflonPlayerRef.current || !videoElement || !playerType) return;
        if (isNativePlayer) {
            if (isABREnabled) mouflonPlayerRef.current.enableAbr();
            else mouflonPlayerRef.current.disableAbr();
        }
        if (abTests) mouflonPlayerRef.current.setAbTests(abTests);
        if (abTestsSupport) mouflonPlayerRef.current?.setAbTestsSupport(abTestsSupport);
        if (playerConfig) mouflonPlayerRef.current.setConfig(playerConfig);
        if (appKey) mouflonPlayerRef.current.setAppKey(appKey);
        mouflonPlayerRef.current.setVideoElement(videoElement);
        mouflonPlayerRef.current.setStreamConfig(currentStreamConfig);
        mouflonPlayerRef.current.setPlayerType(playerType);
        if (abrPresets) mouflonPlayerRef.current?.setAbrResolutions(abrPresets.filter((preset)=>!preset.name.includes("blurred")));
        if (shouldWatchDogStopPlayer !== undefined) mouflonPlayerRef.current?.setShouldStopPlayer?.(shouldWatchDogStopPlayer);
        if (WebRTCQuality && !isNativePlayer) mouflonPlayerRef.current?.setResolutionByName(WebRTCQuality);
    }, [
        mouflonPlayerRef.current,
        videoElement,
        playerType,
        isABREnabled,
        abrPresets,
        appKey,
        shouldWatchDogStopPlayer
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        let isNewlyCreated = false;
        if (!videoElement || !playerType || [
            (0, $e175c1d94c759890$export$41789205b2aea69e).BROADCAST,
            (0, $e175c1d94c759890$export$41789205b2aea69e).WEBRTC
        ].includes(playerType) && !appKey) return;
        if (mouflonPlayerRef.current) return;
        if (!mouflonPlayerRef.current) {
            isNewlyCreated = true;
            mouflonPlayerRef.current = new (0, $e175c1d94c759890$export$57663087b8d9f5a6)();
            if (playerRef) playerRef.current = mouflonPlayerRef.current;
        }
        retune();
        if (isNewlyCreated) mouflonPlayerRef.current?.start();
    }, [
        mouflonPlayerRef.current,
        videoElement,
        playerType,
        abrPresets,
        isABREnabled,
        appKey
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        mouflonPlayerRef.current?.setVolume(volume);
    }, [
        volume
    ]);
    const resetAdditionalFields = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        const connectionInfo = navigator.connection;
        mouflonPlayerRef.current?.setAdditionalMetricsFields({
            ...additionalMetricFields,
            reportedDownlink: connectionInfo?.downlink,
            reportedRTT: connectionInfo?.rtt,
            reportedNetworkType: connectionInfo?.type
        });
    }, [
        additionalMetricFields,
        mouflonPlayerRef.current
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        resetAdditionalFields();
    }, [
        additionalMetricFields
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        return ()=>{
            mouflonPlayerRef.current?.destroy();
        };
    }, []);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (playerConfig) mouflonPlayerRef?.current?.setConfig(playerConfig);
    }, [
        playerConfig
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (playerType) mouflonPlayerRef.current?.setPlayerType(playerType);
    }, [
        playerType
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (metricsCollectionEndpoint && metricsProjectId && playerRef?.current) playerRef.current?.configureMetrics(metricsCollectionEndpoint, metricsProjectId);
    }, [
        playerRef?.current,
        metricsProjectId,
        metricsCollectionEndpoint
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (videoElement) mouflonPlayerRef.current?.setVideoElement(videoElement);
    }, [
        videoElement
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        // TODO: Remove this filter once resolutions list will be filtered on SC side
        if (abrPresets) mouflonPlayerRef.current?.setAbrResolutions(abrPresets.filter((preset)=>!preset.name.includes("blurred")));
    }, [
        abrPresets
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (appKey) mouflonPlayerRef.current?.setAppKey(appKey);
    }, [
        appKey
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (abTests) mouflonPlayerRef.current?.setAbTests(abTests);
    }, [
        abTests
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (abTestsSupport) mouflonPlayerRef.current?.setAbTestsSupport(abTestsSupport);
    }, [
        abTestsSupport
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (!mouflonPlayerRef.current) return;
        if (quality) mouflonPlayerRef.current.setResolutionByName(quality);
        else if (qualityBitrate) mouflonPlayerRef.current.setResolutionByBitrate(qualityBitrate);
        else if (WebRTCQuality && playerType === (0, $e175c1d94c759890$export$41789205b2aea69e).WEBRTC) mouflonPlayerRef.current.setResolutionByName(WebRTCQuality);
        if (isABREnabled) mouflonPlayerRef.current.enableAbr();
        else mouflonPlayerRef.current.disableAbr();
    }, [
        isABREnabled,
        WebRTCQuality,
        quality,
        qualityBitrate
    ]);
    (0, $a33fc491e3e07def$export$f4b266cd2aae9cb1)(resetAdditionalFields, 2000);
    return /*#__PURE__*/ (0, $akeyK$reactjsxruntime.jsx)((0, $akeyK$reactjsxruntime.Fragment), {
        children: children
    });
};


/* eslint-disable @typescript-eslint/typedef */ 

const $59ca1dda55658eb6$var$isSrcObjectAvailable = (videoElement)=>videoElement?.srcObject !== undefined;
const $59ca1dda55658eb6$export$a16ee9849ed85b4e = ({ videoElement: videoElement , fakeStreamOptionals: fakeStreamOptionals  } = {})=>{
    const userMediaRef = (0, ($parcel$interopDefault($akeyK$react))).useRef(null);
    const [availableDevices, setAvailableDevices] = (0, ($parcel$interopDefault($akeyK$react))).useState({
        audio: [],
        video: []
    });
    const [constraints, setConstraints] = (0, ($parcel$interopDefault($akeyK$react))).useState({});
    const [mediaStream, setMediaStream] = (0, ($parcel$interopDefault($akeyK$react))).useState(null);
    const [streamFPS, setStreamFPS] = (0, ($parcel$interopDefault($akeyK$react))).useState(null);
    const [isPermissionsRequested, setPermissionsRequested] = (0, ($parcel$interopDefault($akeyK$react))).useState(false);
    const [error, setError] = (0, ($parcel$interopDefault($akeyK$react))).useState(null);
    const [mediaCheckResult, setMediaCheckResults] = (0, ($parcel$interopDefault($akeyK$react))).useState(null);
    const [isDevicesFound, setIsDevicesFound] = (0, ($parcel$interopDefault($akeyK$react))).useState(false);
    const updateDevices = async ()=>{
        if (userMediaRef.current) {
            const audio = await userMediaRef.current.getAudioInputDevices();
            const video = await userMediaRef.current.getVideoDevices();
            setAvailableDevices({
                audio: audio,
                video: video
            });
        }
    };
    const requestPermissions = (0, ($parcel$interopDefault($akeyK$react))).useCallback((devices)=>{
        const compositeDevices = devices ? devices : {
            audio: true,
            video: true
        };
        return userMediaRef.current?.requestPermissions(compositeDevices).then((mediaCheckedResult)=>{
            setMediaCheckResults(mediaCheckedResult);
            setPermissionsRequested(true);
            updateDevices();
            setIsDevicesFound(true);
        });
    }, [
        userMediaRef.current
    ]);
    const attachListeners = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        userMediaRef.current?.addEventListener((0, $cdb872cfc8d057e0$export$1f8aff248f4faedf).MEDIA_DEVICES_UPDATED, updateDevices);
    }, [
        userMediaRef.current
    ]);
    const detachListeners = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        userMediaRef.current?.removeEventListener((0, $cdb872cfc8d057e0$export$1f8aff248f4faedf).MEDIA_DEVICES_UPDATED, updateDevices);
    }, [
        userMediaRef.current
    ]);
    const destroy = (0, ($parcel$interopDefault($akeyK$react))).useCallback(()=>{
        userMediaRef.current?.destroy();
    }, []);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (constraints && Object.keys(constraints).length > 0 && userMediaRef.current) {
            if (!Object.values(constraints).some((c)=>typeof c === "object" ? !!c.deviceId || c.facingMode : !!c)) return;
            userMediaRef.current?.getMediaStream(constraints, {
                sizeThreshold: 50,
                baseAspectRatio: 1.333
            }, fakeStreamOptionals).then((mediaStream)=>{
                setMediaStream(mediaStream);
                setStreamFPS(userMediaRef.current?.streamFPS ?? null);
                updateDevices();
            }).catch((e)=>{
                setError(e);
            });
        }
    }, [
        userMediaRef.current,
        constraints
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        if (videoElement) {
            if (mediaStream) {
                if ($59ca1dda55658eb6$var$isSrcObjectAvailable(videoElement)) videoElement.srcObject = mediaStream;
                else videoElement.src = globalThis.URL?.createObjectURL(mediaStream);
                videoElement.play();
            } else if ($59ca1dda55658eb6$var$isSrcObjectAvailable(videoElement)) videoElement.srcObject = null;
            else globalThis.URL?.revokeObjectURL(videoElement.src);
        }
    }, [
        videoElement,
        mediaStream
    ]);
    (0, ($parcel$interopDefault($akeyK$react))).useEffect(()=>{
        userMediaRef.current = new (0, $cdb872cfc8d057e0$export$187d60d76727d102)();
        attachListeners();
        return ()=>{
            destroy();
            detachListeners();
        };
    }, []);
    return {
        requestPermissions: requestPermissions,
        setConstraints: setConstraints,
        mediaStream: mediaStream,
        streamFPS: streamFPS,
        isPermissionsRequested: isPermissionsRequested,
        availableVideoDevices: availableDevices.video,
        availableAudioDevices: availableDevices.audio,
        destroy: destroy,
        error: error,
        mediaCheckResult: mediaCheckResult,
        isDevicesFound: isDevicesFound
    };
};


// TODO: We should get rid of code duplicating
let $006bb0748335bd60$var$cachedVideoElement = null;
const $006bb0748335bd60$export$ccb78460aa37b1d6 = ()=>{
    if ($006bb0748335bd60$var$cachedVideoElement) return $006bb0748335bd60$var$cachedVideoElement;
    $006bb0748335bd60$var$cachedVideoElement = document.createElement("video");
    return $006bb0748335bd60$var$cachedVideoElement;
};
const $006bb0748335bd60$export$2e47fab1429dbb4f = ()=>$006bb0748335bd60$export$ccb78460aa37b1d6().play();





//# sourceMappingURL=main.js.map
